/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: string; output: string; }
};

export type Account = Node & {
  __typename?: 'Account';
  /** Reads and enables pagination through a set of `BoostLiquidityBalanceChange`. */
  boostLiquidityBalanceChangesByLiquidityProviderId: BoostLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `BoostShare`. */
  boostSharesByLiquidityProviderId: BoostSharesConnection;
  /** Reads and enables pagination through a set of `DepositChannel`. */
  depositChannelsByBrokerId: DepositChannelsConnection;
  /** Reads and enables pagination through a set of `DepositChannel`. */
  depositChannelsByLiquidityProviderId: DepositChannelsConnection;
  id: Scalars['Int']['output'];
  idSs58: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangesByLiquidityProviderId: LendingLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `LimitOrderFill`. */
  limitOrderFillsByLiquidityProviderId: LimitOrderFillsConnection;
  /** Reads and enables pagination through a set of `LiquidityProviderBoostPoolSummary`. */
  liquidityProviderBoostPoolSummariesByLiquidityProviderId: LiquidityProviderBoostPoolSummariesConnection;
  /** Reads and enables pagination through a set of `LiquiditySnapshot`. */
  liquiditySnapshotsByLiquidityProviderId: LiquiditySnapshotsConnection;
  /** Reads and enables pagination through a set of `Loan`. */
  loansByBorrowerId: LoansConnection;
  /** Reads and enables pagination through a set of `Loan`. */
  loansByBrokerId: LoansConnection;
  /** Reads and enables pagination through a set of `LpCollateralBalanceChange`. */
  lpCollateralBalanceChangesByLiquidityProviderId: LpCollateralBalanceChangesConnection;
  /** Reads and enables pagination through a set of `LpFlipAirdropDistributionEvent`. */
  lpFlipAirdropDistributionEventsByLiquidityProviderId: LpFlipAirdropDistributionEventsConnection;
  /** Reads and enables pagination through a set of `LpLendingPoolSnapshot`. */
  lpLendingPoolSnapshotsByLiquidityProviderId: LpLendingPoolSnapshotsConnection;
  /** Reads and enables pagination through a set of `LpPointDistributionEvent`. */
  lpPointDistributionEventsByLiquidityProviderId: LpPointDistributionEventsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `PendingBoostLiquidityWithdrawal`. */
  pendingBoostLiquidityWithdrawalsByLiquidityProviderId: PendingBoostLiquidityWithdrawalsConnection;
  /** Reads and enables pagination through a set of `PoolOrder`. */
  poolOrdersByLiquidityProviderId: PoolOrdersConnection;
  /** Reads and enables pagination through a set of `RangeOrderFill`. */
  rangeOrderFillsByLiquidityProviderId: RangeOrderFillsConnection;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  tradingStrategiesByOwnerAccountId: TradingStrategiesConnection;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  tradingStrategiesByStrategyAccountId: TradingStrategiesConnection;
  /** Reads a single `TradingStrategy` that is related to this `Account`. */
  tradingStrategyByStrategyAccountId?: Maybe<TradingStrategy>;
  type: AccountType;
};


export type AccountBoostLiquidityBalanceChangesByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostLiquidityBalanceChangesOrderBy>>;
};


export type AccountBoostSharesByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostShareCondition>;
  filter?: InputMaybe<BoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSharesOrderBy>>;
};


export type AccountDepositChannelsByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositChannelCondition>;
  filter?: InputMaybe<DepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositChannelsOrderBy>>;
};


export type AccountDepositChannelsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositChannelCondition>;
  filter?: InputMaybe<DepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositChannelsOrderBy>>;
};


export type AccountLendingLiquidityBalanceChangesByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy>>;
};


export type AccountLimitOrderFillsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LimitOrderFillCondition>;
  filter?: InputMaybe<LimitOrderFillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LimitOrderFillsOrderBy>>;
};


export type AccountLiquidityProviderBoostPoolSummariesByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityProviderBoostPoolSummaryCondition>;
  filter?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityProviderBoostPoolSummariesOrderBy>>;
};


export type AccountLiquiditySnapshotsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquiditySnapshotCondition>;
  filter?: InputMaybe<LiquiditySnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquiditySnapshotsOrderBy>>;
};


export type AccountLoansByBorrowerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type AccountLoansByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type AccountLpCollateralBalanceChangesByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpCollateralBalanceChangeCondition>;
  filter?: InputMaybe<LpCollateralBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpCollateralBalanceChangesOrderBy>>;
};


export type AccountLpFlipAirdropDistributionEventsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpFlipAirdropDistributionEventCondition>;
  filter?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpFlipAirdropDistributionEventsOrderBy>>;
};


export type AccountLpLendingPoolSnapshotsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLendingPoolSnapshotCondition>;
  filter?: InputMaybe<LpLendingPoolSnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLendingPoolSnapshotsOrderBy>>;
};


export type AccountLpPointDistributionEventsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpPointDistributionEventCondition>;
  filter?: InputMaybe<LpPointDistributionEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpPointDistributionEventsOrderBy>>;
};


export type AccountPendingBoostLiquidityWithdrawalsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PendingBoostLiquidityWithdrawalCondition>;
  filter?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PendingBoostLiquidityWithdrawalsOrderBy>>;
};


export type AccountPoolOrdersByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderCondition>;
  filter?: InputMaybe<PoolOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrdersOrderBy>>;
};


export type AccountRangeOrderFillsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RangeOrderFillCondition>;
  filter?: InputMaybe<RangeOrderFillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RangeOrderFillsOrderBy>>;
};


export type AccountTradingStrategiesByOwnerAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};


export type AccountTradingStrategiesByStrategyAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};

export type AccountAggregates = {
  __typename?: 'AccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountVarianceSampleAggregates>;
};

export type AccountAverageAggregates = {
  __typename?: 'AccountAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AccountType>;
};

export type AccountDistinctCountAggregates = {
  __typename?: 'AccountDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Account` object types. All fields are combined with a logical ‘and.’ */
export type AccountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `boostLiquidityBalanceChangesByLiquidityProviderId` relation. */
  boostLiquidityBalanceChangesByLiquidityProviderId?: InputMaybe<AccountToManyBoostLiquidityBalanceChangeFilter>;
  /** Some related `boostLiquidityBalanceChangesByLiquidityProviderId` exist. */
  boostLiquidityBalanceChangesByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostSharesByLiquidityProviderId` relation. */
  boostSharesByLiquidityProviderId?: InputMaybe<AccountToManyBoostShareFilter>;
  /** Some related `boostSharesByLiquidityProviderId` exist. */
  boostSharesByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `depositChannelsByBrokerId` relation. */
  depositChannelsByBrokerId?: InputMaybe<AccountToManyDepositChannelFilter>;
  /** Some related `depositChannelsByBrokerId` exist. */
  depositChannelsByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `depositChannelsByLiquidityProviderId` relation. */
  depositChannelsByLiquidityProviderId?: InputMaybe<AccountToManyDepositChannelFilter>;
  /** Some related `depositChannelsByLiquidityProviderId` exist. */
  depositChannelsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lendingLiquidityBalanceChangesByLiquidityProviderId` relation. */
  lendingLiquidityBalanceChangesByLiquidityProviderId?: InputMaybe<AccountToManyLendingLiquidityBalanceChangeFilter>;
  /** Some related `lendingLiquidityBalanceChangesByLiquidityProviderId` exist. */
  lendingLiquidityBalanceChangesByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `limitOrderFillsByLiquidityProviderId` relation. */
  limitOrderFillsByLiquidityProviderId?: InputMaybe<AccountToManyLimitOrderFillFilter>;
  /** Some related `limitOrderFillsByLiquidityProviderId` exist. */
  limitOrderFillsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityProviderBoostPoolSummariesByLiquidityProviderId` relation. */
  liquidityProviderBoostPoolSummariesByLiquidityProviderId?: InputMaybe<AccountToManyLiquidityProviderBoostPoolSummaryFilter>;
  /** Some related `liquidityProviderBoostPoolSummariesByLiquidityProviderId` exist. */
  liquidityProviderBoostPoolSummariesByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquiditySnapshotsByLiquidityProviderId` relation. */
  liquiditySnapshotsByLiquidityProviderId?: InputMaybe<AccountToManyLiquiditySnapshotFilter>;
  /** Some related `liquiditySnapshotsByLiquidityProviderId` exist. */
  liquiditySnapshotsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loansByBorrowerId` relation. */
  loansByBorrowerId?: InputMaybe<AccountToManyLoanFilter>;
  /** Some related `loansByBorrowerId` exist. */
  loansByBorrowerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loansByBrokerId` relation. */
  loansByBrokerId?: InputMaybe<AccountToManyLoanFilter>;
  /** Some related `loansByBrokerId` exist. */
  loansByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpCollateralBalanceChangesByLiquidityProviderId` relation. */
  lpCollateralBalanceChangesByLiquidityProviderId?: InputMaybe<AccountToManyLpCollateralBalanceChangeFilter>;
  /** Some related `lpCollateralBalanceChangesByLiquidityProviderId` exist. */
  lpCollateralBalanceChangesByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpFlipAirdropDistributionEventsByLiquidityProviderId` relation. */
  lpFlipAirdropDistributionEventsByLiquidityProviderId?: InputMaybe<AccountToManyLpFlipAirdropDistributionEventFilter>;
  /** Some related `lpFlipAirdropDistributionEventsByLiquidityProviderId` exist. */
  lpFlipAirdropDistributionEventsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpLendingPoolSnapshotsByLiquidityProviderId` relation. */
  lpLendingPoolSnapshotsByLiquidityProviderId?: InputMaybe<AccountToManyLpLendingPoolSnapshotFilter>;
  /** Some related `lpLendingPoolSnapshotsByLiquidityProviderId` exist. */
  lpLendingPoolSnapshotsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpPointDistributionEventsByLiquidityProviderId` relation. */
  lpPointDistributionEventsByLiquidityProviderId?: InputMaybe<AccountToManyLpPointDistributionEventFilter>;
  /** Some related `lpPointDistributionEventsByLiquidityProviderId` exist. */
  lpPointDistributionEventsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<AccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `pendingBoostLiquidityWithdrawalsByLiquidityProviderId` relation. */
  pendingBoostLiquidityWithdrawalsByLiquidityProviderId?: InputMaybe<AccountToManyPendingBoostLiquidityWithdrawalFilter>;
  /** Some related `pendingBoostLiquidityWithdrawalsByLiquidityProviderId` exist. */
  pendingBoostLiquidityWithdrawalsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `poolOrdersByLiquidityProviderId` relation. */
  poolOrdersByLiquidityProviderId?: InputMaybe<AccountToManyPoolOrderFilter>;
  /** Some related `poolOrdersByLiquidityProviderId` exist. */
  poolOrdersByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rangeOrderFillsByLiquidityProviderId` relation. */
  rangeOrderFillsByLiquidityProviderId?: InputMaybe<AccountToManyRangeOrderFillFilter>;
  /** Some related `rangeOrderFillsByLiquidityProviderId` exist. */
  rangeOrderFillsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tradingStrategiesByOwnerAccountId` relation. */
  tradingStrategiesByOwnerAccountId?: InputMaybe<AccountToManyTradingStrategyFilter>;
  /** Some related `tradingStrategiesByOwnerAccountId` exist. */
  tradingStrategiesByOwnerAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tradingStrategyByStrategyAccountId` relation. */
  tradingStrategyByStrategyAccountId?: InputMaybe<TradingStrategyFilter>;
  /** A related `tradingStrategyByStrategyAccountId` exists. */
  tradingStrategyByStrategyAccountIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AccountTypeFilter>;
};

/** Grouping methods for `Account` for usage during aggregation. */
export type AccountGroupBy =
  | 'TYPE';

export type AccountHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Account` aggregates. */
export type AccountHavingInput = {
  AND?: InputMaybe<Array<AccountHavingInput>>;
  OR?: InputMaybe<Array<AccountHavingInput>>;
  average?: InputMaybe<AccountHavingAverageInput>;
  distinctCount?: InputMaybe<AccountHavingDistinctCountInput>;
  max?: InputMaybe<AccountHavingMaxInput>;
  min?: InputMaybe<AccountHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountHavingStddevSampleInput>;
  sum?: InputMaybe<AccountHavingSumInput>;
  variancePopulation?: InputMaybe<AccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountHavingVarianceSampleInput>;
};

export type AccountHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountMaxAggregates = {
  __typename?: 'AccountMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountMinAggregates = {
  __typename?: 'AccountMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountStddevPopulationAggregates = {
  __typename?: 'AccountStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStddevSampleAggregates = {
  __typename?: 'AccountStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountSumAggregates = {
  __typename?: 'AccountSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `BoostLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyBoostLiquidityBalanceChangeFilter = {
  /** Aggregates across related `BoostLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<BoostLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** No related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** Some related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `BoostShare` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyBoostShareFilter = {
  /** Aggregates across related `BoostShare` match the filter criteria. */
  aggregates?: InputMaybe<BoostShareAggregatesFilter>;
  /** Every related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostShareFilter>;
  /** No related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostShareFilter>;
  /** Some related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostShareFilter>;
};

/** A filter to be used against many `DepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyDepositChannelFilter = {
  /** Aggregates across related `DepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<DepositChannelAggregatesFilter>;
  /** Every related `DepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepositChannelFilter>;
  /** No related `DepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepositChannelFilter>;
  /** Some related `DepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepositChannelFilter>;
};

/** A filter to be used against many `LendingLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLendingLiquidityBalanceChangeFilter = {
  /** Aggregates across related `LendingLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LendingLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** No related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Some related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `LimitOrderFill` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLimitOrderFillFilter = {
  /** Aggregates across related `LimitOrderFill` match the filter criteria. */
  aggregates?: InputMaybe<LimitOrderFillAggregatesFilter>;
  /** Every related `LimitOrderFill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LimitOrderFillFilter>;
  /** No related `LimitOrderFill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LimitOrderFillFilter>;
  /** Some related `LimitOrderFill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LimitOrderFillFilter>;
};

/** A filter to be used against many `LiquidityProviderBoostPoolSummary` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLiquidityProviderBoostPoolSummaryFilter = {
  /** Aggregates across related `LiquidityProviderBoostPoolSummary` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityProviderBoostPoolSummaryAggregatesFilter>;
  /** Every related `LiquidityProviderBoostPoolSummary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  /** No related `LiquidityProviderBoostPoolSummary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  /** Some related `LiquidityProviderBoostPoolSummary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
};

/** A filter to be used against many `LiquiditySnapshot` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLiquiditySnapshotFilter = {
  /** Aggregates across related `LiquiditySnapshot` match the filter criteria. */
  aggregates?: InputMaybe<LiquiditySnapshotAggregatesFilter>;
  /** Every related `LiquiditySnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquiditySnapshotFilter>;
  /** No related `LiquiditySnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquiditySnapshotFilter>;
  /** Some related `LiquiditySnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquiditySnapshotFilter>;
};

/** A filter to be used against many `Loan` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLoanFilter = {
  /** Aggregates across related `Loan` match the filter criteria. */
  aggregates?: InputMaybe<LoanAggregatesFilter>;
  /** Every related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFilter>;
  /** No related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFilter>;
  /** Some related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFilter>;
};

/** A filter to be used against many `LpCollateralBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLpCollateralBalanceChangeFilter = {
  /** Aggregates across related `LpCollateralBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LpCollateralBalanceChangeAggregatesFilter>;
  /** Every related `LpCollateralBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpCollateralBalanceChangeFilter>;
  /** No related `LpCollateralBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpCollateralBalanceChangeFilter>;
  /** Some related `LpCollateralBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpCollateralBalanceChangeFilter>;
};

/** A filter to be used against many `LpFlipAirdropDistributionEvent` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLpFlipAirdropDistributionEventFilter = {
  /** Aggregates across related `LpFlipAirdropDistributionEvent` match the filter criteria. */
  aggregates?: InputMaybe<LpFlipAirdropDistributionEventAggregatesFilter>;
  /** Every related `LpFlipAirdropDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  /** No related `LpFlipAirdropDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  /** Some related `LpFlipAirdropDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
};

/** A filter to be used against many `LpLendingPoolSnapshot` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLpLendingPoolSnapshotFilter = {
  /** Aggregates across related `LpLendingPoolSnapshot` match the filter criteria. */
  aggregates?: InputMaybe<LpLendingPoolSnapshotAggregatesFilter>;
  /** Every related `LpLendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpLendingPoolSnapshotFilter>;
  /** No related `LpLendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpLendingPoolSnapshotFilter>;
  /** Some related `LpLendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpLendingPoolSnapshotFilter>;
};

/** A filter to be used against many `LpPointDistributionEvent` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLpPointDistributionEventFilter = {
  /** Aggregates across related `LpPointDistributionEvent` match the filter criteria. */
  aggregates?: InputMaybe<LpPointDistributionEventAggregatesFilter>;
  /** Every related `LpPointDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpPointDistributionEventFilter>;
  /** No related `LpPointDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpPointDistributionEventFilter>;
  /** Some related `LpPointDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpPointDistributionEventFilter>;
};

/** A filter to be used against many `PendingBoostLiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyPendingBoostLiquidityWithdrawalFilter = {
  /** Aggregates across related `PendingBoostLiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<PendingBoostLiquidityWithdrawalAggregatesFilter>;
  /** Every related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** No related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** Some related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
};

/** A filter to be used against many `PoolOrder` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyPoolOrderFilter = {
  /** Aggregates across related `PoolOrder` match the filter criteria. */
  aggregates?: InputMaybe<PoolOrderAggregatesFilter>;
  /** Every related `PoolOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PoolOrderFilter>;
  /** No related `PoolOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PoolOrderFilter>;
  /** Some related `PoolOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PoolOrderFilter>;
};

/** A filter to be used against many `RangeOrderFill` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyRangeOrderFillFilter = {
  /** Aggregates across related `RangeOrderFill` match the filter criteria. */
  aggregates?: InputMaybe<RangeOrderFillAggregatesFilter>;
  /** Every related `RangeOrderFill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RangeOrderFillFilter>;
  /** No related `RangeOrderFill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RangeOrderFillFilter>;
  /** Some related `RangeOrderFill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RangeOrderFillFilter>;
};

/** A filter to be used against many `TradingStrategy` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyTradingStrategyFilter = {
  /** Aggregates across related `TradingStrategy` match the filter criteria. */
  aggregates?: InputMaybe<TradingStrategyAggregatesFilter>;
  /** Every related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingStrategyFilter>;
  /** No related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingStrategyFilter>;
  /** Some related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingStrategyFilter>;
};

export type AccountType =
  | 'BROKER'
  | 'LIQUIDITY_PROVIDER'
  | 'OPERATOR'
  | 'TRADING_STRATEGY'
  | 'UNREGISTERED'
  | 'VALIDATOR';

/** A filter to be used against AccountType fields. All fields are combined with a logical ‘and.’ */
export type AccountTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AccountType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AccountType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AccountType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AccountType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AccountType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AccountType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AccountType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AccountType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AccountType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AccountType>>;
};

export type AccountVariancePopulationAggregates = {
  __typename?: 'AccountVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountVarianceSampleAggregates = {
  __typename?: 'AccountVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountAggregates>;
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountAggregates>>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Account` values. */
export type AccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountGroupBy>;
  having?: InputMaybe<AccountHavingInput>;
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export type AccountsOrderBy =
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOST_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOST_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_COUNT_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_COUNT_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ADDRESS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ADDRESS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ADDRESS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ADDRESS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_IS_POSITION_OPENING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_IS_POSITION_OPENING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_TIMESTAMP_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_TIMESTAMP_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_TIMESTAMP_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_TIMESTAMP_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_TIMESTAMP_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_TIMESTAMP_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TICK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEES_EARNED_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEES_EARNED_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEES_EARNED_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEES_EARNED_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORIGINAL_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORIGINAL_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SELL_AMOUNT_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SELL_AMOUNT_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SELL_AMOUNT_VALUE_USD_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SELL_AMOUNT_VALUE_USD_DESC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TICK_ASC'
  | 'LIMIT_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TICK_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_COLLATERAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_COLLATERAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_DEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_DEPLOYED_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STAKING_BALANCE_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STAKING_BALANCE_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STAKING_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STAKING_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STRATEGY_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STRATEGY_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TOTAL_BALANCE_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TOTAL_BALANCE_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TOTAL_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TOTAL_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'LIQUIDITY_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_UNDEPLOYED_LIQUIDITY_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_COUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_COUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_IS_LIQUIDATED_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_IS_LIQUIDATED_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BORROWER_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_COUNT_ASC'
  | 'LOANS_BY_BROKER_ID_COUNT_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_IS_LIQUIDATED_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_IS_LIQUIDATED_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BROKER_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LP_SS58_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LP_SS58_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_POINT_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_HOUR_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_HOUR_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_HOUR_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_HOUR_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_HOUR_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_HOUR_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_SUM_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_USD_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LP_SS58_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LP_SS58_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'NATURAL'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FINALIZED_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FINALIZED_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOST_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOST_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_CREATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_CREATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_TYPE_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_TYPE_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STATUS_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_STATUS_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_CREATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_CREATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MAX_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_CREATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_CREATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_MIN_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_SUM_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_UPPER_TICK_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_TIMESTAMP_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_TIMESTAMP_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_TIMESTAMP_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_TIMESTAMP_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MAX_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_TIMESTAMP_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_TIMESTAMP_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_MIN_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_SUM_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_RANGE_START_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FEES_EARNED_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FEES_EARNED_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FILLED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FILLED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_RECEIVED_AMOUNT_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_RECEIVED_AMOUNT_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_RANGE_END_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_RANGE_END_TICK_DESC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_RANGE_START_TICK_ASC'
  | 'RANGE_ORDER_FILLS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_RANGE_START_TICK_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_AVERAGE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_COUNT_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_COUNT_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_KEY_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_KEY_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MAX_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_MIN_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_POPULATION_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_STDDEV_SAMPLE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_SUM_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_POPULATION_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_OWNER_ACCOUNT_ID_VARIANCE_SAMPLE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type Boost = Node & {
  __typename?: 'Boost';
  asset: ChainflipAsset;
  /** Reads and enables pagination through a set of `BoostLiquidityBalanceChange`. */
  boostLiquidityBalanceChangesByBoostId: BoostLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `BoostPoolBoostShare`. */
  boostPoolBoostSharesByBoostId: BoostPoolBoostSharesConnection;
  /** Reads and enables pagination through a set of `BoostShare`. */
  boostSharesByBoostId: BoostSharesConnection;
  chain: ChainflipChain;
  depositAmount: Scalars['BigFloat']['output'];
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `DepositChannel` that is related to this `Boost`. */
  depositChannelByDepositChannelId: DepositChannel;
  depositChannelId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `Boost`. */
  eventByExecutedAtEventId: Event;
  /** Reads a single `Event` that is related to this `Boost`. */
  eventByLostAtEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `Boost`. */
  eventBySettledAtEventId?: Maybe<Event>;
  executedAtEventId: Scalars['BigInt']['output'];
  executedAtTimestamp: Scalars['Datetime']['output'];
  fee: Scalars['BigFloat']['output'];
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['Int']['output'];
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `Loan`. */
  loansByBoostId: LoansConnection;
  lostAtEventId?: Maybe<Scalars['BigInt']['output']>;
  lostAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  networkFeeSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `PendingBoostLiquidityWithdrawal`. */
  pendingBoostLiquidityWithdrawalsByBoostId: PendingBoostLiquidityWithdrawalsConnection;
  prewitnessedDepositId: Scalars['BigInt']['output'];
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
  settledAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  swapId?: Maybe<Scalars['BigInt']['output']>;
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};


export type BoostBoostLiquidityBalanceChangesByBoostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostLiquidityBalanceChangesOrderBy>>;
};


export type BoostBoostPoolBoostSharesByBoostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolBoostShareCondition>;
  filter?: InputMaybe<BoostPoolBoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolBoostSharesOrderBy>>;
};


export type BoostBoostSharesByBoostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostShareCondition>;
  filter?: InputMaybe<BoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSharesOrderBy>>;
};


export type BoostLoansByBoostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type BoostPendingBoostLiquidityWithdrawalsByBoostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PendingBoostLiquidityWithdrawalCondition>;
  filter?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PendingBoostLiquidityWithdrawalsOrderBy>>;
};

export type BoostAggregates = {
  __typename?: 'BoostAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Boost` object types. */
export type BoostAggregatesFilter = {
  /** Mean average aggregate over matching `Boost` objects. */
  average?: InputMaybe<BoostAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Boost` objects. */
  distinctCount?: InputMaybe<BoostDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Boost` object to be included within the aggregate. */
  filter?: InputMaybe<BoostFilter>;
  /** Maximum aggregate over matching `Boost` objects. */
  max?: InputMaybe<BoostMaxAggregateFilter>;
  /** Minimum aggregate over matching `Boost` objects. */
  min?: InputMaybe<BoostMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Boost` objects. */
  stddevPopulation?: InputMaybe<BoostStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Boost` objects. */
  stddevSample?: InputMaybe<BoostStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Boost` objects. */
  sum?: InputMaybe<BoostSumAggregateFilter>;
  /** Population variance aggregate over matching `Boost` objects. */
  variancePopulation?: InputMaybe<BoostVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Boost` objects. */
  varianceSample?: InputMaybe<BoostVarianceSampleAggregateFilter>;
};

export type BoostAverageAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  executedAtEventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type BoostAverageAggregates = {
  __typename?: 'BoostAverageAggregates';
  /** Mean average of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Boost` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BoostCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `depositAmount` field. */
  depositAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `depositAmountUsd` field. */
  depositAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  depositChannelByDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `depositChannelId` field. */
  depositChannelId?: InputMaybe<Scalars['Int']['input']>;
  eventByExecutedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByLostAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventBySettledAtEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `executedAtEventId` field. */
  executedAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `executedAtTimestamp` field. */
  executedAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderFeePortion` field. */
  liquidityProviderFeePortion?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidityProviderFeePortionUsd` field. */
  liquidityProviderFeePortionUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lostAtEventId` field. */
  lostAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lostAtTimestamp` field. */
  lostAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `networkFeePortion` field. */
  networkFeePortion?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `networkFeePortionUsd` field. */
  networkFeePortionUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `networkFeeSwapRequestId` field. */
  networkFeeSwapRequestId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `settledAtEventId` field. */
  settledAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `settledAtTimestamp` field. */
  settledAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `swapId` field. */
  swapId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BoostDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  depositAmount?: InputMaybe<BigIntFilter>;
  depositAmountUsd?: InputMaybe<BigIntFilter>;
  depositChannelId?: InputMaybe<BigIntFilter>;
  executedAtEventId?: InputMaybe<BigIntFilter>;
  executedAtTimestamp?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  feeUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigIntFilter>;
  lostAtEventId?: InputMaybe<BigIntFilter>;
  lostAtTimestamp?: InputMaybe<BigIntFilter>;
  networkFeePortion?: InputMaybe<BigIntFilter>;
  networkFeePortionUsd?: InputMaybe<BigIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  settledAtEventId?: InputMaybe<BigIntFilter>;
  settledAtTimestamp?: InputMaybe<BigIntFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type BoostDistinctCountAggregates = {
  __typename?: 'BoostDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lostAtTimestamp across the matching connection */
  lostAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of settledAtTimestamp across the matching connection */
  settledAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Boost` object types. All fields are combined with a logical ‘and.’ */
export type BoostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `boostLiquidityBalanceChangesByBoostId` relation. */
  boostLiquidityBalanceChangesByBoostId?: InputMaybe<BoostToManyBoostLiquidityBalanceChangeFilter>;
  /** Some related `boostLiquidityBalanceChangesByBoostId` exist. */
  boostLiquidityBalanceChangesByBoostIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostPoolBoostSharesByBoostId` relation. */
  boostPoolBoostSharesByBoostId?: InputMaybe<BoostToManyBoostPoolBoostShareFilter>;
  /** Some related `boostPoolBoostSharesByBoostId` exist. */
  boostPoolBoostSharesByBoostIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostSharesByBoostId` relation. */
  boostSharesByBoostId?: InputMaybe<BoostToManyBoostShareFilter>;
  /** Some related `boostSharesByBoostId` exist. */
  boostSharesByBoostIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `depositAmount` field. */
  depositAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `depositAmountUsd` field. */
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `depositChannelByDepositChannelId` relation. */
  depositChannelByDepositChannelId?: InputMaybe<DepositChannelFilter>;
  /** Filter by the object’s `depositChannelId` field. */
  depositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByExecutedAtEventId` relation. */
  eventByExecutedAtEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventByLostAtEventId` relation. */
  eventByLostAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventByLostAtEventId` exists. */
  eventByLostAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventBySettledAtEventId` relation. */
  eventBySettledAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventBySettledAtEventId` exists. */
  eventBySettledAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `executedAtEventId` field. */
  executedAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `executedAtTimestamp` field. */
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderFeePortion` field. */
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidityProviderFeePortionUsd` field. */
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loansByBoostId` relation. */
  loansByBoostId?: InputMaybe<BoostToManyLoanFilter>;
  /** Some related `loansByBoostId` exist. */
  loansByBoostIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lostAtEventId` field. */
  lostAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lostAtTimestamp` field. */
  lostAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `networkFeePortion` field. */
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `networkFeePortionUsd` field. */
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `networkFeeSwapRequestId` field. */
  networkFeeSwapRequestId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostFilter>>;
  /** Filter by the object’s `pendingBoostLiquidityWithdrawalsByBoostId` relation. */
  pendingBoostLiquidityWithdrawalsByBoostId?: InputMaybe<BoostToManyPendingBoostLiquidityWithdrawalFilter>;
  /** Some related `pendingBoostLiquidityWithdrawalsByBoostId` exist. */
  pendingBoostLiquidityWithdrawalsByBoostIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `settledAtEventId` field. */
  settledAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `settledAtTimestamp` field. */
  settledAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `swapId` field. */
  swapId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<BigIntFilter>;
};

/** Grouping methods for `Boost` for usage during aggregation. */
export type BoostGroupBy =
  | 'ASSET'
  | 'CHAIN'
  | 'DEPOSIT_AMOUNT'
  | 'DEPOSIT_AMOUNT_USD'
  | 'DEPOSIT_CHANNEL_ID'
  | 'EXECUTED_AT_EVENT_ID'
  | 'EXECUTED_AT_TIMESTAMP'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'FEE'
  | 'FEE_USD'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_USD'
  | 'LOST_AT_EVENT_ID'
  | 'LOST_AT_TIMESTAMP'
  | 'LOST_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'LOST_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'LOST_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'LOST_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'NETWORK_FEE_PORTION'
  | 'NETWORK_FEE_PORTION_USD'
  | 'NETWORK_FEE_SWAP_REQUEST_ID'
  | 'PREWITNESSED_DEPOSIT_ID'
  | 'SETTLED_AT_EVENT_ID'
  | 'SETTLED_AT_TIMESTAMP'
  | 'SETTLED_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'SETTLED_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'SETTLED_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'SETTLED_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'SWAP_ID'
  | 'SWAP_REQUEST_ID';

export type BoostHavingAverageInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingDistinctCountInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `Boost` aggregates. */
export type BoostHavingInput = {
  AND?: InputMaybe<Array<BoostHavingInput>>;
  OR?: InputMaybe<Array<BoostHavingInput>>;
  average?: InputMaybe<BoostHavingAverageInput>;
  distinctCount?: InputMaybe<BoostHavingDistinctCountInput>;
  max?: InputMaybe<BoostHavingMaxInput>;
  min?: InputMaybe<BoostHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostHavingStddevSampleInput>;
  sum?: InputMaybe<BoostHavingSumInput>;
  variancePopulation?: InputMaybe<BoostHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostHavingVarianceSampleInput>;
};

export type BoostHavingMaxInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingMinInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingStddevPopulationInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingStddevSampleInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingSumInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingVariancePopulationInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostHavingVarianceSampleInput = {
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  executedAtEventId?: InputMaybe<HavingBigintFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  lostAtEventId?: InputMaybe<HavingBigintFilter>;
  lostAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingBigintFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
  settledAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type BoostLiquidityBalanceChange = Node & {
  __typename?: 'BoostLiquidityBalanceChange';
  /** Reads a single `Account` that is related to this `BoostLiquidityBalanceChange`. */
  accountByLiquidityProviderId: Account;
  amount: Scalars['BigFloat']['output'];
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Boost` that is related to this `BoostLiquidityBalanceChange`. */
  boostByBoostId?: Maybe<Boost>;
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `BoostPool` that is related to this `BoostLiquidityBalanceChange`. */
  boostPoolByBoostPoolId: BoostPool;
  boostPoolId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `BoostLiquidityBalanceChange`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: BoostPoolBalanceChangeType;
};

export type BoostLiquidityBalanceChangeAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostLiquidityBalanceChangeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostLiquidityBalanceChangeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostLiquidityBalanceChangeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostLiquidityBalanceChangeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostLiquidityBalanceChangeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostLiquidityBalanceChangeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostLiquidityBalanceChangeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostLiquidityBalanceChangeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostLiquidityBalanceChangeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostLiquidityBalanceChange` object types. */
export type BoostLiquidityBalanceChangeAggregatesFilter = {
  /** Mean average aggregate over matching `BoostLiquidityBalanceChange` objects. */
  average?: InputMaybe<BoostLiquidityBalanceChangeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostLiquidityBalanceChange` objects. */
  distinctCount?: InputMaybe<BoostLiquidityBalanceChangeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostLiquidityBalanceChange` object to be included within the aggregate. */
  filter?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** Maximum aggregate over matching `BoostLiquidityBalanceChange` objects. */
  max?: InputMaybe<BoostLiquidityBalanceChangeMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostLiquidityBalanceChange` objects. */
  min?: InputMaybe<BoostLiquidityBalanceChangeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostLiquidityBalanceChange` objects. */
  stddevPopulation?: InputMaybe<BoostLiquidityBalanceChangeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostLiquidityBalanceChange` objects. */
  stddevSample?: InputMaybe<BoostLiquidityBalanceChangeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostLiquidityBalanceChange` objects. */
  sum?: InputMaybe<BoostLiquidityBalanceChangeSumAggregateFilter>;
  /** Population variance aggregate over matching `BoostLiquidityBalanceChange` objects. */
  variancePopulation?: InputMaybe<BoostLiquidityBalanceChangeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostLiquidityBalanceChange` objects. */
  varianceSample?: InputMaybe<BoostLiquidityBalanceChangeVarianceSampleAggregateFilter>;
};

export type BoostLiquidityBalanceChangeAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostLiquidityBalanceChangeAverageAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostLiquidityBalanceChange` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BoostLiquidityBalanceChangeCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  boostByBoostId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostId` field. */
  boostId?: InputMaybe<Scalars['Int']['input']>;
  boostPoolByBoostPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<BoostPoolBalanceChangeType>;
};

export type BoostLiquidityBalanceChangeDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type BoostLiquidityBalanceChangeDistinctCountAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type BoostLiquidityBalanceChangeFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostLiquidityBalanceChangeFilter>>;
  /** Filter by the object’s `boostByBoostId` relation. */
  boostByBoostId?: InputMaybe<BoostFilter>;
  /** A related `boostByBoostId` exists. */
  boostByBoostIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostId` field. */
  boostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostPoolByBoostPoolId` relation. */
  boostPoolByBoostPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostLiquidityBalanceChangeFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<BoostPoolBalanceChangeTypeFilter>;
};

/** Grouping methods for `BoostLiquidityBalanceChange` for usage during aggregation. */
export type BoostLiquidityBalanceChangeGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'BOOST_ID'
  | 'BOOST_POOL_ID'
  | 'EVENT_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'TYPE';

export type BoostLiquidityBalanceChangeHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BoostLiquidityBalanceChange` aggregates. */
export type BoostLiquidityBalanceChangeHavingInput = {
  AND?: InputMaybe<Array<BoostLiquidityBalanceChangeHavingInput>>;
  OR?: InputMaybe<Array<BoostLiquidityBalanceChangeHavingInput>>;
  average?: InputMaybe<BoostLiquidityBalanceChangeHavingAverageInput>;
  distinctCount?: InputMaybe<BoostLiquidityBalanceChangeHavingDistinctCountInput>;
  max?: InputMaybe<BoostLiquidityBalanceChangeHavingMaxInput>;
  min?: InputMaybe<BoostLiquidityBalanceChangeHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostLiquidityBalanceChangeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostLiquidityBalanceChangeHavingStddevSampleInput>;
  sum?: InputMaybe<BoostLiquidityBalanceChangeHavingSumInput>;
  variancePopulation?: InputMaybe<BoostLiquidityBalanceChangeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostLiquidityBalanceChangeHavingVarianceSampleInput>;
};

export type BoostLiquidityBalanceChangeHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostLiquidityBalanceChangeMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type BoostLiquidityBalanceChangeMaxAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type BoostLiquidityBalanceChangeMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type BoostLiquidityBalanceChangeMinAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type BoostLiquidityBalanceChangeStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostLiquidityBalanceChangeStddevPopulationAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostLiquidityBalanceChangeStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostLiquidityBalanceChangeStddevSampleAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostLiquidityBalanceChangeSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
};

export type BoostLiquidityBalanceChangeSumAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of boostId across the matching connection */
  boostId: Scalars['BigInt']['output'];
  /** Sum of boostPoolId across the matching connection */
  boostPoolId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
};

export type BoostLiquidityBalanceChangeVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostLiquidityBalanceChangeVariancePopulationAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostLiquidityBalanceChangeVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostLiquidityBalanceChangeVarianceSampleAggregates = {
  __typename?: 'BoostLiquidityBalanceChangeVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostLiquidityBalanceChange` values. */
export type BoostLiquidityBalanceChangesConnection = {
  __typename?: 'BoostLiquidityBalanceChangesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostLiquidityBalanceChangeAggregates>;
  /** A list of edges which contains the `BoostLiquidityBalanceChange` and cursor to aid in pagination. */
  edges: Array<BoostLiquidityBalanceChangesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostLiquidityBalanceChangeAggregates>>;
  /** A list of `BoostLiquidityBalanceChange` objects. */
  nodes: Array<BoostLiquidityBalanceChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostLiquidityBalanceChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostLiquidityBalanceChange` values. */
export type BoostLiquidityBalanceChangesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostLiquidityBalanceChangeGroupBy>;
  having?: InputMaybe<BoostLiquidityBalanceChangeHavingInput>;
};

/** A `BoostLiquidityBalanceChange` edge in the connection. */
export type BoostLiquidityBalanceChangesEdge = {
  __typename?: 'BoostLiquidityBalanceChangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostLiquidityBalanceChange` at the end of the edge. */
  node: BoostLiquidityBalanceChange;
};

/** Methods to use when ordering `BoostLiquidityBalanceChange`. */
export type BoostLiquidityBalanceChangesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'BOOST_ID_ASC'
  | 'BOOST_ID_DESC'
  | 'BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type BoostMaxAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<IntFilter>;
  executedAtEventId?: InputMaybe<BigIntFilter>;
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigIntFilter>;
  lostAtTimestamp?: InputMaybe<DatetimeFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  settledAtEventId?: InputMaybe<BigIntFilter>;
  settledAtTimestamp?: InputMaybe<DatetimeFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type BoostMaxAggregates = {
  __typename?: 'BoostMaxAggregates';
  /** Maximum of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of lostAtTimestamp across the matching connection */
  lostAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of settledAtTimestamp across the matching connection */
  settledAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

export type BoostMinAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<IntFilter>;
  executedAtEventId?: InputMaybe<BigIntFilter>;
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigIntFilter>;
  lostAtTimestamp?: InputMaybe<DatetimeFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  settledAtEventId?: InputMaybe<BigIntFilter>;
  settledAtTimestamp?: InputMaybe<DatetimeFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type BoostMinAggregates = {
  __typename?: 'BoostMinAggregates';
  /** Minimum of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of lostAtTimestamp across the matching connection */
  lostAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of settledAtTimestamp across the matching connection */
  settledAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

export type BoostPool = Node & {
  __typename?: 'BoostPool';
  asset: ChainflipAsset;
  /** Reads and enables pagination through a set of `BoostLiquidityBalanceChange`. */
  boostLiquidityBalanceChangesByBoostPoolId: BoostLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `BoostPoolApy`. */
  boostPoolApiesByBoostPoolId: BoostPoolApiesConnection;
  /** Reads and enables pagination through a set of `BoostPoolBoostShare`. */
  boostPoolBoostSharesByBoostPoolId: BoostPoolBoostSharesConnection;
  /** Reads and enables pagination through a set of `BoostPoolLiquidity`. */
  boostPoolLiquiditiesByBoostPoolId: BoostPoolLiquiditiesConnection;
  /** Reads and enables pagination through a set of `BoostShare`. */
  boostSharesByBoostPoolId: BoostSharesConnection;
  feeTierPips: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `LiquidityProviderBoostPoolSummary`. */
  liquidityProviderBoostPoolSummariesByBoostPoolId: LiquidityProviderBoostPoolSummariesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type BoostPoolBoostLiquidityBalanceChangesByBoostPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostLiquidityBalanceChangesOrderBy>>;
};


export type BoostPoolBoostPoolApiesByBoostPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolApyCondition>;
  filter?: InputMaybe<BoostPoolApyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolApiesOrderBy>>;
};


export type BoostPoolBoostPoolBoostSharesByBoostPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolBoostShareCondition>;
  filter?: InputMaybe<BoostPoolBoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolBoostSharesOrderBy>>;
};


export type BoostPoolBoostPoolLiquiditiesByBoostPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolLiquidityCondition>;
  filter?: InputMaybe<BoostPoolLiquidityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolLiquiditiesOrderBy>>;
};


export type BoostPoolBoostSharesByBoostPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostShareCondition>;
  filter?: InputMaybe<BoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSharesOrderBy>>;
};


export type BoostPoolLiquidityProviderBoostPoolSummariesByBoostPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityProviderBoostPoolSummaryCondition>;
  filter?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityProviderBoostPoolSummariesOrderBy>>;
};

export type BoostPoolAggregates = {
  __typename?: 'BoostPoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostPoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostPoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostPoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostPoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostPoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostPoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostPoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostPoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostPoolVarianceSampleAggregates>;
};

/** A connection to a list of `BoostPoolApy` values. */
export type BoostPoolApiesConnection = {
  __typename?: 'BoostPoolApiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostPoolApyAggregates>;
  /** A list of edges which contains the `BoostPoolApy` and cursor to aid in pagination. */
  edges: Array<BoostPoolApiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostPoolApyAggregates>>;
  /** A list of `BoostPoolApy` objects. */
  nodes: Array<BoostPoolApy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostPoolApy` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostPoolApy` values. */
export type BoostPoolApiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostPoolApyGroupBy>;
  having?: InputMaybe<BoostPoolApyHavingInput>;
};

/** A `BoostPoolApy` edge in the connection. */
export type BoostPoolApiesEdge = {
  __typename?: 'BoostPoolApiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostPoolApy` at the end of the edge. */
  node: BoostPoolApy;
};

/** Methods to use when ordering `BoostPoolApy`. */
export type BoostPoolApiesOrderBy =
  | 'AVG_LIQUIDITY_ASC'
  | 'AVG_LIQUIDITY_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_ID_DESC'
  | 'FEES_EARNED_ASC'
  | 'FEES_EARNED_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTERVAL_ASC'
  | 'INTERVAL_DESC'
  | 'LOSSES_ASC'
  | 'LOSSES_DESC'
  | 'MAX_LIQUIDITY_ASC'
  | 'MAX_LIQUIDITY_DESC'
  | 'MIN_LIQUIDITY_ASC'
  | 'MIN_LIQUIDITY_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECTED_APY6H_ASC'
  | 'PROJECTED_APY6H_DESC'
  | 'PROJECTED_APY24H_ASC'
  | 'PROJECTED_APY24H_DESC'
  | 'PROJECTED_APY72H_ASC'
  | 'PROJECTED_APY72H_DESC'
  | 'PROJECTED_APY168H_ASC'
  | 'PROJECTED_APY168H_DESC'
  | 'PROJECTED_APY720H_ASC'
  | 'PROJECTED_APY720H_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC';

export type BoostPoolApy = Node & {
  __typename?: 'BoostPoolApy';
  avgLiquidity: Scalars['BigFloat']['output'];
  block: Scalars['Int']['output'];
  /** Reads a single `BoostPool` that is related to this `BoostPoolApy`. */
  boostPoolByBoostPoolId: BoostPool;
  boostPoolId: Scalars['Int']['output'];
  feesEarned: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  interval: Scalars['Int']['output'];
  losses: Scalars['BigFloat']['output'];
  maxLiquidity: Scalars['BigFloat']['output'];
  minLiquidity: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  timestamp: Scalars['Datetime']['output'];
};

export type BoostPoolApyAggregates = {
  __typename?: 'BoostPoolApyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostPoolApyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostPoolApyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostPoolApyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostPoolApyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostPoolApyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostPoolApyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostPoolApySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostPoolApyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostPoolApyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostPoolApy` object types. */
export type BoostPoolApyAggregatesFilter = {
  /** Mean average aggregate over matching `BoostPoolApy` objects. */
  average?: InputMaybe<BoostPoolApyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostPoolApy` objects. */
  distinctCount?: InputMaybe<BoostPoolApyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostPoolApy` object to be included within the aggregate. */
  filter?: InputMaybe<BoostPoolApyFilter>;
  /** Maximum aggregate over matching `BoostPoolApy` objects. */
  max?: InputMaybe<BoostPoolApyMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostPoolApy` objects. */
  min?: InputMaybe<BoostPoolApyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostPoolApy` objects. */
  stddevPopulation?: InputMaybe<BoostPoolApyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostPoolApy` objects. */
  stddevSample?: InputMaybe<BoostPoolApyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostPoolApy` objects. */
  sum?: InputMaybe<BoostPoolApySumAggregateFilter>;
  /** Population variance aggregate over matching `BoostPoolApy` objects. */
  variancePopulation?: InputMaybe<BoostPoolApyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostPoolApy` objects. */
  varianceSample?: InputMaybe<BoostPoolApyVarianceSampleAggregateFilter>;
};

export type BoostPoolApyAverageAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolApyAverageAggregates = {
  __typename?: 'BoostPoolApyAverageAggregates';
  /** Mean average of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostPoolApy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BoostPoolApyCondition = {
  /** Checks for equality with the object’s `avgLiquidity` field. */
  avgLiquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  boostPoolByBoostPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `feesEarned` field. */
  feesEarned?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `losses` field. */
  losses?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxLiquidity` field. */
  maxLiquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minLiquidity` field. */
  minLiquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BoostPoolApyDistinctCountAggregateFilter = {
  avgLiquidity?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  feesEarned?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigIntFilter>;
  maxLiquidity?: InputMaybe<BigIntFilter>;
  minLiquidity?: InputMaybe<BigIntFilter>;
  projectedApy6H?: InputMaybe<BigIntFilter>;
  projectedApy24H?: InputMaybe<BigIntFilter>;
  projectedApy72H?: InputMaybe<BigIntFilter>;
  projectedApy168H?: InputMaybe<BigIntFilter>;
  projectedApy720H?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type BoostPoolApyDistinctCountAggregates = {
  __typename?: 'BoostPoolApyDistinctCountAggregates';
  /** Distinct count of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interval across the matching connection */
  interval?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losses across the matching connection */
  losses?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostPoolApy` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolApyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostPoolApyFilter>>;
  /** Filter by the object’s `avgLiquidity` field. */
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostPoolByBoostPoolId` relation. */
  boostPoolByBoostPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `feesEarned` field. */
  feesEarned?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interval` field. */
  interval?: InputMaybe<IntFilter>;
  /** Filter by the object’s `losses` field. */
  losses?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxLiquidity` field. */
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minLiquidity` field. */
  minLiquidity?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostPoolApyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostPoolApyFilter>>;
  /** Filter by the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BoostPoolApy` for usage during aggregation. */
export type BoostPoolApyGroupBy =
  | 'AVG_LIQUIDITY'
  | 'BLOCK'
  | 'BOOST_POOL_ID'
  | 'FEES_EARNED'
  | 'INTERVAL'
  | 'LOSSES'
  | 'MAX_LIQUIDITY'
  | 'MIN_LIQUIDITY'
  | 'PROJECTED_APY6H'
  | 'PROJECTED_APY24H'
  | 'PROJECTED_APY72H'
  | 'PROJECTED_APY168H'
  | 'PROJECTED_APY720H'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type BoostPoolApyHavingAverageInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingDistinctCountInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BoostPoolApy` aggregates. */
export type BoostPoolApyHavingInput = {
  AND?: InputMaybe<Array<BoostPoolApyHavingInput>>;
  OR?: InputMaybe<Array<BoostPoolApyHavingInput>>;
  average?: InputMaybe<BoostPoolApyHavingAverageInput>;
  distinctCount?: InputMaybe<BoostPoolApyHavingDistinctCountInput>;
  max?: InputMaybe<BoostPoolApyHavingMaxInput>;
  min?: InputMaybe<BoostPoolApyHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostPoolApyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostPoolApyHavingStddevSampleInput>;
  sum?: InputMaybe<BoostPoolApyHavingSumInput>;
  variancePopulation?: InputMaybe<BoostPoolApyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostPoolApyHavingVarianceSampleInput>;
};

export type BoostPoolApyHavingMaxInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingMinInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingStddevPopulationInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingStddevSampleInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingSumInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingVariancePopulationInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyHavingVarianceSampleInput = {
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type BoostPoolApyMaxAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  interval?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type BoostPoolApyMaxAggregates = {
  __typename?: 'BoostPoolApyMaxAggregates';
  /** Maximum of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Maximum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type BoostPoolApyMinAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  interval?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type BoostPoolApyMinAggregates = {
  __typename?: 'BoostPoolApyMinAggregates';
  /** Minimum of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Minimum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type BoostPoolApyStddevPopulationAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolApyStddevPopulationAggregates = {
  __typename?: 'BoostPoolApyStddevPopulationAggregates';
  /** Population standard deviation of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolApyStddevSampleAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolApyStddevSampleAggregates = {
  __typename?: 'BoostPoolApyStddevSampleAggregates';
  /** Sample standard deviation of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolApySumAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolApySumAggregates = {
  __typename?: 'BoostPoolApySumAggregates';
  /** Sum of avgLiquidity across the matching connection */
  avgLiquidity: Scalars['BigFloat']['output'];
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of boostPoolId across the matching connection */
  boostPoolId: Scalars['BigInt']['output'];
  /** Sum of feesEarned across the matching connection */
  feesEarned: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of interval across the matching connection */
  interval: Scalars['BigInt']['output'];
  /** Sum of losses across the matching connection */
  losses: Scalars['BigFloat']['output'];
  /** Sum of maxLiquidity across the matching connection */
  maxLiquidity: Scalars['BigFloat']['output'];
  /** Sum of minLiquidity across the matching connection */
  minLiquidity: Scalars['BigFloat']['output'];
  /** Sum of projectedApy6H across the matching connection */
  projectedApy6H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy24H across the matching connection */
  projectedApy24H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy72H across the matching connection */
  projectedApy72H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy168H across the matching connection */
  projectedApy168H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy720H across the matching connection */
  projectedApy720H: Scalars['BigFloat']['output'];
};

export type BoostPoolApyVariancePopulationAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolApyVariancePopulationAggregates = {
  __typename?: 'BoostPoolApyVariancePopulationAggregates';
  /** Population variance of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolApyVarianceSampleAggregateFilter = {
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolApyVarianceSampleAggregates = {
  __typename?: 'BoostPoolApyVarianceSampleAggregates';
  /** Sample variance of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolAverageAggregates = {
  __typename?: 'BoostPoolAverageAggregates';
  /** Mean average of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolBalanceChangeType =
  | 'COLLECTED_FEES'
  | 'DELAYED_WITHDRAWAL'
  | 'FUNDS_ADDED'
  | 'FUNDS_LOST'
  | 'WITHDRAWAL';

/** A filter to be used against BoostPoolBalanceChangeType fields. All fields are combined with a logical ‘and.’ */
export type BoostPoolBalanceChangeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BoostPoolBalanceChangeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BoostPoolBalanceChangeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BoostPoolBalanceChangeType>>;
};

export type BoostPoolBoostShare = Node & {
  __typename?: 'BoostPoolBoostShare';
  amount: Scalars['BigFloat']['output'];
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Boost` that is related to this `BoostPoolBoostShare`. */
  boostByBoostId: Boost;
  boostId: Scalars['Int']['output'];
  /** Reads a single `BoostPool` that is related to this `BoostPoolBoostShare`. */
  boostPoolByBoostPoolId: BoostPool;
  boostPoolId: Scalars['Int']['output'];
  executedAtTimestamp: Scalars['Datetime']['output'];
  fee: Scalars['BigFloat']['output'];
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['BigInt']['output'];
  liquidityProviderFeePortion: Scalars['BigFloat']['output'];
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  lost: Scalars['Boolean']['output'];
  networkFeePortion: Scalars['BigFloat']['output'];
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type BoostPoolBoostShareAggregates = {
  __typename?: 'BoostPoolBoostShareAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostPoolBoostShareAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostPoolBoostShareDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostPoolBoostShareMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostPoolBoostShareMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostPoolBoostShareStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostPoolBoostShareStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostPoolBoostShareSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostPoolBoostShareVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostPoolBoostShareVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostPoolBoostShare` object types. */
export type BoostPoolBoostShareAggregatesFilter = {
  /** Mean average aggregate over matching `BoostPoolBoostShare` objects. */
  average?: InputMaybe<BoostPoolBoostShareAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostPoolBoostShare` objects. */
  distinctCount?: InputMaybe<BoostPoolBoostShareDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostPoolBoostShare` object to be included within the aggregate. */
  filter?: InputMaybe<BoostPoolBoostShareFilter>;
  /** Maximum aggregate over matching `BoostPoolBoostShare` objects. */
  max?: InputMaybe<BoostPoolBoostShareMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostPoolBoostShare` objects. */
  min?: InputMaybe<BoostPoolBoostShareMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostPoolBoostShare` objects. */
  stddevPopulation?: InputMaybe<BoostPoolBoostShareStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostPoolBoostShare` objects. */
  stddevSample?: InputMaybe<BoostPoolBoostShareStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostPoolBoostShare` objects. */
  sum?: InputMaybe<BoostPoolBoostShareSumAggregateFilter>;
  /** Population variance aggregate over matching `BoostPoolBoostShare` objects. */
  variancePopulation?: InputMaybe<BoostPoolBoostShareVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostPoolBoostShare` objects. */
  varianceSample?: InputMaybe<BoostPoolBoostShareVarianceSampleAggregateFilter>;
};

export type BoostPoolBoostShareAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareAverageAggregates = {
  __typename?: 'BoostPoolBoostShareAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostPoolBoostShare` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BoostPoolBoostShareCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  boostByBoostId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostId` field. */
  boostId?: InputMaybe<Scalars['Int']['input']>;
  boostPoolByBoostPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `executedAtTimestamp` field. */
  executedAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `liquidityProviderFeePortion` field. */
  liquidityProviderFeePortion?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidityProviderFeePortionUsd` field. */
  liquidityProviderFeePortionUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lost` field. */
  lost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `networkFeePortion` field. */
  networkFeePortion?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `networkFeePortionUsd` field. */
  networkFeePortionUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostPoolBoostShareDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  executedAtTimestamp?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  feeUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigIntFilter>;
  lost?: InputMaybe<BigIntFilter>;
  networkFeePortion?: InputMaybe<BigIntFilter>;
  networkFeePortionUsd?: InputMaybe<BigIntFilter>;
};

export type BoostPoolBoostShareDistinctCountAggregates = {
  __typename?: 'BoostPoolBoostShareDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lost across the matching connection */
  lost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostPoolBoostShare` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolBoostShareFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostPoolBoostShareFilter>>;
  /** Filter by the object’s `boostByBoostId` relation. */
  boostByBoostId?: InputMaybe<BoostFilter>;
  /** Filter by the object’s `boostId` field. */
  boostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostPoolByBoostPoolId` relation. */
  boostPoolByBoostPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `executedAtTimestamp` field. */
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityProviderFeePortion` field. */
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidityProviderFeePortionUsd` field. */
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lost` field. */
  lost?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `networkFeePortion` field. */
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `networkFeePortionUsd` field. */
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostPoolBoostShareFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostPoolBoostShareFilter>>;
};

/** Grouping methods for `BoostPoolBoostShare` for usage during aggregation. */
export type BoostPoolBoostShareGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'BOOST_ID'
  | 'BOOST_POOL_ID'
  | 'EXECUTED_AT_TIMESTAMP'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'FEE'
  | 'FEE_USD'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_USD'
  | 'LOST'
  | 'NETWORK_FEE_PORTION'
  | 'NETWORK_FEE_PORTION_USD';

export type BoostPoolBoostShareHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostPoolBoostShare` aggregates. */
export type BoostPoolBoostShareHavingInput = {
  AND?: InputMaybe<Array<BoostPoolBoostShareHavingInput>>;
  OR?: InputMaybe<Array<BoostPoolBoostShareHavingInput>>;
  average?: InputMaybe<BoostPoolBoostShareHavingAverageInput>;
  distinctCount?: InputMaybe<BoostPoolBoostShareHavingDistinctCountInput>;
  max?: InputMaybe<BoostPoolBoostShareHavingMaxInput>;
  min?: InputMaybe<BoostPoolBoostShareHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostPoolBoostShareHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostPoolBoostShareHavingStddevSampleInput>;
  sum?: InputMaybe<BoostPoolBoostShareHavingSumInput>;
  variancePopulation?: InputMaybe<BoostPoolBoostShareHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostPoolBoostShareHavingVarianceSampleInput>;
};

export type BoostPoolBoostShareHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderFeePortion?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortion?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolBoostShareMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareMaxAggregates = {
  __typename?: 'BoostPoolBoostShareMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolBoostShareMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareMinAggregates = {
  __typename?: 'BoostPoolBoostShareMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolBoostShareStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareStddevPopulationAggregates = {
  __typename?: 'BoostPoolBoostShareStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolBoostShareStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareStddevSampleAggregates = {
  __typename?: 'BoostPoolBoostShareStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolBoostShareSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareSumAggregates = {
  __typename?: 'BoostPoolBoostShareSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of boostId across the matching connection */
  boostId: Scalars['BigInt']['output'];
  /** Sum of boostPoolId across the matching connection */
  boostPoolId: Scalars['BigInt']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of feeUsd across the matching connection */
  feeUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd: Scalars['BigFloat']['output'];
  /** Sum of networkFeePortion across the matching connection */
  networkFeePortion: Scalars['BigFloat']['output'];
  /** Sum of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd: Scalars['BigFloat']['output'];
};

export type BoostPoolBoostShareVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareVariancePopulationAggregates = {
  __typename?: 'BoostPoolBoostShareVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolBoostShareVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolBoostShareVarianceSampleAggregates = {
  __typename?: 'BoostPoolBoostShareVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostPoolBoostShare` values. */
export type BoostPoolBoostSharesConnection = {
  __typename?: 'BoostPoolBoostSharesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostPoolBoostShareAggregates>;
  /** A list of edges which contains the `BoostPoolBoostShare` and cursor to aid in pagination. */
  edges: Array<BoostPoolBoostSharesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostPoolBoostShareAggregates>>;
  /** A list of `BoostPoolBoostShare` objects. */
  nodes: Array<BoostPoolBoostShare>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostPoolBoostShare` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostPoolBoostShare` values. */
export type BoostPoolBoostSharesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostPoolBoostShareGroupBy>;
  having?: InputMaybe<BoostPoolBoostShareHavingInput>;
};

/** A `BoostPoolBoostShare` edge in the connection. */
export type BoostPoolBoostSharesEdge = {
  __typename?: 'BoostPoolBoostSharesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostPoolBoostShare` at the end of the edge. */
  node: BoostPoolBoostShare;
};

/** Methods to use when ordering `BoostPoolBoostShare`. */
export type BoostPoolBoostSharesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'BOOST_ID_ASC'
  | 'BOOST_ID_DESC'
  | 'BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_ID_DESC'
  | 'EXECUTED_AT_TIMESTAMP_ASC'
  | 'EXECUTED_AT_TIMESTAMP_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'FEE_USD_ASC'
  | 'FEE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'LOST_ASC'
  | 'LOST_DESC'
  | 'NATURAL'
  | 'NETWORK_FEE_PORTION_ASC'
  | 'NETWORK_FEE_PORTION_DESC'
  | 'NETWORK_FEE_PORTION_USD_ASC'
  | 'NETWORK_FEE_PORTION_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/**
 * A condition to be used against `BoostPool` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BoostPoolCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `feeTierPips` field. */
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoostPoolDistinctCountAggregates = {
  __typename?: 'BoostPoolDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isActive across the matching connection */
  isActive?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostPool` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostPoolFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `boostLiquidityBalanceChangesByBoostPoolId` relation. */
  boostLiquidityBalanceChangesByBoostPoolId?: InputMaybe<BoostPoolToManyBoostLiquidityBalanceChangeFilter>;
  /** Some related `boostLiquidityBalanceChangesByBoostPoolId` exist. */
  boostLiquidityBalanceChangesByBoostPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostPoolApiesByBoostPoolId` relation. */
  boostPoolApiesByBoostPoolId?: InputMaybe<BoostPoolToManyBoostPoolApyFilter>;
  /** Some related `boostPoolApiesByBoostPoolId` exist. */
  boostPoolApiesByBoostPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostPoolBoostSharesByBoostPoolId` relation. */
  boostPoolBoostSharesByBoostPoolId?: InputMaybe<BoostPoolToManyBoostPoolBoostShareFilter>;
  /** Some related `boostPoolBoostSharesByBoostPoolId` exist. */
  boostPoolBoostSharesByBoostPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostPoolLiquiditiesByBoostPoolId` relation. */
  boostPoolLiquiditiesByBoostPoolId?: InputMaybe<BoostPoolToManyBoostPoolLiquidityFilter>;
  /** Some related `boostPoolLiquiditiesByBoostPoolId` exist. */
  boostPoolLiquiditiesByBoostPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostSharesByBoostPoolId` relation. */
  boostSharesByBoostPoolId?: InputMaybe<BoostPoolToManyBoostShareFilter>;
  /** Some related `boostSharesByBoostPoolId` exist. */
  boostSharesByBoostPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `feeTierPips` field. */
  feeTierPips?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `liquidityProviderBoostPoolSummariesByBoostPoolId` relation. */
  liquidityProviderBoostPoolSummariesByBoostPoolId?: InputMaybe<BoostPoolToManyLiquidityProviderBoostPoolSummaryFilter>;
  /** Some related `liquidityProviderBoostPoolSummariesByBoostPoolId` exist. */
  liquidityProviderBoostPoolSummariesByBoostPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<BoostPoolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostPoolFilter>>;
};

/** Grouping methods for `BoostPool` for usage during aggregation. */
export type BoostPoolGroupBy =
  | 'ASSET'
  | 'FEE_TIER_PIPS'
  | 'IS_ACTIVE';

export type BoostPoolHavingAverageInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingDistinctCountInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BoostPool` aggregates. */
export type BoostPoolHavingInput = {
  AND?: InputMaybe<Array<BoostPoolHavingInput>>;
  OR?: InputMaybe<Array<BoostPoolHavingInput>>;
  average?: InputMaybe<BoostPoolHavingAverageInput>;
  distinctCount?: InputMaybe<BoostPoolHavingDistinctCountInput>;
  max?: InputMaybe<BoostPoolHavingMaxInput>;
  min?: InputMaybe<BoostPoolHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostPoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostPoolHavingStddevSampleInput>;
  sum?: InputMaybe<BoostPoolHavingSumInput>;
  variancePopulation?: InputMaybe<BoostPoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostPoolHavingVarianceSampleInput>;
};

export type BoostPoolHavingMaxInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingMinInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingStddevPopulationInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingStddevSampleInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingSumInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingVariancePopulationInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostPoolHavingVarianceSampleInput = {
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** A connection to a list of `BoostPoolLiquidity` values. */
export type BoostPoolLiquiditiesConnection = {
  __typename?: 'BoostPoolLiquiditiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostPoolLiquidityAggregates>;
  /** A list of edges which contains the `BoostPoolLiquidity` and cursor to aid in pagination. */
  edges: Array<BoostPoolLiquiditiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostPoolLiquidityAggregates>>;
  /** A list of `BoostPoolLiquidity` objects. */
  nodes: Array<BoostPoolLiquidity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostPoolLiquidity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostPoolLiquidity` values. */
export type BoostPoolLiquiditiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostPoolLiquidityGroupBy>;
  having?: InputMaybe<BoostPoolLiquidityHavingInput>;
};

/** A `BoostPoolLiquidity` edge in the connection. */
export type BoostPoolLiquiditiesEdge = {
  __typename?: 'BoostPoolLiquiditiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostPoolLiquidity` at the end of the edge. */
  node: BoostPoolLiquidity;
};

/** Methods to use when ordering `BoostPoolLiquidity`. */
export type BoostPoolLiquiditiesOrderBy =
  | 'AVAILABLE_AMOUNT_ASC'
  | 'AVAILABLE_AMOUNT_DESC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TOTAL_AMOUNT_ASC'
  | 'TOTAL_AMOUNT_DESC'
  | 'TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'UNAVAILABLE_AMOUNT_ASC'
  | 'UNAVAILABLE_AMOUNT_DESC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_DESC';

export type BoostPoolLiquidity = Node & {
  __typename?: 'BoostPoolLiquidity';
  availableAmount: Scalars['BigFloat']['output'];
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  block: Scalars['Int']['output'];
  /** Reads a single `BoostPool` that is related to this `BoostPoolLiquidity`. */
  boostPoolByBoostPoolId: BoostPool;
  boostPoolId: Scalars['Int']['output'];
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  timestamp: Scalars['Datetime']['output'];
  totalAmount: Scalars['BigFloat']['output'];
  totalAmountValueUsd: Scalars['BigFloat']['output'];
  unavailableAmount: Scalars['BigFloat']['output'];
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

export type BoostPoolLiquidityAggregates = {
  __typename?: 'BoostPoolLiquidityAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostPoolLiquidityAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostPoolLiquidityDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostPoolLiquidityMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostPoolLiquidityMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostPoolLiquidityStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostPoolLiquidityStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostPoolLiquiditySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostPoolLiquidityVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostPoolLiquidityVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostPoolLiquidity` object types. */
export type BoostPoolLiquidityAggregatesFilter = {
  /** Mean average aggregate over matching `BoostPoolLiquidity` objects. */
  average?: InputMaybe<BoostPoolLiquidityAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostPoolLiquidity` objects. */
  distinctCount?: InputMaybe<BoostPoolLiquidityDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostPoolLiquidity` object to be included within the aggregate. */
  filter?: InputMaybe<BoostPoolLiquidityFilter>;
  /** Maximum aggregate over matching `BoostPoolLiquidity` objects. */
  max?: InputMaybe<BoostPoolLiquidityMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostPoolLiquidity` objects. */
  min?: InputMaybe<BoostPoolLiquidityMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostPoolLiquidity` objects. */
  stddevPopulation?: InputMaybe<BoostPoolLiquidityStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostPoolLiquidity` objects. */
  stddevSample?: InputMaybe<BoostPoolLiquidityStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostPoolLiquidity` objects. */
  sum?: InputMaybe<BoostPoolLiquiditySumAggregateFilter>;
  /** Population variance aggregate over matching `BoostPoolLiquidity` objects. */
  variancePopulation?: InputMaybe<BoostPoolLiquidityVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostPoolLiquidity` objects. */
  varianceSample?: InputMaybe<BoostPoolLiquidityVarianceSampleAggregateFilter>;
};

export type BoostPoolLiquidityAverageAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityAverageAggregates = {
  __typename?: 'BoostPoolLiquidityAverageAggregates';
  /** Mean average of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostPoolLiquidity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BoostPoolLiquidityCondition = {
  /** Checks for equality with the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  boostPoolByBoostPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAmountValueUsd` field. */
  totalAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostPoolLiquidityDistinctCountAggregateFilter = {
  availableAmount?: InputMaybe<BigIntFilter>;
  availableAmountValueUsd?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigIntFilter>;
  totalAmountValueUsd?: InputMaybe<BigIntFilter>;
  unavailableAmount?: InputMaybe<BigIntFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigIntFilter>;
};

export type BoostPoolLiquidityDistinctCountAggregates = {
  __typename?: 'BoostPoolLiquidityDistinctCountAggregates';
  /** Distinct count of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostPoolLiquidity` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolLiquidityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostPoolLiquidityFilter>>;
  /** Filter by the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostPoolByBoostPoolId` relation. */
  boostPoolByBoostPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostPoolLiquidityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostPoolLiquidityFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAmountValueUsd` field. */
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BoostPoolLiquidity` for usage during aggregation. */
export type BoostPoolLiquidityGroupBy =
  | 'AVAILABLE_AMOUNT'
  | 'AVAILABLE_AMOUNT_VALUE_USD'
  | 'BLOCK'
  | 'BOOST_POOL_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TOTAL_AMOUNT'
  | 'TOTAL_AMOUNT_VALUE_USD'
  | 'UNAVAILABLE_AMOUNT'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD';

export type BoostPoolLiquidityHavingAverageInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingDistinctCountInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostPoolLiquidity` aggregates. */
export type BoostPoolLiquidityHavingInput = {
  AND?: InputMaybe<Array<BoostPoolLiquidityHavingInput>>;
  OR?: InputMaybe<Array<BoostPoolLiquidityHavingInput>>;
  average?: InputMaybe<BoostPoolLiquidityHavingAverageInput>;
  distinctCount?: InputMaybe<BoostPoolLiquidityHavingDistinctCountInput>;
  max?: InputMaybe<BoostPoolLiquidityHavingMaxInput>;
  min?: InputMaybe<BoostPoolLiquidityHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostPoolLiquidityHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostPoolLiquidityHavingStddevSampleInput>;
  sum?: InputMaybe<BoostPoolLiquidityHavingSumInput>;
  variancePopulation?: InputMaybe<BoostPoolLiquidityHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostPoolLiquidityHavingVarianceSampleInput>;
};

export type BoostPoolLiquidityHavingMaxInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingMinInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingStddevPopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingStddevSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingSumInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingVariancePopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityHavingVarianceSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolLiquidityMaxAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityMaxAggregates = {
  __typename?: 'BoostPoolLiquidityMaxAggregates';
  /** Maximum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolLiquidityMinAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityMinAggregates = {
  __typename?: 'BoostPoolLiquidityMinAggregates';
  /** Minimum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolLiquidityStddevPopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityStddevPopulationAggregates = {
  __typename?: 'BoostPoolLiquidityStddevPopulationAggregates';
  /** Population standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolLiquidityStddevSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityStddevSampleAggregates = {
  __typename?: 'BoostPoolLiquidityStddevSampleAggregates';
  /** Sample standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolLiquiditySumAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquiditySumAggregates = {
  __typename?: 'BoostPoolLiquiditySumAggregates';
  /** Sum of availableAmount across the matching connection */
  availableAmount: Scalars['BigFloat']['output'];
  /** Sum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of boostPoolId across the matching connection */
  boostPoolId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of totalAmount across the matching connection */
  totalAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmount across the matching connection */
  unavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

export type BoostPoolLiquidityVariancePopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityVariancePopulationAggregates = {
  __typename?: 'BoostPoolLiquidityVariancePopulationAggregates';
  /** Population variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolLiquidityVarianceSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostPoolLiquidityVarianceSampleAggregates = {
  __typename?: 'BoostPoolLiquidityVarianceSampleAggregates';
  /** Sample variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolMaxAggregates = {
  __typename?: 'BoostPoolMaxAggregates';
  /** Maximum of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BoostPoolMinAggregates = {
  __typename?: 'BoostPoolMinAggregates';
  /** Minimum of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BoostPoolStddevPopulationAggregates = {
  __typename?: 'BoostPoolStddevPopulationAggregates';
  /** Population standard deviation of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolStddevSampleAggregates = {
  __typename?: 'BoostPoolStddevSampleAggregates';
  /** Sample standard deviation of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolSumAggregates = {
  __typename?: 'BoostPoolSumAggregates';
  /** Sum of feeTierPips across the matching connection */
  feeTierPips: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `BoostLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostLiquidityBalanceChangeFilter = {
  /** Aggregates across related `BoostLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<BoostLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** No related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** Some related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `BoostPoolApy` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostPoolApyFilter = {
  /** Aggregates across related `BoostPoolApy` match the filter criteria. */
  aggregates?: InputMaybe<BoostPoolApyAggregatesFilter>;
  /** Every related `BoostPoolApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostPoolApyFilter>;
  /** No related `BoostPoolApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostPoolApyFilter>;
  /** Some related `BoostPoolApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostPoolApyFilter>;
};

/** A filter to be used against many `BoostPoolBoostShare` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostPoolBoostShareFilter = {
  /** Aggregates across related `BoostPoolBoostShare` match the filter criteria. */
  aggregates?: InputMaybe<BoostPoolBoostShareAggregatesFilter>;
  /** Every related `BoostPoolBoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostPoolBoostShareFilter>;
  /** No related `BoostPoolBoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostPoolBoostShareFilter>;
  /** Some related `BoostPoolBoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostPoolBoostShareFilter>;
};

/** A filter to be used against many `BoostPoolLiquidity` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostPoolLiquidityFilter = {
  /** Aggregates across related `BoostPoolLiquidity` match the filter criteria. */
  aggregates?: InputMaybe<BoostPoolLiquidityAggregatesFilter>;
  /** Every related `BoostPoolLiquidity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostPoolLiquidityFilter>;
  /** No related `BoostPoolLiquidity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostPoolLiquidityFilter>;
  /** Some related `BoostPoolLiquidity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostPoolLiquidityFilter>;
};

/** A filter to be used against many `BoostShare` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostShareFilter = {
  /** Aggregates across related `BoostShare` match the filter criteria. */
  aggregates?: InputMaybe<BoostShareAggregatesFilter>;
  /** Every related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostShareFilter>;
  /** No related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostShareFilter>;
  /** Some related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostShareFilter>;
};

/** A filter to be used against many `LiquidityProviderBoostPoolSummary` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyLiquidityProviderBoostPoolSummaryFilter = {
  /** Aggregates across related `LiquidityProviderBoostPoolSummary` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityProviderBoostPoolSummaryAggregatesFilter>;
  /** Every related `LiquidityProviderBoostPoolSummary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  /** No related `LiquidityProviderBoostPoolSummary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  /** Some related `LiquidityProviderBoostPoolSummary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
};

export type BoostPoolVariancePopulationAggregates = {
  __typename?: 'BoostPoolVariancePopulationAggregates';
  /** Population variance of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolVarianceSampleAggregates = {
  __typename?: 'BoostPoolVarianceSampleAggregates';
  /** Sample variance of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostPool` values. */
export type BoostPoolsConnection = {
  __typename?: 'BoostPoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostPoolAggregates>;
  /** A list of edges which contains the `BoostPool` and cursor to aid in pagination. */
  edges: Array<BoostPoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostPoolAggregates>>;
  /** A list of `BoostPool` objects. */
  nodes: Array<BoostPool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostPool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostPool` values. */
export type BoostPoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostPoolGroupBy>;
  having?: InputMaybe<BoostPoolHavingInput>;
};

/** A `BoostPool` edge in the connection. */
export type BoostPoolsEdge = {
  __typename?: 'BoostPoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostPool` at the end of the edge. */
  node: BoostPool;
};

/** Methods to use when ordering `BoostPool`. */
export type BoostPoolsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_COUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_COUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_AVERAGE_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_COUNT_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_COUNT_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_SUM_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AVG_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AVG_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEES_EARNED_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEES_EARNED_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_INTERVAL_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_INTERVAL_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LOSSES_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LOSSES_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_MAX_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_MAX_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_MIN_LIQUIDITY_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_MIN_LIQUIDITY_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_DESC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_ASC'
  | 'BOOST_POOL_APIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_COUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_COUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LOST_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LOST_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MAX_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_MIN_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_SUM_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_COUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_COUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_POOL_LIQUIDITIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_COUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_COUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LOST_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LOST_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'FEE_TIER_PIPS_ASC'
  | 'FEE_TIER_PIPS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_ACTIVE_ASC'
  | 'IS_ACTIVE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_COUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_COUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_BOOST_POOL_SUMMARIES_BY_BOOST_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type BoostShare = Node & {
  __typename?: 'BoostShare';
  /** Reads a single `Account` that is related to this `BoostShare`. */
  accountByLiquidityProviderId: Account;
  amount: Scalars['BigFloat']['output'];
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Boost` that is related to this `BoostShare`. */
  boostByBoostId: Boost;
  boostId: Scalars['Int']['output'];
  /** Reads a single `BoostPool` that is related to this `BoostShare`. */
  boostPoolByBoostPoolId: BoostPool;
  boostPoolId: Scalars['Int']['output'];
  executedAtTimestamp: Scalars['Datetime']['output'];
  fee: Scalars['BigFloat']['output'];
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  lost: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type BoostShareAggregates = {
  __typename?: 'BoostShareAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostShareAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostShareDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostShareMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostShareMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostShareStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostShareStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostShareSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostShareVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostShareVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostShare` object types. */
export type BoostShareAggregatesFilter = {
  /** Mean average aggregate over matching `BoostShare` objects. */
  average?: InputMaybe<BoostShareAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostShare` objects. */
  distinctCount?: InputMaybe<BoostShareDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostShare` object to be included within the aggregate. */
  filter?: InputMaybe<BoostShareFilter>;
  /** Maximum aggregate over matching `BoostShare` objects. */
  max?: InputMaybe<BoostShareMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostShare` objects. */
  min?: InputMaybe<BoostShareMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostShare` objects. */
  stddevPopulation?: InputMaybe<BoostShareStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostShare` objects. */
  stddevSample?: InputMaybe<BoostShareStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostShare` objects. */
  sum?: InputMaybe<BoostShareSumAggregateFilter>;
  /** Population variance aggregate over matching `BoostShare` objects. */
  variancePopulation?: InputMaybe<BoostShareVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostShare` objects. */
  varianceSample?: InputMaybe<BoostShareVarianceSampleAggregateFilter>;
};

export type BoostShareAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostShareAverageAggregates = {
  __typename?: 'BoostShareAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostShare` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BoostShareCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  boostByBoostId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostId` field. */
  boostId?: InputMaybe<Scalars['Int']['input']>;
  boostPoolByBoostPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `executedAtTimestamp` field. */
  executedAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lost` field. */
  lost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoostShareDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  executedAtTimestamp?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  feeUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  lost?: InputMaybe<BigIntFilter>;
};

export type BoostShareDistinctCountAggregates = {
  __typename?: 'BoostShareDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lost across the matching connection */
  lost?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostShare` object types. All fields are combined with a logical ‘and.’ */
export type BoostShareFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostShareFilter>>;
  /** Filter by the object’s `boostByBoostId` relation. */
  boostByBoostId?: InputMaybe<BoostFilter>;
  /** Filter by the object’s `boostId` field. */
  boostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostPoolByBoostPoolId` relation. */
  boostPoolByBoostPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `executedAtTimestamp` field. */
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lost` field. */
  lost?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostShareFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostShareFilter>>;
};

/** Grouping methods for `BoostShare` for usage during aggregation. */
export type BoostShareGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'BOOST_ID'
  | 'BOOST_POOL_ID'
  | 'EXECUTED_AT_TIMESTAMP'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'EXECUTED_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'FEE'
  | 'FEE_USD'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'LOST';

export type BoostShareHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BoostShare` aggregates. */
export type BoostShareHavingInput = {
  AND?: InputMaybe<Array<BoostShareHavingInput>>;
  OR?: InputMaybe<Array<BoostShareHavingInput>>;
  average?: InputMaybe<BoostShareHavingAverageInput>;
  distinctCount?: InputMaybe<BoostShareHavingDistinctCountInput>;
  max?: InputMaybe<BoostShareHavingMaxInput>;
  min?: InputMaybe<BoostShareHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostShareHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostShareHavingStddevSampleInput>;
  sum?: InputMaybe<BoostShareHavingSumInput>;
  variancePopulation?: InputMaybe<BoostShareHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostShareHavingVarianceSampleInput>;
};

export type BoostShareHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostId?: InputMaybe<HavingIntFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  executedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type BoostShareMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type BoostShareMaxAggregates = {
  __typename?: 'BoostShareMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type BoostShareMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<IntFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  executedAtTimestamp?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type BoostShareMinAggregates = {
  __typename?: 'BoostShareMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of executedAtTimestamp across the matching connection */
  executedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type BoostShareStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostShareStddevPopulationAggregates = {
  __typename?: 'BoostShareStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostShareStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostShareStddevSampleAggregates = {
  __typename?: 'BoostShareStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostShareSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
};

export type BoostShareSumAggregates = {
  __typename?: 'BoostShareSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of boostId across the matching connection */
  boostId: Scalars['BigInt']['output'];
  /** Sum of boostPoolId across the matching connection */
  boostPoolId: Scalars['BigInt']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of feeUsd across the matching connection */
  feeUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
};

export type BoostShareVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostShareVariancePopulationAggregates = {
  __typename?: 'BoostShareVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostShareVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostId?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type BoostShareVarianceSampleAggregates = {
  __typename?: 'BoostShareVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostShare` values. */
export type BoostSharesConnection = {
  __typename?: 'BoostSharesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostShareAggregates>;
  /** A list of edges which contains the `BoostShare` and cursor to aid in pagination. */
  edges: Array<BoostSharesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostShareAggregates>>;
  /** A list of `BoostShare` objects. */
  nodes: Array<BoostShare>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostShare` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostShare` values. */
export type BoostSharesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostShareGroupBy>;
  having?: InputMaybe<BoostShareHavingInput>;
};

/** A `BoostShare` edge in the connection. */
export type BoostSharesEdge = {
  __typename?: 'BoostSharesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostShare` at the end of the edge. */
  node: BoostShare;
};

/** Methods to use when ordering `BoostShare`. */
export type BoostSharesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'BOOST_ID_ASC'
  | 'BOOST_ID_DESC'
  | 'BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_ID_DESC'
  | 'EXECUTED_AT_TIMESTAMP_ASC'
  | 'EXECUTED_AT_TIMESTAMP_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'FEE_USD_ASC'
  | 'FEE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LOST_ASC'
  | 'LOST_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type BoostStddevPopulationAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  executedAtEventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type BoostStddevPopulationAggregates = {
  __typename?: 'BoostStddevPopulationAggregates';
  /** Population standard deviation of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostStddevSampleAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  executedAtEventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type BoostStddevSampleAggregates = {
  __typename?: 'BoostStddevSampleAggregates';
  /** Sample standard deviation of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSumAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigIntFilter>;
  executedAtEventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type BoostSumAggregates = {
  __typename?: 'BoostSumAggregates';
  /** Sum of depositAmount across the matching connection */
  depositAmount: Scalars['BigFloat']['output'];
  /** Sum of depositAmountUsd across the matching connection */
  depositAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of depositChannelId across the matching connection */
  depositChannelId: Scalars['BigInt']['output'];
  /** Sum of executedAtEventId across the matching connection */
  executedAtEventId: Scalars['BigFloat']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of feeUsd across the matching connection */
  feeUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd: Scalars['BigFloat']['output'];
  /** Sum of lostAtEventId across the matching connection */
  lostAtEventId: Scalars['BigFloat']['output'];
  /** Sum of networkFeePortion across the matching connection */
  networkFeePortion: Scalars['BigFloat']['output'];
  /** Sum of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd: Scalars['BigFloat']['output'];
  /** Sum of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId: Scalars['BigFloat']['output'];
  /** Sum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId: Scalars['BigFloat']['output'];
  /** Sum of settledAtEventId across the matching connection */
  settledAtEventId: Scalars['BigFloat']['output'];
  /** Sum of swapId across the matching connection */
  swapId: Scalars['BigFloat']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `BoostLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type BoostToManyBoostLiquidityBalanceChangeFilter = {
  /** Aggregates across related `BoostLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<BoostLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** No related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** Some related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `BoostPoolBoostShare` object types. All fields are combined with a logical ‘and.’ */
export type BoostToManyBoostPoolBoostShareFilter = {
  /** Aggregates across related `BoostPoolBoostShare` match the filter criteria. */
  aggregates?: InputMaybe<BoostPoolBoostShareAggregatesFilter>;
  /** Every related `BoostPoolBoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostPoolBoostShareFilter>;
  /** No related `BoostPoolBoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostPoolBoostShareFilter>;
  /** Some related `BoostPoolBoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostPoolBoostShareFilter>;
};

/** A filter to be used against many `BoostShare` object types. All fields are combined with a logical ‘and.’ */
export type BoostToManyBoostShareFilter = {
  /** Aggregates across related `BoostShare` match the filter criteria. */
  aggregates?: InputMaybe<BoostShareAggregatesFilter>;
  /** Every related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostShareFilter>;
  /** No related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostShareFilter>;
  /** Some related `BoostShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostShareFilter>;
};

/** A filter to be used against many `Loan` object types. All fields are combined with a logical ‘and.’ */
export type BoostToManyLoanFilter = {
  /** Aggregates across related `Loan` match the filter criteria. */
  aggregates?: InputMaybe<LoanAggregatesFilter>;
  /** Every related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFilter>;
  /** No related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFilter>;
  /** Some related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFilter>;
};

/** A filter to be used against many `PendingBoostLiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type BoostToManyPendingBoostLiquidityWithdrawalFilter = {
  /** Aggregates across related `PendingBoostLiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<PendingBoostLiquidityWithdrawalAggregatesFilter>;
  /** Every related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** No related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** Some related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
};

export type BoostVariancePopulationAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  executedAtEventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type BoostVariancePopulationAggregates = {
  __typename?: 'BoostVariancePopulationAggregates';
  /** Population variance of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostVarianceSampleAggregateFilter = {
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositAmountUsd?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  executedAtEventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortion?: InputMaybe<BigFloatFilter>;
  liquidityProviderFeePortionUsd?: InputMaybe<BigFloatFilter>;
  lostAtEventId?: InputMaybe<BigFloatFilter>;
  networkFeePortion?: InputMaybe<BigFloatFilter>;
  networkFeePortionUsd?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type BoostVarianceSampleAggregates = {
  __typename?: 'BoostVarianceSampleAggregates';
  /** Sample variance of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositAmountUsd across the matching connection */
  depositAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of executedAtEventId across the matching connection */
  executedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderFeePortion across the matching connection */
  liquidityProviderFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderFeePortionUsd across the matching connection */
  liquidityProviderFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lostAtEventId across the matching connection */
  lostAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeePortion across the matching connection */
  networkFeePortion?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeePortionUsd across the matching connection */
  networkFeePortionUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Boost` values. */
export type BoostsConnection = {
  __typename?: 'BoostsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostAggregates>;
  /** A list of edges which contains the `Boost` and cursor to aid in pagination. */
  edges: Array<BoostsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostAggregates>>;
  /** A list of `Boost` objects. */
  nodes: Array<Boost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Boost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Boost` values. */
export type BoostsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostGroupBy>;
  having?: InputMaybe<BoostHavingInput>;
};

/** A `Boost` edge in the connection. */
export type BoostsEdge = {
  __typename?: 'BoostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Boost` at the end of the edge. */
  node: Boost;
};

/** Methods to use when ordering `Boost`. */
export type BoostsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_COUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_COUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_AVERAGE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_COUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_COUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LOST_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LOST_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MAX_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_MIN_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_SUM_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOST_POOL_BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_COUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_COUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LOST_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_DISTINCT_COUNT_LOST_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_SHARES_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'DEPOSIT_AMOUNT_ASC'
  | 'DEPOSIT_AMOUNT_DESC'
  | 'DEPOSIT_AMOUNT_USD_ASC'
  | 'DEPOSIT_AMOUNT_USD_DESC'
  | 'DEPOSIT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNEL_ID_DESC'
  | 'EXECUTED_AT_EVENT_ID_ASC'
  | 'EXECUTED_AT_EVENT_ID_DESC'
  | 'EXECUTED_AT_TIMESTAMP_ASC'
  | 'EXECUTED_AT_TIMESTAMP_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'FEE_USD_ASC'
  | 'FEE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_COUNT_ASC'
  | 'LOANS_BY_BOOST_ID_COUNT_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_IS_LIQUIDATED_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_IS_LIQUIDATED_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_BOOST_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOST_AT_EVENT_ID_ASC'
  | 'LOST_AT_EVENT_ID_DESC'
  | 'LOST_AT_TIMESTAMP_ASC'
  | 'LOST_AT_TIMESTAMP_DESC'
  | 'NATURAL'
  | 'NETWORK_FEE_PORTION_ASC'
  | 'NETWORK_FEE_PORTION_DESC'
  | 'NETWORK_FEE_PORTION_USD_ASC'
  | 'NETWORK_FEE_PORTION_USD_DESC'
  | 'NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_AVERAGE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_COUNT_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_COUNT_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_FINALIZED_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_FINALIZED_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_LOST_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_LOST_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_DISTINCT_COUNT_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MAX_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_MIN_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_POPULATION_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_STDDEV_SAMPLE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_SUM_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_POPULATION_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_BOOST_ID_VARIANCE_SAMPLE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PREWITNESSED_DEPOSIT_ID_ASC'
  | 'PREWITNESSED_DEPOSIT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SETTLED_AT_EVENT_ID_ASC'
  | 'SETTLED_AT_EVENT_ID_DESC'
  | 'SETTLED_AT_TIMESTAMP_ASC'
  | 'SETTLED_AT_TIMESTAMP_DESC'
  | 'SWAP_ID_ASC'
  | 'SWAP_ID_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC';

export type ChainflipAsset =
  | 'ArbEth'
  | 'ArbUsdc'
  | 'ArbUsdt'
  | 'Bnb'
  | 'BscUsdt'
  | 'Btc'
  | 'Cbbtc'
  | 'Dot'
  | 'Eth'
  | 'Flip'
  | 'HubDot'
  | 'HubUsdc'
  | 'HubUsdt'
  | 'Sol'
  | 'SolUsdc'
  | 'SolUsdt'
  | 'Trx'
  | 'TrxUsdt'
  | 'Usdc'
  | 'Usdt'
  | 'Wbtc';

/** A filter to be used against ChainflipAsset fields. All fields are combined with a logical ‘and.’ */
export type ChainflipAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipAsset>>;
};

export type ChainflipChain =
  | 'Arbitrum'
  | 'Assethub'
  | 'Bitcoin'
  | 'Bsc'
  | 'Ethereum'
  | 'Polkadot'
  | 'Solana'
  | 'Tron';

/** A filter to be used against ChainflipChain fields. All fields are combined with a logical ‘and.’ */
export type ChainflipChainFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipChain>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipChain>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipChain>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipChain>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipChain>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipChain>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipChain>>;
};

export type CollateralBalanceChangeType =
  | 'DEPOSIT'
  | 'LIQUIDATION_EXCESS_AMOUNT_CREDITED'
  | 'SYSTEM_TOP_UP'
  | 'WITHDRAWAL';

/** A filter to be used against CollateralBalanceChangeType fields. All fields are combined with a logical ‘and.’ */
export type CollateralBalanceChangeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CollateralBalanceChangeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CollateralBalanceChangeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CollateralBalanceChangeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CollateralBalanceChangeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CollateralBalanceChangeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CollateralBalanceChangeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CollateralBalanceChangeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CollateralBalanceChangeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CollateralBalanceChangeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CollateralBalanceChangeType>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DepositChannel = Node & {
  __typename?: 'DepositChannel';
  /** Reads a single `Account` that is related to this `DepositChannel`. */
  accountByBrokerId?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `DepositChannel`. */
  accountByLiquidityProviderId?: Maybe<Account>;
  address?: Maybe<Scalars['String']['output']>;
  boostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Boost`. */
  boostsByDepositChannelId: BoostsConnection;
  brokerId?: Maybe<Scalars['Int']['output']>;
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['output'];
  closeBrokerChannelEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Event` that is related to this `DepositChannel`. */
  eventByCloseBrokerChannelEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `DepositChannel`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  issuedBlockId: Scalars['Int']['output'];
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: DepositChannelType;
};


export type DepositChannelBoostsByDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostCondition>;
  filter?: InputMaybe<BoostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
};

export type DepositChannelAggregates = {
  __typename?: 'DepositChannelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<DepositChannelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DepositChannelDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<DepositChannelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<DepositChannelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<DepositChannelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<DepositChannelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<DepositChannelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<DepositChannelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<DepositChannelVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `DepositChannel` object types. */
export type DepositChannelAggregatesFilter = {
  /** Mean average aggregate over matching `DepositChannel` objects. */
  average?: InputMaybe<DepositChannelAverageAggregateFilter>;
  /** Distinct count aggregate over matching `DepositChannel` objects. */
  distinctCount?: InputMaybe<DepositChannelDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DepositChannel` object to be included within the aggregate. */
  filter?: InputMaybe<DepositChannelFilter>;
  /** Maximum aggregate over matching `DepositChannel` objects. */
  max?: InputMaybe<DepositChannelMaxAggregateFilter>;
  /** Minimum aggregate over matching `DepositChannel` objects. */
  min?: InputMaybe<DepositChannelMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `DepositChannel` objects. */
  stddevPopulation?: InputMaybe<DepositChannelStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `DepositChannel` objects. */
  stddevSample?: InputMaybe<DepositChannelStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `DepositChannel` objects. */
  sum?: InputMaybe<DepositChannelSumAggregateFilter>;
  /** Population variance aggregate over matching `DepositChannel` objects. */
  variancePopulation?: InputMaybe<DepositChannelVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `DepositChannel` objects. */
  varianceSample?: InputMaybe<DepositChannelVarianceSampleAggregateFilter>;
};

export type DepositChannelAverageAggregateFilter = {
  boostFeeBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type DepositChannelAverageAggregates = {
  __typename?: 'DepositChannelAverageAggregates';
  /** Mean average of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `DepositChannel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DepositChannelCondition = {
  accountByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `boostFeeBps` field. */
  boostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `channelId` field. */
  channelId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `closeBrokerChannelEventId` field. */
  closeBrokerChannelEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByCloseBrokerChannelEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DepositChannelType>;
};

export type DepositChannelDistinctCountAggregateFilter = {
  address?: InputMaybe<BigIntFilter>;
  boostFeeBps?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type DepositChannelDistinctCountAggregates = {
  __typename?: 'DepositChannelDistinctCountAggregates';
  /** Distinct count of address across the matching connection */
  address?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `DepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type DepositChannelFilter = {
  /** Filter by the object’s `accountByBrokerId` relation. */
  accountByBrokerId?: InputMaybe<AccountFilter>;
  /** A related `accountByBrokerId` exists. */
  accountByBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** A related `accountByLiquidityProviderId` exists. */
  accountByLiquidityProviderIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DepositChannelFilter>>;
  /** Filter by the object’s `boostFeeBps` field. */
  boostFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostsByDepositChannelId` relation. */
  boostsByDepositChannelId?: InputMaybe<DepositChannelToManyBoostFilter>;
  /** Some related `boostsByDepositChannelId` exist. */
  boostsByDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `channelId` field. */
  channelId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `closeBrokerChannelEventId` field. */
  closeBrokerChannelEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByCloseBrokerChannelEventId` relation. */
  eventByCloseBrokerChannelEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCloseBrokerChannelEventId` exists. */
  eventByCloseBrokerChannelEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DepositChannelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DepositChannelFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<DepositChannelTypeFilter>;
};

/** Grouping methods for `DepositChannel` for usage during aggregation. */
export type DepositChannelGroupBy =
  | 'ADDRESS'
  | 'BOOST_FEE_BPS'
  | 'BROKER_ID'
  | 'CHAIN'
  | 'CHANNEL_ID'
  | 'CLOSE_BROKER_CHANNEL_EVENT_ID'
  | 'EVENT_ID'
  | 'ISSUED_BLOCK_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'TYPE';

export type DepositChannelHavingAverageInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingDistinctCountInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `DepositChannel` aggregates. */
export type DepositChannelHavingInput = {
  AND?: InputMaybe<Array<DepositChannelHavingInput>>;
  OR?: InputMaybe<Array<DepositChannelHavingInput>>;
  average?: InputMaybe<DepositChannelHavingAverageInput>;
  distinctCount?: InputMaybe<DepositChannelHavingDistinctCountInput>;
  max?: InputMaybe<DepositChannelHavingMaxInput>;
  min?: InputMaybe<DepositChannelHavingMinInput>;
  stddevPopulation?: InputMaybe<DepositChannelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DepositChannelHavingStddevSampleInput>;
  sum?: InputMaybe<DepositChannelHavingSumInput>;
  variancePopulation?: InputMaybe<DepositChannelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DepositChannelHavingVarianceSampleInput>;
};

export type DepositChannelHavingMaxInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingMinInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingStddevPopulationInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingStddevSampleInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingSumInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingVariancePopulationInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelHavingVarianceSampleInput = {
  boostFeeBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeBrokerChannelEventId?: InputMaybe<HavingBigintFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type DepositChannelMaxAggregateFilter = {
  boostFeeBps?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type DepositChannelMaxAggregates = {
  __typename?: 'DepositChannelMaxAggregates';
  /** Maximum of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type DepositChannelMinAggregateFilter = {
  boostFeeBps?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type DepositChannelMinAggregates = {
  __typename?: 'DepositChannelMinAggregates';
  /** Minimum of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type DepositChannelStddevPopulationAggregateFilter = {
  boostFeeBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type DepositChannelStddevPopulationAggregates = {
  __typename?: 'DepositChannelStddevPopulationAggregates';
  /** Population standard deviation of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositChannelStddevSampleAggregateFilter = {
  boostFeeBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type DepositChannelStddevSampleAggregates = {
  __typename?: 'DepositChannelStddevSampleAggregates';
  /** Sample standard deviation of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositChannelSumAggregateFilter = {
  boostFeeBps?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
};

export type DepositChannelSumAggregates = {
  __typename?: 'DepositChannelSumAggregates';
  /** Sum of boostFeeBps across the matching connection */
  boostFeeBps: Scalars['BigInt']['output'];
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of channelId across the matching connection */
  channelId: Scalars['BigFloat']['output'];
  /** Sum of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of issuedBlockId across the matching connection */
  issuedBlockId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Boost` object types. All fields are combined with a logical ‘and.’ */
export type DepositChannelToManyBoostFilter = {
  /** Aggregates across related `Boost` match the filter criteria. */
  aggregates?: InputMaybe<BoostAggregatesFilter>;
  /** Every related `Boost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostFilter>;
  /** No related `Boost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostFilter>;
  /** Some related `Boost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostFilter>;
};

export type DepositChannelType =
  | 'ACCOUNT_CREATION'
  | 'BROKER'
  | 'LIQUIDITY'
  | 'SWAP';

/** A filter to be used against DepositChannelType fields. All fields are combined with a logical ‘and.’ */
export type DepositChannelTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DepositChannelType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DepositChannelType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DepositChannelType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DepositChannelType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DepositChannelType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DepositChannelType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DepositChannelType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DepositChannelType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DepositChannelType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DepositChannelType>>;
};

export type DepositChannelVariancePopulationAggregateFilter = {
  boostFeeBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type DepositChannelVariancePopulationAggregates = {
  __typename?: 'DepositChannelVariancePopulationAggregates';
  /** Population variance of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositChannelVarianceSampleAggregateFilter = {
  boostFeeBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeBrokerChannelEventId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type DepositChannelVarianceSampleAggregates = {
  __typename?: 'DepositChannelVarianceSampleAggregates';
  /** Sample variance of boostFeeBps across the matching connection */
  boostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of closeBrokerChannelEventId across the matching connection */
  closeBrokerChannelEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `DepositChannel` values. */
export type DepositChannelsConnection = {
  __typename?: 'DepositChannelsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DepositChannelAggregates>;
  /** A list of edges which contains the `DepositChannel` and cursor to aid in pagination. */
  edges: Array<DepositChannelsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DepositChannelAggregates>>;
  /** A list of `DepositChannel` objects. */
  nodes: Array<DepositChannel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DepositChannel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `DepositChannel` values. */
export type DepositChannelsConnectionGroupedAggregatesArgs = {
  groupBy: Array<DepositChannelGroupBy>;
  having?: InputMaybe<DepositChannelHavingInput>;
};

/** A `DepositChannel` edge in the connection. */
export type DepositChannelsEdge = {
  __typename?: 'DepositChannelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DepositChannel` at the end of the edge. */
  node: DepositChannel;
};

/** Methods to use when ordering `DepositChannel`. */
export type DepositChannelsOrderBy =
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_FEE_BPS_ASC'
  | 'BOOST_FEE_BPS_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'CHANNEL_ID_ASC'
  | 'CHANNEL_ID_DESC'
  | 'CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ISSUED_BLOCK_ID_ASC'
  | 'ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type Event = Node & {
  __typename?: 'Event';
  block: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `BoostLiquidityBalanceChange`. */
  boostLiquidityBalanceChangesByEventId: BoostLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `Boost`. */
  boostsByExecutedAtEventId: BoostsConnection;
  /** Reads and enables pagination through a set of `Boost`. */
  boostsByLostAtEventId: BoostsConnection;
  /** Reads and enables pagination through a set of `Boost`. */
  boostsBySettledAtEventId: BoostsConnection;
  /** Reads and enables pagination through a set of `DepositChannel`. */
  depositChannelsByCloseBrokerChannelEventId: DepositChannelsConnection;
  /** Reads and enables pagination through a set of `DepositChannel`. */
  depositChannelsByEventId: DepositChannelsConnection;
  id: Scalars['BigInt']['output'];
  indexInBlock: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangesByEventId: LendingLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapRequest`. */
  liquidationSwapRequestsByAbortedAtEventId: LiquidationSwapRequestsConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapRequest`. */
  liquidationSwapRequestsByCompletedAtEventId: LiquidationSwapRequestsConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapRequest`. */
  liquidationSwapRequestsByCreatedAtEventId: LiquidationSwapRequestsConnection;
  /** Reads and enables pagination through a set of `LoanFee`. */
  loanFeesByEventId: LoanFeesConnection;
  /** Reads and enables pagination through a set of `LoanUpdate`. */
  loanUpdatesByEventId: LoanUpdatesConnection;
  /** Reads and enables pagination through a set of `Loan`. */
  loansByCreatedAtEventId: LoansConnection;
  /** Reads and enables pagination through a set of `Loan`. */
  loansBySettledAtEventId: LoansConnection;
  /** Reads and enables pagination through a set of `LpCollateralBalanceChange`. */
  lpCollateralBalanceChangesByEventId: LpCollateralBalanceChangesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OraclePriceTracking`. */
  oraclePriceTrackingsByCreatedAtEventId: OraclePriceTrackingsConnection;
  /** Reads and enables pagination through a set of `PendingBoostLiquidityWithdrawal`. */
  pendingBoostLiquidityWithdrawalsByStoppedBoostingEventId: PendingBoostLiquidityWithdrawalsConnection;
  /** Reads a single `PoolOrder` that is related to this `Event`. */
  poolOrderByOrderCreatedEventId?: Maybe<PoolOrder>;
  /** Reads and enables pagination through a set of `PoolOrder`. */
  poolOrdersByOrderCreatedEventId: PoolOrdersConnection;
  /** Reads and enables pagination through a set of `PoolOrder`. */
  poolOrdersByOrderLastUpdatedEventId: PoolOrdersConnection;
  timestamp: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  tradingStrategiesByClosedAtEventId: TradingStrategiesConnection;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  tradingStrategiesByCreatedAtEventId: TradingStrategiesConnection;
  /** Reads and enables pagination through a set of `TradingStrategyBalanceChangeEvent`. */
  tradingStrategyBalanceChangeEventsByEventId: TradingStrategyBalanceChangeEventsConnection;
};


export type EventBoostLiquidityBalanceChangesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostLiquidityBalanceChangesOrderBy>>;
};


export type EventBoostsByExecutedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostCondition>;
  filter?: InputMaybe<BoostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
};


export type EventBoostsByLostAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostCondition>;
  filter?: InputMaybe<BoostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
};


export type EventBoostsBySettledAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostCondition>;
  filter?: InputMaybe<BoostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
};


export type EventDepositChannelsByCloseBrokerChannelEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositChannelCondition>;
  filter?: InputMaybe<DepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositChannelsOrderBy>>;
};


export type EventDepositChannelsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositChannelCondition>;
  filter?: InputMaybe<DepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositChannelsOrderBy>>;
};


export type EventLendingLiquidityBalanceChangesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy>>;
};


export type EventLiquidationSwapRequestsByAbortedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapRequestCondition>;
  filter?: InputMaybe<LiquidationSwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapRequestsOrderBy>>;
};


export type EventLiquidationSwapRequestsByCompletedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapRequestCondition>;
  filter?: InputMaybe<LiquidationSwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapRequestsOrderBy>>;
};


export type EventLiquidationSwapRequestsByCreatedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapRequestCondition>;
  filter?: InputMaybe<LiquidationSwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapRequestsOrderBy>>;
};


export type EventLoanFeesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanFeeCondition>;
  filter?: InputMaybe<LoanFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanFeesOrderBy>>;
};


export type EventLoanUpdatesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanUpdateCondition>;
  filter?: InputMaybe<LoanUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanUpdatesOrderBy>>;
};


export type EventLoansByCreatedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type EventLoansBySettledAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type EventLpCollateralBalanceChangesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpCollateralBalanceChangeCondition>;
  filter?: InputMaybe<LpCollateralBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpCollateralBalanceChangesOrderBy>>;
};


export type EventOraclePriceTrackingsByCreatedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OraclePriceTrackingCondition>;
  filter?: InputMaybe<OraclePriceTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OraclePriceTrackingsOrderBy>>;
};


export type EventPendingBoostLiquidityWithdrawalsByStoppedBoostingEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PendingBoostLiquidityWithdrawalCondition>;
  filter?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PendingBoostLiquidityWithdrawalsOrderBy>>;
};


export type EventPoolOrdersByOrderCreatedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderCondition>;
  filter?: InputMaybe<PoolOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrdersOrderBy>>;
};


export type EventPoolOrdersByOrderLastUpdatedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderCondition>;
  filter?: InputMaybe<PoolOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrdersOrderBy>>;
};


export type EventTradingStrategiesByClosedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};


export type EventTradingStrategiesByCreatedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};


export type EventTradingStrategyBalanceChangeEventsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyBalanceChangeEventCondition>;
  filter?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategyBalanceChangeEventsOrderBy>>;
};

export type EventAggregates = {
  __typename?: 'EventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EventVarianceSampleAggregates>;
};

export type EventAverageAggregates = {
  __typename?: 'EventAverageAggregates';
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Event` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EventCondition = {
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `indexInBlock` field. */
  indexInBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type EventDistinctCountAggregates = {
  __typename?: 'EventDistinctCountAggregates';
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Event` object types. All fields are combined with a logical ‘and.’ */
export type EventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostLiquidityBalanceChangesByEventId` relation. */
  boostLiquidityBalanceChangesByEventId?: InputMaybe<EventToManyBoostLiquidityBalanceChangeFilter>;
  /** Some related `boostLiquidityBalanceChangesByEventId` exist. */
  boostLiquidityBalanceChangesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostsByExecutedAtEventId` relation. */
  boostsByExecutedAtEventId?: InputMaybe<EventToManyBoostFilter>;
  /** Some related `boostsByExecutedAtEventId` exist. */
  boostsByExecutedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostsByLostAtEventId` relation. */
  boostsByLostAtEventId?: InputMaybe<EventToManyBoostFilter>;
  /** Some related `boostsByLostAtEventId` exist. */
  boostsByLostAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostsBySettledAtEventId` relation. */
  boostsBySettledAtEventId?: InputMaybe<EventToManyBoostFilter>;
  /** Some related `boostsBySettledAtEventId` exist. */
  boostsBySettledAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `depositChannelsByCloseBrokerChannelEventId` relation. */
  depositChannelsByCloseBrokerChannelEventId?: InputMaybe<EventToManyDepositChannelFilter>;
  /** Some related `depositChannelsByCloseBrokerChannelEventId` exist. */
  depositChannelsByCloseBrokerChannelEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `depositChannelsByEventId` relation. */
  depositChannelsByEventId?: InputMaybe<EventToManyDepositChannelFilter>;
  /** Some related `depositChannelsByEventId` exist. */
  depositChannelsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `indexInBlock` field. */
  indexInBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingLiquidityBalanceChangesByEventId` relation. */
  lendingLiquidityBalanceChangesByEventId?: InputMaybe<EventToManyLendingLiquidityBalanceChangeFilter>;
  /** Some related `lendingLiquidityBalanceChangesByEventId` exist. */
  lendingLiquidityBalanceChangesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapRequestsByAbortedAtEventId` relation. */
  liquidationSwapRequestsByAbortedAtEventId?: InputMaybe<EventToManyLiquidationSwapRequestFilter>;
  /** Some related `liquidationSwapRequestsByAbortedAtEventId` exist. */
  liquidationSwapRequestsByAbortedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapRequestsByCompletedAtEventId` relation. */
  liquidationSwapRequestsByCompletedAtEventId?: InputMaybe<EventToManyLiquidationSwapRequestFilter>;
  /** Some related `liquidationSwapRequestsByCompletedAtEventId` exist. */
  liquidationSwapRequestsByCompletedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapRequestsByCreatedAtEventId` relation. */
  liquidationSwapRequestsByCreatedAtEventId?: InputMaybe<EventToManyLiquidationSwapRequestFilter>;
  /** Some related `liquidationSwapRequestsByCreatedAtEventId` exist. */
  liquidationSwapRequestsByCreatedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanFeesByEventId` relation. */
  loanFeesByEventId?: InputMaybe<EventToManyLoanFeeFilter>;
  /** Some related `loanFeesByEventId` exist. */
  loanFeesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanUpdatesByEventId` relation. */
  loanUpdatesByEventId?: InputMaybe<EventToManyLoanUpdateFilter>;
  /** Some related `loanUpdatesByEventId` exist. */
  loanUpdatesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loansByCreatedAtEventId` relation. */
  loansByCreatedAtEventId?: InputMaybe<EventToManyLoanFilter>;
  /** Some related `loansByCreatedAtEventId` exist. */
  loansByCreatedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loansBySettledAtEventId` relation. */
  loansBySettledAtEventId?: InputMaybe<EventToManyLoanFilter>;
  /** Some related `loansBySettledAtEventId` exist. */
  loansBySettledAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpCollateralBalanceChangesByEventId` relation. */
  lpCollateralBalanceChangesByEventId?: InputMaybe<EventToManyLpCollateralBalanceChangeFilter>;
  /** Some related `lpCollateralBalanceChangesByEventId` exist. */
  lpCollateralBalanceChangesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<EventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `oraclePriceTrackingsByCreatedAtEventId` relation. */
  oraclePriceTrackingsByCreatedAtEventId?: InputMaybe<EventToManyOraclePriceTrackingFilter>;
  /** Some related `oraclePriceTrackingsByCreatedAtEventId` exist. */
  oraclePriceTrackingsByCreatedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `pendingBoostLiquidityWithdrawalsByStoppedBoostingEventId` relation. */
  pendingBoostLiquidityWithdrawalsByStoppedBoostingEventId?: InputMaybe<EventToManyPendingBoostLiquidityWithdrawalFilter>;
  /** Some related `pendingBoostLiquidityWithdrawalsByStoppedBoostingEventId` exist. */
  pendingBoostLiquidityWithdrawalsByStoppedBoostingEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `poolOrderByOrderCreatedEventId` relation. */
  poolOrderByOrderCreatedEventId?: InputMaybe<PoolOrderFilter>;
  /** A related `poolOrderByOrderCreatedEventId` exists. */
  poolOrderByOrderCreatedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `poolOrdersByOrderLastUpdatedEventId` relation. */
  poolOrdersByOrderLastUpdatedEventId?: InputMaybe<EventToManyPoolOrderFilter>;
  /** Some related `poolOrdersByOrderLastUpdatedEventId` exist. */
  poolOrdersByOrderLastUpdatedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `tradingStrategiesByClosedAtEventId` relation. */
  tradingStrategiesByClosedAtEventId?: InputMaybe<EventToManyTradingStrategyFilter>;
  /** Some related `tradingStrategiesByClosedAtEventId` exist. */
  tradingStrategiesByClosedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tradingStrategiesByCreatedAtEventId` relation. */
  tradingStrategiesByCreatedAtEventId?: InputMaybe<EventToManyTradingStrategyFilter>;
  /** Some related `tradingStrategiesByCreatedAtEventId` exist. */
  tradingStrategiesByCreatedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tradingStrategyBalanceChangeEventsByEventId` relation. */
  tradingStrategyBalanceChangeEventsByEventId?: InputMaybe<EventToManyTradingStrategyBalanceChangeEventFilter>;
  /** Some related `tradingStrategyBalanceChangeEventsByEventId` exist. */
  tradingStrategyBalanceChangeEventsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Event` for usage during aggregation. */
export type EventGroupBy =
  | 'BLOCK'
  | 'INDEX_IN_BLOCK'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type EventHavingAverageInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingDistinctCountInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Event` aggregates. */
export type EventHavingInput = {
  AND?: InputMaybe<Array<EventHavingInput>>;
  OR?: InputMaybe<Array<EventHavingInput>>;
  average?: InputMaybe<EventHavingAverageInput>;
  distinctCount?: InputMaybe<EventHavingDistinctCountInput>;
  max?: InputMaybe<EventHavingMaxInput>;
  min?: InputMaybe<EventHavingMinInput>;
  stddevPopulation?: InputMaybe<EventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EventHavingStddevSampleInput>;
  sum?: InputMaybe<EventHavingSumInput>;
  variancePopulation?: InputMaybe<EventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EventHavingVarianceSampleInput>;
};

export type EventHavingMaxInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingMinInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingStddevPopulationInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingStddevSampleInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingSumInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingVariancePopulationInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventHavingVarianceSampleInput = {
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type EventMaxAggregates = {
  __typename?: 'EventMaxAggregates';
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type EventMinAggregates = {
  __typename?: 'EventMinAggregates';
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type EventStddevPopulationAggregates = {
  __typename?: 'EventStddevPopulationAggregates';
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type EventStddevSampleAggregates = {
  __typename?: 'EventStddevSampleAggregates';
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type EventSumAggregates = {
  __typename?: 'EventSumAggregates';
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of indexInBlock across the matching connection */
  indexInBlock: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Boost` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBoostFilter = {
  /** Aggregates across related `Boost` match the filter criteria. */
  aggregates?: InputMaybe<BoostAggregatesFilter>;
  /** Every related `Boost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostFilter>;
  /** No related `Boost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostFilter>;
  /** Some related `Boost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostFilter>;
};

/** A filter to be used against many `BoostLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBoostLiquidityBalanceChangeFilter = {
  /** Aggregates across related `BoostLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<BoostLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** No related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  /** Some related `BoostLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `DepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyDepositChannelFilter = {
  /** Aggregates across related `DepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<DepositChannelAggregatesFilter>;
  /** Every related `DepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepositChannelFilter>;
  /** No related `DepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepositChannelFilter>;
  /** Some related `DepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepositChannelFilter>;
};

/** A filter to be used against many `LendingLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLendingLiquidityBalanceChangeFilter = {
  /** Aggregates across related `LendingLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LendingLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** No related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Some related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `LiquidationSwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLiquidationSwapRequestFilter = {
  /** Aggregates across related `LiquidationSwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<LiquidationSwapRequestAggregatesFilter>;
  /** Every related `LiquidationSwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidationSwapRequestFilter>;
  /** No related `LiquidationSwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidationSwapRequestFilter>;
  /** Some related `LiquidationSwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidationSwapRequestFilter>;
};

/** A filter to be used against many `LoanFee` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLoanFeeFilter = {
  /** Aggregates across related `LoanFee` match the filter criteria. */
  aggregates?: InputMaybe<LoanFeeAggregatesFilter>;
  /** Every related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFeeFilter>;
  /** No related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFeeFilter>;
  /** Some related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFeeFilter>;
};

/** A filter to be used against many `Loan` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLoanFilter = {
  /** Aggregates across related `Loan` match the filter criteria. */
  aggregates?: InputMaybe<LoanAggregatesFilter>;
  /** Every related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFilter>;
  /** No related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFilter>;
  /** Some related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFilter>;
};

/** A filter to be used against many `LoanUpdate` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLoanUpdateFilter = {
  /** Aggregates across related `LoanUpdate` match the filter criteria. */
  aggregates?: InputMaybe<LoanUpdateAggregatesFilter>;
  /** Every related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanUpdateFilter>;
  /** No related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanUpdateFilter>;
  /** Some related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanUpdateFilter>;
};

/** A filter to be used against many `LpCollateralBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLpCollateralBalanceChangeFilter = {
  /** Aggregates across related `LpCollateralBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LpCollateralBalanceChangeAggregatesFilter>;
  /** Every related `LpCollateralBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpCollateralBalanceChangeFilter>;
  /** No related `LpCollateralBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpCollateralBalanceChangeFilter>;
  /** Some related `LpCollateralBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpCollateralBalanceChangeFilter>;
};

/** A filter to be used against many `OraclePriceTracking` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyOraclePriceTrackingFilter = {
  /** Aggregates across related `OraclePriceTracking` match the filter criteria. */
  aggregates?: InputMaybe<OraclePriceTrackingAggregatesFilter>;
  /** Every related `OraclePriceTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OraclePriceTrackingFilter>;
  /** No related `OraclePriceTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OraclePriceTrackingFilter>;
  /** Some related `OraclePriceTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OraclePriceTrackingFilter>;
};

/** A filter to be used against many `PendingBoostLiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyPendingBoostLiquidityWithdrawalFilter = {
  /** Aggregates across related `PendingBoostLiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<PendingBoostLiquidityWithdrawalAggregatesFilter>;
  /** Every related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** No related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** Some related `PendingBoostLiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
};

/** A filter to be used against many `PoolOrder` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyPoolOrderFilter = {
  /** Aggregates across related `PoolOrder` match the filter criteria. */
  aggregates?: InputMaybe<PoolOrderAggregatesFilter>;
  /** Every related `PoolOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PoolOrderFilter>;
  /** No related `PoolOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PoolOrderFilter>;
  /** Some related `PoolOrder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PoolOrderFilter>;
};

/** A filter to be used against many `TradingStrategyBalanceChangeEvent` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyTradingStrategyBalanceChangeEventFilter = {
  /** Aggregates across related `TradingStrategyBalanceChangeEvent` match the filter criteria. */
  aggregates?: InputMaybe<TradingStrategyBalanceChangeEventAggregatesFilter>;
  /** Every related `TradingStrategyBalanceChangeEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  /** No related `TradingStrategyBalanceChangeEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  /** Some related `TradingStrategyBalanceChangeEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
};

/** A filter to be used against many `TradingStrategy` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyTradingStrategyFilter = {
  /** Aggregates across related `TradingStrategy` match the filter criteria. */
  aggregates?: InputMaybe<TradingStrategyAggregatesFilter>;
  /** Every related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingStrategyFilter>;
  /** No related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingStrategyFilter>;
  /** Some related `TradingStrategy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingStrategyFilter>;
};

export type EventVariancePopulationAggregates = {
  __typename?: 'EventVariancePopulationAggregates';
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type EventVarianceSampleAggregates = {
  __typename?: 'EventVarianceSampleAggregates';
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Event` values. */
export type EventsConnection = {
  __typename?: 'EventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EventAggregates>;
  /** A list of edges which contains the `Event` and cursor to aid in pagination. */
  edges: Array<EventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EventAggregates>>;
  /** A list of `Event` objects. */
  nodes: Array<Event>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Event` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Event` values. */
export type EventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<EventGroupBy>;
  having?: InputMaybe<EventHavingInput>;
};

/** A `Event` edge in the connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Event` at the end of the edge. */
  node: Event;
};

/** Methods to use when ordering `Event`. */
export type EventsOrderBy =
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_COUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_COUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_EXECUTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_COUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_COUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_LOST_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_COUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_COUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_EXECUTED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_EXECUTED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SETTLED_AT_TIMESTAMP_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SETTLED_AT_TIMESTAMP_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_EXECUTED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_USD_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'BOOSTS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_COUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_COUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_POOL_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'BOOST_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_COUNT_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_COUNT_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_ADDRESS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_ADDRESS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_CLOSE_BROKER_CHANNEL_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_COUNT_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_COUNT_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_ADDRESS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_ADDRESS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_FEE_BPS_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_CLOSE_BROKER_CHANNEL_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'DEPOSIT_CHANNELS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INDEX_IN_BLOCK_ASC'
  | 'INDEX_IN_BLOCK_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_COUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_COUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_IS_POSITION_OPENING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_IS_POSITION_OPENING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_SUM_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_IS_HARD_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_IS_HARD_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_IS_HARD_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_IS_HARD_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_IS_HARD_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_IS_HARD_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_COUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_COUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATED_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATED_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_COUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_COUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATED_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATED_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_SETTLED_AT_EVENT_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_COUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_COUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MAX_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_MIN_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_SUM_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_COUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_COUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_COUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_COUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_COLLATERAL_BALANCE_CHANGES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_COUNT_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_COUNT_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_X128_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_AVERAGE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_COUNT_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_COUNT_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_FINALIZED_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_FINALIZED_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_LOST_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_LOST_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_DISTINCT_COUNT_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MAX_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_MIN_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_POPULATION_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_STDDEV_SAMPLE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_SUM_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_POPULATION_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'PENDING_BOOST_LIQUIDITY_WITHDRAWALS_BY_STOPPED_BOOSTING_EVENT_ID_VARIANCE_SAMPLE_STOPPED_BOOSTING_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_AVERAGE_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_COUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_COUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_CREATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_CREATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_TYPE_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_ORDER_TYPE_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_STATUS_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_STATUS_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_DISTINCT_COUNT_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_CREATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_CREATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MAX_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_CREATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_CREATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_MIN_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_POPULATION_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_STDDEV_SAMPLE_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_SUM_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_POPULATION_UPPER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_FILLED_BASE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_FILLED_BASE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_FILLED_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_FILLED_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_LOWER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_LOWER_TICK_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_OPEN_POOL_ORDER_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_OPEN_POOL_ORDER_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_ORDER_CREATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_ORDER_CREATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_UPPER_TICK_ASC'
  | 'POOL_ORDERS_BY_ORDER_LAST_UPDATED_EVENT_ID_VARIANCE_SAMPLE_UPPER_TICK_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_AVERAGE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_COUNT_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_COUNT_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_KEY_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_KEY_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MAX_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_MIN_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_POPULATION_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_STDDEV_SAMPLE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_SUM_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_POPULATION_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CLOSED_AT_EVENT_ID_VARIANCE_SAMPLE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_AVERAGE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_COUNT_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_COUNT_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_KEY_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_KEY_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MAX_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_MIN_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_SUM_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CLOSED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CLOSED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_OWNER_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_OWNER_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_STRATEGY_ACCOUNT_ID_ASC'
  | 'TRADING_STRATEGIES_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_AVERAGE_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_COUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_COUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MAX_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_MIN_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_SUM_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_TRADING_STRATEGY_ID_DESC';

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

export type IncentiveSeason = Node & {
  __typename?: 'IncentiveSeason';
  endBlockDate: Scalars['Datetime']['output'];
  endBlockHeight: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `LendingPoolIncentiveProgram`. */
  lendingPoolIncentiveProgramsByIncentiveSeasonId: LendingPoolIncentiveProgramsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  seasonIndex: Scalars['Int']['output'];
  startBlockDate: Scalars['Datetime']['output'];
  startBlockHeight: Scalars['Int']['output'];
};


export type IncentiveSeasonLendingPoolIncentiveProgramsByIncentiveSeasonIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolIncentiveProgramCondition>;
  filter?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolIncentiveProgramsOrderBy>>;
};

export type IncentiveSeasonAggregates = {
  __typename?: 'IncentiveSeasonAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<IncentiveSeasonAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<IncentiveSeasonDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<IncentiveSeasonMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<IncentiveSeasonMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<IncentiveSeasonStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<IncentiveSeasonStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<IncentiveSeasonSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<IncentiveSeasonVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<IncentiveSeasonVarianceSampleAggregates>;
};

export type IncentiveSeasonAverageAggregates = {
  __typename?: 'IncentiveSeasonAverageAggregates';
  /** Mean average of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `IncentiveSeason` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IncentiveSeasonCondition = {
  /** Checks for equality with the object’s `endBlockDate` field. */
  endBlockDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `endBlockHeight` field. */
  endBlockHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `seasonIndex` field. */
  seasonIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startBlockDate` field. */
  startBlockDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startBlockHeight` field. */
  startBlockHeight?: InputMaybe<Scalars['Int']['input']>;
};

export type IncentiveSeasonDistinctCountAggregates = {
  __typename?: 'IncentiveSeasonDistinctCountAggregates';
  /** Distinct count of endBlockDate across the matching connection */
  endBlockDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isActive across the matching connection */
  isActive?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockDate across the matching connection */
  startBlockDate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `IncentiveSeason` object types. All fields are combined with a logical ‘and.’ */
export type IncentiveSeasonFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IncentiveSeasonFilter>>;
  /** Filter by the object’s `endBlockDate` field. */
  endBlockDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endBlockHeight` field. */
  endBlockHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lendingPoolIncentiveProgramsByIncentiveSeasonId` relation. */
  lendingPoolIncentiveProgramsByIncentiveSeasonId?: InputMaybe<IncentiveSeasonToManyLendingPoolIncentiveProgramFilter>;
  /** Some related `lendingPoolIncentiveProgramsByIncentiveSeasonId` exist. */
  lendingPoolIncentiveProgramsByIncentiveSeasonIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<IncentiveSeasonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IncentiveSeasonFilter>>;
  /** Filter by the object’s `seasonIndex` field. */
  seasonIndex?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startBlockDate` field. */
  startBlockDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startBlockHeight` field. */
  startBlockHeight?: InputMaybe<IntFilter>;
};

/** Grouping methods for `IncentiveSeason` for usage during aggregation. */
export type IncentiveSeasonGroupBy =
  | 'END_BLOCK_DATE'
  | 'END_BLOCK_DATE_TRUNCATED_TO_DAY'
  | 'END_BLOCK_DATE_TRUNCATED_TO_HOUR'
  | 'END_BLOCK_DATE_TRUNCATED_TO_MONTH'
  | 'END_BLOCK_DATE_TRUNCATED_TO_WEEK'
  | 'END_BLOCK_HEIGHT'
  | 'IS_ACTIVE'
  | 'START_BLOCK_DATE'
  | 'START_BLOCK_DATE_TRUNCATED_TO_DAY'
  | 'START_BLOCK_DATE_TRUNCATED_TO_HOUR'
  | 'START_BLOCK_DATE_TRUNCATED_TO_MONTH'
  | 'START_BLOCK_DATE_TRUNCATED_TO_WEEK'
  | 'START_BLOCK_HEIGHT';

export type IncentiveSeasonHavingAverageInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingDistinctCountInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `IncentiveSeason` aggregates. */
export type IncentiveSeasonHavingInput = {
  AND?: InputMaybe<Array<IncentiveSeasonHavingInput>>;
  OR?: InputMaybe<Array<IncentiveSeasonHavingInput>>;
  average?: InputMaybe<IncentiveSeasonHavingAverageInput>;
  distinctCount?: InputMaybe<IncentiveSeasonHavingDistinctCountInput>;
  max?: InputMaybe<IncentiveSeasonHavingMaxInput>;
  min?: InputMaybe<IncentiveSeasonHavingMinInput>;
  stddevPopulation?: InputMaybe<IncentiveSeasonHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<IncentiveSeasonHavingStddevSampleInput>;
  sum?: InputMaybe<IncentiveSeasonHavingSumInput>;
  variancePopulation?: InputMaybe<IncentiveSeasonHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<IncentiveSeasonHavingVarianceSampleInput>;
};

export type IncentiveSeasonHavingMaxInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingMinInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingStddevPopulationInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingStddevSampleInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingSumInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingVariancePopulationInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonHavingVarianceSampleInput = {
  endBlockDate?: InputMaybe<HavingDatetimeFilter>;
  endBlockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  seasonIndex?: InputMaybe<HavingIntFilter>;
  startBlockDate?: InputMaybe<HavingDatetimeFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
};

export type IncentiveSeasonMaxAggregates = {
  __typename?: 'IncentiveSeasonMaxAggregates';
  /** Maximum of endBlockDate across the matching connection */
  endBlockDate?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockDate across the matching connection */
  startBlockDate?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['Int']['output']>;
};

export type IncentiveSeasonMinAggregates = {
  __typename?: 'IncentiveSeasonMinAggregates';
  /** Minimum of endBlockDate across the matching connection */
  endBlockDate?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockDate across the matching connection */
  startBlockDate?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['Int']['output']>;
};

export type IncentiveSeasonStddevPopulationAggregates = {
  __typename?: 'IncentiveSeasonStddevPopulationAggregates';
  /** Population standard deviation of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
};

export type IncentiveSeasonStddevSampleAggregates = {
  __typename?: 'IncentiveSeasonStddevSampleAggregates';
  /** Sample standard deviation of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
};

export type IncentiveSeasonSumAggregates = {
  __typename?: 'IncentiveSeasonSumAggregates';
  /** Sum of endBlockHeight across the matching connection */
  endBlockHeight: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of seasonIndex across the matching connection */
  seasonIndex: Scalars['BigInt']['output'];
  /** Sum of startBlockHeight across the matching connection */
  startBlockHeight: Scalars['BigInt']['output'];
};

/** A filter to be used against many `LendingPoolIncentiveProgram` object types. All fields are combined with a logical ‘and.’ */
export type IncentiveSeasonToManyLendingPoolIncentiveProgramFilter = {
  /** Aggregates across related `LendingPoolIncentiveProgram` match the filter criteria. */
  aggregates?: InputMaybe<LendingPoolIncentiveProgramAggregatesFilter>;
  /** Every related `LendingPoolIncentiveProgram` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** No related `LendingPoolIncentiveProgram` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** Some related `LendingPoolIncentiveProgram` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingPoolIncentiveProgramFilter>;
};

export type IncentiveSeasonVariancePopulationAggregates = {
  __typename?: 'IncentiveSeasonVariancePopulationAggregates';
  /** Population variance of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
};

export type IncentiveSeasonVarianceSampleAggregates = {
  __typename?: 'IncentiveSeasonVarianceSampleAggregates';
  /** Sample variance of endBlockHeight across the matching connection */
  endBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of seasonIndex across the matching connection */
  seasonIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `IncentiveSeason` values. */
export type IncentiveSeasonsConnection = {
  __typename?: 'IncentiveSeasonsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<IncentiveSeasonAggregates>;
  /** A list of edges which contains the `IncentiveSeason` and cursor to aid in pagination. */
  edges: Array<IncentiveSeasonsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<IncentiveSeasonAggregates>>;
  /** A list of `IncentiveSeason` objects. */
  nodes: Array<IncentiveSeason>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IncentiveSeason` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `IncentiveSeason` values. */
export type IncentiveSeasonsConnectionGroupedAggregatesArgs = {
  groupBy: Array<IncentiveSeasonGroupBy>;
  having?: InputMaybe<IncentiveSeasonHavingInput>;
};

/** A `IncentiveSeason` edge in the connection. */
export type IncentiveSeasonsEdge = {
  __typename?: 'IncentiveSeasonsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IncentiveSeason` at the end of the edge. */
  node: IncentiveSeason;
};

/** Methods to use when ordering `IncentiveSeason`. */
export type IncentiveSeasonsOrderBy =
  | 'END_BLOCK_DATE_ASC'
  | 'END_BLOCK_DATE_DESC'
  | 'END_BLOCK_HEIGHT_ASC'
  | 'END_BLOCK_HEIGHT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_ACTIVE_ASC'
  | 'IS_ACTIVE_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_AVERAGE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_COUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_COUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MAX_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_MIN_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_STDDEV_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_SUM_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_INCENTIVE_SEASON_ID_VARIANCE_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SEASON_INDEX_ASC'
  | 'SEASON_INDEX_DESC'
  | 'START_BLOCK_DATE_ASC'
  | 'START_BLOCK_DATE_DESC'
  | 'START_BLOCK_HEIGHT_ASC'
  | 'START_BLOCK_HEIGHT_DESC';

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LastBlock = Node & {
  __typename?: 'LastBlock';
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  timestamp: Scalars['Datetime']['output'];
};

export type LastBlockAggregates = {
  __typename?: 'LastBlockAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LastBlockAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LastBlockDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LastBlockMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LastBlockMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LastBlockStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LastBlockStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LastBlockSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LastBlockVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LastBlockVarianceSampleAggregates>;
};

export type LastBlockAverageAggregates = {
  __typename?: 'LastBlockAverageAggregates';
  /** Mean average of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LastBlock` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LastBlockCondition = {
  /** Checks for equality with the object’s `height` field. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type LastBlockDistinctCountAggregates = {
  __typename?: 'LastBlockDistinctCountAggregates';
  /** Distinct count of height across the matching connection */
  height?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LastBlock` object types. All fields are combined with a logical ‘and.’ */
export type LastBlockFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LastBlockFilter>>;
  /** Filter by the object’s `height` field. */
  height?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LastBlockFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LastBlockFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `LastBlock` for usage during aggregation. */
export type LastBlockGroupBy =
  | 'HEIGHT'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type LastBlockHavingAverageInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingDistinctCountInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `LastBlock` aggregates. */
export type LastBlockHavingInput = {
  AND?: InputMaybe<Array<LastBlockHavingInput>>;
  OR?: InputMaybe<Array<LastBlockHavingInput>>;
  average?: InputMaybe<LastBlockHavingAverageInput>;
  distinctCount?: InputMaybe<LastBlockHavingDistinctCountInput>;
  max?: InputMaybe<LastBlockHavingMaxInput>;
  min?: InputMaybe<LastBlockHavingMinInput>;
  stddevPopulation?: InputMaybe<LastBlockHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LastBlockHavingStddevSampleInput>;
  sum?: InputMaybe<LastBlockHavingSumInput>;
  variancePopulation?: InputMaybe<LastBlockHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LastBlockHavingVarianceSampleInput>;
};

export type LastBlockHavingMaxInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingMinInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingStddevPopulationInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingStddevSampleInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingSumInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingVariancePopulationInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockHavingVarianceSampleInput = {
  height?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LastBlockMaxAggregates = {
  __typename?: 'LastBlockMaxAggregates';
  /** Maximum of height across the matching connection */
  height?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LastBlockMinAggregates = {
  __typename?: 'LastBlockMinAggregates';
  /** Minimum of height across the matching connection */
  height?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LastBlockStddevPopulationAggregates = {
  __typename?: 'LastBlockStddevPopulationAggregates';
  /** Population standard deviation of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LastBlockStddevSampleAggregates = {
  __typename?: 'LastBlockStddevSampleAggregates';
  /** Sample standard deviation of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LastBlockSumAggregates = {
  __typename?: 'LastBlockSumAggregates';
  /** Sum of height across the matching connection */
  height: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type LastBlockVariancePopulationAggregates = {
  __typename?: 'LastBlockVariancePopulationAggregates';
  /** Population variance of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LastBlockVarianceSampleAggregates = {
  __typename?: 'LastBlockVarianceSampleAggregates';
  /** Sample variance of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LastBlock` values. */
export type LastBlocksConnection = {
  __typename?: 'LastBlocksConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LastBlockAggregates>;
  /** A list of edges which contains the `LastBlock` and cursor to aid in pagination. */
  edges: Array<LastBlocksEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LastBlockAggregates>>;
  /** A list of `LastBlock` objects. */
  nodes: Array<LastBlock>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LastBlock` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LastBlock` values. */
export type LastBlocksConnectionGroupedAggregatesArgs = {
  groupBy: Array<LastBlockGroupBy>;
  having?: InputMaybe<LastBlockHavingInput>;
};

/** A `LastBlock` edge in the connection. */
export type LastBlocksEdge = {
  __typename?: 'LastBlocksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LastBlock` at the end of the edge. */
  node: LastBlock;
};

/** Methods to use when ordering `LastBlock`. */
export type LastBlocksOrderBy =
  | 'HEIGHT_ASC'
  | 'HEIGHT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC';

export type LendingLiquidityBalanceChange = Node & {
  __typename?: 'LendingLiquidityBalanceChange';
  /** Reads a single `Account` that is related to this `LendingLiquidityBalanceChange`. */
  accountByLiquidityProviderId?: Maybe<Account>;
  amount: Scalars['BigFloat']['output'];
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  asset: ChainflipAsset;
  /** Reads a single `Event` that is related to this `LendingLiquidityBalanceChange`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  isPositionClosing?: Maybe<Scalars['Boolean']['output']>;
  isPositionOpening?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `LendingPool` that is related to this `LendingLiquidityBalanceChange`. */
  lendingPoolByPoolId: LendingPool;
  /** Reads a single `LiquidationSwapRequest` that is related to this `LendingLiquidityBalanceChange`. */
  liquidationSwapRequestByLiquidationSwapRequestId?: Maybe<LiquidationSwapRequest>;
  liquidationSwapRequestId?: Maybe<Scalars['Int']['output']>;
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Loan` that is related to this `LendingLiquidityBalanceChange`. */
  loanByLoanLossId?: Maybe<Loan>;
  loanLossId?: Maybe<Scalars['BigInt']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  poolId: Scalars['Int']['output'];
  timestamp: Scalars['Datetime']['output'];
  type: LendingPoolBalanceChangeType;
};

export type LendingLiquidityBalanceChangeAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingLiquidityBalanceChangeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingLiquidityBalanceChangeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingLiquidityBalanceChangeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingLiquidityBalanceChangeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingLiquidityBalanceChangeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingLiquidityBalanceChangeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingLiquidityBalanceChangeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingLiquidityBalanceChangeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingLiquidityBalanceChangeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LendingLiquidityBalanceChange` object types. */
export type LendingLiquidityBalanceChangeAggregatesFilter = {
  /** Mean average aggregate over matching `LendingLiquidityBalanceChange` objects. */
  average?: InputMaybe<LendingLiquidityBalanceChangeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LendingLiquidityBalanceChange` objects. */
  distinctCount?: InputMaybe<LendingLiquidityBalanceChangeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LendingLiquidityBalanceChange` object to be included within the aggregate. */
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Maximum aggregate over matching `LendingLiquidityBalanceChange` objects. */
  max?: InputMaybe<LendingLiquidityBalanceChangeMaxAggregateFilter>;
  /** Minimum aggregate over matching `LendingLiquidityBalanceChange` objects. */
  min?: InputMaybe<LendingLiquidityBalanceChangeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LendingLiquidityBalanceChange` objects. */
  stddevPopulation?: InputMaybe<LendingLiquidityBalanceChangeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LendingLiquidityBalanceChange` objects. */
  stddevSample?: InputMaybe<LendingLiquidityBalanceChangeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LendingLiquidityBalanceChange` objects. */
  sum?: InputMaybe<LendingLiquidityBalanceChangeSumAggregateFilter>;
  /** Population variance aggregate over matching `LendingLiquidityBalanceChange` objects. */
  variancePopulation?: InputMaybe<LendingLiquidityBalanceChangeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LendingLiquidityBalanceChange` objects. */
  varianceSample?: InputMaybe<LendingLiquidityBalanceChangeVarianceSampleAggregateFilter>;
};

export type LendingLiquidityBalanceChangeAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidationSwapRequestId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  loanLossId?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
};

export type LendingLiquidityBalanceChangeAverageAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingLiquidityBalanceChange` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LendingLiquidityBalanceChangeCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isPositionClosing` field. */
  isPositionClosing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isPositionOpening` field. */
  isPositionOpening?: InputMaybe<Scalars['Boolean']['input']>;
  lendingPoolByPoolId?: InputMaybe<Scalars['ID']['input']>;
  liquidationSwapRequestByLiquidationSwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidationSwapRequestId` field. */
  liquidationSwapRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  loanByLoanLossId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `loanLossId` field. */
  loanLossId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LendingPoolBalanceChangeType>;
};

export type LendingLiquidityBalanceChangeDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isPositionClosing?: InputMaybe<BigIntFilter>;
  isPositionOpening?: InputMaybe<BigIntFilter>;
  liquidationSwapRequestId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  loanLossId?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LendingLiquidityBalanceChangeDistinctCountAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isPositionClosing across the matching connection */
  isPositionClosing?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isPositionOpening across the matching connection */
  isPositionOpening?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type LendingLiquidityBalanceChangeFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** A related `accountByLiquidityProviderId` exists. */
  accountByLiquidityProviderIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingLiquidityBalanceChangeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isPositionClosing` field. */
  isPositionClosing?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isPositionOpening` field. */
  isPositionOpening?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lendingPoolByPoolId` relation. */
  lendingPoolByPoolId?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `liquidationSwapRequestByLiquidationSwapRequestId` relation. */
  liquidationSwapRequestByLiquidationSwapRequestId?: InputMaybe<LiquidationSwapRequestFilter>;
  /** A related `liquidationSwapRequestByLiquidationSwapRequestId` exists. */
  liquidationSwapRequestByLiquidationSwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapRequestId` field. */
  liquidationSwapRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loanByLoanLossId` relation. */
  loanByLoanLossId?: InputMaybe<LoanFilter>;
  /** A related `loanByLoanLossId` exists. */
  loanByLoanLossIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanLossId` field. */
  loanLossId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingLiquidityBalanceChangeFilter>>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LendingPoolBalanceChangeTypeFilter>;
};

/** Grouping methods for `LendingLiquidityBalanceChange` for usage during aggregation. */
export type LendingLiquidityBalanceChangeGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'ASSET'
  | 'EVENT_ID'
  | 'IS_POSITION_CLOSING'
  | 'IS_POSITION_OPENING'
  | 'LIQUIDATION_SWAP_REQUEST_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'LOAN_LOSS_ID'
  | 'POOL_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TYPE';

export type LendingLiquidityBalanceChangeHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `LendingLiquidityBalanceChange` aggregates. */
export type LendingLiquidityBalanceChangeHavingInput = {
  AND?: InputMaybe<Array<LendingLiquidityBalanceChangeHavingInput>>;
  OR?: InputMaybe<Array<LendingLiquidityBalanceChangeHavingInput>>;
  average?: InputMaybe<LendingLiquidityBalanceChangeHavingAverageInput>;
  distinctCount?: InputMaybe<LendingLiquidityBalanceChangeHavingDistinctCountInput>;
  max?: InputMaybe<LendingLiquidityBalanceChangeHavingMaxInput>;
  min?: InputMaybe<LendingLiquidityBalanceChangeHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingLiquidityBalanceChangeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingLiquidityBalanceChangeHavingStddevSampleInput>;
  sum?: InputMaybe<LendingLiquidityBalanceChangeHavingSumInput>;
  variancePopulation?: InputMaybe<LendingLiquidityBalanceChangeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingLiquidityBalanceChangeHavingVarianceSampleInput>;
};

export type LendingLiquidityBalanceChangeHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidationSwapRequestId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  loanLossId?: InputMaybe<HavingBigintFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingLiquidityBalanceChangeMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidationSwapRequestId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  loanLossId?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LendingLiquidityBalanceChangeMaxAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LendingLiquidityBalanceChangeMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidationSwapRequestId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  loanLossId?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LendingLiquidityBalanceChangeMinAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LendingLiquidityBalanceChangeStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidationSwapRequestId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  loanLossId?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
};

export type LendingLiquidityBalanceChangeStddevPopulationAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingLiquidityBalanceChangeStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidationSwapRequestId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  loanLossId?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
};

export type LendingLiquidityBalanceChangeStddevSampleAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingLiquidityBalanceChangeSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidationSwapRequestId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  loanLossId?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigIntFilter>;
};

export type LendingLiquidityBalanceChangeSumAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of loanLossId across the matching connection */
  loanLossId: Scalars['BigFloat']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
};

export type LendingLiquidityBalanceChangeVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidationSwapRequestId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  loanLossId?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
};

export type LendingLiquidityBalanceChangeVariancePopulationAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingLiquidityBalanceChangeVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidationSwapRequestId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  loanLossId?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
};

export type LendingLiquidityBalanceChangeVarianceSampleAggregates = {
  __typename?: 'LendingLiquidityBalanceChangeVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidationSwapRequestId across the matching connection */
  liquidationSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanLossId across the matching connection */
  loanLossId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingLiquidityBalanceChange` values. */
export type LendingLiquidityBalanceChangesConnection = {
  __typename?: 'LendingLiquidityBalanceChangesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingLiquidityBalanceChangeAggregates>;
  /** A list of edges which contains the `LendingLiquidityBalanceChange` and cursor to aid in pagination. */
  edges: Array<LendingLiquidityBalanceChangesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingLiquidityBalanceChangeAggregates>>;
  /** A list of `LendingLiquidityBalanceChange` objects. */
  nodes: Array<LendingLiquidityBalanceChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingLiquidityBalanceChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingLiquidityBalanceChange` values. */
export type LendingLiquidityBalanceChangesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingLiquidityBalanceChangeGroupBy>;
  having?: InputMaybe<LendingLiquidityBalanceChangeHavingInput>;
};

/** A `LendingLiquidityBalanceChange` edge in the connection. */
export type LendingLiquidityBalanceChangesEdge = {
  __typename?: 'LendingLiquidityBalanceChangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingLiquidityBalanceChange` at the end of the edge. */
  node: LendingLiquidityBalanceChange;
};

/** Methods to use when ordering `LendingLiquidityBalanceChange`. */
export type LendingLiquidityBalanceChangesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_POSITION_CLOSING_ASC'
  | 'IS_POSITION_CLOSING_DESC'
  | 'IS_POSITION_OPENING_ASC'
  | 'IS_POSITION_OPENING_DESC'
  | 'LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LOAN_LOSS_ID_ASC'
  | 'LOAN_LOSS_ID_DESC'
  | 'NATURAL'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type LendingPool = Node & {
  __typename?: 'LendingPool';
  asset: ChainflipAsset;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangesByPoolId: LendingLiquidityBalanceChangesConnection;
  /** Reads and enables pagination through a set of `LendingPoolIncentiveProgram`. */
  lendingPoolIncentiveProgramsByLendingPoolId: LendingPoolIncentiveProgramsConnection;
  /** Reads and enables pagination through a set of `LendingPoolSnapshot`. */
  lendingPoolSnapshotsByPoolId: LendingPoolSnapshotsConnection;
  /** Reads and enables pagination through a set of `LendingPoolStat`. */
  lendingPoolStatsByPoolId: LendingPoolStatsConnection;
  /** Reads and enables pagination through a set of `LoanFee`. */
  loanFeesByPoolId: LoanFeesConnection;
  /** Reads and enables pagination through a set of `Loan`. */
  loansByPoolId: LoansConnection;
  /** Reads and enables pagination through a set of `LpLendingPoolSnapshot`. */
  lpLendingPoolSnapshotsByLendingPoolId: LpLendingPoolSnapshotsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type LendingPoolLendingLiquidityBalanceChangesByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy>>;
};


export type LendingPoolLendingPoolIncentiveProgramsByLendingPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolIncentiveProgramCondition>;
  filter?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolIncentiveProgramsOrderBy>>;
};


export type LendingPoolLendingPoolSnapshotsByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolSnapshotCondition>;
  filter?: InputMaybe<LendingPoolSnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolSnapshotsOrderBy>>;
};


export type LendingPoolLendingPoolStatsByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolStatCondition>;
  filter?: InputMaybe<LendingPoolStatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolStatsOrderBy>>;
};


export type LendingPoolLoanFeesByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanFeeCondition>;
  filter?: InputMaybe<LoanFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanFeesOrderBy>>;
};


export type LendingPoolLoansByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


export type LendingPoolLpLendingPoolSnapshotsByLendingPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLendingPoolSnapshotCondition>;
  filter?: InputMaybe<LpLendingPoolSnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLendingPoolSnapshotsOrderBy>>;
};

export type LendingPoolAggregates = {
  __typename?: 'LendingPoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingPoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingPoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingPoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingPoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingPoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingPoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingPoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingPoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingPoolVarianceSampleAggregates>;
};

export type LendingPoolAverageAggregates = {
  __typename?: 'LendingPoolAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolBalanceChangeType =
  | 'FEES_ACCRUED'
  | 'LIQUIDATION_LOSS'
  | 'MANUAL_DEPOSIT'
  | 'MANUAL_WITHDRAWAL'
  | 'SYSTEM_LIQUIDATION_EXCESS_AMOUNT_DEPOSIT'
  | 'SYSTEM_LIQUIDATION_UNUSED_AMOUNT_DEPOSIT'
  | 'SYSTEM_LIQUIDATION_WITHDRAWAL';

/** A filter to be used against LendingPoolBalanceChangeType fields. All fields are combined with a logical ‘and.’ */
export type LendingPoolBalanceChangeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LendingPoolBalanceChangeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LendingPoolBalanceChangeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LendingPoolBalanceChangeType>>;
};

/**
 * A condition to be used against `LendingPool` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LendingPoolCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type LendingPoolDistinctCountAggregates = {
  __typename?: 'LendingPoolDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingPool` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingPoolFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingLiquidityBalanceChangesByPoolId` relation. */
  lendingLiquidityBalanceChangesByPoolId?: InputMaybe<LendingPoolToManyLendingLiquidityBalanceChangeFilter>;
  /** Some related `lendingLiquidityBalanceChangesByPoolId` exist. */
  lendingLiquidityBalanceChangesByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lendingPoolIncentiveProgramsByLendingPoolId` relation. */
  lendingPoolIncentiveProgramsByLendingPoolId?: InputMaybe<LendingPoolToManyLendingPoolIncentiveProgramFilter>;
  /** Some related `lendingPoolIncentiveProgramsByLendingPoolId` exist. */
  lendingPoolIncentiveProgramsByLendingPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lendingPoolSnapshotsByPoolId` relation. */
  lendingPoolSnapshotsByPoolId?: InputMaybe<LendingPoolToManyLendingPoolSnapshotFilter>;
  /** Some related `lendingPoolSnapshotsByPoolId` exist. */
  lendingPoolSnapshotsByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lendingPoolStatsByPoolId` relation. */
  lendingPoolStatsByPoolId?: InputMaybe<LendingPoolToManyLendingPoolStatFilter>;
  /** Some related `lendingPoolStatsByPoolId` exist. */
  lendingPoolStatsByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanFeesByPoolId` relation. */
  loanFeesByPoolId?: InputMaybe<LendingPoolToManyLoanFeeFilter>;
  /** Some related `loanFeesByPoolId` exist. */
  loanFeesByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loansByPoolId` relation. */
  loansByPoolId?: InputMaybe<LendingPoolToManyLoanFilter>;
  /** Some related `loansByPoolId` exist. */
  loansByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpLendingPoolSnapshotsByLendingPoolId` relation. */
  lpLendingPoolSnapshotsByLendingPoolId?: InputMaybe<LendingPoolToManyLpLendingPoolSnapshotFilter>;
  /** Some related `lpLendingPoolSnapshotsByLendingPoolId` exist. */
  lpLendingPoolSnapshotsByLendingPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LendingPoolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingPoolFilter>>;
};

export type LendingPoolIncentiveProgram = Node & {
  __typename?: 'LendingPoolIncentiveProgram';
  id: Scalars['Int']['output'];
  /** Reads a single `IncentiveSeason` that is related to this `LendingPoolIncentiveProgram`. */
  incentiveSeasonByIncentiveSeasonId: IncentiveSeason;
  incentiveSeasonId: Scalars['Int']['output'];
  /** Reads a single `LendingPool` that is related to this `LendingPoolIncentiveProgram`. */
  lendingPoolByLendingPoolId: LendingPool;
  lendingPoolId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LpFlipAirdropDistributionEvent`. */
  lpFlipAirdropDistributionEventsByLendingPoolIncentiveProgramId: LpFlipAirdropDistributionEventsConnection;
  /** Reads and enables pagination through a set of `LpPointDistributionEvent`. */
  lpPointDistributionEventsByLendingPoolIncentiveProgramId: LpPointDistributionEventsConnection;
  maxAllocatedAmountValueUsd: Scalars['BigFloat']['output'];
  maxAllocatedFlipAmount: Scalars['BigFloat']['output'];
  maxAllocatedPoints: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  pointDistributionIntervalBlocks: Scalars['Int']['output'];
  pointsDistributedPerInterval: Scalars['BigFloat']['output'];
  type: LendingPoolIncentiveProgramType;
};


export type LendingPoolIncentiveProgramLpFlipAirdropDistributionEventsByLendingPoolIncentiveProgramIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpFlipAirdropDistributionEventCondition>;
  filter?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpFlipAirdropDistributionEventsOrderBy>>;
};


export type LendingPoolIncentiveProgramLpPointDistributionEventsByLendingPoolIncentiveProgramIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpPointDistributionEventCondition>;
  filter?: InputMaybe<LpPointDistributionEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpPointDistributionEventsOrderBy>>;
};

export type LendingPoolIncentiveProgramAggregates = {
  __typename?: 'LendingPoolIncentiveProgramAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingPoolIncentiveProgramAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingPoolIncentiveProgramDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingPoolIncentiveProgramMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingPoolIncentiveProgramMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingPoolIncentiveProgramStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingPoolIncentiveProgramStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingPoolIncentiveProgramSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingPoolIncentiveProgramVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingPoolIncentiveProgramVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LendingPoolIncentiveProgram` object types. */
export type LendingPoolIncentiveProgramAggregatesFilter = {
  /** Mean average aggregate over matching `LendingPoolIncentiveProgram` objects. */
  average?: InputMaybe<LendingPoolIncentiveProgramAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LendingPoolIncentiveProgram` objects. */
  distinctCount?: InputMaybe<LendingPoolIncentiveProgramDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LendingPoolIncentiveProgram` object to be included within the aggregate. */
  filter?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** Maximum aggregate over matching `LendingPoolIncentiveProgram` objects. */
  max?: InputMaybe<LendingPoolIncentiveProgramMaxAggregateFilter>;
  /** Minimum aggregate over matching `LendingPoolIncentiveProgram` objects. */
  min?: InputMaybe<LendingPoolIncentiveProgramMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LendingPoolIncentiveProgram` objects. */
  stddevPopulation?: InputMaybe<LendingPoolIncentiveProgramStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LendingPoolIncentiveProgram` objects. */
  stddevSample?: InputMaybe<LendingPoolIncentiveProgramStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LendingPoolIncentiveProgram` objects. */
  sum?: InputMaybe<LendingPoolIncentiveProgramSumAggregateFilter>;
  /** Population variance aggregate over matching `LendingPoolIncentiveProgram` objects. */
  variancePopulation?: InputMaybe<LendingPoolIncentiveProgramVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LendingPoolIncentiveProgram` objects. */
  varianceSample?: InputMaybe<LendingPoolIncentiveProgramVarianceSampleAggregateFilter>;
};

export type LendingPoolIncentiveProgramAverageAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  incentiveSeasonId?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigFloatFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramAverageAggregates = {
  __typename?: 'LendingPoolIncentiveProgramAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingPoolIncentiveProgram` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LendingPoolIncentiveProgramCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  incentiveSeasonByIncentiveSeasonId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `incentiveSeasonId` field. */
  incentiveSeasonId?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolByLendingPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lendingPoolId` field. */
  lendingPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxAllocatedAmountValueUsd` field. */
  maxAllocatedAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxAllocatedFlipAmount` field. */
  maxAllocatedFlipAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxAllocatedPoints` field. */
  maxAllocatedPoints?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `pointDistributionIntervalBlocks` field. */
  pointDistributionIntervalBlocks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `pointsDistributedPerInterval` field. */
  pointsDistributedPerInterval?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LendingPoolIncentiveProgramType>;
};

export type LendingPoolIncentiveProgramDistinctCountAggregateFilter = {
  id?: InputMaybe<BigIntFilter>;
  incentiveSeasonId?: InputMaybe<BigIntFilter>;
  lendingPoolId?: InputMaybe<BigIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigIntFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigIntFilter>;
  maxAllocatedPoints?: InputMaybe<BigIntFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LendingPoolIncentiveProgramDistinctCountAggregates = {
  __typename?: 'LendingPoolIncentiveProgramDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingPoolIncentiveProgram` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolIncentiveProgramFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingPoolIncentiveProgramFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `incentiveSeasonByIncentiveSeasonId` relation. */
  incentiveSeasonByIncentiveSeasonId?: InputMaybe<IncentiveSeasonFilter>;
  /** Filter by the object’s `incentiveSeasonId` field. */
  incentiveSeasonId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolByLendingPoolId` relation. */
  lendingPoolByLendingPoolId?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `lendingPoolId` field. */
  lendingPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lpFlipAirdropDistributionEventsByLendingPoolIncentiveProgramId` relation. */
  lpFlipAirdropDistributionEventsByLendingPoolIncentiveProgramId?: InputMaybe<LendingPoolIncentiveProgramToManyLpFlipAirdropDistributionEventFilter>;
  /** Some related `lpFlipAirdropDistributionEventsByLendingPoolIncentiveProgramId` exist. */
  lpFlipAirdropDistributionEventsByLendingPoolIncentiveProgramIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lpPointDistributionEventsByLendingPoolIncentiveProgramId` relation. */
  lpPointDistributionEventsByLendingPoolIncentiveProgramId?: InputMaybe<LendingPoolIncentiveProgramToManyLpPointDistributionEventFilter>;
  /** Some related `lpPointDistributionEventsByLendingPoolIncentiveProgramId` exist. */
  lpPointDistributionEventsByLendingPoolIncentiveProgramIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maxAllocatedAmountValueUsd` field. */
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxAllocatedFlipAmount` field. */
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxAllocatedPoints` field. */
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingPoolIncentiveProgramFilter>>;
  /** Filter by the object’s `pointDistributionIntervalBlocks` field. */
  pointDistributionIntervalBlocks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pointsDistributedPerInterval` field. */
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LendingPoolIncentiveProgramTypeFilter>;
};

/** Grouping methods for `LendingPoolIncentiveProgram` for usage during aggregation. */
export type LendingPoolIncentiveProgramGroupBy =
  | 'INCENTIVE_SEASON_ID'
  | 'LENDING_POOL_ID'
  | 'MAX_ALLOCATED_AMOUNT_VALUE_USD'
  | 'MAX_ALLOCATED_FLIP_AMOUNT'
  | 'MAX_ALLOCATED_POINTS'
  | 'POINTS_DISTRIBUTED_PER_INTERVAL'
  | 'POINT_DISTRIBUTION_INTERVAL_BLOCKS'
  | 'TYPE';

export type LendingPoolIncentiveProgramHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LendingPoolIncentiveProgram` aggregates. */
export type LendingPoolIncentiveProgramHavingInput = {
  AND?: InputMaybe<Array<LendingPoolIncentiveProgramHavingInput>>;
  OR?: InputMaybe<Array<LendingPoolIncentiveProgramHavingInput>>;
  average?: InputMaybe<LendingPoolIncentiveProgramHavingAverageInput>;
  distinctCount?: InputMaybe<LendingPoolIncentiveProgramHavingDistinctCountInput>;
  max?: InputMaybe<LendingPoolIncentiveProgramHavingMaxInput>;
  min?: InputMaybe<LendingPoolIncentiveProgramHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingPoolIncentiveProgramHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingPoolIncentiveProgramHavingStddevSampleInput>;
  sum?: InputMaybe<LendingPoolIncentiveProgramHavingSumInput>;
  variancePopulation?: InputMaybe<LendingPoolIncentiveProgramHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingPoolIncentiveProgramHavingVarianceSampleInput>;
};

export type LendingPoolIncentiveProgramHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  incentiveSeasonId?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<HavingBigfloatFilter>;
  maxAllocatedPoints?: InputMaybe<HavingBigfloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<HavingIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<HavingBigfloatFilter>;
};

export type LendingPoolIncentiveProgramMaxAggregateFilter = {
  id?: InputMaybe<IntFilter>;
  incentiveSeasonId?: InputMaybe<IntFilter>;
  lendingPoolId?: InputMaybe<IntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<IntFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramMaxAggregates = {
  __typename?: 'LendingPoolIncentiveProgramMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolIncentiveProgramMinAggregateFilter = {
  id?: InputMaybe<IntFilter>;
  incentiveSeasonId?: InputMaybe<IntFilter>;
  lendingPoolId?: InputMaybe<IntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<IntFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramMinAggregates = {
  __typename?: 'LendingPoolIncentiveProgramMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolIncentiveProgramStddevPopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  incentiveSeasonId?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigFloatFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramStddevPopulationAggregates = {
  __typename?: 'LendingPoolIncentiveProgramStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolIncentiveProgramStddevSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  incentiveSeasonId?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigFloatFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramStddevSampleAggregates = {
  __typename?: 'LendingPoolIncentiveProgramStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolIncentiveProgramSumAggregateFilter = {
  id?: InputMaybe<BigIntFilter>;
  incentiveSeasonId?: InputMaybe<BigIntFilter>;
  lendingPoolId?: InputMaybe<BigIntFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigIntFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramSumAggregates = {
  __typename?: 'LendingPoolIncentiveProgramSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of incentiveSeasonId across the matching connection */
  incentiveSeasonId: Scalars['BigInt']['output'];
  /** Sum of lendingPoolId across the matching connection */
  lendingPoolId: Scalars['BigInt']['output'];
  /** Sum of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount: Scalars['BigFloat']['output'];
  /** Sum of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints: Scalars['BigFloat']['output'];
  /** Sum of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks: Scalars['BigInt']['output'];
  /** Sum of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `LpFlipAirdropDistributionEvent` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolIncentiveProgramToManyLpFlipAirdropDistributionEventFilter = {
  /** Aggregates across related `LpFlipAirdropDistributionEvent` match the filter criteria. */
  aggregates?: InputMaybe<LpFlipAirdropDistributionEventAggregatesFilter>;
  /** Every related `LpFlipAirdropDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  /** No related `LpFlipAirdropDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  /** Some related `LpFlipAirdropDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
};

/** A filter to be used against many `LpPointDistributionEvent` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolIncentiveProgramToManyLpPointDistributionEventFilter = {
  /** Aggregates across related `LpPointDistributionEvent` match the filter criteria. */
  aggregates?: InputMaybe<LpPointDistributionEventAggregatesFilter>;
  /** Every related `LpPointDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpPointDistributionEventFilter>;
  /** No related `LpPointDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpPointDistributionEventFilter>;
  /** Some related `LpPointDistributionEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpPointDistributionEventFilter>;
};

export type LendingPoolIncentiveProgramType =
  | 'TOTAL_BORROWED_AMOUNT'
  | 'TOTAL_SUPPLIED_AMOUNT';

/** A filter to be used against LendingPoolIncentiveProgramType fields. All fields are combined with a logical ‘and.’ */
export type LendingPoolIncentiveProgramTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LendingPoolIncentiveProgramType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LendingPoolIncentiveProgramType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LendingPoolIncentiveProgramType>>;
};

export type LendingPoolIncentiveProgramVariancePopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  incentiveSeasonId?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigFloatFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramVariancePopulationAggregates = {
  __typename?: 'LendingPoolIncentiveProgramVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolIncentiveProgramVarianceSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  incentiveSeasonId?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  maxAllocatedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  maxAllocatedFlipAmount?: InputMaybe<BigFloatFilter>;
  maxAllocatedPoints?: InputMaybe<BigFloatFilter>;
  pointDistributionIntervalBlocks?: InputMaybe<BigFloatFilter>;
  pointsDistributedPerInterval?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolIncentiveProgramVarianceSampleAggregates = {
  __typename?: 'LendingPoolIncentiveProgramVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of incentiveSeasonId across the matching connection */
  incentiveSeasonId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxAllocatedAmountValueUsd across the matching connection */
  maxAllocatedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxAllocatedFlipAmount across the matching connection */
  maxAllocatedFlipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxAllocatedPoints across the matching connection */
  maxAllocatedPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of pointDistributionIntervalBlocks across the matching connection */
  pointDistributionIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of pointsDistributedPerInterval across the matching connection */
  pointsDistributedPerInterval?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingPoolIncentiveProgram` values. */
export type LendingPoolIncentiveProgramsConnection = {
  __typename?: 'LendingPoolIncentiveProgramsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingPoolIncentiveProgramAggregates>;
  /** A list of edges which contains the `LendingPoolIncentiveProgram` and cursor to aid in pagination. */
  edges: Array<LendingPoolIncentiveProgramsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingPoolIncentiveProgramAggregates>>;
  /** A list of `LendingPoolIncentiveProgram` objects. */
  nodes: Array<LendingPoolIncentiveProgram>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingPoolIncentiveProgram` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingPoolIncentiveProgram` values. */
export type LendingPoolIncentiveProgramsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingPoolIncentiveProgramGroupBy>;
  having?: InputMaybe<LendingPoolIncentiveProgramHavingInput>;
};

/** A `LendingPoolIncentiveProgram` edge in the connection. */
export type LendingPoolIncentiveProgramsEdge = {
  __typename?: 'LendingPoolIncentiveProgramsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingPoolIncentiveProgram` at the end of the edge. */
  node: LendingPoolIncentiveProgram;
};

/** Methods to use when ordering `LendingPoolIncentiveProgram`. */
export type LendingPoolIncentiveProgramsOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INCENTIVE_SEASON_ID_ASC'
  | 'INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_COUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_COUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LP_SS58_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LP_SS58_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_POINT_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_USD_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_FLIP_AMOUNT_USD_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_POINT_AMOUNT_ASC'
  | 'LP_FLIP_AIRDROP_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_AVERAGE_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_COUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_COUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LP_SS58_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_LP_SS58_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_DISTINCT_COUNT_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_TIMESTAMP_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_TIMESTAMP_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MAX_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_TIMESTAMP_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_TIMESTAMP_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_MIN_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_STDDEV_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_SUM_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_POPULATION_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'LP_POINT_DISTRIBUTION_EVENTS_BY_LENDING_POOL_INCENTIVE_PROGRAM_ID_VARIANCE_SAMPLE_TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC'
  | 'MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'MAX_ALLOCATED_POINTS_ASC'
  | 'MAX_ALLOCATED_POINTS_DESC'
  | 'NATURAL'
  | 'POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type LendingPoolMaxAggregates = {
  __typename?: 'LendingPoolMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type LendingPoolMinAggregates = {
  __typename?: 'LendingPoolMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type LendingPoolSnapshot = Node & {
  __typename?: 'LendingPoolSnapshot';
  asset: ChainflipAsset;
  availableAmount: Scalars['BigFloat']['output'];
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  block: Scalars['Int']['output'];
  id: Scalars['BigInt']['output'];
  interestRateBps: Scalars['Int']['output'];
  /** Reads a single `LendingPool` that is related to this `LendingPoolSnapshot`. */
  lendingPoolByPoolId: LendingPool;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  poolId: Scalars['Int']['output'];
  timestamp: Scalars['Datetime']['output'];
  totalAmount: Scalars['BigFloat']['output'];
  totalAmountValueUsd: Scalars['BigFloat']['output'];
  unavailableAmount: Scalars['BigFloat']['output'];
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
  utilisationRateBps: Scalars['Int']['output'];
};

export type LendingPoolSnapshotAggregates = {
  __typename?: 'LendingPoolSnapshotAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingPoolSnapshotAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingPoolSnapshotDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingPoolSnapshotMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingPoolSnapshotMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingPoolSnapshotStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingPoolSnapshotStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingPoolSnapshotSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingPoolSnapshotVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingPoolSnapshotVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LendingPoolSnapshot` object types. */
export type LendingPoolSnapshotAggregatesFilter = {
  /** Mean average aggregate over matching `LendingPoolSnapshot` objects. */
  average?: InputMaybe<LendingPoolSnapshotAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LendingPoolSnapshot` objects. */
  distinctCount?: InputMaybe<LendingPoolSnapshotDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LendingPoolSnapshot` object to be included within the aggregate. */
  filter?: InputMaybe<LendingPoolSnapshotFilter>;
  /** Maximum aggregate over matching `LendingPoolSnapshot` objects. */
  max?: InputMaybe<LendingPoolSnapshotMaxAggregateFilter>;
  /** Minimum aggregate over matching `LendingPoolSnapshot` objects. */
  min?: InputMaybe<LendingPoolSnapshotMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LendingPoolSnapshot` objects. */
  stddevPopulation?: InputMaybe<LendingPoolSnapshotStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LendingPoolSnapshot` objects. */
  stddevSample?: InputMaybe<LendingPoolSnapshotStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LendingPoolSnapshot` objects. */
  sum?: InputMaybe<LendingPoolSnapshotSumAggregateFilter>;
  /** Population variance aggregate over matching `LendingPoolSnapshot` objects. */
  variancePopulation?: InputMaybe<LendingPoolSnapshotVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LendingPoolSnapshot` objects. */
  varianceSample?: InputMaybe<LendingPoolSnapshotVarianceSampleAggregateFilter>;
};

export type LendingPoolSnapshotAverageAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolSnapshotAverageAggregates = {
  __typename?: 'LendingPoolSnapshotAverageAggregates';
  /** Mean average of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingPoolSnapshot` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LendingPoolSnapshotCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `interestRateBps` field. */
  interestRateBps?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolByPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAmountValueUsd` field. */
  totalAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `utilisationRateBps` field. */
  utilisationRateBps?: InputMaybe<Scalars['Int']['input']>;
};

export type LendingPoolSnapshotDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  availableAmount?: InputMaybe<BigIntFilter>;
  availableAmountValueUsd?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interestRateBps?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigIntFilter>;
  totalAmountValueUsd?: InputMaybe<BigIntFilter>;
  unavailableAmount?: InputMaybe<BigIntFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigIntFilter>;
  utilisationRateBps?: InputMaybe<BigIntFilter>;
};

export type LendingPoolSnapshotDistinctCountAggregates = {
  __typename?: 'LendingPoolSnapshotDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingPoolSnapshot` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolSnapshotFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingPoolSnapshotFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `interestRateBps` field. */
  interestRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolByPoolId` relation. */
  lendingPoolByPoolId?: InputMaybe<LendingPoolFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LendingPoolSnapshotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingPoolSnapshotFilter>>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAmountValueUsd` field. */
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `utilisationRateBps` field. */
  utilisationRateBps?: InputMaybe<IntFilter>;
};

/** Grouping methods for `LendingPoolSnapshot` for usage during aggregation. */
export type LendingPoolSnapshotGroupBy =
  | 'ASSET'
  | 'AVAILABLE_AMOUNT'
  | 'AVAILABLE_AMOUNT_VALUE_USD'
  | 'BLOCK'
  | 'INTEREST_RATE_BPS'
  | 'POOL_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TOTAL_AMOUNT'
  | 'TOTAL_AMOUNT_VALUE_USD'
  | 'UNAVAILABLE_AMOUNT'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD'
  | 'UTILISATION_RATE_BPS';

export type LendingPoolSnapshotHavingAverageInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingDistinctCountInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LendingPoolSnapshot` aggregates. */
export type LendingPoolSnapshotHavingInput = {
  AND?: InputMaybe<Array<LendingPoolSnapshotHavingInput>>;
  OR?: InputMaybe<Array<LendingPoolSnapshotHavingInput>>;
  average?: InputMaybe<LendingPoolSnapshotHavingAverageInput>;
  distinctCount?: InputMaybe<LendingPoolSnapshotHavingDistinctCountInput>;
  max?: InputMaybe<LendingPoolSnapshotHavingMaxInput>;
  min?: InputMaybe<LendingPoolSnapshotHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingPoolSnapshotHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingPoolSnapshotHavingStddevSampleInput>;
  sum?: InputMaybe<LendingPoolSnapshotHavingSumInput>;
  variancePopulation?: InputMaybe<LendingPoolSnapshotHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingPoolSnapshotHavingVarianceSampleInput>;
};

export type LendingPoolSnapshotHavingMaxInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingMinInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingStddevPopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingStddevSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingSumInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingVariancePopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotHavingVarianceSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interestRateBps?: InputMaybe<HavingIntFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  utilisationRateBps?: InputMaybe<HavingIntFilter>;
};

export type LendingPoolSnapshotMaxAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interestRateBps?: InputMaybe<IntFilter>;
  poolId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<IntFilter>;
};

export type LendingPoolSnapshotMaxAggregates = {
  __typename?: 'LendingPoolSnapshotMaxAggregates';
  /** Maximum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['Int']['output']>;
};

export type LendingPoolSnapshotMinAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interestRateBps?: InputMaybe<IntFilter>;
  poolId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<IntFilter>;
};

export type LendingPoolSnapshotMinAggregates = {
  __typename?: 'LendingPoolSnapshotMinAggregates';
  /** Minimum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['Int']['output']>;
};

export type LendingPoolSnapshotStddevPopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolSnapshotStddevPopulationAggregates = {
  __typename?: 'LendingPoolSnapshotStddevPopulationAggregates';
  /** Population standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolSnapshotStddevSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolSnapshotStddevSampleAggregates = {
  __typename?: 'LendingPoolSnapshotStddevSampleAggregates';
  /** Sample standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolSnapshotSumAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigIntFilter>;
};

export type LendingPoolSnapshotSumAggregates = {
  __typename?: 'LendingPoolSnapshotSumAggregates';
  /** Sum of availableAmount across the matching connection */
  availableAmount: Scalars['BigFloat']['output'];
  /** Sum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of interestRateBps across the matching connection */
  interestRateBps: Scalars['BigInt']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
  /** Sum of totalAmount across the matching connection */
  totalAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmount across the matching connection */
  unavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of utilisationRateBps across the matching connection */
  utilisationRateBps: Scalars['BigInt']['output'];
};

export type LendingPoolSnapshotVariancePopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolSnapshotVariancePopulationAggregates = {
  __typename?: 'LendingPoolSnapshotVariancePopulationAggregates';
  /** Population variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolSnapshotVarianceSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestRateBps?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  utilisationRateBps?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolSnapshotVarianceSampleAggregates = {
  __typename?: 'LendingPoolSnapshotVarianceSampleAggregates';
  /** Sample variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestRateBps across the matching connection */
  interestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of utilisationRateBps across the matching connection */
  utilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingPoolSnapshot` values. */
export type LendingPoolSnapshotsConnection = {
  __typename?: 'LendingPoolSnapshotsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingPoolSnapshotAggregates>;
  /** A list of edges which contains the `LendingPoolSnapshot` and cursor to aid in pagination. */
  edges: Array<LendingPoolSnapshotsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingPoolSnapshotAggregates>>;
  /** A list of `LendingPoolSnapshot` objects. */
  nodes: Array<LendingPoolSnapshot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingPoolSnapshot` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingPoolSnapshot` values. */
export type LendingPoolSnapshotsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingPoolSnapshotGroupBy>;
  having?: InputMaybe<LendingPoolSnapshotHavingInput>;
};

/** A `LendingPoolSnapshot` edge in the connection. */
export type LendingPoolSnapshotsEdge = {
  __typename?: 'LendingPoolSnapshotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingPoolSnapshot` at the end of the edge. */
  node: LendingPoolSnapshot;
};

/** Methods to use when ordering `LendingPoolSnapshot`. */
export type LendingPoolSnapshotsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'AVAILABLE_AMOUNT_ASC'
  | 'AVAILABLE_AMOUNT_DESC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEREST_RATE_BPS_ASC'
  | 'INTEREST_RATE_BPS_DESC'
  | 'NATURAL'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TOTAL_AMOUNT_ASC'
  | 'TOTAL_AMOUNT_DESC'
  | 'TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'UNAVAILABLE_AMOUNT_ASC'
  | 'UNAVAILABLE_AMOUNT_DESC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'UTILISATION_RATE_BPS_ASC'
  | 'UTILISATION_RATE_BPS_DESC';

export type LendingPoolStat = Node & {
  __typename?: 'LendingPoolStat';
  asset: ChainflipAsset;
  avgInterestRateBps: Scalars['Int']['output'];
  avgLiquidity: Scalars['BigFloat']['output'];
  avgLiquidityValueUsd: Scalars['BigFloat']['output'];
  avgTvlValue: Scalars['BigFloat']['output'];
  avgTvlValueUsd: Scalars['BigFloat']['output'];
  avgUnavailableAmount: Scalars['BigFloat']['output'];
  avgUnavailableAmountUsd: Scalars['BigFloat']['output'];
  avgUtilisationRateBps: Scalars['Int']['output'];
  block: Scalars['Int']['output'];
  feesEarned: Scalars['BigFloat']['output'];
  feesEarnedValueUsd: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  interestPaid: Scalars['BigFloat']['output'];
  interestPaidValueUsd: Scalars['BigFloat']['output'];
  interval: Scalars['Int']['output'];
  /** Reads a single `LendingPool` that is related to this `LendingPoolStat`. */
  lendingPoolByPoolId: LendingPool;
  losses: Scalars['BigFloat']['output'];
  lossesValueUsd: Scalars['BigFloat']['output'];
  maxLiquidity: Scalars['BigFloat']['output'];
  maxLiquidityValueUsd: Scalars['BigFloat']['output'];
  maxUnavailableAmount: Scalars['BigFloat']['output'];
  maxUnavailableAmountUsd: Scalars['BigFloat']['output'];
  minLiquidity: Scalars['BigFloat']['output'];
  minLiquidityValueUsd: Scalars['BigFloat']['output'];
  minUnavailableAmount: Scalars['BigFloat']['output'];
  minUnavailableAmountUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  poolId: Scalars['Int']['output'];
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
  timestamp: Scalars['Datetime']['output'];
};

export type LendingPoolStatAggregates = {
  __typename?: 'LendingPoolStatAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingPoolStatAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingPoolStatDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingPoolStatMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingPoolStatMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingPoolStatStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingPoolStatStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingPoolStatSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingPoolStatVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingPoolStatVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LendingPoolStat` object types. */
export type LendingPoolStatAggregatesFilter = {
  /** Mean average aggregate over matching `LendingPoolStat` objects. */
  average?: InputMaybe<LendingPoolStatAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LendingPoolStat` objects. */
  distinctCount?: InputMaybe<LendingPoolStatDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LendingPoolStat` object to be included within the aggregate. */
  filter?: InputMaybe<LendingPoolStatFilter>;
  /** Maximum aggregate over matching `LendingPoolStat` objects. */
  max?: InputMaybe<LendingPoolStatMaxAggregateFilter>;
  /** Minimum aggregate over matching `LendingPoolStat` objects. */
  min?: InputMaybe<LendingPoolStatMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LendingPoolStat` objects. */
  stddevPopulation?: InputMaybe<LendingPoolStatStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LendingPoolStat` objects. */
  stddevSample?: InputMaybe<LendingPoolStatStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LendingPoolStat` objects. */
  sum?: InputMaybe<LendingPoolStatSumAggregateFilter>;
  /** Population variance aggregate over matching `LendingPoolStat` objects. */
  variancePopulation?: InputMaybe<LendingPoolStatVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LendingPoolStat` objects. */
  varianceSample?: InputMaybe<LendingPoolStatVarianceSampleAggregateFilter>;
};

export type LendingPoolStatAverageAggregateFilter = {
  avgInterestRateBps?: InputMaybe<BigFloatFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStatAverageAggregates = {
  __typename?: 'LendingPoolStatAverageAggregates';
  /** Mean average of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingPoolStat` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LendingPoolStatCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `avgInterestRateBps` field. */
  avgInterestRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `avgLiquidity` field. */
  avgLiquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `avgLiquidityValueUsd` field. */
  avgLiquidityValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `avgTvlValue` field. */
  avgTvlValue?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `avgTvlValueUsd` field. */
  avgTvlValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `avgUnavailableAmount` field. */
  avgUnavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `avgUnavailableAmountUsd` field. */
  avgUnavailableAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `avgUtilisationRateBps` field. */
  avgUtilisationRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `feesEarned` field. */
  feesEarned?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feesEarnedValueUsd` field. */
  feesEarnedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interestPaid` field. */
  interestPaid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `interestPaidValueUsd` field. */
  interestPaidValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolByPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `losses` field. */
  losses?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxLiquidity` field. */
  maxLiquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxLiquidityValueUsd` field. */
  maxLiquidityValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxUnavailableAmount` field. */
  maxUnavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxUnavailableAmountUsd` field. */
  maxUnavailableAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minLiquidity` field. */
  minLiquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minLiquidityValueUsd` field. */
  minLiquidityValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minUnavailableAmount` field. */
  minUnavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minUnavailableAmountUsd` field. */
  minUnavailableAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedBorrowApy6H` field. */
  projectedBorrowApy6H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedBorrowApy24H` field. */
  projectedBorrowApy24H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedBorrowApy72H` field. */
  projectedBorrowApy72H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedBorrowApy168H` field. */
  projectedBorrowApy168H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedBorrowApy720H` field. */
  projectedBorrowApy720H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type LendingPoolStatDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  avgInterestRateBps?: InputMaybe<BigIntFilter>;
  avgLiquidity?: InputMaybe<BigIntFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigIntFilter>;
  avgTvlValue?: InputMaybe<BigIntFilter>;
  avgTvlValueUsd?: InputMaybe<BigIntFilter>;
  avgUnavailableAmount?: InputMaybe<BigIntFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigIntFilter>;
  avgUtilisationRateBps?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  feesEarned?: InputMaybe<BigIntFilter>;
  feesEarnedValueUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interestPaid?: InputMaybe<BigIntFilter>;
  interestPaidValueUsd?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigIntFilter>;
  lossesValueUsd?: InputMaybe<BigIntFilter>;
  maxLiquidity?: InputMaybe<BigIntFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigIntFilter>;
  maxUnavailableAmount?: InputMaybe<BigIntFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigIntFilter>;
  minLiquidity?: InputMaybe<BigIntFilter>;
  minLiquidityValueUsd?: InputMaybe<BigIntFilter>;
  minUnavailableAmount?: InputMaybe<BigIntFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  projectedApy6H?: InputMaybe<BigIntFilter>;
  projectedApy24H?: InputMaybe<BigIntFilter>;
  projectedApy72H?: InputMaybe<BigIntFilter>;
  projectedApy168H?: InputMaybe<BigIntFilter>;
  projectedApy720H?: InputMaybe<BigIntFilter>;
  projectedBorrowApy6H?: InputMaybe<BigIntFilter>;
  projectedBorrowApy24H?: InputMaybe<BigIntFilter>;
  projectedBorrowApy72H?: InputMaybe<BigIntFilter>;
  projectedBorrowApy168H?: InputMaybe<BigIntFilter>;
  projectedBorrowApy720H?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type LendingPoolStatDistinctCountAggregates = {
  __typename?: 'LendingPoolStatDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interval across the matching connection */
  interval?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losses across the matching connection */
  losses?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingPoolStat` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolStatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingPoolStatFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `avgInterestRateBps` field. */
  avgInterestRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `avgLiquidity` field. */
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgLiquidityValueUsd` field. */
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgTvlValue` field. */
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgTvlValueUsd` field. */
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgUnavailableAmount` field. */
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgUnavailableAmountUsd` field. */
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `avgUtilisationRateBps` field. */
  avgUtilisationRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `feesEarned` field. */
  feesEarned?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feesEarnedValueUsd` field. */
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interestPaid` field. */
  interestPaid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `interestPaidValueUsd` field. */
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `interval` field. */
  interval?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolByPoolId` relation. */
  lendingPoolByPoolId?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `losses` field. */
  losses?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxLiquidity` field. */
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxLiquidityValueUsd` field. */
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxUnavailableAmount` field. */
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxUnavailableAmountUsd` field. */
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minLiquidity` field. */
  minLiquidity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minLiquidityValueUsd` field. */
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minUnavailableAmount` field. */
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minUnavailableAmountUsd` field. */
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LendingPoolStatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingPoolStatFilter>>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedBorrowApy6H` field. */
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedBorrowApy24H` field. */
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedBorrowApy72H` field. */
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedBorrowApy168H` field. */
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedBorrowApy720H` field. */
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `LendingPoolStat` for usage during aggregation. */
export type LendingPoolStatGroupBy =
  | 'ASSET'
  | 'AVG_INTEREST_RATE_BPS'
  | 'AVG_LIQUIDITY'
  | 'AVG_LIQUIDITY_VALUE_USD'
  | 'AVG_TVL_VALUE'
  | 'AVG_TVL_VALUE_USD'
  | 'AVG_UNAVAILABLE_AMOUNT'
  | 'AVG_UNAVAILABLE_AMOUNT_USD'
  | 'AVG_UTILISATION_RATE_BPS'
  | 'BLOCK'
  | 'FEES_EARNED'
  | 'FEES_EARNED_VALUE_USD'
  | 'INTEREST_PAID'
  | 'INTEREST_PAID_VALUE_USD'
  | 'INTERVAL'
  | 'LOSSES'
  | 'LOSSES_VALUE_USD'
  | 'MAX_LIQUIDITY'
  | 'MAX_LIQUIDITY_VALUE_USD'
  | 'MAX_UNAVAILABLE_AMOUNT'
  | 'MAX_UNAVAILABLE_AMOUNT_USD'
  | 'MIN_LIQUIDITY'
  | 'MIN_LIQUIDITY_VALUE_USD'
  | 'MIN_UNAVAILABLE_AMOUNT'
  | 'MIN_UNAVAILABLE_AMOUNT_USD'
  | 'POOL_ID'
  | 'PROJECTED_APY6H'
  | 'PROJECTED_APY24H'
  | 'PROJECTED_APY72H'
  | 'PROJECTED_APY168H'
  | 'PROJECTED_APY720H'
  | 'PROJECTED_BORROW_APY6H'
  | 'PROJECTED_BORROW_APY24H'
  | 'PROJECTED_BORROW_APY72H'
  | 'PROJECTED_BORROW_APY168H'
  | 'PROJECTED_BORROW_APY720H'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type LendingPoolStatHavingAverageInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingDistinctCountInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `LendingPoolStat` aggregates. */
export type LendingPoolStatHavingInput = {
  AND?: InputMaybe<Array<LendingPoolStatHavingInput>>;
  OR?: InputMaybe<Array<LendingPoolStatHavingInput>>;
  average?: InputMaybe<LendingPoolStatHavingAverageInput>;
  distinctCount?: InputMaybe<LendingPoolStatHavingDistinctCountInput>;
  max?: InputMaybe<LendingPoolStatHavingMaxInput>;
  min?: InputMaybe<LendingPoolStatHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingPoolStatHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingPoolStatHavingStddevSampleInput>;
  sum?: InputMaybe<LendingPoolStatHavingSumInput>;
  variancePopulation?: InputMaybe<LendingPoolStatHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingPoolStatHavingVarianceSampleInput>;
};

export type LendingPoolStatHavingMaxInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingMinInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingStddevPopulationInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingStddevSampleInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingSumInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingVariancePopulationInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatHavingVarianceSampleInput = {
  avgInterestRateBps?: InputMaybe<HavingIntFilter>;
  avgLiquidity?: InputMaybe<HavingBigfloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValue?: InputMaybe<HavingBigfloatFilter>;
  avgTvlValueUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  avgUtilisationRateBps?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interestPaid?: InputMaybe<HavingBigfloatFilter>;
  interestPaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidity?: InputMaybe<HavingBigfloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  minLiquidity?: InputMaybe<HavingBigfloatFilter>;
  minLiquidityValueUsd?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedBorrowApy720H?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LendingPoolStatMaxAggregateFilter = {
  avgInterestRateBps?: InputMaybe<IntFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<IntFilter>;
  block?: InputMaybe<IntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LendingPoolStatMaxAggregates = {
  __typename?: 'LendingPoolStatMaxAggregates';
  /** Maximum of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Maximum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LendingPoolStatMinAggregateFilter = {
  avgInterestRateBps?: InputMaybe<IntFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<IntFilter>;
  block?: InputMaybe<IntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LendingPoolStatMinAggregates = {
  __typename?: 'LendingPoolStatMinAggregates';
  /** Minimum of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Minimum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LendingPoolStatStddevPopulationAggregateFilter = {
  avgInterestRateBps?: InputMaybe<BigFloatFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStatStddevPopulationAggregates = {
  __typename?: 'LendingPoolStatStddevPopulationAggregates';
  /** Population standard deviation of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolStatStddevSampleAggregateFilter = {
  avgInterestRateBps?: InputMaybe<BigFloatFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStatStddevSampleAggregates = {
  __typename?: 'LendingPoolStatStddevSampleAggregates';
  /** Sample standard deviation of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolStatSumAggregateFilter = {
  avgInterestRateBps?: InputMaybe<BigIntFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStatSumAggregates = {
  __typename?: 'LendingPoolStatSumAggregates';
  /** Sum of avgInterestRateBps across the matching connection */
  avgInterestRateBps: Scalars['BigInt']['output'];
  /** Sum of avgLiquidity across the matching connection */
  avgLiquidity: Scalars['BigFloat']['output'];
  /** Sum of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd: Scalars['BigFloat']['output'];
  /** Sum of avgTvlValue across the matching connection */
  avgTvlValue: Scalars['BigFloat']['output'];
  /** Sum of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd: Scalars['BigFloat']['output'];
  /** Sum of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps: Scalars['BigInt']['output'];
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of feesEarned across the matching connection */
  feesEarned: Scalars['BigFloat']['output'];
  /** Sum of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of interestPaid across the matching connection */
  interestPaid: Scalars['BigFloat']['output'];
  /** Sum of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd: Scalars['BigFloat']['output'];
  /** Sum of interval across the matching connection */
  interval: Scalars['BigInt']['output'];
  /** Sum of losses across the matching connection */
  losses: Scalars['BigFloat']['output'];
  /** Sum of lossesValueUsd across the matching connection */
  lossesValueUsd: Scalars['BigFloat']['output'];
  /** Sum of maxLiquidity across the matching connection */
  maxLiquidity: Scalars['BigFloat']['output'];
  /** Sum of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd: Scalars['BigFloat']['output'];
  /** Sum of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of minLiquidity across the matching connection */
  minLiquidity: Scalars['BigFloat']['output'];
  /** Sum of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd: Scalars['BigFloat']['output'];
  /** Sum of minUnavailableAmount across the matching connection */
  minUnavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
  /** Sum of projectedApy6H across the matching connection */
  projectedApy6H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy24H across the matching connection */
  projectedApy24H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy72H across the matching connection */
  projectedApy72H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy168H across the matching connection */
  projectedApy168H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy720H across the matching connection */
  projectedApy720H: Scalars['BigFloat']['output'];
  /** Sum of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H: Scalars['BigFloat']['output'];
  /** Sum of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H: Scalars['BigFloat']['output'];
  /** Sum of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H: Scalars['BigFloat']['output'];
  /** Sum of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H: Scalars['BigFloat']['output'];
  /** Sum of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H: Scalars['BigFloat']['output'];
};

export type LendingPoolStatVariancePopulationAggregateFilter = {
  avgInterestRateBps?: InputMaybe<BigFloatFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStatVariancePopulationAggregates = {
  __typename?: 'LendingPoolStatVariancePopulationAggregates';
  /** Population variance of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolStatVarianceSampleAggregateFilter = {
  avgInterestRateBps?: InputMaybe<BigFloatFilter>;
  avgLiquidity?: InputMaybe<BigFloatFilter>;
  avgLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  avgTvlValue?: InputMaybe<BigFloatFilter>;
  avgTvlValueUsd?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmount?: InputMaybe<BigFloatFilter>;
  avgUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  avgUtilisationRateBps?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interestPaid?: InputMaybe<BigFloatFilter>;
  interestPaidValueUsd?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxLiquidity?: InputMaybe<BigFloatFilter>;
  maxLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmount?: InputMaybe<BigFloatFilter>;
  maxUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  minLiquidity?: InputMaybe<BigFloatFilter>;
  minLiquidityValueUsd?: InputMaybe<BigFloatFilter>;
  minUnavailableAmount?: InputMaybe<BigFloatFilter>;
  minUnavailableAmountUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy6H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy24H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy72H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy168H?: InputMaybe<BigFloatFilter>;
  projectedBorrowApy720H?: InputMaybe<BigFloatFilter>;
};

export type LendingPoolStatVarianceSampleAggregates = {
  __typename?: 'LendingPoolStatVarianceSampleAggregates';
  /** Sample variance of avgInterestRateBps across the matching connection */
  avgInterestRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgLiquidity across the matching connection */
  avgLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgLiquidityValueUsd across the matching connection */
  avgLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgTvlValue across the matching connection */
  avgTvlValue?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgTvlValueUsd across the matching connection */
  avgTvlValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgUnavailableAmount across the matching connection */
  avgUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgUnavailableAmountUsd across the matching connection */
  avgUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgUtilisationRateBps across the matching connection */
  avgUtilisationRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestPaid across the matching connection */
  interestPaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interestPaidValueUsd across the matching connection */
  interestPaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxLiquidity across the matching connection */
  maxLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxLiquidityValueUsd across the matching connection */
  maxLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxUnavailableAmount across the matching connection */
  maxUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxUnavailableAmountUsd across the matching connection */
  maxUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minLiquidity across the matching connection */
  minLiquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minLiquidityValueUsd across the matching connection */
  minLiquidityValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minUnavailableAmount across the matching connection */
  minUnavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minUnavailableAmountUsd across the matching connection */
  minUnavailableAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedBorrowApy6H across the matching connection */
  projectedBorrowApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedBorrowApy24H across the matching connection */
  projectedBorrowApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedBorrowApy72H across the matching connection */
  projectedBorrowApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedBorrowApy168H across the matching connection */
  projectedBorrowApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedBorrowApy720H across the matching connection */
  projectedBorrowApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingPoolStat` values. */
export type LendingPoolStatsConnection = {
  __typename?: 'LendingPoolStatsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingPoolStatAggregates>;
  /** A list of edges which contains the `LendingPoolStat` and cursor to aid in pagination. */
  edges: Array<LendingPoolStatsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingPoolStatAggregates>>;
  /** A list of `LendingPoolStat` objects. */
  nodes: Array<LendingPoolStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingPoolStat` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingPoolStat` values. */
export type LendingPoolStatsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingPoolStatGroupBy>;
  having?: InputMaybe<LendingPoolStatHavingInput>;
};

/** A `LendingPoolStat` edge in the connection. */
export type LendingPoolStatsEdge = {
  __typename?: 'LendingPoolStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingPoolStat` at the end of the edge. */
  node: LendingPoolStat;
};

/** Methods to use when ordering `LendingPoolStat`. */
export type LendingPoolStatsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'AVG_INTEREST_RATE_BPS_ASC'
  | 'AVG_INTEREST_RATE_BPS_DESC'
  | 'AVG_LIQUIDITY_ASC'
  | 'AVG_LIQUIDITY_DESC'
  | 'AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'AVG_TVL_VALUE_ASC'
  | 'AVG_TVL_VALUE_DESC'
  | 'AVG_TVL_VALUE_USD_ASC'
  | 'AVG_TVL_VALUE_USD_DESC'
  | 'AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'AVG_UTILISATION_RATE_BPS_ASC'
  | 'AVG_UTILISATION_RATE_BPS_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'FEES_EARNED_ASC'
  | 'FEES_EARNED_DESC'
  | 'FEES_EARNED_VALUE_USD_ASC'
  | 'FEES_EARNED_VALUE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEREST_PAID_ASC'
  | 'INTEREST_PAID_DESC'
  | 'INTEREST_PAID_VALUE_USD_ASC'
  | 'INTEREST_PAID_VALUE_USD_DESC'
  | 'INTERVAL_ASC'
  | 'INTERVAL_DESC'
  | 'LOSSES_ASC'
  | 'LOSSES_DESC'
  | 'LOSSES_VALUE_USD_ASC'
  | 'LOSSES_VALUE_USD_DESC'
  | 'MAX_LIQUIDITY_ASC'
  | 'MAX_LIQUIDITY_DESC'
  | 'MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'MIN_LIQUIDITY_ASC'
  | 'MIN_LIQUIDITY_DESC'
  | 'MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'NATURAL'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECTED_APY6H_ASC'
  | 'PROJECTED_APY6H_DESC'
  | 'PROJECTED_APY24H_ASC'
  | 'PROJECTED_APY24H_DESC'
  | 'PROJECTED_APY72H_ASC'
  | 'PROJECTED_APY72H_DESC'
  | 'PROJECTED_APY168H_ASC'
  | 'PROJECTED_APY168H_DESC'
  | 'PROJECTED_APY720H_ASC'
  | 'PROJECTED_APY720H_DESC'
  | 'PROJECTED_BORROW_APY6H_ASC'
  | 'PROJECTED_BORROW_APY6H_DESC'
  | 'PROJECTED_BORROW_APY24H_ASC'
  | 'PROJECTED_BORROW_APY24H_DESC'
  | 'PROJECTED_BORROW_APY72H_ASC'
  | 'PROJECTED_BORROW_APY72H_DESC'
  | 'PROJECTED_BORROW_APY168H_ASC'
  | 'PROJECTED_BORROW_APY168H_DESC'
  | 'PROJECTED_BORROW_APY720H_ASC'
  | 'PROJECTED_BORROW_APY720H_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC';

export type LendingPoolStddevPopulationAggregates = {
  __typename?: 'LendingPoolStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolStddevSampleAggregates = {
  __typename?: 'LendingPoolStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolSumAggregates = {
  __typename?: 'LendingPoolSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `LendingLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLendingLiquidityBalanceChangeFilter = {
  /** Aggregates across related `LendingLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LendingLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** No related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Some related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `LendingPoolIncentiveProgram` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLendingPoolIncentiveProgramFilter = {
  /** Aggregates across related `LendingPoolIncentiveProgram` match the filter criteria. */
  aggregates?: InputMaybe<LendingPoolIncentiveProgramAggregatesFilter>;
  /** Every related `LendingPoolIncentiveProgram` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** No related `LendingPoolIncentiveProgram` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** Some related `LendingPoolIncentiveProgram` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingPoolIncentiveProgramFilter>;
};

/** A filter to be used against many `LendingPoolSnapshot` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLendingPoolSnapshotFilter = {
  /** Aggregates across related `LendingPoolSnapshot` match the filter criteria. */
  aggregates?: InputMaybe<LendingPoolSnapshotAggregatesFilter>;
  /** Every related `LendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingPoolSnapshotFilter>;
  /** No related `LendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingPoolSnapshotFilter>;
  /** Some related `LendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingPoolSnapshotFilter>;
};

/** A filter to be used against many `LendingPoolStat` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLendingPoolStatFilter = {
  /** Aggregates across related `LendingPoolStat` match the filter criteria. */
  aggregates?: InputMaybe<LendingPoolStatAggregatesFilter>;
  /** Every related `LendingPoolStat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingPoolStatFilter>;
  /** No related `LendingPoolStat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingPoolStatFilter>;
  /** Some related `LendingPoolStat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingPoolStatFilter>;
};

/** A filter to be used against many `LoanFee` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLoanFeeFilter = {
  /** Aggregates across related `LoanFee` match the filter criteria. */
  aggregates?: InputMaybe<LoanFeeAggregatesFilter>;
  /** Every related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFeeFilter>;
  /** No related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFeeFilter>;
  /** Some related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFeeFilter>;
};

/** A filter to be used against many `Loan` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLoanFilter = {
  /** Aggregates across related `Loan` match the filter criteria. */
  aggregates?: InputMaybe<LoanAggregatesFilter>;
  /** Every related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFilter>;
  /** No related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFilter>;
  /** Some related `Loan` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFilter>;
};

/** A filter to be used against many `LpLendingPoolSnapshot` object types. All fields are combined with a logical ‘and.’ */
export type LendingPoolToManyLpLendingPoolSnapshotFilter = {
  /** Aggregates across related `LpLendingPoolSnapshot` match the filter criteria. */
  aggregates?: InputMaybe<LpLendingPoolSnapshotAggregatesFilter>;
  /** Every related `LpLendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpLendingPoolSnapshotFilter>;
  /** No related `LpLendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpLendingPoolSnapshotFilter>;
  /** Some related `LpLendingPoolSnapshot` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpLendingPoolSnapshotFilter>;
};

export type LendingPoolVariancePopulationAggregates = {
  __typename?: 'LendingPoolVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingPoolVarianceSampleAggregates = {
  __typename?: 'LendingPoolVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingPool` values. */
export type LendingPoolsConnection = {
  __typename?: 'LendingPoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingPoolAggregates>;
  /** A list of edges which contains the `LendingPool` and cursor to aid in pagination. */
  edges: Array<LendingPoolsEdge>;
  /** A list of `LendingPool` objects. */
  nodes: Array<LendingPool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingPool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LendingPool` edge in the connection. */
export type LendingPoolsEdge = {
  __typename?: 'LendingPoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingPool` at the end of the edge. */
  node: LendingPool;
};

/** Methods to use when ordering `LendingPool`. */
export type LendingPoolsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_COUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_COUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_IS_POSITION_OPENING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_IS_POSITION_OPENING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_AVERAGE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_COUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_COUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MAX_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_MIN_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_SUM_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_INCENTIVE_SEASON_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_INCENTIVE_SEASON_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_FLIP_AMOUNT_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_POINTS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_MAX_ALLOCATED_POINTS_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_POINTS_DISTRIBUTED_PER_INTERVAL_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAMS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_POINT_DISTRIBUTION_INTERVAL_BLOCKS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_AVERAGE_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_COUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_COUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_DISTINCT_COUNT_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MAX_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_MIN_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_POPULATION_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_STDDEV_SAMPLE_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_SUM_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_POPULATION_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_SNAPSHOTS_BY_POOL_ID_VARIANCE_SAMPLE_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_AVERAGE_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_COUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_COUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_POPULATION_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_STDDEV_SAMPLE_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_SUM_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_POPULATION_PROJECTED_BORROW_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_INTEREST_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_INTEREST_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_TVL_VALUE_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_TVL_VALUE_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_TVL_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_TVL_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_UTILISATION_RATE_BPS_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_AVG_UTILISATION_RATE_BPS_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_FEES_EARNED_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_FEES_EARNED_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_FEES_EARNED_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_FEES_EARNED_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_INTEREST_PAID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_INTEREST_PAID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_INTEREST_PAID_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_INTEREST_PAID_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_INTERVAL_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_INTERVAL_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_LOSSES_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_LOSSES_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MAX_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_LIQUIDITY_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_LIQUIDITY_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_LIQUIDITY_VALUE_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_LIQUIDITY_VALUE_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_UNAVAILABLE_AMOUNT_USD_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_MIN_UNAVAILABLE_AMOUNT_USD_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY6H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY6H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY24H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY24H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY72H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY72H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY168H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY168H_DESC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY720H_ASC'
  | 'LENDING_POOL_STATS_BY_POOL_ID_VARIANCE_SAMPLE_PROJECTED_BORROW_APY720H_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_AVERAGE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_AVERAGE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_COUNT_ASC'
  | 'LOANS_BY_POOL_ID_COUNT_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BORROWER_TYPE_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BORROWER_TYPE_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BROKER_ID_SS58_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_BROKER_ID_SS58_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_IS_LIQUIDATED_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_IS_LIQUIDATED_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_DISTINCT_COUNT_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_MAX_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_MAX_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_POOL_ID_MAX_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_POOL_ID_MAX_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_POOL_ID_MAX_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_POOL_ID_MAX_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_MAX_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_MAX_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_MAX_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_MAX_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_MAX_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_MIN_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_MIN_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_CREATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_POOL_ID_MIN_CREATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_POOL_ID_MIN_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LOANS_BY_POOL_ID_MIN_LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LOANS_BY_POOL_ID_MIN_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_MIN_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_MIN_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_MIN_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_MIN_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_MIN_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_STDDEV_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_SUM_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_SUM_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_SUM_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_SUM_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_SUM_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_SUM_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_SUM_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_POPULATION_SETTLED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BOOST_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_BPS_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_LOST_AMOUNT_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_LOST_AMOUNT_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_LOST_AMOUNT_VALUE_USD_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_ASC'
  | 'LOANS_BY_POOL_ID_VARIANCE_SAMPLE_SETTLED_AT_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_COUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_COUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_FEES_BY_POOL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MAX_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_MIN_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_SUM_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_POOL_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_AVERAGE_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_COUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_COUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TIMESTAMP_HOUR_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TIMESTAMP_HOUR_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_TIMESTAMP_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_TIMESTAMP_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_TIMESTAMP_HOUR_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MAX_TIMESTAMP_HOUR_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_TIMESTAMP_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_TIMESTAMP_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_TIMESTAMP_HOUR_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_MIN_TIMESTAMP_HOUR_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_POPULATION_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_STDDEV_SAMPLE_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_SUM_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_POPULATION_SUPPLY_PNL1H_USD_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_BLOCK_HEIGHT_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_INTERVAL_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_INTERVAL_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_LENDING_POOL_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_DESC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_USD_ASC'
  | 'LP_LENDING_POOL_SNAPSHOTS_BY_LENDING_POOL_ID_VARIANCE_SAMPLE_SUPPLY_PNL1H_USD_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type LimitOrderFill = Node & {
  __typename?: 'LimitOrderFill';
  /** Reads a single `Account` that is related to this `LimitOrderFill`. */
  accountByLiquidityProviderId: Account;
  baseAsset: ChainflipAsset;
  block: Scalars['Int']['output'];
  blockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  feesEarned: Scalars['BigFloat']['output'];
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  filledAmount: Scalars['BigFloat']['output'];
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  originalSellAmount: Scalars['BigFloat']['output'];
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  sellAmount: Scalars['BigFloat']['output'];
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  tick: Scalars['Int']['output'];
  type: LimitOrderType;
};

export type LimitOrderFillAggregates = {
  __typename?: 'LimitOrderFillAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LimitOrderFillAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LimitOrderFillDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LimitOrderFillMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LimitOrderFillMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LimitOrderFillStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LimitOrderFillStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LimitOrderFillSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LimitOrderFillVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LimitOrderFillVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LimitOrderFill` object types. */
export type LimitOrderFillAggregatesFilter = {
  /** Mean average aggregate over matching `LimitOrderFill` objects. */
  average?: InputMaybe<LimitOrderFillAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LimitOrderFill` objects. */
  distinctCount?: InputMaybe<LimitOrderFillDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LimitOrderFill` object to be included within the aggregate. */
  filter?: InputMaybe<LimitOrderFillFilter>;
  /** Maximum aggregate over matching `LimitOrderFill` objects. */
  max?: InputMaybe<LimitOrderFillMaxAggregateFilter>;
  /** Minimum aggregate over matching `LimitOrderFill` objects. */
  min?: InputMaybe<LimitOrderFillMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LimitOrderFill` objects. */
  stddevPopulation?: InputMaybe<LimitOrderFillStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LimitOrderFill` objects. */
  stddevSample?: InputMaybe<LimitOrderFillStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LimitOrderFill` objects. */
  sum?: InputMaybe<LimitOrderFillSumAggregateFilter>;
  /** Population variance aggregate over matching `LimitOrderFill` objects. */
  variancePopulation?: InputMaybe<LimitOrderFillVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LimitOrderFill` objects. */
  varianceSample?: InputMaybe<LimitOrderFillVarianceSampleAggregateFilter>;
};

export type LimitOrderFillAverageAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<BigFloatFilter>;
};

export type LimitOrderFillAverageAggregates = {
  __typename?: 'LimitOrderFillAverageAggregates';
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tick across the matching connection */
  tick?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LimitOrderFill` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LimitOrderFillCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `blockTimestamp` field. */
  blockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `feesEarned` field. */
  feesEarned?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feesEarnedValueUsd` field. */
  feesEarnedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `filledAmount` field. */
  filledAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `filledAmountValueUsd` field. */
  filledAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `originalSellAmount` field. */
  originalSellAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `originalSellAmountValueUsd` field. */
  originalSellAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sellAmount` field. */
  sellAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sellAmountValueUsd` field. */
  sellAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `tick` field. */
  tick?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LimitOrderType>;
};

export type LimitOrderFillDistinctCountAggregateFilter = {
  baseAsset?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  blockTimestamp?: InputMaybe<BigIntFilter>;
  feesEarned?: InputMaybe<BigIntFilter>;
  feesEarnedValueUsd?: InputMaybe<BigIntFilter>;
  filledAmount?: InputMaybe<BigIntFilter>;
  filledAmountValueUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  orderId?: InputMaybe<BigIntFilter>;
  originalSellAmount?: InputMaybe<BigIntFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigIntFilter>;
  sellAmount?: InputMaybe<BigIntFilter>;
  sellAmountValueUsd?: InputMaybe<BigIntFilter>;
  tick?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LimitOrderFillDistinctCountAggregates = {
  __typename?: 'LimitOrderFillDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockTimestamp across the matching connection */
  blockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderId across the matching connection */
  orderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tick across the matching connection */
  tick?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LimitOrderFill` object types. All fields are combined with a logical ‘and.’ */
export type LimitOrderFillFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LimitOrderFillFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blockTimestamp` field. */
  blockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `feesEarned` field. */
  feesEarned?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feesEarnedValueUsd` field. */
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `filledAmount` field. */
  filledAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `filledAmountValueUsd` field. */
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LimitOrderFillFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LimitOrderFillFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `originalSellAmount` field. */
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `originalSellAmountValueUsd` field. */
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sellAmount` field. */
  sellAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sellAmountValueUsd` field. */
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tick` field. */
  tick?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LimitOrderTypeFilter>;
};

/** Grouping methods for `LimitOrderFill` for usage during aggregation. */
export type LimitOrderFillGroupBy =
  | 'BASE_ASSET'
  | 'BLOCK'
  | 'BLOCK_TIMESTAMP'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'FEES_EARNED'
  | 'FEES_EARNED_VALUE_USD'
  | 'FILLED_AMOUNT'
  | 'FILLED_AMOUNT_VALUE_USD'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'ORDER_ID'
  | 'ORIGINAL_SELL_AMOUNT'
  | 'ORIGINAL_SELL_AMOUNT_VALUE_USD'
  | 'SELL_AMOUNT'
  | 'SELL_AMOUNT_VALUE_USD'
  | 'TICK'
  | 'TYPE';

export type LimitOrderFillHavingAverageInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingDistinctCountInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LimitOrderFill` aggregates. */
export type LimitOrderFillHavingInput = {
  AND?: InputMaybe<Array<LimitOrderFillHavingInput>>;
  OR?: InputMaybe<Array<LimitOrderFillHavingInput>>;
  average?: InputMaybe<LimitOrderFillHavingAverageInput>;
  distinctCount?: InputMaybe<LimitOrderFillHavingDistinctCountInput>;
  max?: InputMaybe<LimitOrderFillHavingMaxInput>;
  min?: InputMaybe<LimitOrderFillHavingMinInput>;
  stddevPopulation?: InputMaybe<LimitOrderFillHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LimitOrderFillHavingStddevSampleInput>;
  sum?: InputMaybe<LimitOrderFillHavingSumInput>;
  variancePopulation?: InputMaybe<LimitOrderFillHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LimitOrderFillHavingVarianceSampleInput>;
};

export type LimitOrderFillHavingMaxInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingMinInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingStddevPopulationInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingStddevSampleInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingSumInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingVariancePopulationInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillHavingVarianceSampleInput = {
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  feesEarned?: InputMaybe<HavingBigfloatFilter>;
  feesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  filledAmount?: InputMaybe<HavingBigfloatFilter>;
  filledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  originalSellAmount?: InputMaybe<HavingBigfloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  sellAmount?: InputMaybe<HavingBigfloatFilter>;
  sellAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  tick?: InputMaybe<HavingIntFilter>;
};

export type LimitOrderFillMaxAggregateFilter = {
  block?: InputMaybe<IntFilter>;
  blockTimestamp?: InputMaybe<DatetimeFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<IntFilter>;
};

export type LimitOrderFillMaxAggregates = {
  __typename?: 'LimitOrderFillMaxAggregates';
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of blockTimestamp across the matching connection */
  blockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of tick across the matching connection */
  tick?: Maybe<Scalars['Int']['output']>;
};

export type LimitOrderFillMinAggregateFilter = {
  block?: InputMaybe<IntFilter>;
  blockTimestamp?: InputMaybe<DatetimeFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<IntFilter>;
};

export type LimitOrderFillMinAggregates = {
  __typename?: 'LimitOrderFillMinAggregates';
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of blockTimestamp across the matching connection */
  blockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of tick across the matching connection */
  tick?: Maybe<Scalars['Int']['output']>;
};

export type LimitOrderFillStddevPopulationAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<BigFloatFilter>;
};

export type LimitOrderFillStddevPopulationAggregates = {
  __typename?: 'LimitOrderFillStddevPopulationAggregates';
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tick across the matching connection */
  tick?: Maybe<Scalars['BigFloat']['output']>;
};

export type LimitOrderFillStddevSampleAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<BigFloatFilter>;
};

export type LimitOrderFillStddevSampleAggregates = {
  __typename?: 'LimitOrderFillStddevSampleAggregates';
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tick across the matching connection */
  tick?: Maybe<Scalars['BigFloat']['output']>;
};

export type LimitOrderFillSumAggregateFilter = {
  block?: InputMaybe<BigIntFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<BigIntFilter>;
};

export type LimitOrderFillSumAggregates = {
  __typename?: 'LimitOrderFillSumAggregates';
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of feesEarned across the matching connection */
  feesEarned: Scalars['BigFloat']['output'];
  /** Sum of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd: Scalars['BigFloat']['output'];
  /** Sum of filledAmount across the matching connection */
  filledAmount: Scalars['BigFloat']['output'];
  /** Sum of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of originalSellAmount across the matching connection */
  originalSellAmount: Scalars['BigFloat']['output'];
  /** Sum of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of sellAmount across the matching connection */
  sellAmount: Scalars['BigFloat']['output'];
  /** Sum of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of tick across the matching connection */
  tick: Scalars['BigInt']['output'];
};

export type LimitOrderFillVariancePopulationAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<BigFloatFilter>;
};

export type LimitOrderFillVariancePopulationAggregates = {
  __typename?: 'LimitOrderFillVariancePopulationAggregates';
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tick across the matching connection */
  tick?: Maybe<Scalars['BigFloat']['output']>;
};

export type LimitOrderFillVarianceSampleAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  feesEarned?: InputMaybe<BigFloatFilter>;
  feesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  filledAmount?: InputMaybe<BigFloatFilter>;
  filledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  originalSellAmount?: InputMaybe<BigFloatFilter>;
  originalSellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  sellAmount?: InputMaybe<BigFloatFilter>;
  sellAmountValueUsd?: InputMaybe<BigFloatFilter>;
  tick?: InputMaybe<BigFloatFilter>;
};

export type LimitOrderFillVarianceSampleAggregates = {
  __typename?: 'LimitOrderFillVarianceSampleAggregates';
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feesEarned across the matching connection */
  feesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feesEarnedValueUsd across the matching connection */
  feesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of filledAmount across the matching connection */
  filledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of filledAmountValueUsd across the matching connection */
  filledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of originalSellAmount across the matching connection */
  originalSellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of originalSellAmountValueUsd across the matching connection */
  originalSellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sellAmount across the matching connection */
  sellAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sellAmountValueUsd across the matching connection */
  sellAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tick across the matching connection */
  tick?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LimitOrderFill` values. */
export type LimitOrderFillsConnection = {
  __typename?: 'LimitOrderFillsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LimitOrderFillAggregates>;
  /** A list of edges which contains the `LimitOrderFill` and cursor to aid in pagination. */
  edges: Array<LimitOrderFillsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LimitOrderFillAggregates>>;
  /** A list of `LimitOrderFill` objects. */
  nodes: Array<LimitOrderFill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LimitOrderFill` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LimitOrderFill` values. */
export type LimitOrderFillsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LimitOrderFillGroupBy>;
  having?: InputMaybe<LimitOrderFillHavingInput>;
};

/** A `LimitOrderFill` edge in the connection. */
export type LimitOrderFillsEdge = {
  __typename?: 'LimitOrderFillsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LimitOrderFill` at the end of the edge. */
  node: LimitOrderFill;
};

/** Methods to use when ordering `LimitOrderFill`. */
export type LimitOrderFillsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'BLOCK_TIMESTAMP_ASC'
  | 'BLOCK_TIMESTAMP_DESC'
  | 'FEES_EARNED_ASC'
  | 'FEES_EARNED_DESC'
  | 'FEES_EARNED_VALUE_USD_ASC'
  | 'FEES_EARNED_VALUE_USD_DESC'
  | 'FILLED_AMOUNT_ASC'
  | 'FILLED_AMOUNT_DESC'
  | 'FILLED_AMOUNT_VALUE_USD_ASC'
  | 'FILLED_AMOUNT_VALUE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'ORDER_ID_ASC'
  | 'ORDER_ID_DESC'
  | 'ORIGINAL_SELL_AMOUNT_ASC'
  | 'ORIGINAL_SELL_AMOUNT_DESC'
  | 'ORIGINAL_SELL_AMOUNT_VALUE_USD_ASC'
  | 'ORIGINAL_SELL_AMOUNT_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SELL_AMOUNT_ASC'
  | 'SELL_AMOUNT_DESC'
  | 'SELL_AMOUNT_VALUE_USD_ASC'
  | 'SELL_AMOUNT_VALUE_USD_DESC'
  | 'TICK_ASC'
  | 'TICK_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type LimitOrderType =
  | 'Ask'
  | 'Bid';

/** A filter to be used against LimitOrderType fields. All fields are combined with a logical ‘and.’ */
export type LimitOrderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LimitOrderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LimitOrderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LimitOrderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LimitOrderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LimitOrderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LimitOrderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LimitOrderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LimitOrderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LimitOrderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LimitOrderType>>;
};

export type LiquidationSwapRequest = Node & {
  __typename?: 'LiquidationSwapRequest';
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  createdAtEventId: Scalars['BigInt']['output'];
  /** Reads a single `Event` that is related to this `LiquidationSwapRequest`. */
  eventByAbortedAtEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `LiquidationSwapRequest`. */
  eventByCompletedAtEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `LiquidationSwapRequest`. */
  eventByCreatedAtEventId: Event;
  id: Scalars['Int']['output'];
  isHard?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangesByLiquidationSwapRequestId: LendingLiquidityBalanceChangesConnection;
  /** Reads a single `Loan` that is related to this `LiquidationSwapRequest`. */
  loanByLoanId: Loan;
  loanId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  swapRequestId: Scalars['BigInt']['output'];
};


export type LiquidationSwapRequestLendingLiquidityBalanceChangesByLiquidationSwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy>>;
};

export type LiquidationSwapRequestAggregates = {
  __typename?: 'LiquidationSwapRequestAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidationSwapRequestAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidationSwapRequestDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidationSwapRequestMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidationSwapRequestMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidationSwapRequestStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidationSwapRequestStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidationSwapRequestSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidationSwapRequestVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidationSwapRequestVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidationSwapRequest` object types. */
export type LiquidationSwapRequestAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidationSwapRequest` objects. */
  average?: InputMaybe<LiquidationSwapRequestAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidationSwapRequest` objects. */
  distinctCount?: InputMaybe<LiquidationSwapRequestDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidationSwapRequest` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidationSwapRequestFilter>;
  /** Maximum aggregate over matching `LiquidationSwapRequest` objects. */
  max?: InputMaybe<LiquidationSwapRequestMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidationSwapRequest` objects. */
  min?: InputMaybe<LiquidationSwapRequestMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidationSwapRequest` objects. */
  stddevPopulation?: InputMaybe<LiquidationSwapRequestStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidationSwapRequest` objects. */
  stddevSample?: InputMaybe<LiquidationSwapRequestStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidationSwapRequest` objects. */
  sum?: InputMaybe<LiquidationSwapRequestSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidationSwapRequest` objects. */
  variancePopulation?: InputMaybe<LiquidationSwapRequestVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidationSwapRequest` objects. */
  varianceSample?: InputMaybe<LiquidationSwapRequestVarianceSampleAggregateFilter>;
};

export type LiquidationSwapRequestAverageAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapRequestAverageAggregates = {
  __typename?: 'LiquidationSwapRequestAverageAggregates';
  /** Mean average of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidationSwapRequest` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LiquidationSwapRequestCondition = {
  /** Checks for equality with the object’s `abortedAtEventId` field. */
  abortedAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `completedAtEventId` field. */
  completedAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByAbortedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByCompletedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByCreatedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isHard` field. */
  isHard?: InputMaybe<Scalars['Boolean']['input']>;
  loanByLoanId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `loanId` field. */
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type LiquidationSwapRequestDistinctCountAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  completedAtEventId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isHard?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type LiquidationSwapRequestDistinctCountAggregates = {
  __typename?: 'LiquidationSwapRequestDistinctCountAggregates';
  /** Distinct count of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isHard across the matching connection */
  isHard?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidationSwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type LiquidationSwapRequestFilter = {
  /** Filter by the object’s `abortedAtEventId` field. */
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidationSwapRequestFilter>>;
  /** Filter by the object’s `completedAtEventId` field. */
  completedAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByAbortedAtEventId` relation. */
  eventByAbortedAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventByAbortedAtEventId` exists. */
  eventByAbortedAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByCompletedAtEventId` relation. */
  eventByCompletedAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCompletedAtEventId` exists. */
  eventByCompletedAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByCreatedAtEventId` relation. */
  eventByCreatedAtEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isHard` field. */
  isHard?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lendingLiquidityBalanceChangesByLiquidationSwapRequestId` relation. */
  lendingLiquidityBalanceChangesByLiquidationSwapRequestId?: InputMaybe<LiquidationSwapRequestToManyLendingLiquidityBalanceChangeFilter>;
  /** Some related `lendingLiquidityBalanceChangesByLiquidationSwapRequestId` exist. */
  lendingLiquidityBalanceChangesByLiquidationSwapRequestIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanByLoanId` relation. */
  loanByLoanId?: InputMaybe<LoanFilter>;
  /** Filter by the object’s `loanId` field. */
  loanId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidationSwapRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidationSwapRequestFilter>>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<BigIntFilter>;
};

/** Grouping methods for `LiquidationSwapRequest` for usage during aggregation. */
export type LiquidationSwapRequestGroupBy =
  | 'ABORTED_AT_EVENT_ID'
  | 'COMPLETED_AT_EVENT_ID'
  | 'CREATED_AT_EVENT_ID'
  | 'IS_HARD'
  | 'LOAN_ID'
  | 'SWAP_REQUEST_ID';

export type LiquidationSwapRequestHavingAverageInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingDistinctCountInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `LiquidationSwapRequest` aggregates. */
export type LiquidationSwapRequestHavingInput = {
  AND?: InputMaybe<Array<LiquidationSwapRequestHavingInput>>;
  OR?: InputMaybe<Array<LiquidationSwapRequestHavingInput>>;
  average?: InputMaybe<LiquidationSwapRequestHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidationSwapRequestHavingDistinctCountInput>;
  max?: InputMaybe<LiquidationSwapRequestHavingMaxInput>;
  min?: InputMaybe<LiquidationSwapRequestHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidationSwapRequestHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidationSwapRequestHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidationSwapRequestHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidationSwapRequestHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidationSwapRequestHavingVarianceSampleInput>;
};

export type LiquidationSwapRequestHavingMaxInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingMinInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingStddevPopulationInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingStddevSampleInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingSumInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingVariancePopulationInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestHavingVarianceSampleInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingBigintFilter>;
};

export type LiquidationSwapRequestMaxAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  completedAtEventId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type LiquidationSwapRequestMaxAggregates = {
  __typename?: 'LiquidationSwapRequestMaxAggregates';
  /** Maximum of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

export type LiquidationSwapRequestMinAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  completedAtEventId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type LiquidationSwapRequestMinAggregates = {
  __typename?: 'LiquidationSwapRequestMinAggregates';
  /** Minimum of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

export type LiquidationSwapRequestStddevPopulationAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapRequestStddevPopulationAggregates = {
  __typename?: 'LiquidationSwapRequestStddevPopulationAggregates';
  /** Population standard deviation of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidationSwapRequestStddevSampleAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapRequestStddevSampleAggregates = {
  __typename?: 'LiquidationSwapRequestStddevSampleAggregates';
  /** Sample standard deviation of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidationSwapRequestSumAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapRequestSumAggregates = {
  __typename?: 'LiquidationSwapRequestSumAggregates';
  /** Sum of abortedAtEventId across the matching connection */
  abortedAtEventId: Scalars['BigFloat']['output'];
  /** Sum of completedAtEventId across the matching connection */
  completedAtEventId: Scalars['BigFloat']['output'];
  /** Sum of createdAtEventId across the matching connection */
  createdAtEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of loanId across the matching connection */
  loanId: Scalars['BigFloat']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `LendingLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type LiquidationSwapRequestToManyLendingLiquidityBalanceChangeFilter = {
  /** Aggregates across related `LendingLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LendingLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** No related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Some related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
};

export type LiquidationSwapRequestVariancePopulationAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapRequestVariancePopulationAggregates = {
  __typename?: 'LiquidationSwapRequestVariancePopulationAggregates';
  /** Population variance of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidationSwapRequestVarianceSampleAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapRequestVarianceSampleAggregates = {
  __typename?: 'LiquidationSwapRequestVarianceSampleAggregates';
  /** Sample variance of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidationSwapRequest` values. */
export type LiquidationSwapRequestsConnection = {
  __typename?: 'LiquidationSwapRequestsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidationSwapRequestAggregates>;
  /** A list of edges which contains the `LiquidationSwapRequest` and cursor to aid in pagination. */
  edges: Array<LiquidationSwapRequestsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidationSwapRequestAggregates>>;
  /** A list of `LiquidationSwapRequest` objects. */
  nodes: Array<LiquidationSwapRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidationSwapRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidationSwapRequest` values. */
export type LiquidationSwapRequestsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidationSwapRequestGroupBy>;
  having?: InputMaybe<LiquidationSwapRequestHavingInput>;
};

/** A `LiquidationSwapRequest` edge in the connection. */
export type LiquidationSwapRequestsEdge = {
  __typename?: 'LiquidationSwapRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidationSwapRequest` at the end of the edge. */
  node: LiquidationSwapRequest;
};

/** Methods to use when ordering `LiquidationSwapRequest`. */
export type LiquidationSwapRequestsOrderBy =
  | 'ABORTED_AT_EVENT_ID_ASC'
  | 'ABORTED_AT_EVENT_ID_DESC'
  | 'COMPLETED_AT_EVENT_ID_ASC'
  | 'COMPLETED_AT_EVENT_ID_DESC'
  | 'CREATED_AT_EVENT_ID_ASC'
  | 'CREATED_AT_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_HARD_ASC'
  | 'IS_HARD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_COUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_COUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_IS_POSITION_OPENING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_IS_POSITION_OPENING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_SUM_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LIQUIDATION_SWAP_REQUEST_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOAN_ID_ASC'
  | 'LOAN_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC';

/** A connection to a list of `LiquidityProviderBoostPoolSummary` values. */
export type LiquidityProviderBoostPoolSummariesConnection = {
  __typename?: 'LiquidityProviderBoostPoolSummariesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityProviderBoostPoolSummaryAggregates>;
  /** A list of edges which contains the `LiquidityProviderBoostPoolSummary` and cursor to aid in pagination. */
  edges: Array<LiquidityProviderBoostPoolSummariesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityProviderBoostPoolSummaryAggregates>>;
  /** A list of `LiquidityProviderBoostPoolSummary` objects. */
  nodes: Array<LiquidityProviderBoostPoolSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityProviderBoostPoolSummary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityProviderBoostPoolSummary` values. */
export type LiquidityProviderBoostPoolSummariesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityProviderBoostPoolSummaryGroupBy>;
  having?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingInput>;
};

/** A `LiquidityProviderBoostPoolSummary` edge in the connection. */
export type LiquidityProviderBoostPoolSummariesEdge = {
  __typename?: 'LiquidityProviderBoostPoolSummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityProviderBoostPoolSummary` at the end of the edge. */
  node: LiquidityProviderBoostPoolSummary;
};

/** Methods to use when ordering `LiquidityProviderBoostPoolSummary`. */
export type LiquidityProviderBoostPoolSummariesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'BOOST_POOL_ID_ASC'
  | 'BOOST_POOL_ID_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'FEE_USD_ASC'
  | 'FEE_USD_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL';

export type LiquidityProviderBoostPoolSummary = {
  __typename?: 'LiquidityProviderBoostPoolSummary';
  /** Reads a single `Account` that is related to this `LiquidityProviderBoostPoolSummary`. */
  accountByLiquidityProviderId: Account;
  amount: Scalars['BigFloat']['output'];
  amountUsd: Scalars['BigFloat']['output'];
  /** Reads a single `BoostPool` that is related to this `LiquidityProviderBoostPoolSummary`. */
  boostPoolByBoostPoolId: BoostPool;
  boostPoolId: Scalars['Int']['output'];
  fee: Scalars['BigFloat']['output'];
  feeUsd: Scalars['BigFloat']['output'];
  liquidityProviderId: Scalars['Int']['output'];
};

export type LiquidityProviderBoostPoolSummaryAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityProviderBoostPoolSummaryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityProviderBoostPoolSummaryDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityProviderBoostPoolSummaryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityProviderBoostPoolSummaryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityProviderBoostPoolSummaryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityProviderBoostPoolSummaryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityProviderBoostPoolSummarySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityProviderBoostPoolSummaryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityProviderBoostPoolSummaryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityProviderBoostPoolSummary` object types. */
export type LiquidityProviderBoostPoolSummaryAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  average?: InputMaybe<LiquidityProviderBoostPoolSummaryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  distinctCount?: InputMaybe<LiquidityProviderBoostPoolSummaryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityProviderBoostPoolSummary` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  /** Maximum aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  max?: InputMaybe<LiquidityProviderBoostPoolSummaryMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  min?: InputMaybe<LiquidityProviderBoostPoolSummaryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  stddevPopulation?: InputMaybe<LiquidityProviderBoostPoolSummaryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  stddevSample?: InputMaybe<LiquidityProviderBoostPoolSummaryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  sum?: InputMaybe<LiquidityProviderBoostPoolSummarySumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  variancePopulation?: InputMaybe<LiquidityProviderBoostPoolSummaryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityProviderBoostPoolSummary` objects. */
  varianceSample?: InputMaybe<LiquidityProviderBoostPoolSummaryVarianceSampleAggregateFilter>;
};

export type LiquidityProviderBoostPoolSummaryAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderBoostPoolSummaryAverageAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidityProviderBoostPoolSummary` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type LiquidityProviderBoostPoolSummaryCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  boostPoolByBoostPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type LiquidityProviderBoostPoolSummaryDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  feeUsd?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryDistinctCountAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityProviderBoostPoolSummary` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderBoostPoolSummaryFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityProviderBoostPoolSummaryFilter>>;
  /** Filter by the object’s `boostPoolByBoostPoolId` relation. */
  boostPoolByBoostPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `boostPoolId` field. */
  boostPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityProviderBoostPoolSummaryFilter>>;
};

/** Grouping methods for `LiquidityProviderBoostPoolSummary` for usage during aggregation. */
export type LiquidityProviderBoostPoolSummaryGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'BOOST_POOL_ID'
  | 'FEE'
  | 'FEE_USD'
  | 'LIQUIDITY_PROVIDER_ID';

export type LiquidityProviderBoostPoolSummaryHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LiquidityProviderBoostPoolSummary` aggregates. */
export type LiquidityProviderBoostPoolSummaryHavingInput = {
  AND?: InputMaybe<Array<LiquidityProviderBoostPoolSummaryHavingInput>>;
  OR?: InputMaybe<Array<LiquidityProviderBoostPoolSummaryHavingInput>>;
  average?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingMaxInput>;
  min?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityProviderBoostPoolSummaryHavingVarianceSampleInput>;
};

export type LiquidityProviderBoostPoolSummaryHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  boostPoolId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderBoostPoolSummaryMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type LiquidityProviderBoostPoolSummaryMaxAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type LiquidityProviderBoostPoolSummaryMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<IntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type LiquidityProviderBoostPoolSummaryMinAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type LiquidityProviderBoostPoolSummaryStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderBoostPoolSummaryStddevPopulationAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityProviderBoostPoolSummaryStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderBoostPoolSummaryStddevSampleAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityProviderBoostPoolSummarySumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
};

export type LiquidityProviderBoostPoolSummarySumAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummarySumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of boostPoolId across the matching connection */
  boostPoolId: Scalars['BigInt']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of feeUsd across the matching connection */
  feeUsd: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
};

export type LiquidityProviderBoostPoolSummaryVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderBoostPoolSummaryVariancePopulationAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityProviderBoostPoolSummaryVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  boostPoolId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderBoostPoolSummaryVarianceSampleAggregates = {
  __typename?: 'LiquidityProviderBoostPoolSummaryVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostPoolId across the matching connection */
  boostPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquiditySnapshot = Node & {
  __typename?: 'LiquiditySnapshot';
  /** Reads a single `Account` that is related to this `LiquiditySnapshot`. */
  accountByLiquidityProviderId: Account;
  block: Scalars['Int']['output'];
  boostLiquidityUsd: Scalars['BigFloat']['output'];
  collateralLiquidityUsd: Scalars['BigFloat']['output'];
  deployedLiquidityUsd: Scalars['BigFloat']['output'];
  id: Scalars['BigInt']['output'];
  lendingLiquidityUsd: Scalars['BigFloat']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  strategyLiquidityUsd: Scalars['BigFloat']['output'];
  timestamp: Scalars['Datetime']['output'];
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  totalLiquidityUsd: Scalars['BigFloat']['output'];
  undeployedLiquidityUsd: Scalars['BigFloat']['output'];
};

export type LiquiditySnapshotAggregates = {
  __typename?: 'LiquiditySnapshotAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquiditySnapshotAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquiditySnapshotDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquiditySnapshotMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquiditySnapshotMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquiditySnapshotStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquiditySnapshotStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquiditySnapshotSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquiditySnapshotVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquiditySnapshotVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquiditySnapshot` object types. */
export type LiquiditySnapshotAggregatesFilter = {
  /** Mean average aggregate over matching `LiquiditySnapshot` objects. */
  average?: InputMaybe<LiquiditySnapshotAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquiditySnapshot` objects. */
  distinctCount?: InputMaybe<LiquiditySnapshotDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquiditySnapshot` object to be included within the aggregate. */
  filter?: InputMaybe<LiquiditySnapshotFilter>;
  /** Maximum aggregate over matching `LiquiditySnapshot` objects. */
  max?: InputMaybe<LiquiditySnapshotMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquiditySnapshot` objects. */
  min?: InputMaybe<LiquiditySnapshotMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquiditySnapshot` objects. */
  stddevPopulation?: InputMaybe<LiquiditySnapshotStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquiditySnapshot` objects. */
  stddevSample?: InputMaybe<LiquiditySnapshotStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquiditySnapshot` objects. */
  sum?: InputMaybe<LiquiditySnapshotSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquiditySnapshot` objects. */
  variancePopulation?: InputMaybe<LiquiditySnapshotVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquiditySnapshot` objects. */
  varianceSample?: InputMaybe<LiquiditySnapshotVarianceSampleAggregateFilter>;
};

export type LiquiditySnapshotAverageAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotAverageAggregates = {
  __typename?: 'LiquiditySnapshotAverageAggregates';
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquiditySnapshot` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LiquiditySnapshotCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `boostLiquidityUsd` field. */
  boostLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `collateralLiquidityUsd` field. */
  collateralLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `deployedLiquidityUsd` field. */
  deployedLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `lendingLiquidityUsd` field. */
  lendingLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stakingBalance` field. */
  stakingBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stakingBalanceUsd` field. */
  stakingBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `strategyLiquidityUsd` field. */
  strategyLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalBalanceUsd` field. */
  totalBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalLiquidityUsd` field. */
  totalLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `undeployedLiquidityUsd` field. */
  undeployedLiquidityUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LiquiditySnapshotDistinctCountAggregateFilter = {
  block?: InputMaybe<BigIntFilter>;
  boostLiquidityUsd?: InputMaybe<BigIntFilter>;
  collateralLiquidityUsd?: InputMaybe<BigIntFilter>;
  deployedLiquidityUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingLiquidityUsd?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  stakingBalance?: InputMaybe<BigIntFilter>;
  stakingBalanceUsd?: InputMaybe<BigIntFilter>;
  strategyLiquidityUsd?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  totalBalanceUsd?: InputMaybe<BigIntFilter>;
  totalLiquidityUsd?: InputMaybe<BigIntFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigIntFilter>;
};

export type LiquiditySnapshotDistinctCountAggregates = {
  __typename?: 'LiquiditySnapshotDistinctCountAggregates';
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquiditySnapshot` object types. All fields are combined with a logical ‘and.’ */
export type LiquiditySnapshotFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquiditySnapshotFilter>>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostLiquidityUsd` field. */
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `collateralLiquidityUsd` field. */
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `deployedLiquidityUsd` field. */
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `lendingLiquidityUsd` field. */
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquiditySnapshotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquiditySnapshotFilter>>;
  /** Filter by the object’s `stakingBalance` field. */
  stakingBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stakingBalanceUsd` field. */
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `strategyLiquidityUsd` field. */
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalBalanceUsd` field. */
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalLiquidityUsd` field. */
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `undeployedLiquidityUsd` field. */
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LiquiditySnapshot` for usage during aggregation. */
export type LiquiditySnapshotGroupBy =
  | 'BLOCK'
  | 'BOOST_LIQUIDITY_USD'
  | 'COLLATERAL_LIQUIDITY_USD'
  | 'DEPLOYED_LIQUIDITY_USD'
  | 'LENDING_LIQUIDITY_USD'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'STAKING_BALANCE'
  | 'STAKING_BALANCE_USD'
  | 'STRATEGY_LIQUIDITY_USD'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TOTAL_BALANCE_USD'
  | 'TOTAL_LIQUIDITY_USD'
  | 'UNDEPLOYED_LIQUIDITY_USD';

export type LiquiditySnapshotHavingAverageInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingDistinctCountInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LiquiditySnapshot` aggregates. */
export type LiquiditySnapshotHavingInput = {
  AND?: InputMaybe<Array<LiquiditySnapshotHavingInput>>;
  OR?: InputMaybe<Array<LiquiditySnapshotHavingInput>>;
  average?: InputMaybe<LiquiditySnapshotHavingAverageInput>;
  distinctCount?: InputMaybe<LiquiditySnapshotHavingDistinctCountInput>;
  max?: InputMaybe<LiquiditySnapshotHavingMaxInput>;
  min?: InputMaybe<LiquiditySnapshotHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquiditySnapshotHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquiditySnapshotHavingStddevSampleInput>;
  sum?: InputMaybe<LiquiditySnapshotHavingSumInput>;
  variancePopulation?: InputMaybe<LiquiditySnapshotHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquiditySnapshotHavingVarianceSampleInput>;
};

export type LiquiditySnapshotHavingMaxInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingMinInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingStddevPopulationInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingStddevSampleInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingSumInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingVariancePopulationInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotHavingVarianceSampleInput = {
  block?: InputMaybe<HavingIntFilter>;
  boostLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  collateralLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  deployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lendingLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stakingBalance?: InputMaybe<HavingBigfloatFilter>;
  stakingBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  strategyLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  totalLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquiditySnapshotMaxAggregateFilter = {
  block?: InputMaybe<IntFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotMaxAggregates = {
  __typename?: 'LiquiditySnapshotMaxAggregates';
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquiditySnapshotMinAggregateFilter = {
  block?: InputMaybe<IntFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotMinAggregates = {
  __typename?: 'LiquiditySnapshotMinAggregates';
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquiditySnapshotStddevPopulationAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotStddevPopulationAggregates = {
  __typename?: 'LiquiditySnapshotStddevPopulationAggregates';
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquiditySnapshotStddevSampleAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotStddevSampleAggregates = {
  __typename?: 'LiquiditySnapshotStddevSampleAggregates';
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquiditySnapshotSumAggregateFilter = {
  block?: InputMaybe<BigIntFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotSumAggregates = {
  __typename?: 'LiquiditySnapshotSumAggregates';
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd: Scalars['BigFloat']['output'];
  /** Sum of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd: Scalars['BigFloat']['output'];
  /** Sum of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of stakingBalance across the matching connection */
  stakingBalance: Scalars['BigFloat']['output'];
  /** Sum of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd: Scalars['BigFloat']['output'];
  /** Sum of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd: Scalars['BigFloat']['output'];
  /** Sum of totalBalanceUsd across the matching connection */
  totalBalanceUsd: Scalars['BigFloat']['output'];
  /** Sum of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd: Scalars['BigFloat']['output'];
  /** Sum of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd: Scalars['BigFloat']['output'];
};

export type LiquiditySnapshotVariancePopulationAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotVariancePopulationAggregates = {
  __typename?: 'LiquiditySnapshotVariancePopulationAggregates';
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquiditySnapshotVarianceSampleAggregateFilter = {
  block?: InputMaybe<BigFloatFilter>;
  boostLiquidityUsd?: InputMaybe<BigFloatFilter>;
  collateralLiquidityUsd?: InputMaybe<BigFloatFilter>;
  deployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingLiquidityUsd?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stakingBalance?: InputMaybe<BigFloatFilter>;
  stakingBalanceUsd?: InputMaybe<BigFloatFilter>;
  strategyLiquidityUsd?: InputMaybe<BigFloatFilter>;
  totalBalanceUsd?: InputMaybe<BigFloatFilter>;
  totalLiquidityUsd?: InputMaybe<BigFloatFilter>;
  undeployedLiquidityUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquiditySnapshotVarianceSampleAggregates = {
  __typename?: 'LiquiditySnapshotVarianceSampleAggregates';
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostLiquidityUsd across the matching connection */
  boostLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of collateralLiquidityUsd across the matching connection */
  collateralLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of deployedLiquidityUsd across the matching connection */
  deployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingLiquidityUsd across the matching connection */
  lendingLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stakingBalance across the matching connection */
  stakingBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stakingBalanceUsd across the matching connection */
  stakingBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of strategyLiquidityUsd across the matching connection */
  strategyLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBalanceUsd across the matching connection */
  totalBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalLiquidityUsd across the matching connection */
  totalLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of undeployedLiquidityUsd across the matching connection */
  undeployedLiquidityUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquiditySnapshot` values. */
export type LiquiditySnapshotsConnection = {
  __typename?: 'LiquiditySnapshotsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquiditySnapshotAggregates>;
  /** A list of edges which contains the `LiquiditySnapshot` and cursor to aid in pagination. */
  edges: Array<LiquiditySnapshotsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquiditySnapshotAggregates>>;
  /** A list of `LiquiditySnapshot` objects. */
  nodes: Array<LiquiditySnapshot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquiditySnapshot` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquiditySnapshot` values. */
export type LiquiditySnapshotsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquiditySnapshotGroupBy>;
  having?: InputMaybe<LiquiditySnapshotHavingInput>;
};

/** A `LiquiditySnapshot` edge in the connection. */
export type LiquiditySnapshotsEdge = {
  __typename?: 'LiquiditySnapshotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquiditySnapshot` at the end of the edge. */
  node: LiquiditySnapshot;
};

/** Methods to use when ordering `LiquiditySnapshot`. */
export type LiquiditySnapshotsOrderBy =
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'BOOST_LIQUIDITY_USD_ASC'
  | 'BOOST_LIQUIDITY_USD_DESC'
  | 'COLLATERAL_LIQUIDITY_USD_ASC'
  | 'COLLATERAL_LIQUIDITY_USD_DESC'
  | 'DEPLOYED_LIQUIDITY_USD_ASC'
  | 'DEPLOYED_LIQUIDITY_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LENDING_LIQUIDITY_USD_ASC'
  | 'LENDING_LIQUIDITY_USD_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STAKING_BALANCE_ASC'
  | 'STAKING_BALANCE_DESC'
  | 'STAKING_BALANCE_USD_ASC'
  | 'STAKING_BALANCE_USD_DESC'
  | 'STRATEGY_LIQUIDITY_USD_ASC'
  | 'STRATEGY_LIQUIDITY_USD_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TOTAL_BALANCE_USD_ASC'
  | 'TOTAL_BALANCE_USD_DESC'
  | 'TOTAL_LIQUIDITY_USD_ASC'
  | 'TOTAL_LIQUIDITY_USD_DESC'
  | 'UNDEPLOYED_LIQUIDITY_USD_ASC'
  | 'UNDEPLOYED_LIQUIDITY_USD_DESC';

export type Loan = Node & {
  __typename?: 'Loan';
  /** Reads a single `Account` that is related to this `Loan`. */
  accountByBorrowerId?: Maybe<Account>;
  /** Reads a single `Account` that is related to this `Loan`. */
  accountByBrokerId?: Maybe<Account>;
  asset: ChainflipAsset;
  /** Reads a single `Boost` that is related to this `Loan`. */
  boostByBoostId?: Maybe<Boost>;
  boostId?: Maybe<Scalars['Int']['output']>;
  borrowerId?: Maybe<Scalars['Int']['output']>;
  borrowerType: LoanBorrowerType;
  brokerCommissionBps?: Maybe<Scalars['Int']['output']>;
  brokerId?: Maybe<Scalars['Int']['output']>;
  brokerIdSs58?: Maybe<Scalars['String']['output']>;
  createdAtEventId: Scalars['BigInt']['output'];
  createdAtTimestamp: Scalars['Datetime']['output'];
  /** Reads a single `Event` that is related to this `Loan`. */
  eventByCreatedAtEventId: Event;
  /** Reads a single `Event` that is related to this `Loan`. */
  eventBySettledAtEventId?: Maybe<Event>;
  id: Scalars['BigInt']['output'];
  isLiquidated: Scalars['Boolean']['output'];
  lastUpdatedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangesByLoanLossId: LendingLiquidityBalanceChangesConnection;
  /** Reads a single `LendingPool` that is related to this `Loan`. */
  lendingPoolByPoolId: LendingPool;
  /** Reads and enables pagination through a set of `LiquidationSwapRequest`. */
  liquidationSwapRequestsByLoanId: LiquidationSwapRequestsConnection;
  /** Reads and enables pagination through a set of `LoanFee`. */
  loanFeesByLoanId: LoanFeesConnection;
  /** Reads and enables pagination through a set of `LoanUpdate`. */
  loanUpdatesByLoanId: LoanUpdatesConnection;
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  poolId: Scalars['Int']['output'];
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
};


export type LoanLendingLiquidityBalanceChangesByLoanLossIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy>>;
};


export type LoanLiquidationSwapRequestsByLoanIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapRequestCondition>;
  filter?: InputMaybe<LiquidationSwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapRequestsOrderBy>>;
};


export type LoanLoanFeesByLoanIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanFeeCondition>;
  filter?: InputMaybe<LoanFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanFeesOrderBy>>;
};


export type LoanLoanUpdatesByLoanIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanUpdateCondition>;
  filter?: InputMaybe<LoanUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanUpdatesOrderBy>>;
};

export type LoanAggregates = {
  __typename?: 'LoanAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LoanAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LoanDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LoanMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LoanMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LoanStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LoanStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LoanSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LoanVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LoanVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Loan` object types. */
export type LoanAggregatesFilter = {
  /** Mean average aggregate over matching `Loan` objects. */
  average?: InputMaybe<LoanAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Loan` objects. */
  distinctCount?: InputMaybe<LoanDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Loan` object to be included within the aggregate. */
  filter?: InputMaybe<LoanFilter>;
  /** Maximum aggregate over matching `Loan` objects. */
  max?: InputMaybe<LoanMaxAggregateFilter>;
  /** Minimum aggregate over matching `Loan` objects. */
  min?: InputMaybe<LoanMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Loan` objects. */
  stddevPopulation?: InputMaybe<LoanStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Loan` objects. */
  stddevSample?: InputMaybe<LoanStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Loan` objects. */
  sum?: InputMaybe<LoanSumAggregateFilter>;
  /** Population variance aggregate over matching `Loan` objects. */
  variancePopulation?: InputMaybe<LoanVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Loan` objects. */
  varianceSample?: InputMaybe<LoanVarianceSampleAggregateFilter>;
};

export type LoanAverageAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
};

export type LoanAverageAggregates = {
  __typename?: 'LoanAverageAggregates';
  /** Mean average of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanBorrowerType =
  | 'SYSTEM_BOOST'
  | 'USER';

/** A filter to be used against LoanBorrowerType fields. All fields are combined with a logical ‘and.’ */
export type LoanBorrowerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoanBorrowerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoanBorrowerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoanBorrowerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoanBorrowerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoanBorrowerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoanBorrowerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoanBorrowerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoanBorrowerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoanBorrowerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoanBorrowerType>>;
};

/** A condition to be used against `Loan` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LoanCondition = {
  accountByBorrowerId?: InputMaybe<Scalars['ID']['input']>;
  accountByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  boostByBoostId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostId` field. */
  boostId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `borrowerId` field. */
  borrowerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `borrowerType` field. */
  borrowerType?: InputMaybe<LoanBorrowerType>;
  /** Checks for equality with the object’s `brokerCommissionBps` field. */
  brokerCommissionBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerIdSs58` field. */
  brokerIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAtTimestamp` field. */
  createdAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  eventByCreatedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventBySettledAtEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isLiquidated` field. */
  isLiquidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lastUpdatedAtTimestamp` field. */
  lastUpdatedAtTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  lendingPoolByPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lostAmount` field. */
  lostAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lostAmountValueUsd` field. */
  lostAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `settledAtEventId` field. */
  settledAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type LoanDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  boostId?: InputMaybe<BigIntFilter>;
  borrowerId?: InputMaybe<BigIntFilter>;
  borrowerType?: InputMaybe<BigIntFilter>;
  brokerCommissionBps?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  brokerIdSs58?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  createdAtTimestamp?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isLiquidated?: InputMaybe<BigIntFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<BigIntFilter>;
  lostAmount?: InputMaybe<BigIntFilter>;
  lostAmountValueUsd?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  settledAtEventId?: InputMaybe<BigIntFilter>;
};

export type LoanDistinctCountAggregates = {
  __typename?: 'LoanDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of borrowerType across the matching connection */
  borrowerType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerIdSs58 across the matching connection */
  brokerIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAtTimestamp across the matching connection */
  createdAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isLiquidated across the matching connection */
  isLiquidated?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastUpdatedAtTimestamp across the matching connection */
  lastUpdatedAtTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type LoanFee = Node & {
  __typename?: 'LoanFee';
  asset: ChainflipAsset;
  brokerFeePortionAmount: Scalars['BigFloat']['output'];
  brokerFeePortionAmountValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `LoanFee`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `LendingPool` that is related to this `LoanFee`. */
  lendingPoolByPoolId: LendingPool;
  /** Reads a single `Loan` that is related to this `LoanFee`. */
  loanByLoanId: Loan;
  loanId: Scalars['BigInt']['output'];
  networkFeePortionAmount: Scalars['BigFloat']['output'];
  networkFeePortionAmountValueUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  oraclePriceId: Scalars['Int']['output'];
  /** Reads a single `OraclePriceTracking` that is related to this `LoanFee`. */
  oraclePriceTrackingByOraclePriceId: OraclePriceTracking;
  poolFeePortionAmount: Scalars['BigFloat']['output'];
  poolFeePortionAmountValueUsd: Scalars['BigFloat']['output'];
  poolId: Scalars['Int']['output'];
  timestamp: Scalars['Datetime']['output'];
  totalAmount: Scalars['BigFloat']['output'];
  totalAmountValueUsd: Scalars['BigFloat']['output'];
  type: LoanFeeType;
};

export type LoanFeeAggregates = {
  __typename?: 'LoanFeeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LoanFeeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LoanFeeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LoanFeeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LoanFeeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LoanFeeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LoanFeeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LoanFeeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LoanFeeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LoanFeeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LoanFee` object types. */
export type LoanFeeAggregatesFilter = {
  /** Mean average aggregate over matching `LoanFee` objects. */
  average?: InputMaybe<LoanFeeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LoanFee` objects. */
  distinctCount?: InputMaybe<LoanFeeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LoanFee` object to be included within the aggregate. */
  filter?: InputMaybe<LoanFeeFilter>;
  /** Maximum aggregate over matching `LoanFee` objects. */
  max?: InputMaybe<LoanFeeMaxAggregateFilter>;
  /** Minimum aggregate over matching `LoanFee` objects. */
  min?: InputMaybe<LoanFeeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LoanFee` objects. */
  stddevPopulation?: InputMaybe<LoanFeeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LoanFee` objects. */
  stddevSample?: InputMaybe<LoanFeeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LoanFee` objects. */
  sum?: InputMaybe<LoanFeeSumAggregateFilter>;
  /** Population variance aggregate over matching `LoanFee` objects. */
  variancePopulation?: InputMaybe<LoanFeeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LoanFee` objects. */
  varianceSample?: InputMaybe<LoanFeeVarianceSampleAggregateFilter>;
};

export type LoanFeeAverageAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeAverageAggregates = {
  __typename?: 'LoanFeeAverageAggregates';
  /** Mean average of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `LoanFee` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LoanFeeCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `brokerFeePortionAmount` field. */
  brokerFeePortionAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `brokerFeePortionAmountValueUsd` field. */
  brokerFeePortionAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolByPoolId?: InputMaybe<Scalars['ID']['input']>;
  loanByLoanId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `loanId` field. */
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `networkFeePortionAmount` field. */
  networkFeePortionAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `networkFeePortionAmountValueUsd` field. */
  networkFeePortionAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `oraclePriceId` field. */
  oraclePriceId?: InputMaybe<Scalars['Int']['input']>;
  oraclePriceTrackingByOraclePriceId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `poolFeePortionAmount` field. */
  poolFeePortionAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `poolFeePortionAmountValueUsd` field. */
  poolFeePortionAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalAmountValueUsd` field. */
  totalAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LoanFeeType>;
};

export type LoanFeeDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  brokerFeePortionAmount?: InputMaybe<BigIntFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  networkFeePortionAmount?: InputMaybe<BigIntFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigIntFilter>;
  oraclePriceId?: InputMaybe<BigIntFilter>;
  poolFeePortionAmount?: InputMaybe<BigIntFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigIntFilter>;
  totalAmountValueUsd?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LoanFeeDistinctCountAggregates = {
  __typename?: 'LoanFeeDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LoanFee` object types. All fields are combined with a logical ‘and.’ */
export type LoanFeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LoanFeeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `brokerFeePortionAmount` field. */
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `brokerFeePortionAmountValueUsd` field. */
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolByPoolId` relation. */
  lendingPoolByPoolId?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `loanByLoanId` relation. */
  loanByLoanId?: InputMaybe<LoanFilter>;
  /** Filter by the object’s `loanId` field. */
  loanId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `networkFeePortionAmount` field. */
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `networkFeePortionAmountValueUsd` field. */
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LoanFeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LoanFeeFilter>>;
  /** Filter by the object’s `oraclePriceId` field. */
  oraclePriceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `oraclePriceTrackingByOraclePriceId` relation. */
  oraclePriceTrackingByOraclePriceId?: InputMaybe<OraclePriceTrackingFilter>;
  /** Filter by the object’s `poolFeePortionAmount` field. */
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `poolFeePortionAmountValueUsd` field. */
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalAmountValueUsd` field. */
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LoanFeeTypeFilter>;
};

/** Grouping methods for `LoanFee` for usage during aggregation. */
export type LoanFeeGroupBy =
  | 'ASSET'
  | 'BROKER_FEE_PORTION_AMOUNT'
  | 'BROKER_FEE_PORTION_AMOUNT_VALUE_USD'
  | 'EVENT_ID'
  | 'LOAN_ID'
  | 'NETWORK_FEE_PORTION_AMOUNT'
  | 'NETWORK_FEE_PORTION_AMOUNT_VALUE_USD'
  | 'ORACLE_PRICE_ID'
  | 'POOL_FEE_PORTION_AMOUNT'
  | 'POOL_FEE_PORTION_AMOUNT_VALUE_USD'
  | 'POOL_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TOTAL_AMOUNT'
  | 'TOTAL_AMOUNT_VALUE_USD'
  | 'TYPE';

export type LoanFeeHavingAverageInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingDistinctCountInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LoanFee` aggregates. */
export type LoanFeeHavingInput = {
  AND?: InputMaybe<Array<LoanFeeHavingInput>>;
  OR?: InputMaybe<Array<LoanFeeHavingInput>>;
  average?: InputMaybe<LoanFeeHavingAverageInput>;
  distinctCount?: InputMaybe<LoanFeeHavingDistinctCountInput>;
  max?: InputMaybe<LoanFeeHavingMaxInput>;
  min?: InputMaybe<LoanFeeHavingMinInput>;
  stddevPopulation?: InputMaybe<LoanFeeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LoanFeeHavingStddevSampleInput>;
  sum?: InputMaybe<LoanFeeHavingSumInput>;
  variancePopulation?: InputMaybe<LoanFeeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LoanFeeHavingVarianceSampleInput>;
};

export type LoanFeeHavingMaxInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingMinInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingStddevPopulationInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingStddevSampleInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingSumInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingVariancePopulationInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeHavingVarianceSampleInput = {
  brokerFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  networkFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  poolFeePortionAmount?: InputMaybe<HavingBigfloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  totalAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LoanFeeMaxAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<IntFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeMaxAggregates = {
  __typename?: 'LoanFeeMaxAggregates';
  /** Maximum of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanFeeMinAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<IntFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeMinAggregates = {
  __typename?: 'LoanFeeMinAggregates';
  /** Minimum of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanFeeStddevPopulationAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeStddevPopulationAggregates = {
  __typename?: 'LoanFeeStddevPopulationAggregates';
  /** Population standard deviation of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanFeeStddevSampleAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeStddevSampleAggregates = {
  __typename?: 'LoanFeeStddevSampleAggregates';
  /** Sample standard deviation of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanFeeSumAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigIntFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeSumAggregates = {
  __typename?: 'LoanFeeSumAggregates';
  /** Sum of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount: Scalars['BigFloat']['output'];
  /** Sum of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of loanId across the matching connection */
  loanId: Scalars['BigFloat']['output'];
  /** Sum of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount: Scalars['BigFloat']['output'];
  /** Sum of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of oraclePriceId across the matching connection */
  oraclePriceId: Scalars['BigInt']['output'];
  /** Sum of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount: Scalars['BigFloat']['output'];
  /** Sum of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
  /** Sum of totalAmount across the matching connection */
  totalAmount: Scalars['BigFloat']['output'];
  /** Sum of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd: Scalars['BigFloat']['output'];
};

export type LoanFeeType =
  | 'INTEREST_RATE'
  | 'LIQUIDATION'
  | 'LOW_LTV_PENALTY'
  | 'ORIGINATION';

/** A filter to be used against LoanFeeType fields. All fields are combined with a logical ‘and.’ */
export type LoanFeeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoanFeeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoanFeeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoanFeeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoanFeeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoanFeeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoanFeeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoanFeeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoanFeeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoanFeeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoanFeeType>>;
};

export type LoanFeeVariancePopulationAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeVariancePopulationAggregates = {
  __typename?: 'LoanFeeVariancePopulationAggregates';
  /** Population variance of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanFeeVarianceSampleAggregateFilter = {
  brokerFeePortionAmount?: InputMaybe<BigFloatFilter>;
  brokerFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmount?: InputMaybe<BigFloatFilter>;
  networkFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmount?: InputMaybe<BigFloatFilter>;
  poolFeePortionAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  totalAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type LoanFeeVarianceSampleAggregates = {
  __typename?: 'LoanFeeVarianceSampleAggregates';
  /** Sample variance of brokerFeePortionAmount across the matching connection */
  brokerFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerFeePortionAmountValueUsd across the matching connection */
  brokerFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeePortionAmount across the matching connection */
  networkFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeePortionAmountValueUsd across the matching connection */
  networkFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolFeePortionAmount across the matching connection */
  poolFeePortionAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolFeePortionAmountValueUsd across the matching connection */
  poolFeePortionAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmountValueUsd across the matching connection */
  totalAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LoanFee` values. */
export type LoanFeesConnection = {
  __typename?: 'LoanFeesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LoanFeeAggregates>;
  /** A list of edges which contains the `LoanFee` and cursor to aid in pagination. */
  edges: Array<LoanFeesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LoanFeeAggregates>>;
  /** A list of `LoanFee` objects. */
  nodes: Array<LoanFee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LoanFee` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LoanFee` values. */
export type LoanFeesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LoanFeeGroupBy>;
  having?: InputMaybe<LoanFeeHavingInput>;
};

/** A `LoanFee` edge in the connection. */
export type LoanFeesEdge = {
  __typename?: 'LoanFeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LoanFee` at the end of the edge. */
  node: LoanFee;
};

/** Methods to use when ordering `LoanFee`. */
export type LoanFeesOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOAN_ID_ASC'
  | 'LOAN_ID_DESC'
  | 'NATURAL'
  | 'NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'ORACLE_PRICE_ID_ASC'
  | 'ORACLE_PRICE_ID_DESC'
  | 'POOL_FEE_PORTION_AMOUNT_ASC'
  | 'POOL_FEE_PORTION_AMOUNT_DESC'
  | 'POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TOTAL_AMOUNT_ASC'
  | 'TOTAL_AMOUNT_DESC'
  | 'TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

/** A filter to be used against `Loan` object types. All fields are combined with a logical ‘and.’ */
export type LoanFilter = {
  /** Filter by the object’s `accountByBorrowerId` relation. */
  accountByBorrowerId?: InputMaybe<AccountFilter>;
  /** A related `accountByBorrowerId` exists. */
  accountByBorrowerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountByBrokerId` relation. */
  accountByBrokerId?: InputMaybe<AccountFilter>;
  /** A related `accountByBrokerId` exists. */
  accountByBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LoanFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `boostByBoostId` relation. */
  boostByBoostId?: InputMaybe<BoostFilter>;
  /** A related `boostByBoostId` exists. */
  boostByBoostIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostId` field. */
  boostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `borrowerId` field. */
  borrowerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `borrowerType` field. */
  borrowerType?: InputMaybe<LoanBorrowerTypeFilter>;
  /** Filter by the object’s `brokerCommissionBps` field. */
  brokerCommissionBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `brokerIdSs58` field. */
  brokerIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAtTimestamp` field. */
  createdAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventByCreatedAtEventId` relation. */
  eventByCreatedAtEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventBySettledAtEventId` relation. */
  eventBySettledAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventBySettledAtEventId` exists. */
  eventBySettledAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isLiquidated` field. */
  isLiquidated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastUpdatedAtTimestamp` field. */
  lastUpdatedAtTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lendingLiquidityBalanceChangesByLoanLossId` relation. */
  lendingLiquidityBalanceChangesByLoanLossId?: InputMaybe<LoanToManyLendingLiquidityBalanceChangeFilter>;
  /** Some related `lendingLiquidityBalanceChangesByLoanLossId` exist. */
  lendingLiquidityBalanceChangesByLoanLossIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lendingPoolByPoolId` relation. */
  lendingPoolByPoolId?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `liquidationSwapRequestsByLoanId` relation. */
  liquidationSwapRequestsByLoanId?: InputMaybe<LoanToManyLiquidationSwapRequestFilter>;
  /** Some related `liquidationSwapRequestsByLoanId` exist. */
  liquidationSwapRequestsByLoanIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanFeesByLoanId` relation. */
  loanFeesByLoanId?: InputMaybe<LoanToManyLoanFeeFilter>;
  /** Some related `loanFeesByLoanId` exist. */
  loanFeesByLoanIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanUpdatesByLoanId` relation. */
  loanUpdatesByLoanId?: InputMaybe<LoanToManyLoanUpdateFilter>;
  /** Some related `loanUpdatesByLoanId` exist. */
  loanUpdatesByLoanIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `lostAmount` field. */
  lostAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lostAmountValueUsd` field. */
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LoanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LoanFilter>>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `settledAtEventId` field. */
  settledAtEventId?: InputMaybe<BigIntFilter>;
};

/** Grouping methods for `Loan` for usage during aggregation. */
export type LoanGroupBy =
  | 'ASSET'
  | 'BOOST_ID'
  | 'BORROWER_ID'
  | 'BORROWER_TYPE'
  | 'BROKER_COMMISSION_BPS'
  | 'BROKER_ID'
  | 'BROKER_ID_SS58'
  | 'CREATED_AT_EVENT_ID'
  | 'CREATED_AT_TIMESTAMP'
  | 'CREATED_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'CREATED_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'CREATED_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'IS_LIQUIDATED'
  | 'LAST_UPDATED_AT_TIMESTAMP'
  | 'LAST_UPDATED_AT_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'LAST_UPDATED_AT_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'LAST_UPDATED_AT_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'LAST_UPDATED_AT_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'LOST_AMOUNT'
  | 'LOST_AMOUNT_VALUE_USD'
  | 'POOL_ID'
  | 'PREWITNESSED_DEPOSIT_ID'
  | 'SETTLED_AT_EVENT_ID';

export type LoanHavingAverageInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingDistinctCountInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `Loan` aggregates. */
export type LoanHavingInput = {
  AND?: InputMaybe<Array<LoanHavingInput>>;
  OR?: InputMaybe<Array<LoanHavingInput>>;
  average?: InputMaybe<LoanHavingAverageInput>;
  distinctCount?: InputMaybe<LoanHavingDistinctCountInput>;
  max?: InputMaybe<LoanHavingMaxInput>;
  min?: InputMaybe<LoanHavingMinInput>;
  stddevPopulation?: InputMaybe<LoanHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LoanHavingStddevSampleInput>;
  sum?: InputMaybe<LoanHavingSumInput>;
  variancePopulation?: InputMaybe<LoanHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LoanHavingVarianceSampleInput>;
};

export type LoanHavingMaxInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingMinInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingStddevPopulationInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingStddevSampleInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingSumInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingVariancePopulationInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanHavingVarianceSampleInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  brokerCommissionBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<HavingDatetimeFilter>;
  lostAmount?: InputMaybe<HavingBigfloatFilter>;
  lostAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  settledAtEventId?: InputMaybe<HavingBigintFilter>;
};

export type LoanMaxAggregateFilter = {
  boostId?: InputMaybe<IntFilter>;
  borrowerId?: InputMaybe<IntFilter>;
  brokerCommissionBps?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  createdAtTimestamp?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<DatetimeFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  settledAtEventId?: InputMaybe<BigIntFilter>;
};

export type LoanMaxAggregates = {
  __typename?: 'LoanMaxAggregates';
  /** Maximum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of createdAtTimestamp across the matching connection */
  createdAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of lastUpdatedAtTimestamp across the matching connection */
  lastUpdatedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type LoanMinAggregateFilter = {
  boostId?: InputMaybe<IntFilter>;
  borrowerId?: InputMaybe<IntFilter>;
  brokerCommissionBps?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  createdAtTimestamp?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdatedAtTimestamp?: InputMaybe<DatetimeFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  settledAtEventId?: InputMaybe<BigIntFilter>;
};

export type LoanMinAggregates = {
  __typename?: 'LoanMinAggregates';
  /** Minimum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of createdAtTimestamp across the matching connection */
  createdAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of lastUpdatedAtTimestamp across the matching connection */
  lastUpdatedAtTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type LoanStddevPopulationAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
};

export type LoanStddevPopulationAggregates = {
  __typename?: 'LoanStddevPopulationAggregates';
  /** Population standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanStddevSampleAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
};

export type LoanStddevSampleAggregates = {
  __typename?: 'LoanStddevSampleAggregates';
  /** Sample standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanSumAggregateFilter = {
  boostId?: InputMaybe<BigIntFilter>;
  borrowerId?: InputMaybe<BigIntFilter>;
  brokerCommissionBps?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
};

export type LoanSumAggregates = {
  __typename?: 'LoanSumAggregates';
  /** Sum of boostId across the matching connection */
  boostId: Scalars['BigInt']['output'];
  /** Sum of borrowerId across the matching connection */
  borrowerId: Scalars['BigInt']['output'];
  /** Sum of brokerCommissionBps across the matching connection */
  brokerCommissionBps: Scalars['BigInt']['output'];
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of createdAtEventId across the matching connection */
  createdAtEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of lostAmount across the matching connection */
  lostAmount: Scalars['BigFloat']['output'];
  /** Sum of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
  /** Sum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId: Scalars['BigFloat']['output'];
  /** Sum of settledAtEventId across the matching connection */
  settledAtEventId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `LendingLiquidityBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type LoanToManyLendingLiquidityBalanceChangeFilter = {
  /** Aggregates across related `LendingLiquidityBalanceChange` match the filter criteria. */
  aggregates?: InputMaybe<LendingLiquidityBalanceChangeAggregatesFilter>;
  /** Every related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** No related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  /** Some related `LendingLiquidityBalanceChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
};

/** A filter to be used against many `LiquidationSwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type LoanToManyLiquidationSwapRequestFilter = {
  /** Aggregates across related `LiquidationSwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<LiquidationSwapRequestAggregatesFilter>;
  /** Every related `LiquidationSwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidationSwapRequestFilter>;
  /** No related `LiquidationSwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidationSwapRequestFilter>;
  /** Some related `LiquidationSwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidationSwapRequestFilter>;
};

/** A filter to be used against many `LoanFee` object types. All fields are combined with a logical ‘and.’ */
export type LoanToManyLoanFeeFilter = {
  /** Aggregates across related `LoanFee` match the filter criteria. */
  aggregates?: InputMaybe<LoanFeeAggregatesFilter>;
  /** Every related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFeeFilter>;
  /** No related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFeeFilter>;
  /** Some related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFeeFilter>;
};

/** A filter to be used against many `LoanUpdate` object types. All fields are combined with a logical ‘and.’ */
export type LoanToManyLoanUpdateFilter = {
  /** Aggregates across related `LoanUpdate` match the filter criteria. */
  aggregates?: InputMaybe<LoanUpdateAggregatesFilter>;
  /** Every related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanUpdateFilter>;
  /** No related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanUpdateFilter>;
  /** Some related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanUpdateFilter>;
};

export type LoanUpdate = Node & {
  __typename?: 'LoanUpdate';
  amount: Scalars['BigFloat']['output'];
  amountValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `LoanUpdate`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `Loan` that is related to this `LoanUpdate`. */
  loanByLoanId: Loan;
  loanId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  oraclePriceId: Scalars['Int']['output'];
  /** Reads a single `OraclePriceTracking` that is related to this `LoanUpdate`. */
  oraclePriceTrackingByOraclePriceId: OraclePriceTracking;
  timestamp: Scalars['Datetime']['output'];
  type: LoanUpdateType;
};

export type LoanUpdateAggregates = {
  __typename?: 'LoanUpdateAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LoanUpdateAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LoanUpdateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LoanUpdateMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LoanUpdateMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LoanUpdateStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LoanUpdateStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LoanUpdateSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LoanUpdateVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LoanUpdateVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LoanUpdate` object types. */
export type LoanUpdateAggregatesFilter = {
  /** Mean average aggregate over matching `LoanUpdate` objects. */
  average?: InputMaybe<LoanUpdateAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LoanUpdate` objects. */
  distinctCount?: InputMaybe<LoanUpdateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LoanUpdate` object to be included within the aggregate. */
  filter?: InputMaybe<LoanUpdateFilter>;
  /** Maximum aggregate over matching `LoanUpdate` objects. */
  max?: InputMaybe<LoanUpdateMaxAggregateFilter>;
  /** Minimum aggregate over matching `LoanUpdate` objects. */
  min?: InputMaybe<LoanUpdateMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LoanUpdate` objects. */
  stddevPopulation?: InputMaybe<LoanUpdateStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LoanUpdate` objects. */
  stddevSample?: InputMaybe<LoanUpdateStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LoanUpdate` objects. */
  sum?: InputMaybe<LoanUpdateSumAggregateFilter>;
  /** Population variance aggregate over matching `LoanUpdate` objects. */
  variancePopulation?: InputMaybe<LoanUpdateVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LoanUpdate` objects. */
  varianceSample?: InputMaybe<LoanUpdateVarianceSampleAggregateFilter>;
};

export type LoanUpdateAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
};

export type LoanUpdateAverageAggregates = {
  __typename?: 'LoanUpdateAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LoanUpdate` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LoanUpdateCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountValueUsd` field. */
  amountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  loanByLoanId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `loanId` field. */
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `oraclePriceId` field. */
  oraclePriceId?: InputMaybe<Scalars['Int']['input']>;
  oraclePriceTrackingByOraclePriceId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LoanUpdateType>;
};

export type LoanUpdateDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountValueUsd?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  oraclePriceId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LoanUpdateDistinctCountAggregates = {
  __typename?: 'LoanUpdateDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LoanUpdate` object types. All fields are combined with a logical ‘and.’ */
export type LoanUpdateFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountValueUsd` field. */
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LoanUpdateFilter>>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loanByLoanId` relation. */
  loanByLoanId?: InputMaybe<LoanFilter>;
  /** Filter by the object’s `loanId` field. */
  loanId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LoanUpdateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LoanUpdateFilter>>;
  /** Filter by the object’s `oraclePriceId` field. */
  oraclePriceId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `oraclePriceTrackingByOraclePriceId` relation. */
  oraclePriceTrackingByOraclePriceId?: InputMaybe<OraclePriceTrackingFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LoanUpdateTypeFilter>;
};

/** Grouping methods for `LoanUpdate` for usage during aggregation. */
export type LoanUpdateGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_VALUE_USD'
  | 'EVENT_ID'
  | 'LOAN_ID'
  | 'ORACLE_PRICE_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TYPE';

export type LoanUpdateHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `LoanUpdate` aggregates. */
export type LoanUpdateHavingInput = {
  AND?: InputMaybe<Array<LoanUpdateHavingInput>>;
  OR?: InputMaybe<Array<LoanUpdateHavingInput>>;
  average?: InputMaybe<LoanUpdateHavingAverageInput>;
  distinctCount?: InputMaybe<LoanUpdateHavingDistinctCountInput>;
  max?: InputMaybe<LoanUpdateHavingMaxInput>;
  min?: InputMaybe<LoanUpdateHavingMinInput>;
  stddevPopulation?: InputMaybe<LoanUpdateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LoanUpdateHavingStddevSampleInput>;
  sum?: InputMaybe<LoanUpdateHavingSumInput>;
  variancePopulation?: InputMaybe<LoanUpdateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LoanUpdateHavingVarianceSampleInput>;
};

export type LoanUpdateHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  oraclePriceId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LoanUpdateMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  oraclePriceId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LoanUpdateMaxAggregates = {
  __typename?: 'LoanUpdateMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LoanUpdateMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  oraclePriceId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LoanUpdateMinAggregates = {
  __typename?: 'LoanUpdateMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LoanUpdateStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
};

export type LoanUpdateStddevPopulationAggregates = {
  __typename?: 'LoanUpdateStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanUpdateStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
};

export type LoanUpdateStddevSampleAggregates = {
  __typename?: 'LoanUpdateStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanUpdateSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigIntFilter>;
};

export type LoanUpdateSumAggregates = {
  __typename?: 'LoanUpdateSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountValueUsd across the matching connection */
  amountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of loanId across the matching connection */
  loanId: Scalars['BigFloat']['output'];
  /** Sum of oraclePriceId across the matching connection */
  oraclePriceId: Scalars['BigInt']['output'];
};

export type LoanUpdateType =
  | 'BORROWING'
  | 'REPAYMENT';

/** A filter to be used against LoanUpdateType fields. All fields are combined with a logical ‘and.’ */
export type LoanUpdateTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoanUpdateType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoanUpdateType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoanUpdateType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoanUpdateType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoanUpdateType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoanUpdateType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoanUpdateType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoanUpdateType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoanUpdateType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoanUpdateType>>;
};

export type LoanUpdateVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
};

export type LoanUpdateVariancePopulationAggregates = {
  __typename?: 'LoanUpdateVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanUpdateVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  oraclePriceId?: InputMaybe<BigFloatFilter>;
};

export type LoanUpdateVarianceSampleAggregates = {
  __typename?: 'LoanUpdateVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceId across the matching connection */
  oraclePriceId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LoanUpdate` values. */
export type LoanUpdatesConnection = {
  __typename?: 'LoanUpdatesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LoanUpdateAggregates>;
  /** A list of edges which contains the `LoanUpdate` and cursor to aid in pagination. */
  edges: Array<LoanUpdatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LoanUpdateAggregates>>;
  /** A list of `LoanUpdate` objects. */
  nodes: Array<LoanUpdate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LoanUpdate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LoanUpdate` values. */
export type LoanUpdatesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LoanUpdateGroupBy>;
  having?: InputMaybe<LoanUpdateHavingInput>;
};

/** A `LoanUpdate` edge in the connection. */
export type LoanUpdatesEdge = {
  __typename?: 'LoanUpdatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LoanUpdate` at the end of the edge. */
  node: LoanUpdate;
};

/** Methods to use when ordering `LoanUpdate`. */
export type LoanUpdatesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_VALUE_USD_ASC'
  | 'AMOUNT_VALUE_USD_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOAN_ID_ASC'
  | 'LOAN_ID_DESC'
  | 'NATURAL'
  | 'ORACLE_PRICE_ID_ASC'
  | 'ORACLE_PRICE_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type LoanVariancePopulationAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
};

export type LoanVariancePopulationAggregates = {
  __typename?: 'LoanVariancePopulationAggregates';
  /** Population variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LoanVarianceSampleAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  brokerCommissionBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lostAmount?: InputMaybe<BigFloatFilter>;
  lostAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  settledAtEventId?: InputMaybe<BigFloatFilter>;
};

export type LoanVarianceSampleAggregates = {
  __typename?: 'LoanVarianceSampleAggregates';
  /** Sample variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerCommissionBps across the matching connection */
  brokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lostAmount across the matching connection */
  lostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lostAmountValueUsd across the matching connection */
  lostAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of settledAtEventId across the matching connection */
  settledAtEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Loan` values. */
export type LoansConnection = {
  __typename?: 'LoansConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LoanAggregates>;
  /** A list of edges which contains the `Loan` and cursor to aid in pagination. */
  edges: Array<LoansEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LoanAggregates>>;
  /** A list of `Loan` objects. */
  nodes: Array<Loan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Loan` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Loan` values. */
export type LoansConnectionGroupedAggregatesArgs = {
  groupBy: Array<LoanGroupBy>;
  having?: InputMaybe<LoanHavingInput>;
};

/** A `Loan` edge in the connection. */
export type LoansEdge = {
  __typename?: 'LoansEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Loan` at the end of the edge. */
  node: Loan;
};

/** Methods to use when ordering `Loan`. */
export type LoansOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BOOST_ID_ASC'
  | 'BOOST_ID_DESC'
  | 'BORROWER_ID_ASC'
  | 'BORROWER_ID_DESC'
  | 'BORROWER_TYPE_ASC'
  | 'BORROWER_TYPE_DESC'
  | 'BROKER_COMMISSION_BPS_ASC'
  | 'BROKER_COMMISSION_BPS_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'BROKER_ID_SS58_ASC'
  | 'BROKER_ID_SS58_DESC'
  | 'CREATED_AT_EVENT_ID_ASC'
  | 'CREATED_AT_EVENT_ID_DESC'
  | 'CREATED_AT_TIMESTAMP_ASC'
  | 'CREATED_AT_TIMESTAMP_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_LIQUIDATED_ASC'
  | 'IS_LIQUIDATED_DESC'
  | 'LAST_UPDATED_AT_TIMESTAMP_ASC'
  | 'LAST_UPDATED_AT_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_AVERAGE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_COUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_COUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_IS_POSITION_CLOSING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_IS_POSITION_OPENING_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_IS_POSITION_OPENING_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MAX_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_TIMESTAMP_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_MIN_TIMESTAMP_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_SUM_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_LIQUIDATION_SWAP_REQUEST_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_LOAN_LOSS_ID_DESC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LENDING_LIQUIDITY_BALANCE_CHANGES_BY_LOAN_LOSS_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_IS_HARD_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_IS_HARD_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_REQUESTS_BY_LOAN_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_COUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_COUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MAX_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_MIN_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_SUM_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_LOAN_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_COUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_COUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_LOAN_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOST_AMOUNT_ASC'
  | 'LOST_AMOUNT_DESC'
  | 'LOST_AMOUNT_VALUE_USD_ASC'
  | 'LOST_AMOUNT_VALUE_USD_DESC'
  | 'NATURAL'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'PREWITNESSED_DEPOSIT_ID_ASC'
  | 'PREWITNESSED_DEPOSIT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SETTLED_AT_EVENT_ID_ASC'
  | 'SETTLED_AT_EVENT_ID_DESC';

export type LpCollateralBalanceChange = Node & {
  __typename?: 'LpCollateralBalanceChange';
  /** Reads a single `Account` that is related to this `LpCollateralBalanceChange`. */
  accountByLiquidityProviderId?: Maybe<Account>;
  amount: Scalars['BigFloat']['output'];
  amountValueUsd: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Event` that is related to this `LpCollateralBalanceChange`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: CollateralBalanceChangeType;
};

export type LpCollateralBalanceChangeAggregates = {
  __typename?: 'LpCollateralBalanceChangeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpCollateralBalanceChangeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpCollateralBalanceChangeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpCollateralBalanceChangeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpCollateralBalanceChangeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpCollateralBalanceChangeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpCollateralBalanceChangeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpCollateralBalanceChangeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpCollateralBalanceChangeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpCollateralBalanceChangeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpCollateralBalanceChange` object types. */
export type LpCollateralBalanceChangeAggregatesFilter = {
  /** Mean average aggregate over matching `LpCollateralBalanceChange` objects. */
  average?: InputMaybe<LpCollateralBalanceChangeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpCollateralBalanceChange` objects. */
  distinctCount?: InputMaybe<LpCollateralBalanceChangeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpCollateralBalanceChange` object to be included within the aggregate. */
  filter?: InputMaybe<LpCollateralBalanceChangeFilter>;
  /** Maximum aggregate over matching `LpCollateralBalanceChange` objects. */
  max?: InputMaybe<LpCollateralBalanceChangeMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpCollateralBalanceChange` objects. */
  min?: InputMaybe<LpCollateralBalanceChangeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpCollateralBalanceChange` objects. */
  stddevPopulation?: InputMaybe<LpCollateralBalanceChangeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpCollateralBalanceChange` objects. */
  stddevSample?: InputMaybe<LpCollateralBalanceChangeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpCollateralBalanceChange` objects. */
  sum?: InputMaybe<LpCollateralBalanceChangeSumAggregateFilter>;
  /** Population variance aggregate over matching `LpCollateralBalanceChange` objects. */
  variancePopulation?: InputMaybe<LpCollateralBalanceChangeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpCollateralBalanceChange` objects. */
  varianceSample?: InputMaybe<LpCollateralBalanceChangeVarianceSampleAggregateFilter>;
};

export type LpCollateralBalanceChangeAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceChangeAverageAggregates = {
  __typename?: 'LpCollateralBalanceChangeAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpCollateralBalanceChange` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LpCollateralBalanceChangeCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountValueUsd` field. */
  amountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<CollateralBalanceChangeType>;
};

export type LpCollateralBalanceChangeDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountValueUsd?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LpCollateralBalanceChangeDistinctCountAggregates = {
  __typename?: 'LpCollateralBalanceChangeDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpCollateralBalanceChange` object types. All fields are combined with a logical ‘and.’ */
export type LpCollateralBalanceChangeFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** A related `accountByLiquidityProviderId` exists. */
  accountByLiquidityProviderIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountValueUsd` field. */
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpCollateralBalanceChangeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpCollateralBalanceChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpCollateralBalanceChangeFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<CollateralBalanceChangeTypeFilter>;
};

/** Grouping methods for `LpCollateralBalanceChange` for usage during aggregation. */
export type LpCollateralBalanceChangeGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_VALUE_USD'
  | 'ASSET'
  | 'EVENT_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'TYPE';

export type LpCollateralBalanceChangeHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LpCollateralBalanceChange` aggregates. */
export type LpCollateralBalanceChangeHavingInput = {
  AND?: InputMaybe<Array<LpCollateralBalanceChangeHavingInput>>;
  OR?: InputMaybe<Array<LpCollateralBalanceChangeHavingInput>>;
  average?: InputMaybe<LpCollateralBalanceChangeHavingAverageInput>;
  distinctCount?: InputMaybe<LpCollateralBalanceChangeHavingDistinctCountInput>;
  max?: InputMaybe<LpCollateralBalanceChangeHavingMaxInput>;
  min?: InputMaybe<LpCollateralBalanceChangeHavingMinInput>;
  stddevPopulation?: InputMaybe<LpCollateralBalanceChangeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpCollateralBalanceChangeHavingStddevSampleInput>;
  sum?: InputMaybe<LpCollateralBalanceChangeHavingSumInput>;
  variancePopulation?: InputMaybe<LpCollateralBalanceChangeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpCollateralBalanceChangeHavingVarianceSampleInput>;
};

export type LpCollateralBalanceChangeHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
};

export type LpCollateralBalanceChangeMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type LpCollateralBalanceChangeMaxAggregates = {
  __typename?: 'LpCollateralBalanceChangeMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type LpCollateralBalanceChangeMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
};

export type LpCollateralBalanceChangeMinAggregates = {
  __typename?: 'LpCollateralBalanceChangeMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
};

export type LpCollateralBalanceChangeStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceChangeStddevPopulationAggregates = {
  __typename?: 'LpCollateralBalanceChangeStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceChangeStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceChangeStddevSampleAggregates = {
  __typename?: 'LpCollateralBalanceChangeStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceChangeSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
};

export type LpCollateralBalanceChangeSumAggregates = {
  __typename?: 'LpCollateralBalanceChangeSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountValueUsd across the matching connection */
  amountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
};

export type LpCollateralBalanceChangeVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceChangeVariancePopulationAggregates = {
  __typename?: 'LpCollateralBalanceChangeVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpCollateralBalanceChangeVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
};

export type LpCollateralBalanceChangeVarianceSampleAggregates = {
  __typename?: 'LpCollateralBalanceChangeVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountValueUsd across the matching connection */
  amountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpCollateralBalanceChange` values. */
export type LpCollateralBalanceChangesConnection = {
  __typename?: 'LpCollateralBalanceChangesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpCollateralBalanceChangeAggregates>;
  /** A list of edges which contains the `LpCollateralBalanceChange` and cursor to aid in pagination. */
  edges: Array<LpCollateralBalanceChangesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpCollateralBalanceChangeAggregates>>;
  /** A list of `LpCollateralBalanceChange` objects. */
  nodes: Array<LpCollateralBalanceChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpCollateralBalanceChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpCollateralBalanceChange` values. */
export type LpCollateralBalanceChangesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpCollateralBalanceChangeGroupBy>;
  having?: InputMaybe<LpCollateralBalanceChangeHavingInput>;
};

/** A `LpCollateralBalanceChange` edge in the connection. */
export type LpCollateralBalanceChangesEdge = {
  __typename?: 'LpCollateralBalanceChangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpCollateralBalanceChange` at the end of the edge. */
  node: LpCollateralBalanceChange;
};

/** Methods to use when ordering `LpCollateralBalanceChange`. */
export type LpCollateralBalanceChangesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_VALUE_USD_ASC'
  | 'AMOUNT_VALUE_USD_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type LpFlipAirdropDistributionEvent = Node & {
  __typename?: 'LpFlipAirdropDistributionEvent';
  /** Reads a single `Account` that is related to this `LpFlipAirdropDistributionEvent`. */
  accountByLiquidityProviderId: Account;
  flipAmount: Scalars['BigFloat']['output'];
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LendingPoolIncentiveProgram` that is related to this `LpFlipAirdropDistributionEvent`. */
  lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId: LendingPoolIncentiveProgram;
  lendingPoolIncentiveProgramId: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  lpSs58Id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  pointAmount: Scalars['BigFloat']['output'];
  txRef?: Maybe<Scalars['String']['output']>;
};

export type LpFlipAirdropDistributionEventAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpFlipAirdropDistributionEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpFlipAirdropDistributionEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpFlipAirdropDistributionEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpFlipAirdropDistributionEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpFlipAirdropDistributionEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpFlipAirdropDistributionEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpFlipAirdropDistributionEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpFlipAirdropDistributionEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpFlipAirdropDistributionEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpFlipAirdropDistributionEvent` object types. */
export type LpFlipAirdropDistributionEventAggregatesFilter = {
  /** Mean average aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  average?: InputMaybe<LpFlipAirdropDistributionEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  distinctCount?: InputMaybe<LpFlipAirdropDistributionEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpFlipAirdropDistributionEvent` object to be included within the aggregate. */
  filter?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  /** Maximum aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  max?: InputMaybe<LpFlipAirdropDistributionEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  min?: InputMaybe<LpFlipAirdropDistributionEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  stddevPopulation?: InputMaybe<LpFlipAirdropDistributionEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  stddevSample?: InputMaybe<LpFlipAirdropDistributionEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  sum?: InputMaybe<LpFlipAirdropDistributionEventSumAggregateFilter>;
  /** Population variance aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  variancePopulation?: InputMaybe<LpFlipAirdropDistributionEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpFlipAirdropDistributionEvent` objects. */
  varianceSample?: InputMaybe<LpFlipAirdropDistributionEventVarianceSampleAggregateFilter>;
};

export type LpFlipAirdropDistributionEventAverageAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventAverageAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventAverageAggregates';
  /** Mean average of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpFlipAirdropDistributionEvent` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type LpFlipAirdropDistributionEventCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `flipAmount` field. */
  flipAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `flipAmountUsd` field. */
  flipAmountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lendingPoolIncentiveProgramId` field. */
  lendingPoolIncentiveProgramId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lpSs58Id` field. */
  lpSs58Id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pointAmount` field. */
  pointAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `txRef` field. */
  txRef?: InputMaybe<Scalars['String']['input']>;
};

export type LpFlipAirdropDistributionEventDistinctCountAggregateFilter = {
  flipAmount?: InputMaybe<BigIntFilter>;
  flipAmountUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  lpSs58Id?: InputMaybe<BigIntFilter>;
  pointAmount?: InputMaybe<BigIntFilter>;
  txRef?: InputMaybe<BigIntFilter>;
};

export type LpFlipAirdropDistributionEventDistinctCountAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventDistinctCountAggregates';
  /** Distinct count of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpSs58Id across the matching connection */
  lpSs58Id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of txRef across the matching connection */
  txRef?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpFlipAirdropDistributionEvent` object types. All fields are combined with a logical ‘and.’ */
export type LpFlipAirdropDistributionEventFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpFlipAirdropDistributionEventFilter>>;
  /** Filter by the object’s `flipAmount` field. */
  flipAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `flipAmountUsd` field. */
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId` relation. */
  lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** Filter by the object’s `lendingPoolIncentiveProgramId` field. */
  lendingPoolIncentiveProgramId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lpSs58Id` field. */
  lpSs58Id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpFlipAirdropDistributionEventFilter>>;
  /** Filter by the object’s `pointAmount` field. */
  pointAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `txRef` field. */
  txRef?: InputMaybe<StringFilter>;
};

/** Grouping methods for `LpFlipAirdropDistributionEvent` for usage during aggregation. */
export type LpFlipAirdropDistributionEventGroupBy =
  | 'FLIP_AMOUNT'
  | 'FLIP_AMOUNT_USD'
  | 'LENDING_POOL_INCENTIVE_PROGRAM_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'LP_SS58_ID'
  | 'POINT_AMOUNT'
  | 'TX_REF';

export type LpFlipAirdropDistributionEventHavingAverageInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingDistinctCountInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpFlipAirdropDistributionEvent` aggregates. */
export type LpFlipAirdropDistributionEventHavingInput = {
  AND?: InputMaybe<Array<LpFlipAirdropDistributionEventHavingInput>>;
  OR?: InputMaybe<Array<LpFlipAirdropDistributionEventHavingInput>>;
  average?: InputMaybe<LpFlipAirdropDistributionEventHavingAverageInput>;
  distinctCount?: InputMaybe<LpFlipAirdropDistributionEventHavingDistinctCountInput>;
  max?: InputMaybe<LpFlipAirdropDistributionEventHavingMaxInput>;
  min?: InputMaybe<LpFlipAirdropDistributionEventHavingMinInput>;
  stddevPopulation?: InputMaybe<LpFlipAirdropDistributionEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpFlipAirdropDistributionEventHavingStddevSampleInput>;
  sum?: InputMaybe<LpFlipAirdropDistributionEventHavingSumInput>;
  variancePopulation?: InputMaybe<LpFlipAirdropDistributionEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpFlipAirdropDistributionEventHavingVarianceSampleInput>;
};

export type LpFlipAirdropDistributionEventHavingMaxInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingMinInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingStddevPopulationInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingStddevSampleInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingSumInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingVariancePopulationInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventHavingVarianceSampleInput = {
  flipAmount?: InputMaybe<HavingBigfloatFilter>;
  flipAmountUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  pointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpFlipAirdropDistributionEventMaxAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventMaxAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventMaxAggregates';
  /** Maximum of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpFlipAirdropDistributionEventMinAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventMinAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventMinAggregates';
  /** Minimum of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpFlipAirdropDistributionEventStddevPopulationAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventStddevPopulationAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventStddevPopulationAggregates';
  /** Population standard deviation of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpFlipAirdropDistributionEventStddevSampleAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventStddevSampleAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventStddevSampleAggregates';
  /** Sample standard deviation of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpFlipAirdropDistributionEventSumAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventSumAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventSumAggregates';
  /** Sum of flipAmount across the matching connection */
  flipAmount: Scalars['BigFloat']['output'];
  /** Sum of flipAmountUsd across the matching connection */
  flipAmountUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of pointAmount across the matching connection */
  pointAmount: Scalars['BigFloat']['output'];
};

export type LpFlipAirdropDistributionEventVariancePopulationAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventVariancePopulationAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventVariancePopulationAggregates';
  /** Population variance of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpFlipAirdropDistributionEventVarianceSampleAggregateFilter = {
  flipAmount?: InputMaybe<BigFloatFilter>;
  flipAmountUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  pointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpFlipAirdropDistributionEventVarianceSampleAggregates = {
  __typename?: 'LpFlipAirdropDistributionEventVarianceSampleAggregates';
  /** Sample variance of flipAmount across the matching connection */
  flipAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of flipAmountUsd across the matching connection */
  flipAmountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of pointAmount across the matching connection */
  pointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpFlipAirdropDistributionEvent` values. */
export type LpFlipAirdropDistributionEventsConnection = {
  __typename?: 'LpFlipAirdropDistributionEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpFlipAirdropDistributionEventAggregates>;
  /** A list of edges which contains the `LpFlipAirdropDistributionEvent` and cursor to aid in pagination. */
  edges: Array<LpFlipAirdropDistributionEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpFlipAirdropDistributionEventAggregates>>;
  /** A list of `LpFlipAirdropDistributionEvent` objects. */
  nodes: Array<LpFlipAirdropDistributionEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpFlipAirdropDistributionEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpFlipAirdropDistributionEvent` values. */
export type LpFlipAirdropDistributionEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpFlipAirdropDistributionEventGroupBy>;
  having?: InputMaybe<LpFlipAirdropDistributionEventHavingInput>;
};

/** A `LpFlipAirdropDistributionEvent` edge in the connection. */
export type LpFlipAirdropDistributionEventsEdge = {
  __typename?: 'LpFlipAirdropDistributionEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpFlipAirdropDistributionEvent` at the end of the edge. */
  node: LpFlipAirdropDistributionEvent;
};

/** Methods to use when ordering `LpFlipAirdropDistributionEvent`. */
export type LpFlipAirdropDistributionEventsOrderBy =
  | 'FLIP_AMOUNT_ASC'
  | 'FLIP_AMOUNT_DESC'
  | 'FLIP_AMOUNT_USD_ASC'
  | 'FLIP_AMOUNT_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_SS58_ID_ASC'
  | 'LP_SS58_ID_DESC'
  | 'NATURAL'
  | 'POINT_AMOUNT_ASC'
  | 'POINT_AMOUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TX_REF_ASC'
  | 'TX_REF_DESC';

export type LpLendingPoolSnapshot = Node & {
  __typename?: 'LpLendingPoolSnapshot';
  /** Reads a single `Account` that is related to this `LpLendingPoolSnapshot`. */
  accountByLiquidityProviderId: Account;
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  blockHeight: Scalars['Int']['output'];
  id: Scalars['BigInt']['output'];
  interval: Scalars['Int']['output'];
  /** Reads a single `LendingPool` that is related to this `LpLendingPoolSnapshot`. */
  lendingPoolByLendingPoolId: LendingPool;
  lendingPoolId: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
  timestamp: Scalars['Datetime']['output'];
  timestampHour: Scalars['Datetime']['output'];
  type: LpLendingPoolSnapshotType;
};

export type LpLendingPoolSnapshotAggregates = {
  __typename?: 'LpLendingPoolSnapshotAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpLendingPoolSnapshotAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpLendingPoolSnapshotDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpLendingPoolSnapshotMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpLendingPoolSnapshotMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpLendingPoolSnapshotStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpLendingPoolSnapshotStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpLendingPoolSnapshotSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpLendingPoolSnapshotVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpLendingPoolSnapshotVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpLendingPoolSnapshot` object types. */
export type LpLendingPoolSnapshotAggregatesFilter = {
  /** Mean average aggregate over matching `LpLendingPoolSnapshot` objects. */
  average?: InputMaybe<LpLendingPoolSnapshotAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpLendingPoolSnapshot` objects. */
  distinctCount?: InputMaybe<LpLendingPoolSnapshotDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpLendingPoolSnapshot` object to be included within the aggregate. */
  filter?: InputMaybe<LpLendingPoolSnapshotFilter>;
  /** Maximum aggregate over matching `LpLendingPoolSnapshot` objects. */
  max?: InputMaybe<LpLendingPoolSnapshotMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpLendingPoolSnapshot` objects. */
  min?: InputMaybe<LpLendingPoolSnapshotMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpLendingPoolSnapshot` objects. */
  stddevPopulation?: InputMaybe<LpLendingPoolSnapshotStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpLendingPoolSnapshot` objects. */
  stddevSample?: InputMaybe<LpLendingPoolSnapshotStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpLendingPoolSnapshot` objects. */
  sum?: InputMaybe<LpLendingPoolSnapshotSumAggregateFilter>;
  /** Population variance aggregate over matching `LpLendingPoolSnapshot` objects. */
  variancePopulation?: InputMaybe<LpLendingPoolSnapshotVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpLendingPoolSnapshot` objects. */
  varianceSample?: InputMaybe<LpLendingPoolSnapshotVarianceSampleAggregateFilter>;
};

export type LpLendingPoolSnapshotAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingPoolSnapshotAverageAggregates = {
  __typename?: 'LpLendingPoolSnapshotAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpLendingPoolSnapshot` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LpLendingPoolSnapshotCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `blockHeight` field. */
  blockHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolByLendingPoolId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lendingPoolId` field. */
  lendingPoolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `supplyPnl1H` field. */
  supplyPnl1H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `supplyPnl1HUsd` field. */
  supplyPnl1HUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `timestampHour` field. */
  timestampHour?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LpLendingPoolSnapshotType>;
};

export type LpLendingPoolSnapshotDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  blockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<BigIntFilter>;
  lendingPoolId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  supplyPnl1H?: InputMaybe<BigIntFilter>;
  supplyPnl1HUsd?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  timestampHour?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type LpLendingPoolSnapshotDistinctCountAggregates = {
  __typename?: 'LpLendingPoolSnapshotDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interval across the matching connection */
  interval?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestampHour across the matching connection */
  timestampHour?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpLendingPoolSnapshot` object types. All fields are combined with a logical ‘and.’ */
export type LpLendingPoolSnapshotFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpLendingPoolSnapshotFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockHeight` field. */
  blockHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `interval` field. */
  interval?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolByLendingPoolId` relation. */
  lendingPoolByLendingPoolId?: InputMaybe<LendingPoolFilter>;
  /** Filter by the object’s `lendingPoolId` field. */
  lendingPoolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpLendingPoolSnapshotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpLendingPoolSnapshotFilter>>;
  /** Filter by the object’s `supplyPnl1H` field. */
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `supplyPnl1HUsd` field. */
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `timestampHour` field. */
  timestampHour?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LpLendingPoolSnapshotTypeFilter>;
};

/** Grouping methods for `LpLendingPoolSnapshot` for usage during aggregation. */
export type LpLendingPoolSnapshotGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BLOCK_HEIGHT'
  | 'INTERVAL'
  | 'LENDING_POOL_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'SUPPLY_PNL1H'
  | 'SUPPLY_PNL1H_USD'
  | 'TIMESTAMP'
  | 'TIMESTAMP_HOUR'
  | 'TIMESTAMP_HOUR_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_HOUR_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_HOUR_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_HOUR_TRUNCATED_TO_WEEK'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TYPE';

export type LpLendingPoolSnapshotHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `LpLendingPoolSnapshot` aggregates. */
export type LpLendingPoolSnapshotHavingInput = {
  AND?: InputMaybe<Array<LpLendingPoolSnapshotHavingInput>>;
  OR?: InputMaybe<Array<LpLendingPoolSnapshotHavingInput>>;
  average?: InputMaybe<LpLendingPoolSnapshotHavingAverageInput>;
  distinctCount?: InputMaybe<LpLendingPoolSnapshotHavingDistinctCountInput>;
  max?: InputMaybe<LpLendingPoolSnapshotHavingMaxInput>;
  min?: InputMaybe<LpLendingPoolSnapshotHavingMinInput>;
  stddevPopulation?: InputMaybe<LpLendingPoolSnapshotHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpLendingPoolSnapshotHavingStddevSampleInput>;
  sum?: InputMaybe<LpLendingPoolSnapshotHavingSumInput>;
  variancePopulation?: InputMaybe<LpLendingPoolSnapshotHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpLendingPoolSnapshotHavingVarianceSampleInput>;
};

export type LpLendingPoolSnapshotHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  lendingPoolId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  supplyPnl1H?: InputMaybe<HavingBigfloatFilter>;
  supplyPnl1HUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  timestampHour?: InputMaybe<HavingDatetimeFilter>;
};

export type LpLendingPoolSnapshotMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<IntFilter>;
  lendingPoolId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  timestampHour?: InputMaybe<DatetimeFilter>;
};

export type LpLendingPoolSnapshotMaxAggregates = {
  __typename?: 'LpLendingPoolSnapshotMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of timestampHour across the matching connection */
  timestampHour?: Maybe<Scalars['Datetime']['output']>;
};

export type LpLendingPoolSnapshotMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<IntFilter>;
  lendingPoolId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  timestampHour?: InputMaybe<DatetimeFilter>;
};

export type LpLendingPoolSnapshotMinAggregates = {
  __typename?: 'LpLendingPoolSnapshotMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of timestampHour across the matching connection */
  timestampHour?: Maybe<Scalars['Datetime']['output']>;
};

export type LpLendingPoolSnapshotStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingPoolSnapshotStddevPopulationAggregates = {
  __typename?: 'LpLendingPoolSnapshotStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingPoolSnapshotStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingPoolSnapshotStddevSampleAggregates = {
  __typename?: 'LpLendingPoolSnapshotStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingPoolSnapshotSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigIntFilter>;
  lendingPoolId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingPoolSnapshotSumAggregates = {
  __typename?: 'LpLendingPoolSnapshotSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of blockHeight across the matching connection */
  blockHeight: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of interval across the matching connection */
  interval: Scalars['BigInt']['output'];
  /** Sum of lendingPoolId across the matching connection */
  lendingPoolId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of supplyPnl1H across the matching connection */
  supplyPnl1H: Scalars['BigFloat']['output'];
  /** Sum of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd: Scalars['BigFloat']['output'];
};

export type LpLendingPoolSnapshotType =
  | 'BORROWED_AMOUNT'
  | 'SUPPLIED_AMOUNT';

/** A filter to be used against LpLendingPoolSnapshotType fields. All fields are combined with a logical ‘and.’ */
export type LpLendingPoolSnapshotTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LpLendingPoolSnapshotType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LpLendingPoolSnapshotType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LpLendingPoolSnapshotType>>;
};

export type LpLendingPoolSnapshotVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingPoolSnapshotVariancePopulationAggregates = {
  __typename?: 'LpLendingPoolSnapshotVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpLendingPoolSnapshotVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  lendingPoolId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  supplyPnl1H?: InputMaybe<BigFloatFilter>;
  supplyPnl1HUsd?: InputMaybe<BigFloatFilter>;
};

export type LpLendingPoolSnapshotVarianceSampleAggregates = {
  __typename?: 'LpLendingPoolSnapshotVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingPoolId across the matching connection */
  lendingPoolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of supplyPnl1H across the matching connection */
  supplyPnl1H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of supplyPnl1HUsd across the matching connection */
  supplyPnl1HUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpLendingPoolSnapshot` values. */
export type LpLendingPoolSnapshotsConnection = {
  __typename?: 'LpLendingPoolSnapshotsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpLendingPoolSnapshotAggregates>;
  /** A list of edges which contains the `LpLendingPoolSnapshot` and cursor to aid in pagination. */
  edges: Array<LpLendingPoolSnapshotsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpLendingPoolSnapshotAggregates>>;
  /** A list of `LpLendingPoolSnapshot` objects. */
  nodes: Array<LpLendingPoolSnapshot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpLendingPoolSnapshot` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpLendingPoolSnapshot` values. */
export type LpLendingPoolSnapshotsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpLendingPoolSnapshotGroupBy>;
  having?: InputMaybe<LpLendingPoolSnapshotHavingInput>;
};

/** A `LpLendingPoolSnapshot` edge in the connection. */
export type LpLendingPoolSnapshotsEdge = {
  __typename?: 'LpLendingPoolSnapshotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpLendingPoolSnapshot` at the end of the edge. */
  node: LpLendingPoolSnapshot;
};

/** Methods to use when ordering `LpLendingPoolSnapshot`. */
export type LpLendingPoolSnapshotsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_HEIGHT_ASC'
  | 'BLOCK_HEIGHT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTERVAL_ASC'
  | 'INTERVAL_DESC'
  | 'LENDING_POOL_ID_ASC'
  | 'LENDING_POOL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUPPLY_PNL1H_ASC'
  | 'SUPPLY_PNL1H_DESC'
  | 'SUPPLY_PNL1H_USD_ASC'
  | 'SUPPLY_PNL1H_USD_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TIMESTAMP_HOUR_ASC'
  | 'TIMESTAMP_HOUR_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type LpPointDistributionEvent = Node & {
  __typename?: 'LpPointDistributionEvent';
  /** Reads a single `Account` that is related to this `LpPointDistributionEvent`. */
  accountByLiquidityProviderId: Account;
  blockHeight: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `LendingPoolIncentiveProgram` that is related to this `LpPointDistributionEvent`. */
  lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId: LendingPoolIncentiveProgram;
  lendingPoolIncentiveProgramId: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  lpSs58Id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  timestamp: Scalars['Datetime']['output'];
  totalDistributedPointAmount: Scalars['BigFloat']['output'];
};

export type LpPointDistributionEventAggregates = {
  __typename?: 'LpPointDistributionEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpPointDistributionEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpPointDistributionEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpPointDistributionEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpPointDistributionEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpPointDistributionEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpPointDistributionEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpPointDistributionEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpPointDistributionEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpPointDistributionEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpPointDistributionEvent` object types. */
export type LpPointDistributionEventAggregatesFilter = {
  /** Mean average aggregate over matching `LpPointDistributionEvent` objects. */
  average?: InputMaybe<LpPointDistributionEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpPointDistributionEvent` objects. */
  distinctCount?: InputMaybe<LpPointDistributionEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpPointDistributionEvent` object to be included within the aggregate. */
  filter?: InputMaybe<LpPointDistributionEventFilter>;
  /** Maximum aggregate over matching `LpPointDistributionEvent` objects. */
  max?: InputMaybe<LpPointDistributionEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpPointDistributionEvent` objects. */
  min?: InputMaybe<LpPointDistributionEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpPointDistributionEvent` objects. */
  stddevPopulation?: InputMaybe<LpPointDistributionEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpPointDistributionEvent` objects. */
  stddevSample?: InputMaybe<LpPointDistributionEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpPointDistributionEvent` objects. */
  sum?: InputMaybe<LpPointDistributionEventSumAggregateFilter>;
  /** Population variance aggregate over matching `LpPointDistributionEvent` objects. */
  variancePopulation?: InputMaybe<LpPointDistributionEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpPointDistributionEvent` objects. */
  varianceSample?: InputMaybe<LpPointDistributionEventVarianceSampleAggregateFilter>;
};

export type LpPointDistributionEventAverageAggregateFilter = {
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventAverageAggregates = {
  __typename?: 'LpPointDistributionEventAverageAggregates';
  /** Mean average of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpPointDistributionEvent` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LpPointDistributionEventCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockHeight` field. */
  blockHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `lendingPoolIncentiveProgramId` field. */
  lendingPoolIncentiveProgramId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lpSs58Id` field. */
  lpSs58Id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalDistributedPointAmount` field. */
  totalDistributedPointAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LpPointDistributionEventDistinctCountAggregateFilter = {
  blockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  lpSs58Id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  totalDistributedPointAmount?: InputMaybe<BigIntFilter>;
};

export type LpPointDistributionEventDistinctCountAggregates = {
  __typename?: 'LpPointDistributionEventDistinctCountAggregates';
  /** Distinct count of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpSs58Id across the matching connection */
  lpSs58Id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpPointDistributionEvent` object types. All fields are combined with a logical ‘and.’ */
export type LpPointDistributionEventFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpPointDistributionEventFilter>>;
  /** Filter by the object’s `blockHeight` field. */
  blockHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId` relation. */
  lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  /** Filter by the object’s `lendingPoolIncentiveProgramId` field. */
  lendingPoolIncentiveProgramId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lpSs58Id` field. */
  lpSs58Id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpPointDistributionEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpPointDistributionEventFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalDistributedPointAmount` field. */
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LpPointDistributionEvent` for usage during aggregation. */
export type LpPointDistributionEventGroupBy =
  | 'BLOCK_HEIGHT'
  | 'LENDING_POOL_INCENTIVE_PROGRAM_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'LP_SS58_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TOTAL_DISTRIBUTED_POINT_AMOUNT';

export type LpPointDistributionEventHavingAverageInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingDistinctCountInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpPointDistributionEvent` aggregates. */
export type LpPointDistributionEventHavingInput = {
  AND?: InputMaybe<Array<LpPointDistributionEventHavingInput>>;
  OR?: InputMaybe<Array<LpPointDistributionEventHavingInput>>;
  average?: InputMaybe<LpPointDistributionEventHavingAverageInput>;
  distinctCount?: InputMaybe<LpPointDistributionEventHavingDistinctCountInput>;
  max?: InputMaybe<LpPointDistributionEventHavingMaxInput>;
  min?: InputMaybe<LpPointDistributionEventHavingMinInput>;
  stddevPopulation?: InputMaybe<LpPointDistributionEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpPointDistributionEventHavingStddevSampleInput>;
  sum?: InputMaybe<LpPointDistributionEventHavingSumInput>;
  variancePopulation?: InputMaybe<LpPointDistributionEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpPointDistributionEventHavingVarianceSampleInput>;
};

export type LpPointDistributionEventHavingMaxInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingMinInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingStddevPopulationInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingStddevSampleInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingSumInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingVariancePopulationInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventHavingVarianceSampleInput = {
  blockHeight?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type LpPointDistributionEventMaxAggregateFilter = {
  blockHeight?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventMaxAggregates = {
  __typename?: 'LpPointDistributionEventMaxAggregates';
  /** Maximum of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpPointDistributionEventMinAggregateFilter = {
  blockHeight?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventMinAggregates = {
  __typename?: 'LpPointDistributionEventMinAggregates';
  /** Minimum of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpPointDistributionEventStddevPopulationAggregateFilter = {
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventStddevPopulationAggregates = {
  __typename?: 'LpPointDistributionEventStddevPopulationAggregates';
  /** Population standard deviation of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpPointDistributionEventStddevSampleAggregateFilter = {
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventStddevSampleAggregates = {
  __typename?: 'LpPointDistributionEventStddevSampleAggregates';
  /** Sample standard deviation of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpPointDistributionEventSumAggregateFilter = {
  blockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventSumAggregates = {
  __typename?: 'LpPointDistributionEventSumAggregates';
  /** Sum of blockHeight across the matching connection */
  blockHeight: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount: Scalars['BigFloat']['output'];
};

export type LpPointDistributionEventVariancePopulationAggregateFilter = {
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventVariancePopulationAggregates = {
  __typename?: 'LpPointDistributionEventVariancePopulationAggregates';
  /** Population variance of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpPointDistributionEventVarianceSampleAggregateFilter = {
  blockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lendingPoolIncentiveProgramId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  totalDistributedPointAmount?: InputMaybe<BigFloatFilter>;
};

export type LpPointDistributionEventVarianceSampleAggregates = {
  __typename?: 'LpPointDistributionEventVarianceSampleAggregates';
  /** Sample variance of blockHeight across the matching connection */
  blockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lendingPoolIncentiveProgramId across the matching connection */
  lendingPoolIncentiveProgramId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalDistributedPointAmount across the matching connection */
  totalDistributedPointAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpPointDistributionEvent` values. */
export type LpPointDistributionEventsConnection = {
  __typename?: 'LpPointDistributionEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpPointDistributionEventAggregates>;
  /** A list of edges which contains the `LpPointDistributionEvent` and cursor to aid in pagination. */
  edges: Array<LpPointDistributionEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpPointDistributionEventAggregates>>;
  /** A list of `LpPointDistributionEvent` objects. */
  nodes: Array<LpPointDistributionEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpPointDistributionEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpPointDistributionEvent` values. */
export type LpPointDistributionEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpPointDistributionEventGroupBy>;
  having?: InputMaybe<LpPointDistributionEventHavingInput>;
};

/** A `LpPointDistributionEvent` edge in the connection. */
export type LpPointDistributionEventsEdge = {
  __typename?: 'LpPointDistributionEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpPointDistributionEvent` at the end of the edge. */
  node: LpPointDistributionEvent;
};

/** Methods to use when ordering `LpPointDistributionEvent`. */
export type LpPointDistributionEventsOrderBy =
  | 'BLOCK_HEIGHT_ASC'
  | 'BLOCK_HEIGHT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LENDING_POOL_INCENTIVE_PROGRAM_ID_ASC'
  | 'LENDING_POOL_INCENTIVE_PROGRAM_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LP_SS58_ID_ASC'
  | 'LP_SS58_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TOTAL_DISTRIBUTED_POINT_AMOUNT_ASC'
  | 'TOTAL_DISTRIBUTED_POINT_AMOUNT_DESC';

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type OraclePriceTracking = Node & {
  __typename?: 'OraclePriceTracking';
  baseAsset: PriceAsset;
  createdAtEventId: Scalars['BigInt']['output'];
  /** Reads a single `Event` that is related to this `OraclePriceTracking`. */
  eventByCreatedAtEventId: Event;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LoanFee`. */
  loanFeesByOraclePriceId: LoanFeesConnection;
  /** Reads and enables pagination through a set of `LoanUpdate`. */
  loanUpdatesByOraclePriceId: LoanUpdatesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  priceValidFromBlock: Scalars['Int']['output'];
  priceValidToBlock?: Maybe<Scalars['Int']['output']>;
  priceX128: Scalars['BigFloat']['output'];
  quoteAsset: PriceAsset;
  updatedAtOracleTimestamp: Scalars['Datetime']['output'];
};


export type OraclePriceTrackingLoanFeesByOraclePriceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanFeeCondition>;
  filter?: InputMaybe<LoanFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanFeesOrderBy>>;
};


export type OraclePriceTrackingLoanUpdatesByOraclePriceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanUpdateCondition>;
  filter?: InputMaybe<LoanUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanUpdatesOrderBy>>;
};

export type OraclePriceTrackingAggregates = {
  __typename?: 'OraclePriceTrackingAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OraclePriceTrackingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OraclePriceTrackingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OraclePriceTrackingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OraclePriceTrackingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OraclePriceTrackingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OraclePriceTrackingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OraclePriceTrackingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OraclePriceTrackingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OraclePriceTrackingVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OraclePriceTracking` object types. */
export type OraclePriceTrackingAggregatesFilter = {
  /** Mean average aggregate over matching `OraclePriceTracking` objects. */
  average?: InputMaybe<OraclePriceTrackingAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OraclePriceTracking` objects. */
  distinctCount?: InputMaybe<OraclePriceTrackingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OraclePriceTracking` object to be included within the aggregate. */
  filter?: InputMaybe<OraclePriceTrackingFilter>;
  /** Maximum aggregate over matching `OraclePriceTracking` objects. */
  max?: InputMaybe<OraclePriceTrackingMaxAggregateFilter>;
  /** Minimum aggregate over matching `OraclePriceTracking` objects. */
  min?: InputMaybe<OraclePriceTrackingMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OraclePriceTracking` objects. */
  stddevPopulation?: InputMaybe<OraclePriceTrackingStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OraclePriceTracking` objects. */
  stddevSample?: InputMaybe<OraclePriceTrackingStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OraclePriceTracking` objects. */
  sum?: InputMaybe<OraclePriceTrackingSumAggregateFilter>;
  /** Population variance aggregate over matching `OraclePriceTracking` objects. */
  variancePopulation?: InputMaybe<OraclePriceTrackingVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OraclePriceTracking` objects. */
  varianceSample?: InputMaybe<OraclePriceTrackingVarianceSampleAggregateFilter>;
};

export type OraclePriceTrackingAverageAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingAverageAggregates = {
  __typename?: 'OraclePriceTrackingAverageAggregates';
  /** Mean average of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Mean average of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OraclePriceTracking` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OraclePriceTrackingCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<PriceAsset>;
  /** Checks for equality with the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByCreatedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `priceValidFromBlock` field. */
  priceValidFromBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `priceValidToBlock` field. */
  priceValidToBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `priceX128` field. */
  priceX128?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<PriceAsset>;
  /** Checks for equality with the object’s `updatedAtOracleTimestamp` field. */
  updatedAtOracleTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OraclePriceTrackingDistinctCountAggregateFilter = {
  baseAsset?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  price?: InputMaybe<BigIntFilter>;
  priceValidFromBlock?: InputMaybe<BigIntFilter>;
  priceValidToBlock?: InputMaybe<BigIntFilter>;
  priceX128?: InputMaybe<BigIntFilter>;
  quoteAsset?: InputMaybe<BigIntFilter>;
  updatedAtOracleTimestamp?: InputMaybe<BigIntFilter>;
};

export type OraclePriceTrackingDistinctCountAggregates = {
  __typename?: 'OraclePriceTrackingDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OraclePriceTracking` object types. All fields are combined with a logical ‘and.’ */
export type OraclePriceTrackingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OraclePriceTrackingFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<PriceAssetFilter>;
  /** Filter by the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByCreatedAtEventId` relation. */
  eventByCreatedAtEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loanFeesByOraclePriceId` relation. */
  loanFeesByOraclePriceId?: InputMaybe<OraclePriceTrackingToManyLoanFeeFilter>;
  /** Some related `loanFeesByOraclePriceId` exist. */
  loanFeesByOraclePriceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `loanUpdatesByOraclePriceId` relation. */
  loanUpdatesByOraclePriceId?: InputMaybe<OraclePriceTrackingToManyLoanUpdateFilter>;
  /** Some related `loanUpdatesByOraclePriceId` exist. */
  loanUpdatesByOraclePriceIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<OraclePriceTrackingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OraclePriceTrackingFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `priceValidFromBlock` field. */
  priceValidFromBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `priceValidToBlock` field. */
  priceValidToBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `priceX128` field. */
  priceX128?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<PriceAssetFilter>;
  /** Filter by the object’s `updatedAtOracleTimestamp` field. */
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `OraclePriceTracking` for usage during aggregation. */
export type OraclePriceTrackingGroupBy =
  | 'BASE_ASSET'
  | 'CREATED_AT_EVENT_ID'
  | 'PRICE'
  | 'PRICE_VALID_FROM_BLOCK'
  | 'PRICE_VALID_TO_BLOCK'
  | 'PRICE_X128'
  | 'QUOTE_ASSET'
  | 'UPDATED_AT_ORACLE_TIMESTAMP'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_WEEK';

export type OraclePriceTrackingHavingAverageInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingDistinctCountInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `OraclePriceTracking` aggregates. */
export type OraclePriceTrackingHavingInput = {
  AND?: InputMaybe<Array<OraclePriceTrackingHavingInput>>;
  OR?: InputMaybe<Array<OraclePriceTrackingHavingInput>>;
  average?: InputMaybe<OraclePriceTrackingHavingAverageInput>;
  distinctCount?: InputMaybe<OraclePriceTrackingHavingDistinctCountInput>;
  max?: InputMaybe<OraclePriceTrackingHavingMaxInput>;
  min?: InputMaybe<OraclePriceTrackingHavingMinInput>;
  stddevPopulation?: InputMaybe<OraclePriceTrackingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OraclePriceTrackingHavingStddevSampleInput>;
  sum?: InputMaybe<OraclePriceTrackingHavingSumInput>;
  variancePopulation?: InputMaybe<OraclePriceTrackingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OraclePriceTrackingHavingVarianceSampleInput>;
};

export type OraclePriceTrackingHavingMaxInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingMinInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingStddevPopulationInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingStddevSampleInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingSumInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingVariancePopulationInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingVarianceSampleInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingMaxAggregateFilter = {
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<IntFilter>;
  priceValidToBlock?: InputMaybe<IntFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
};

export type OraclePriceTrackingMaxAggregates = {
  __typename?: 'OraclePriceTrackingMaxAggregates';
  /** Maximum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Maximum of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type OraclePriceTrackingMinAggregateFilter = {
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<IntFilter>;
  priceValidToBlock?: InputMaybe<IntFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
};

export type OraclePriceTrackingMinAggregates = {
  __typename?: 'OraclePriceTrackingMinAggregates';
  /** Minimum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Minimum of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type OraclePriceTrackingStddevPopulationAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingStddevPopulationAggregates = {
  __typename?: 'OraclePriceTrackingStddevPopulationAggregates';
  /** Population standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceTrackingStddevSampleAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingStddevSampleAggregates = {
  __typename?: 'OraclePriceTrackingStddevSampleAggregates';
  /** Sample standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceTrackingSumAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigIntFilter>;
  priceValidToBlock?: InputMaybe<BigIntFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingSumAggregates = {
  __typename?: 'OraclePriceTrackingSumAggregates';
  /** Sum of createdAtEventId across the matching connection */
  createdAtEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['Float']['output'];
  /** Sum of priceValidFromBlock across the matching connection */
  priceValidFromBlock: Scalars['BigInt']['output'];
  /** Sum of priceValidToBlock across the matching connection */
  priceValidToBlock: Scalars['BigInt']['output'];
  /** Sum of priceX128 across the matching connection */
  priceX128: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `LoanFee` object types. All fields are combined with a logical ‘and.’ */
export type OraclePriceTrackingToManyLoanFeeFilter = {
  /** Aggregates across related `LoanFee` match the filter criteria. */
  aggregates?: InputMaybe<LoanFeeAggregatesFilter>;
  /** Every related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanFeeFilter>;
  /** No related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanFeeFilter>;
  /** Some related `LoanFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanFeeFilter>;
};

/** A filter to be used against many `LoanUpdate` object types. All fields are combined with a logical ‘and.’ */
export type OraclePriceTrackingToManyLoanUpdateFilter = {
  /** Aggregates across related `LoanUpdate` match the filter criteria. */
  aggregates?: InputMaybe<LoanUpdateAggregatesFilter>;
  /** Every related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoanUpdateFilter>;
  /** No related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoanUpdateFilter>;
  /** Some related `LoanUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoanUpdateFilter>;
};

export type OraclePriceTrackingVariancePopulationAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingVariancePopulationAggregates = {
  __typename?: 'OraclePriceTrackingVariancePopulationAggregates';
  /** Population variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population variance of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceTrackingVarianceSampleAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingVarianceSampleAggregates = {
  __typename?: 'OraclePriceTrackingVarianceSampleAggregates';
  /** Sample variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OraclePriceTracking` values. */
export type OraclePriceTrackingsConnection = {
  __typename?: 'OraclePriceTrackingsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OraclePriceTrackingAggregates>;
  /** A list of edges which contains the `OraclePriceTracking` and cursor to aid in pagination. */
  edges: Array<OraclePriceTrackingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OraclePriceTrackingAggregates>>;
  /** A list of `OraclePriceTracking` objects. */
  nodes: Array<OraclePriceTracking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OraclePriceTracking` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OraclePriceTracking` values. */
export type OraclePriceTrackingsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OraclePriceTrackingGroupBy>;
  having?: InputMaybe<OraclePriceTrackingHavingInput>;
};

/** A `OraclePriceTracking` edge in the connection. */
export type OraclePriceTrackingsEdge = {
  __typename?: 'OraclePriceTrackingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OraclePriceTracking` at the end of the edge. */
  node: OraclePriceTracking;
};

/** Methods to use when ordering `OraclePriceTracking`. */
export type OraclePriceTrackingsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'CREATED_AT_EVENT_ID_ASC'
  | 'CREATED_AT_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_AVERAGE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_COUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_COUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MAX_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_MIN_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_SUM_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_BROKER_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_NETWORK_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_POOL_FEE_PORTION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_FEES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_AVERAGE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_COUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_COUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MAX_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_TIMESTAMP_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_MIN_TIMESTAMP_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_STDDEV_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_SUM_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_POPULATION_ORACLE_PRICE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_AMOUNT_VALUE_USD_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_ASC'
  | 'LOAN_UPDATES_BY_ORACLE_PRICE_ID_VARIANCE_SAMPLE_ORACLE_PRICE_ID_DESC'
  | 'NATURAL'
  | 'PRICE_ASC'
  | 'PRICE_DESC'
  | 'PRICE_VALID_FROM_BLOCK_ASC'
  | 'PRICE_VALID_FROM_BLOCK_DESC'
  | 'PRICE_VALID_TO_BLOCK_ASC'
  | 'PRICE_VALID_TO_BLOCK_DESC'
  | 'PRICE_X128_ASC'
  | 'PRICE_X128_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_DESC';

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PendingBoostLiquidityWithdrawal = Node & {
  __typename?: 'PendingBoostLiquidityWithdrawal';
  /** Reads a single `Account` that is related to this `PendingBoostLiquidityWithdrawal`. */
  accountByLiquidityProviderId: Account;
  /** Reads a single `Boost` that is related to this `PendingBoostLiquidityWithdrawal`. */
  boostByBoostId: Boost;
  boostId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `PendingBoostLiquidityWithdrawal`. */
  eventByStoppedBoostingEventId: Event;
  finalized: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  lost: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  stoppedBoostingEventId: Scalars['BigInt']['output'];
};

export type PendingBoostLiquidityWithdrawalAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PendingBoostLiquidityWithdrawalAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PendingBoostLiquidityWithdrawalDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PendingBoostLiquidityWithdrawalMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PendingBoostLiquidityWithdrawalMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PendingBoostLiquidityWithdrawalStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PendingBoostLiquidityWithdrawalStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PendingBoostLiquidityWithdrawalSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PendingBoostLiquidityWithdrawalVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PendingBoostLiquidityWithdrawalVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PendingBoostLiquidityWithdrawal` object types. */
export type PendingBoostLiquidityWithdrawalAggregatesFilter = {
  /** Mean average aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  average?: InputMaybe<PendingBoostLiquidityWithdrawalAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  distinctCount?: InputMaybe<PendingBoostLiquidityWithdrawalDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PendingBoostLiquidityWithdrawal` object to be included within the aggregate. */
  filter?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** Maximum aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  max?: InputMaybe<PendingBoostLiquidityWithdrawalMaxAggregateFilter>;
  /** Minimum aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  min?: InputMaybe<PendingBoostLiquidityWithdrawalMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  stddevPopulation?: InputMaybe<PendingBoostLiquidityWithdrawalStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  stddevSample?: InputMaybe<PendingBoostLiquidityWithdrawalStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  sum?: InputMaybe<PendingBoostLiquidityWithdrawalSumAggregateFilter>;
  /** Population variance aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  variancePopulation?: InputMaybe<PendingBoostLiquidityWithdrawalVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PendingBoostLiquidityWithdrawal` objects. */
  varianceSample?: InputMaybe<PendingBoostLiquidityWithdrawalVarianceSampleAggregateFilter>;
};

export type PendingBoostLiquidityWithdrawalAverageAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stoppedBoostingEventId?: InputMaybe<BigFloatFilter>;
};

export type PendingBoostLiquidityWithdrawalAverageAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalAverageAggregates';
  /** Mean average of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PendingBoostLiquidityWithdrawal` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type PendingBoostLiquidityWithdrawalCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  boostByBoostId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `boostId` field. */
  boostId?: InputMaybe<Scalars['Int']['input']>;
  eventByStoppedBoostingEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `finalized` field. */
  finalized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lost` field. */
  lost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `stoppedBoostingEventId` field. */
  stoppedBoostingEventId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type PendingBoostLiquidityWithdrawalDistinctCountAggregateFilter = {
  boostId?: InputMaybe<BigIntFilter>;
  finalized?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  lost?: InputMaybe<BigIntFilter>;
  stoppedBoostingEventId?: InputMaybe<BigIntFilter>;
};

export type PendingBoostLiquidityWithdrawalDistinctCountAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalDistinctCountAggregates';
  /** Distinct count of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of finalized across the matching connection */
  finalized?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lost across the matching connection */
  lost?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `PendingBoostLiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type PendingBoostLiquidityWithdrawalFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PendingBoostLiquidityWithdrawalFilter>>;
  /** Filter by the object’s `boostByBoostId` relation. */
  boostByBoostId?: InputMaybe<BoostFilter>;
  /** Filter by the object’s `boostId` field. */
  boostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByStoppedBoostingEventId` relation. */
  eventByStoppedBoostingEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `finalized` field. */
  finalized?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lost` field. */
  lost?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PendingBoostLiquidityWithdrawalFilter>>;
  /** Filter by the object’s `stoppedBoostingEventId` field. */
  stoppedBoostingEventId?: InputMaybe<BigIntFilter>;
};

/** Grouping methods for `PendingBoostLiquidityWithdrawal` for usage during aggregation. */
export type PendingBoostLiquidityWithdrawalGroupBy =
  | 'BOOST_ID'
  | 'FINALIZED'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'LOST'
  | 'STOPPED_BOOSTING_EVENT_ID';

export type PendingBoostLiquidityWithdrawalHavingAverageInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingDistinctCountInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `PendingBoostLiquidityWithdrawal` aggregates. */
export type PendingBoostLiquidityWithdrawalHavingInput = {
  AND?: InputMaybe<Array<PendingBoostLiquidityWithdrawalHavingInput>>;
  OR?: InputMaybe<Array<PendingBoostLiquidityWithdrawalHavingInput>>;
  average?: InputMaybe<PendingBoostLiquidityWithdrawalHavingAverageInput>;
  distinctCount?: InputMaybe<PendingBoostLiquidityWithdrawalHavingDistinctCountInput>;
  max?: InputMaybe<PendingBoostLiquidityWithdrawalHavingMaxInput>;
  min?: InputMaybe<PendingBoostLiquidityWithdrawalHavingMinInput>;
  stddevPopulation?: InputMaybe<PendingBoostLiquidityWithdrawalHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PendingBoostLiquidityWithdrawalHavingStddevSampleInput>;
  sum?: InputMaybe<PendingBoostLiquidityWithdrawalHavingSumInput>;
  variancePopulation?: InputMaybe<PendingBoostLiquidityWithdrawalHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PendingBoostLiquidityWithdrawalHavingVarianceSampleInput>;
};

export type PendingBoostLiquidityWithdrawalHavingMaxInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingMinInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingStddevPopulationInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingStddevSampleInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingSumInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingVariancePopulationInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalHavingVarianceSampleInput = {
  boostId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  stoppedBoostingEventId?: InputMaybe<HavingBigintFilter>;
};

export type PendingBoostLiquidityWithdrawalMaxAggregateFilter = {
  boostId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  stoppedBoostingEventId?: InputMaybe<BigIntFilter>;
};

export type PendingBoostLiquidityWithdrawalMaxAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalMaxAggregates';
  /** Maximum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type PendingBoostLiquidityWithdrawalMinAggregateFilter = {
  boostId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  stoppedBoostingEventId?: InputMaybe<BigIntFilter>;
};

export type PendingBoostLiquidityWithdrawalMinAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalMinAggregates';
  /** Minimum of boostId across the matching connection */
  boostId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type PendingBoostLiquidityWithdrawalStddevPopulationAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stoppedBoostingEventId?: InputMaybe<BigFloatFilter>;
};

export type PendingBoostLiquidityWithdrawalStddevPopulationAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalStddevPopulationAggregates';
  /** Population standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PendingBoostLiquidityWithdrawalStddevSampleAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stoppedBoostingEventId?: InputMaybe<BigFloatFilter>;
};

export type PendingBoostLiquidityWithdrawalStddevSampleAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalStddevSampleAggregates';
  /** Sample standard deviation of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PendingBoostLiquidityWithdrawalSumAggregateFilter = {
  boostId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  stoppedBoostingEventId?: InputMaybe<BigFloatFilter>;
};

export type PendingBoostLiquidityWithdrawalSumAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalSumAggregates';
  /** Sum of boostId across the matching connection */
  boostId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId: Scalars['BigFloat']['output'];
};

export type PendingBoostLiquidityWithdrawalVariancePopulationAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stoppedBoostingEventId?: InputMaybe<BigFloatFilter>;
};

export type PendingBoostLiquidityWithdrawalVariancePopulationAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalVariancePopulationAggregates';
  /** Population variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PendingBoostLiquidityWithdrawalVarianceSampleAggregateFilter = {
  boostId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  stoppedBoostingEventId?: InputMaybe<BigFloatFilter>;
};

export type PendingBoostLiquidityWithdrawalVarianceSampleAggregates = {
  __typename?: 'PendingBoostLiquidityWithdrawalVarianceSampleAggregates';
  /** Sample variance of boostId across the matching connection */
  boostId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stoppedBoostingEventId across the matching connection */
  stoppedBoostingEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `PendingBoostLiquidityWithdrawal` values. */
export type PendingBoostLiquidityWithdrawalsConnection = {
  __typename?: 'PendingBoostLiquidityWithdrawalsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PendingBoostLiquidityWithdrawalAggregates>;
  /** A list of edges which contains the `PendingBoostLiquidityWithdrawal` and cursor to aid in pagination. */
  edges: Array<PendingBoostLiquidityWithdrawalsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PendingBoostLiquidityWithdrawalAggregates>>;
  /** A list of `PendingBoostLiquidityWithdrawal` objects. */
  nodes: Array<PendingBoostLiquidityWithdrawal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PendingBoostLiquidityWithdrawal` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PendingBoostLiquidityWithdrawal` values. */
export type PendingBoostLiquidityWithdrawalsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PendingBoostLiquidityWithdrawalGroupBy>;
  having?: InputMaybe<PendingBoostLiquidityWithdrawalHavingInput>;
};

/** A `PendingBoostLiquidityWithdrawal` edge in the connection. */
export type PendingBoostLiquidityWithdrawalsEdge = {
  __typename?: 'PendingBoostLiquidityWithdrawalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PendingBoostLiquidityWithdrawal` at the end of the edge. */
  node: PendingBoostLiquidityWithdrawal;
};

/** Methods to use when ordering `PendingBoostLiquidityWithdrawal`. */
export type PendingBoostLiquidityWithdrawalsOrderBy =
  | 'BOOST_ID_ASC'
  | 'BOOST_ID_DESC'
  | 'FINALIZED_ASC'
  | 'FINALIZED_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LOST_ASC'
  | 'LOST_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STOPPED_BOOSTING_EVENT_ID_ASC'
  | 'STOPPED_BOOSTING_EVENT_ID_DESC';

export type PoolOrder = Node & {
  __typename?: 'PoolOrder';
  /** Reads a single `Account` that is related to this `PoolOrder`. */
  accountByLiquidityProviderId: Account;
  baseAmount: Scalars['BigFloat']['output'];
  baseAsset: ChainflipAsset;
  baseCollectedFees: Scalars['BigFloat']['output'];
  baseCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `PoolOrder`. */
  eventByOrderCreatedEventId: Event;
  /** Reads a single `Event` that is related to this `PoolOrder`. */
  eventByOrderLastUpdatedEventId?: Maybe<Event>;
  filledBaseAmount: Scalars['BigFloat']['output'];
  filledQuoteAmount: Scalars['BigFloat']['output'];
  id: Scalars['BigInt']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  lowerTick: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openPoolOrderId?: Maybe<Scalars['Int']['output']>;
  orderCreatedEventId: Scalars['BigInt']['output'];
  orderCreatedTimestamp: Scalars['Datetime']['output'];
  orderId: Scalars['String']['output'];
  orderLastUpdatedEventId?: Maybe<Scalars['BigInt']['output']>;
  orderLastUpdatedTimestamp?: Maybe<Scalars['Datetime']['output']>;
  orderType: PoolOrderType;
  quoteAmount: Scalars['BigFloat']['output'];
  quoteAsset: ChainflipAsset;
  quoteCollectedFees: Scalars['BigFloat']['output'];
  quoteCollectedFeesUsd: Scalars['BigFloat']['output'];
  status: PoolOrderStatus;
  upperTick: Scalars['BigFloat']['output'];
};

export type PoolOrderAggregates = {
  __typename?: 'PoolOrderAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PoolOrderAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PoolOrderDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PoolOrderMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PoolOrderMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PoolOrderStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PoolOrderStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PoolOrderSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PoolOrderVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PoolOrderVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PoolOrder` object types. */
export type PoolOrderAggregatesFilter = {
  /** Mean average aggregate over matching `PoolOrder` objects. */
  average?: InputMaybe<PoolOrderAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PoolOrder` objects. */
  distinctCount?: InputMaybe<PoolOrderDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PoolOrder` object to be included within the aggregate. */
  filter?: InputMaybe<PoolOrderFilter>;
  /** Maximum aggregate over matching `PoolOrder` objects. */
  max?: InputMaybe<PoolOrderMaxAggregateFilter>;
  /** Minimum aggregate over matching `PoolOrder` objects. */
  min?: InputMaybe<PoolOrderMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PoolOrder` objects. */
  stddevPopulation?: InputMaybe<PoolOrderStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PoolOrder` objects. */
  stddevSample?: InputMaybe<PoolOrderStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PoolOrder` objects. */
  sum?: InputMaybe<PoolOrderSumAggregateFilter>;
  /** Population variance aggregate over matching `PoolOrder` objects. */
  variancePopulation?: InputMaybe<PoolOrderVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PoolOrder` objects. */
  varianceSample?: InputMaybe<PoolOrderVarianceSampleAggregateFilter>;
};

export type PoolOrderAverageAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<BigFloatFilter>;
  orderCreatedEventId?: InputMaybe<BigFloatFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderAverageAggregates = {
  __typename?: 'PoolOrderAverageAggregates';
  /** Mean average of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PoolOrder` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PoolOrderCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `baseAmount` field. */
  baseAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseCollectedFees` field. */
  baseCollectedFees?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseCollectedFeesUsd` field. */
  baseCollectedFeesUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByOrderCreatedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByOrderLastUpdatedEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `filledBaseAmount` field. */
  filledBaseAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `filledQuoteAmount` field. */
  filledQuoteAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lowerTick` field. */
  lowerTick?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `openPoolOrderId` field. */
  openPoolOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderCreatedEventId` field. */
  orderCreatedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `orderCreatedTimestamp` field. */
  orderCreatedTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderLastUpdatedEventId` field. */
  orderLastUpdatedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `orderLastUpdatedTimestamp` field. */
  orderLastUpdatedTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `orderType` field. */
  orderType?: InputMaybe<PoolOrderType>;
  /** Checks for equality with the object’s `quoteAmount` field. */
  quoteAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `quoteCollectedFees` field. */
  quoteCollectedFees?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteCollectedFeesUsd` field. */
  quoteCollectedFeesUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<PoolOrderStatus>;
  /** Checks for equality with the object’s `upperTick` field. */
  upperTick?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type PoolOrderDistinctCountAggregateFilter = {
  baseAmount?: InputMaybe<BigIntFilter>;
  baseAsset?: InputMaybe<BigIntFilter>;
  baseCollectedFees?: InputMaybe<BigIntFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigIntFilter>;
  filledBaseAmount?: InputMaybe<BigIntFilter>;
  filledQuoteAmount?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  lowerTick?: InputMaybe<BigIntFilter>;
  openPoolOrderId?: InputMaybe<BigIntFilter>;
  orderCreatedEventId?: InputMaybe<BigIntFilter>;
  orderCreatedTimestamp?: InputMaybe<BigIntFilter>;
  orderId?: InputMaybe<BigIntFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigIntFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<BigIntFilter>;
  orderType?: InputMaybe<BigIntFilter>;
  quoteAmount?: InputMaybe<BigIntFilter>;
  quoteAsset?: InputMaybe<BigIntFilter>;
  quoteCollectedFees?: InputMaybe<BigIntFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  upperTick?: InputMaybe<BigIntFilter>;
};

export type PoolOrderDistinctCountAggregates = {
  __typename?: 'PoolOrderDistinctCountAggregates';
  /** Distinct count of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderCreatedTimestamp across the matching connection */
  orderCreatedTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderId across the matching connection */
  orderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderLastUpdatedTimestamp across the matching connection */
  orderLastUpdatedTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderType across the matching connection */
  orderType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `PoolOrder` object types. All fields are combined with a logical ‘and.’ */
export type PoolOrderFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PoolOrderFilter>>;
  /** Filter by the object’s `baseAmount` field. */
  baseAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseCollectedFees` field. */
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseCollectedFeesUsd` field. */
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `eventByOrderCreatedEventId` relation. */
  eventByOrderCreatedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventByOrderLastUpdatedEventId` relation. */
  eventByOrderLastUpdatedEventId?: InputMaybe<EventFilter>;
  /** A related `eventByOrderLastUpdatedEventId` exists. */
  eventByOrderLastUpdatedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `filledBaseAmount` field. */
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `filledQuoteAmount` field. */
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lowerTick` field. */
  lowerTick?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PoolOrderFilter>;
  /** Filter by the object’s `openPoolOrderId` field. */
  openPoolOrderId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PoolOrderFilter>>;
  /** Filter by the object’s `orderCreatedEventId` field. */
  orderCreatedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `orderCreatedTimestamp` field. */
  orderCreatedTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orderLastUpdatedEventId` field. */
  orderLastUpdatedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `orderLastUpdatedTimestamp` field. */
  orderLastUpdatedTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `orderType` field. */
  orderType?: InputMaybe<PoolOrderTypeFilter>;
  /** Filter by the object’s `quoteAmount` field. */
  quoteAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `quoteCollectedFees` field. */
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteCollectedFeesUsd` field. */
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<PoolOrderStatusFilter>;
  /** Filter by the object’s `upperTick` field. */
  upperTick?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `PoolOrder` for usage during aggregation. */
export type PoolOrderGroupBy =
  | 'BASE_AMOUNT'
  | 'BASE_ASSET'
  | 'BASE_COLLECTED_FEES'
  | 'BASE_COLLECTED_FEES_USD'
  | 'FILLED_BASE_AMOUNT'
  | 'FILLED_QUOTE_AMOUNT'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'LOWER_TICK'
  | 'OPEN_POOL_ORDER_ID'
  | 'ORDER_CREATED_TIMESTAMP'
  | 'ORDER_CREATED_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'ORDER_CREATED_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'ORDER_CREATED_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'ORDER_CREATED_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'ORDER_ID'
  | 'ORDER_LAST_UPDATED_EVENT_ID'
  | 'ORDER_LAST_UPDATED_TIMESTAMP'
  | 'ORDER_LAST_UPDATED_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'ORDER_LAST_UPDATED_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'ORDER_LAST_UPDATED_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'ORDER_LAST_UPDATED_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'ORDER_TYPE'
  | 'QUOTE_AMOUNT'
  | 'QUOTE_ASSET'
  | 'QUOTE_COLLECTED_FEES'
  | 'QUOTE_COLLECTED_FEES_USD'
  | 'STATUS'
  | 'UPPER_TICK';

export type PoolOrderHavingAverageInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingDistinctCountInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `PoolOrder` aggregates. */
export type PoolOrderHavingInput = {
  AND?: InputMaybe<Array<PoolOrderHavingInput>>;
  OR?: InputMaybe<Array<PoolOrderHavingInput>>;
  average?: InputMaybe<PoolOrderHavingAverageInput>;
  distinctCount?: InputMaybe<PoolOrderHavingDistinctCountInput>;
  max?: InputMaybe<PoolOrderHavingMaxInput>;
  min?: InputMaybe<PoolOrderHavingMinInput>;
  stddevPopulation?: InputMaybe<PoolOrderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PoolOrderHavingStddevSampleInput>;
  sum?: InputMaybe<PoolOrderHavingSumInput>;
  variancePopulation?: InputMaybe<PoolOrderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PoolOrderHavingVarianceSampleInput>;
};

export type PoolOrderHavingMaxInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingMinInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingStddevPopulationInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingStddevSampleInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingSumInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingVariancePopulationInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderHavingVarianceSampleInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  filledBaseAmount?: InputMaybe<HavingBigfloatFilter>;
  filledQuoteAmount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  lowerTick?: InputMaybe<HavingBigfloatFilter>;
  openPoolOrderId?: InputMaybe<HavingIntFilter>;
  orderCreatedEventId?: InputMaybe<HavingBigintFilter>;
  orderCreatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<HavingBigintFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<HavingDatetimeFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  upperTick?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolOrderMaxAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<IntFilter>;
  orderCreatedEventId?: InputMaybe<BigIntFilter>;
  orderCreatedTimestamp?: InputMaybe<DatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigIntFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<DatetimeFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderMaxAggregates = {
  __typename?: 'PoolOrderMaxAggregates';
  /** Maximum of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of orderCreatedTimestamp across the matching connection */
  orderCreatedTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of orderLastUpdatedTimestamp across the matching connection */
  orderLastUpdatedTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderMinAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<IntFilter>;
  orderCreatedEventId?: InputMaybe<BigIntFilter>;
  orderCreatedTimestamp?: InputMaybe<DatetimeFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigIntFilter>;
  orderLastUpdatedTimestamp?: InputMaybe<DatetimeFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderMinAggregates = {
  __typename?: 'PoolOrderMinAggregates';
  /** Minimum of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of orderCreatedTimestamp across the matching connection */
  orderCreatedTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of orderLastUpdatedTimestamp across the matching connection */
  orderLastUpdatedTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderStatus =
  | 'CLOSED'
  | 'OPEN';

/** A filter to be used against PoolOrderStatus fields. All fields are combined with a logical ‘and.’ */
export type PoolOrderStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PoolOrderStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PoolOrderStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PoolOrderStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PoolOrderStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PoolOrderStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PoolOrderStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PoolOrderStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PoolOrderStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PoolOrderStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PoolOrderStatus>>;
};

export type PoolOrderStddevPopulationAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<BigFloatFilter>;
  orderCreatedEventId?: InputMaybe<BigFloatFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderStddevPopulationAggregates = {
  __typename?: 'PoolOrderStddevPopulationAggregates';
  /** Population standard deviation of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderStddevSampleAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<BigFloatFilter>;
  orderCreatedEventId?: InputMaybe<BigFloatFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderStddevSampleAggregates = {
  __typename?: 'PoolOrderStddevSampleAggregates';
  /** Sample standard deviation of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderSumAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<BigIntFilter>;
  orderCreatedEventId?: InputMaybe<BigFloatFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderSumAggregates = {
  __typename?: 'PoolOrderSumAggregates';
  /** Sum of baseAmount across the matching connection */
  baseAmount: Scalars['BigFloat']['output'];
  /** Sum of baseCollectedFees across the matching connection */
  baseCollectedFees: Scalars['BigFloat']['output'];
  /** Sum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Sum of filledBaseAmount across the matching connection */
  filledBaseAmount: Scalars['BigFloat']['output'];
  /** Sum of filledQuoteAmount across the matching connection */
  filledQuoteAmount: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of lowerTick across the matching connection */
  lowerTick: Scalars['BigFloat']['output'];
  /** Sum of openPoolOrderId across the matching connection */
  openPoolOrderId: Scalars['BigInt']['output'];
  /** Sum of orderCreatedEventId across the matching connection */
  orderCreatedEventId: Scalars['BigFloat']['output'];
  /** Sum of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId: Scalars['BigFloat']['output'];
  /** Sum of quoteAmount across the matching connection */
  quoteAmount: Scalars['BigFloat']['output'];
  /** Sum of quoteCollectedFees across the matching connection */
  quoteCollectedFees: Scalars['BigFloat']['output'];
  /** Sum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Sum of upperTick across the matching connection */
  upperTick: Scalars['BigFloat']['output'];
};

export type PoolOrderType =
  | 'LIMIT'
  | 'RANGE';

/** A filter to be used against PoolOrderType fields. All fields are combined with a logical ‘and.’ */
export type PoolOrderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PoolOrderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PoolOrderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PoolOrderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PoolOrderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PoolOrderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PoolOrderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PoolOrderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PoolOrderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PoolOrderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PoolOrderType>>;
};

export type PoolOrderVariancePopulationAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<BigFloatFilter>;
  orderCreatedEventId?: InputMaybe<BigFloatFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderVariancePopulationAggregates = {
  __typename?: 'PoolOrderVariancePopulationAggregates';
  /** Population variance of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderVarianceSampleAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  filledBaseAmount?: InputMaybe<BigFloatFilter>;
  filledQuoteAmount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  lowerTick?: InputMaybe<BigFloatFilter>;
  openPoolOrderId?: InputMaybe<BigFloatFilter>;
  orderCreatedEventId?: InputMaybe<BigFloatFilter>;
  orderLastUpdatedEventId?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  upperTick?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderVarianceSampleAggregates = {
  __typename?: 'PoolOrderVarianceSampleAggregates';
  /** Sample variance of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of filledBaseAmount across the matching connection */
  filledBaseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of filledQuoteAmount across the matching connection */
  filledQuoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lowerTick across the matching connection */
  lowerTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of openPoolOrderId across the matching connection */
  openPoolOrderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of orderCreatedEventId across the matching connection */
  orderCreatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of orderLastUpdatedEventId across the matching connection */
  orderLastUpdatedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of upperTick across the matching connection */
  upperTick?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `PoolOrder` values. */
export type PoolOrdersConnection = {
  __typename?: 'PoolOrdersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PoolOrderAggregates>;
  /** A list of edges which contains the `PoolOrder` and cursor to aid in pagination. */
  edges: Array<PoolOrdersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PoolOrderAggregates>>;
  /** A list of `PoolOrder` objects. */
  nodes: Array<PoolOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PoolOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PoolOrder` values. */
export type PoolOrdersConnectionGroupedAggregatesArgs = {
  groupBy: Array<PoolOrderGroupBy>;
  having?: InputMaybe<PoolOrderHavingInput>;
};

/** A `PoolOrder` edge in the connection. */
export type PoolOrdersEdge = {
  __typename?: 'PoolOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PoolOrder` at the end of the edge. */
  node: PoolOrder;
};

/** Methods to use when ordering `PoolOrder`. */
export type PoolOrdersOrderBy =
  | 'BASE_AMOUNT_ASC'
  | 'BASE_AMOUNT_DESC'
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BASE_COLLECTED_FEES_ASC'
  | 'BASE_COLLECTED_FEES_DESC'
  | 'BASE_COLLECTED_FEES_USD_ASC'
  | 'BASE_COLLECTED_FEES_USD_DESC'
  | 'FILLED_BASE_AMOUNT_ASC'
  | 'FILLED_BASE_AMOUNT_DESC'
  | 'FILLED_QUOTE_AMOUNT_ASC'
  | 'FILLED_QUOTE_AMOUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LOWER_TICK_ASC'
  | 'LOWER_TICK_DESC'
  | 'NATURAL'
  | 'OPEN_POOL_ORDER_ID_ASC'
  | 'OPEN_POOL_ORDER_ID_DESC'
  | 'ORDER_CREATED_EVENT_ID_ASC'
  | 'ORDER_CREATED_EVENT_ID_DESC'
  | 'ORDER_CREATED_TIMESTAMP_ASC'
  | 'ORDER_CREATED_TIMESTAMP_DESC'
  | 'ORDER_ID_ASC'
  | 'ORDER_ID_DESC'
  | 'ORDER_LAST_UPDATED_EVENT_ID_ASC'
  | 'ORDER_LAST_UPDATED_EVENT_ID_DESC'
  | 'ORDER_LAST_UPDATED_TIMESTAMP_ASC'
  | 'ORDER_LAST_UPDATED_TIMESTAMP_DESC'
  | 'ORDER_TYPE_ASC'
  | 'ORDER_TYPE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_AMOUNT_ASC'
  | 'QUOTE_AMOUNT_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'QUOTE_COLLECTED_FEES_ASC'
  | 'QUOTE_COLLECTED_FEES_DESC'
  | 'QUOTE_COLLECTED_FEES_USD_ASC'
  | 'QUOTE_COLLECTED_FEES_USD_DESC'
  | 'STATUS_ASC'
  | 'STATUS_DESC'
  | 'UPPER_TICK_ASC'
  | 'UPPER_TICK_DESC';

export type PriceAsset =
  | 'Btc'
  | 'Eth'
  | 'Fine'
  | 'Sol'
  | 'Usd'
  | 'Usdc'
  | 'Usdt';

/** A filter to be used against PriceAsset fields. All fields are combined with a logical ‘and.’ */
export type PriceAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PriceAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PriceAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PriceAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PriceAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PriceAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PriceAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PriceAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PriceAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PriceAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PriceAsset>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `_PrismaMigration` using its globally unique `ID`. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** Get a single `_PrismaMigration`. */
  _prismaMigrationById?: Maybe<_PrismaMigration>;
  /** Reads a single `Account` using its globally unique `ID`. */
  account?: Maybe<Account>;
  /** Get a single `Account`. */
  accountById?: Maybe<Account>;
  /** Get a single `Account`. */
  accountByIdSs58?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Account`. */
  allAccounts?: Maybe<AccountsConnection>;
  /** Reads and enables pagination through a set of `BoostLiquidityBalanceChange`. */
  allBoostLiquidityBalanceChanges?: Maybe<BoostLiquidityBalanceChangesConnection>;
  /** Reads and enables pagination through a set of `BoostPoolApy`. */
  allBoostPoolApies?: Maybe<BoostPoolApiesConnection>;
  /** Reads and enables pagination through a set of `BoostPoolBoostShare`. */
  allBoostPoolBoostShares?: Maybe<BoostPoolBoostSharesConnection>;
  /** Reads and enables pagination through a set of `BoostPoolLiquidity`. */
  allBoostPoolLiquidities?: Maybe<BoostPoolLiquiditiesConnection>;
  /** Reads and enables pagination through a set of `BoostPool`. */
  allBoostPools?: Maybe<BoostPoolsConnection>;
  /** Reads and enables pagination through a set of `BoostShare`. */
  allBoostShares?: Maybe<BoostSharesConnection>;
  /** Reads and enables pagination through a set of `Boost`. */
  allBoosts?: Maybe<BoostsConnection>;
  /** Reads and enables pagination through a set of `DepositChannel`. */
  allDepositChannels?: Maybe<DepositChannelsConnection>;
  /** Reads and enables pagination through a set of `Event`. */
  allEvents?: Maybe<EventsConnection>;
  /** Reads and enables pagination through a set of `IncentiveSeason`. */
  allIncentiveSeasons?: Maybe<IncentiveSeasonsConnection>;
  /** Reads and enables pagination through a set of `LastBlock`. */
  allLastBlocks?: Maybe<LastBlocksConnection>;
  /** Reads and enables pagination through a set of `LendingLiquidityBalanceChange`. */
  allLendingLiquidityBalanceChanges?: Maybe<LendingLiquidityBalanceChangesConnection>;
  /** Reads and enables pagination through a set of `LendingPoolIncentiveProgram`. */
  allLendingPoolIncentivePrograms?: Maybe<LendingPoolIncentiveProgramsConnection>;
  /** Reads and enables pagination through a set of `LendingPoolSnapshot`. */
  allLendingPoolSnapshots?: Maybe<LendingPoolSnapshotsConnection>;
  /** Reads and enables pagination through a set of `LendingPoolStat`. */
  allLendingPoolStats?: Maybe<LendingPoolStatsConnection>;
  /** Reads and enables pagination through a set of `LendingPool`. */
  allLendingPools?: Maybe<LendingPoolsConnection>;
  /** Reads and enables pagination through a set of `LimitOrderFill`. */
  allLimitOrderFills?: Maybe<LimitOrderFillsConnection>;
  /** Reads and enables pagination through a set of `LiquidationSwapRequest`. */
  allLiquidationSwapRequests?: Maybe<LiquidationSwapRequestsConnection>;
  /** Reads and enables pagination through a set of `LiquidityProviderBoostPoolSummary`. */
  allLiquidityProviderBoostPoolSummaries?: Maybe<LiquidityProviderBoostPoolSummariesConnection>;
  /** Reads and enables pagination through a set of `LiquiditySnapshot`. */
  allLiquiditySnapshots?: Maybe<LiquiditySnapshotsConnection>;
  /** Reads and enables pagination through a set of `LoanFee`. */
  allLoanFees?: Maybe<LoanFeesConnection>;
  /** Reads and enables pagination through a set of `LoanUpdate`. */
  allLoanUpdates?: Maybe<LoanUpdatesConnection>;
  /** Reads and enables pagination through a set of `Loan`. */
  allLoans?: Maybe<LoansConnection>;
  /** Reads and enables pagination through a set of `LpCollateralBalanceChange`. */
  allLpCollateralBalanceChanges?: Maybe<LpCollateralBalanceChangesConnection>;
  /** Reads and enables pagination through a set of `LpFlipAirdropDistributionEvent`. */
  allLpFlipAirdropDistributionEvents?: Maybe<LpFlipAirdropDistributionEventsConnection>;
  /** Reads and enables pagination through a set of `LpLendingPoolSnapshot`. */
  allLpLendingPoolSnapshots?: Maybe<LpLendingPoolSnapshotsConnection>;
  /** Reads and enables pagination through a set of `LpPointDistributionEvent`. */
  allLpPointDistributionEvents?: Maybe<LpPointDistributionEventsConnection>;
  /** Reads and enables pagination through a set of `OraclePriceTracking`. */
  allOraclePriceTrackings?: Maybe<OraclePriceTrackingsConnection>;
  /** Reads and enables pagination through a set of `PendingBoostLiquidityWithdrawal`. */
  allPendingBoostLiquidityWithdrawals?: Maybe<PendingBoostLiquidityWithdrawalsConnection>;
  /** Reads and enables pagination through a set of `PoolOrder`. */
  allPoolOrders?: Maybe<PoolOrdersConnection>;
  /** Reads and enables pagination through a set of `_PrismaMigration`. */
  allPrismaMigrations?: Maybe<_PrismaMigrationsConnection>;
  /** Reads and enables pagination through a set of `RangeOrderFill`. */
  allRangeOrderFills?: Maybe<RangeOrderFillsConnection>;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  allTradingStrategies?: Maybe<TradingStrategiesConnection>;
  /** Reads and enables pagination through a set of `TradingStrategyBalanceChangeEvent`. */
  allTradingStrategyBalanceChangeEvents?: Maybe<TradingStrategyBalanceChangeEventsConnection>;
  /** Reads a single `Boost` using its globally unique `ID`. */
  boost?: Maybe<Boost>;
  /** Get a single `Boost`. */
  boostById?: Maybe<Boost>;
  /** Get a single `Boost`. */
  boostByPrewitnessedDepositIdAndChain?: Maybe<Boost>;
  /** Reads a single `BoostLiquidityBalanceChange` using its globally unique `ID`. */
  boostLiquidityBalanceChange?: Maybe<BoostLiquidityBalanceChange>;
  /** Get a single `BoostLiquidityBalanceChange`. */
  boostLiquidityBalanceChangeById?: Maybe<BoostLiquidityBalanceChange>;
  /** Reads a single `BoostPool` using its globally unique `ID`. */
  boostPool?: Maybe<BoostPool>;
  /** Reads a single `BoostPoolApy` using its globally unique `ID`. */
  boostPoolApy?: Maybe<BoostPoolApy>;
  /** Get a single `BoostPoolApy`. */
  boostPoolApyByBoostPoolIdAndBlock?: Maybe<BoostPoolApy>;
  /** Get a single `BoostPoolApy`. */
  boostPoolApyById?: Maybe<BoostPoolApy>;
  /** Reads a single `BoostPoolBoostShare` using its globally unique `ID`. */
  boostPoolBoostShare?: Maybe<BoostPoolBoostShare>;
  /** Get a single `BoostPoolBoostShare`. */
  boostPoolBoostShareByBoostIdAndBoostPoolId?: Maybe<BoostPoolBoostShare>;
  /** Get a single `BoostPoolBoostShare`. */
  boostPoolBoostShareById?: Maybe<BoostPoolBoostShare>;
  /** Get a single `BoostPool`. */
  boostPoolByAssetAndFeeTierPips?: Maybe<BoostPool>;
  /** Get a single `BoostPool`. */
  boostPoolById?: Maybe<BoostPool>;
  /** Reads a single `BoostPoolLiquidity` using its globally unique `ID`. */
  boostPoolLiquidity?: Maybe<BoostPoolLiquidity>;
  /** Get a single `BoostPoolLiquidity`. */
  boostPoolLiquidityByBoostPoolIdAndBlock?: Maybe<BoostPoolLiquidity>;
  /** Get a single `BoostPoolLiquidity`. */
  boostPoolLiquidityById?: Maybe<BoostPoolLiquidity>;
  /** Reads a single `BoostShare` using its globally unique `ID`. */
  boostShare?: Maybe<BoostShare>;
  /** Get a single `BoostShare`. */
  boostShareById?: Maybe<BoostShare>;
  /** Get a single `BoostShare`. */
  boostShareByLiquidityProviderIdAndBoostIdAndBoostPoolId?: Maybe<BoostShare>;
  /** Reads a single `DepositChannel` using its globally unique `ID`. */
  depositChannel?: Maybe<DepositChannel>;
  /** Get a single `DepositChannel`. */
  depositChannelById?: Maybe<DepositChannel>;
  /** Get a single `DepositChannel`. */
  depositChannelByIssuedBlockIdAndChainAndChannelId?: Maybe<DepositChannel>;
  /** Reads a single `Event` using its globally unique `ID`. */
  event?: Maybe<Event>;
  /** Get a single `Event`. */
  eventByBlockAndIndexInBlock?: Maybe<Event>;
  /** Get a single `Event`. */
  eventById?: Maybe<Event>;
  /** Reads a single `IncentiveSeason` using its globally unique `ID`. */
  incentiveSeason?: Maybe<IncentiveSeason>;
  /** Get a single `IncentiveSeason`. */
  incentiveSeasonById?: Maybe<IncentiveSeason>;
  /** Get a single `IncentiveSeason`. */
  incentiveSeasonBySeasonIndex?: Maybe<IncentiveSeason>;
  /** Reads a single `LastBlock` using its globally unique `ID`. */
  lastBlock?: Maybe<LastBlock>;
  /** Get a single `LastBlock`. */
  lastBlockById?: Maybe<LastBlock>;
  /** Reads a single `LendingLiquidityBalanceChange` using its globally unique `ID`. */
  lendingLiquidityBalanceChange?: Maybe<LendingLiquidityBalanceChange>;
  /** Get a single `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangeById?: Maybe<LendingLiquidityBalanceChange>;
  /** Get a single `LendingLiquidityBalanceChange`. */
  lendingLiquidityBalanceChangeByPoolIdAndEventId?: Maybe<LendingLiquidityBalanceChange>;
  /** Reads a single `LendingPool` using its globally unique `ID`. */
  lendingPool?: Maybe<LendingPool>;
  /** Get a single `LendingPool`. */
  lendingPoolByAsset?: Maybe<LendingPool>;
  /** Get a single `LendingPool`. */
  lendingPoolById?: Maybe<LendingPool>;
  /** Reads a single `LendingPoolIncentiveProgram` using its globally unique `ID`. */
  lendingPoolIncentiveProgram?: Maybe<LendingPoolIncentiveProgram>;
  /** Get a single `LendingPoolIncentiveProgram`. */
  lendingPoolIncentiveProgramById?: Maybe<LendingPoolIncentiveProgram>;
  /** Get a single `LendingPoolIncentiveProgram`. */
  lendingPoolIncentiveProgramByLendingPoolIdAndIncentiveSeasonIdAndType?: Maybe<LendingPoolIncentiveProgram>;
  /** Reads a single `LendingPoolSnapshot` using its globally unique `ID`. */
  lendingPoolSnapshot?: Maybe<LendingPoolSnapshot>;
  /** Get a single `LendingPoolSnapshot`. */
  lendingPoolSnapshotById?: Maybe<LendingPoolSnapshot>;
  /** Get a single `LendingPoolSnapshot`. */
  lendingPoolSnapshotByPoolIdAndBlock?: Maybe<LendingPoolSnapshot>;
  /** Reads a single `LendingPoolStat` using its globally unique `ID`. */
  lendingPoolStat?: Maybe<LendingPoolStat>;
  /** Get a single `LendingPoolStat`. */
  lendingPoolStatById?: Maybe<LendingPoolStat>;
  /** Get a single `LendingPoolStat`. */
  lendingPoolStatByPoolIdAndBlock?: Maybe<LendingPoolStat>;
  /** Reads a single `LimitOrderFill` using its globally unique `ID`. */
  limitOrderFill?: Maybe<LimitOrderFill>;
  /** Get a single `LimitOrderFill`. */
  limitOrderFillByBlockAndLiquidityProviderIdAndOrderIdAndBaseAssetAndType?: Maybe<LimitOrderFill>;
  /** Get a single `LimitOrderFill`. */
  limitOrderFillById?: Maybe<LimitOrderFill>;
  /** Reads a single `LiquidationSwapRequest` using its globally unique `ID`. */
  liquidationSwapRequest?: Maybe<LiquidationSwapRequest>;
  /** Get a single `LiquidationSwapRequest`. */
  liquidationSwapRequestById?: Maybe<LiquidationSwapRequest>;
  /** Get a single `LiquidationSwapRequest`. */
  liquidationSwapRequestByLoanIdAndSwapRequestId?: Maybe<LiquidationSwapRequest>;
  /** Get a single `LiquidityProviderBoostPoolSummary`. */
  liquidityProviderBoostPoolSummaryByLiquidityProviderIdAndBoostPoolId?: Maybe<LiquidityProviderBoostPoolSummary>;
  /** Reads a single `LiquiditySnapshot` using its globally unique `ID`. */
  liquiditySnapshot?: Maybe<LiquiditySnapshot>;
  /** Get a single `LiquiditySnapshot`. */
  liquiditySnapshotById?: Maybe<LiquiditySnapshot>;
  /** Get a single `LiquiditySnapshot`. */
  liquiditySnapshotByLiquidityProviderIdAndBlock?: Maybe<LiquiditySnapshot>;
  /** Reads a single `Loan` using its globally unique `ID`. */
  loan?: Maybe<Loan>;
  /** Get a single `Loan`. */
  loanById?: Maybe<Loan>;
  /** Get a single `Loan`. */
  loanByPrewitnessedDepositIdAndAsset?: Maybe<Loan>;
  /** Reads a single `LoanFee` using its globally unique `ID`. */
  loanFee?: Maybe<LoanFee>;
  /** Get a single `LoanFee`. */
  loanFeeById?: Maybe<LoanFee>;
  /** Get a single `LoanFee`. */
  loanFeeByLoanIdAndAssetAndEventIdAndType?: Maybe<LoanFee>;
  /** Reads a single `LoanUpdate` using its globally unique `ID`. */
  loanUpdate?: Maybe<LoanUpdate>;
  /** Get a single `LoanUpdate`. */
  loanUpdateById?: Maybe<LoanUpdate>;
  /** Get a single `LoanUpdate`. */
  loanUpdateByLoanIdAndTypeAndEventId?: Maybe<LoanUpdate>;
  /** Reads a single `LpCollateralBalanceChange` using its globally unique `ID`. */
  lpCollateralBalanceChange?: Maybe<LpCollateralBalanceChange>;
  /** Get a single `LpCollateralBalanceChange`. */
  lpCollateralBalanceChangeById?: Maybe<LpCollateralBalanceChange>;
  /** Get a single `LpCollateralBalanceChange`. */
  lpCollateralBalanceChangeByLiquidityProviderIdAndAssetAndEventId?: Maybe<LpCollateralBalanceChange>;
  /** Reads a single `LpFlipAirdropDistributionEvent` using its globally unique `ID`. */
  lpFlipAirdropDistributionEvent?: Maybe<LpFlipAirdropDistributionEvent>;
  /** Get a single `LpFlipAirdropDistributionEvent`. */
  lpFlipAirdropDistributionEventById?: Maybe<LpFlipAirdropDistributionEvent>;
  /** Get a single `LpFlipAirdropDistributionEvent`. */
  lpFlipAirdropDistributionEventByLiquidityProviderIdAndLendingPoolIncentiveProgramId?: Maybe<LpFlipAirdropDistributionEvent>;
  /** Reads a single `LpLendingPoolSnapshot` using its globally unique `ID`. */
  lpLendingPoolSnapshot?: Maybe<LpLendingPoolSnapshot>;
  /** Get a single `LpLendingPoolSnapshot`. */
  lpLendingPoolSnapshotById?: Maybe<LpLendingPoolSnapshot>;
  /** Get a single `LpLendingPoolSnapshot`. */
  lpLendingPoolSnapshotByLiquidityProviderIdAndLendingPoolIdAndBlockHeightAndTypeAndTimestampHour?: Maybe<LpLendingPoolSnapshot>;
  /** Reads a single `LpPointDistributionEvent` using its globally unique `ID`. */
  lpPointDistributionEvent?: Maybe<LpPointDistributionEvent>;
  /** Get a single `LpPointDistributionEvent`. */
  lpPointDistributionEventById?: Maybe<LpPointDistributionEvent>;
  /** Get a single `LpPointDistributionEvent`. */
  lpPointDistributionEventByLiquidityProviderIdAndLendingPoolIncentiveProgramIdAndBlockHeight?: Maybe<LpPointDistributionEvent>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OraclePriceTracking` using its globally unique `ID`. */
  oraclePriceTracking?: Maybe<OraclePriceTracking>;
  /** Get a single `OraclePriceTracking`. */
  oraclePriceTrackingByBaseAssetAndQuoteAssetAndCreatedAtEventId?: Maybe<OraclePriceTracking>;
  /** Get a single `OraclePriceTracking`. */
  oraclePriceTrackingById?: Maybe<OraclePriceTracking>;
  /** Reads a single `PendingBoostLiquidityWithdrawal` using its globally unique `ID`. */
  pendingBoostLiquidityWithdrawal?: Maybe<PendingBoostLiquidityWithdrawal>;
  /** Get a single `PendingBoostLiquidityWithdrawal`. */
  pendingBoostLiquidityWithdrawalById?: Maybe<PendingBoostLiquidityWithdrawal>;
  /** Reads a single `PoolOrder` using its globally unique `ID`. */
  poolOrder?: Maybe<PoolOrder>;
  /** Get a single `PoolOrder`. */
  poolOrderById?: Maybe<PoolOrder>;
  /** Get a single `PoolOrder`. */
  poolOrderByOrderCreatedEventId?: Maybe<PoolOrder>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `RangeOrderFill` using its globally unique `ID`. */
  rangeOrderFill?: Maybe<RangeOrderFill>;
  /** Get a single `RangeOrderFill`. */
  rangeOrderFillByBlockAndLiquidityProviderIdAndOrderIdAndBaseAsset?: Maybe<RangeOrderFill>;
  /** Get a single `RangeOrderFill`. */
  rangeOrderFillById?: Maybe<RangeOrderFill>;
  /** Reads a single `TradingStrategy` using its globally unique `ID`. */
  tradingStrategy?: Maybe<TradingStrategy>;
  /** Reads a single `TradingStrategyBalanceChangeEvent` using its globally unique `ID`. */
  tradingStrategyBalanceChangeEvent?: Maybe<TradingStrategyBalanceChangeEvent>;
  /** Get a single `TradingStrategyBalanceChangeEvent`. */
  tradingStrategyBalanceChangeEventById?: Maybe<TradingStrategyBalanceChangeEvent>;
  /** Get a single `TradingStrategyBalanceChangeEvent`. */
  tradingStrategyBalanceChangeEventByTradingStrategyIdAndEventIdAndAsset?: Maybe<TradingStrategyBalanceChangeEvent>;
  /** Get a single `TradingStrategy`. */
  tradingStrategyById?: Maybe<TradingStrategy>;
  /** Get a single `TradingStrategy`. */
  tradingStrategyByStrategyAccountId?: Maybe<TradingStrategy>;
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostLiquidityBalanceChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<BoostLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostLiquidityBalanceChangesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostPoolApiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolApyCondition>;
  filter?: InputMaybe<BoostPoolApyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolApiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostPoolBoostSharesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolBoostShareCondition>;
  filter?: InputMaybe<BoostPoolBoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolBoostSharesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostPoolLiquiditiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolLiquidityCondition>;
  filter?: InputMaybe<BoostPoolLiquidityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolLiquiditiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolCondition>;
  filter?: InputMaybe<BoostPoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostSharesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostShareCondition>;
  filter?: InputMaybe<BoostShareFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSharesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostCondition>;
  filter?: InputMaybe<BoostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDepositChannelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositChannelCondition>;
  filter?: InputMaybe<DepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositChannelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIncentiveSeasonsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncentiveSeasonCondition>;
  filter?: InputMaybe<IncentiveSeasonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncentiveSeasonsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLastBlocksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LastBlockCondition>;
  filter?: InputMaybe<LastBlockFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LastBlocksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingLiquidityBalanceChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingLiquidityBalanceChangeCondition>;
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingPoolIncentiveProgramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolIncentiveProgramCondition>;
  filter?: InputMaybe<LendingPoolIncentiveProgramFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolIncentiveProgramsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingPoolSnapshotsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolSnapshotCondition>;
  filter?: InputMaybe<LendingPoolSnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolSnapshotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingPoolStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolStatCondition>;
  filter?: InputMaybe<LendingPoolStatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolStatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingPoolCondition>;
  filter?: InputMaybe<LendingPoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingPoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLimitOrderFillsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LimitOrderFillCondition>;
  filter?: InputMaybe<LimitOrderFillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LimitOrderFillsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidationSwapRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapRequestCondition>;
  filter?: InputMaybe<LiquidationSwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityProviderBoostPoolSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityProviderBoostPoolSummaryCondition>;
  filter?: InputMaybe<LiquidityProviderBoostPoolSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityProviderBoostPoolSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquiditySnapshotsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquiditySnapshotCondition>;
  filter?: InputMaybe<LiquiditySnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquiditySnapshotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLoanFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanFeeCondition>;
  filter?: InputMaybe<LoanFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanFeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLoanUpdatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanUpdateCondition>;
  filter?: InputMaybe<LoanUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoanUpdatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLoansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LoanCondition>;
  filter?: InputMaybe<LoanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpCollateralBalanceChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpCollateralBalanceChangeCondition>;
  filter?: InputMaybe<LpCollateralBalanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpCollateralBalanceChangesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpFlipAirdropDistributionEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpFlipAirdropDistributionEventCondition>;
  filter?: InputMaybe<LpFlipAirdropDistributionEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpFlipAirdropDistributionEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpLendingPoolSnapshotsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpLendingPoolSnapshotCondition>;
  filter?: InputMaybe<LpLendingPoolSnapshotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpLendingPoolSnapshotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpPointDistributionEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpPointDistributionEventCondition>;
  filter?: InputMaybe<LpPointDistributionEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpPointDistributionEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOraclePriceTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OraclePriceTrackingCondition>;
  filter?: InputMaybe<OraclePriceTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OraclePriceTrackingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPendingBoostLiquidityWithdrawalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PendingBoostLiquidityWithdrawalCondition>;
  filter?: InputMaybe<PendingBoostLiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PendingBoostLiquidityWithdrawalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPoolOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderCondition>;
  filter?: InputMaybe<PoolOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrismaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<_PrismaMigrationCondition>;
  filter?: InputMaybe<_PrismaMigrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRangeOrderFillsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RangeOrderFillCondition>;
  filter?: InputMaybe<RangeOrderFillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RangeOrderFillsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTradingStrategiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTradingStrategyBalanceChangeEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyBalanceChangeEventCondition>;
  filter?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategyBalanceChangeEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostByPrewitnessedDepositIdAndChainArgs = {
  chain: ChainflipChain;
  prewitnessedDepositId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostLiquidityBalanceChangeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostLiquidityBalanceChangeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolApyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolApyByBoostPoolIdAndBlockArgs = {
  block: Scalars['Int']['input'];
  boostPoolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolApyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolBoostShareArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolBoostShareByBoostIdAndBoostPoolIdArgs = {
  boostId: Scalars['Int']['input'];
  boostPoolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolBoostShareByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolByAssetAndFeeTierPipsArgs = {
  asset: ChainflipAsset;
  feeTierPips: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolLiquidityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolLiquidityByBoostPoolIdAndBlockArgs = {
  block: Scalars['Int']['input'];
  boostPoolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolLiquidityByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostShareArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostShareByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostShareByLiquidityProviderIdAndBoostIdAndBoostPoolIdArgs = {
  boostId: Scalars['Int']['input'];
  boostPoolId: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDepositChannelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDepositChannelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDepositChannelByIssuedBlockIdAndChainAndChannelIdArgs = {
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['input'];
  issuedBlockId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByBlockAndIndexInBlockArgs = {
  block: Scalars['Int']['input'];
  indexInBlock: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncentiveSeasonArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncentiveSeasonByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncentiveSeasonBySeasonIndexArgs = {
  seasonIndex: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLastBlockArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLastBlockByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingLiquidityBalanceChangeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingLiquidityBalanceChangeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingLiquidityBalanceChangeByPoolIdAndEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
  poolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolByAssetArgs = {
  asset: ChainflipAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolIncentiveProgramArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolIncentiveProgramByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolIncentiveProgramByLendingPoolIdAndIncentiveSeasonIdAndTypeArgs = {
  incentiveSeasonId: Scalars['Int']['input'];
  lendingPoolId: Scalars['Int']['input'];
  type: LendingPoolIncentiveProgramType;
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolSnapshotArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolSnapshotByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolSnapshotByPoolIdAndBlockArgs = {
  block: Scalars['Int']['input'];
  poolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolStatArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolStatByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingPoolStatByPoolIdAndBlockArgs = {
  block: Scalars['Int']['input'];
  poolId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLimitOrderFillArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLimitOrderFillByBlockAndLiquidityProviderIdAndOrderIdAndBaseAssetAndTypeArgs = {
  baseAsset: ChainflipAsset;
  block: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
  type: LimitOrderType;
};


/** The root query type which gives access points into the data universe. */
export type QueryLimitOrderFillByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidationSwapRequestArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidationSwapRequestByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidationSwapRequestByLoanIdAndSwapRequestIdArgs = {
  loanId: Scalars['BigInt']['input'];
  swapRequestId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityProviderBoostPoolSummaryByLiquidityProviderIdAndBoostPoolIdArgs = {
  boostPoolId: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquiditySnapshotArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquiditySnapshotByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquiditySnapshotByLiquidityProviderIdAndBlockArgs = {
  block: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanByPrewitnessedDepositIdAndAssetArgs = {
  asset: ChainflipAsset;
  prewitnessedDepositId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanFeeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanFeeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanFeeByLoanIdAndAssetAndEventIdAndTypeArgs = {
  asset: ChainflipAsset;
  eventId: Scalars['BigInt']['input'];
  loanId: Scalars['BigInt']['input'];
  type: LoanFeeType;
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanUpdateArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanUpdateByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoanUpdateByLoanIdAndTypeAndEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
  loanId: Scalars['BigInt']['input'];
  type: LoanUpdateType;
};


/** The root query type which gives access points into the data universe. */
export type QueryLpCollateralBalanceChangeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpCollateralBalanceChangeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpCollateralBalanceChangeByLiquidityProviderIdAndAssetAndEventIdArgs = {
  asset: ChainflipAsset;
  eventId: Scalars['BigInt']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpFlipAirdropDistributionEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpFlipAirdropDistributionEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpFlipAirdropDistributionEventByLiquidityProviderIdAndLendingPoolIncentiveProgramIdArgs = {
  lendingPoolIncentiveProgramId: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpLendingPoolSnapshotArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpLendingPoolSnapshotByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpLendingPoolSnapshotByLiquidityProviderIdAndLendingPoolIdAndBlockHeightAndTypeAndTimestampHourArgs = {
  blockHeight: Scalars['Int']['input'];
  lendingPoolId: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
  timestampHour: Scalars['Datetime']['input'];
  type: LpLendingPoolSnapshotType;
};


/** The root query type which gives access points into the data universe. */
export type QueryLpPointDistributionEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpPointDistributionEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpPointDistributionEventByLiquidityProviderIdAndLendingPoolIncentiveProgramIdAndBlockHeightArgs = {
  blockHeight: Scalars['Int']['input'];
  lendingPoolIncentiveProgramId: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceTrackingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceTrackingByBaseAssetAndQuoteAssetAndCreatedAtEventIdArgs = {
  baseAsset: PriceAsset;
  createdAtEventId: Scalars['BigInt']['input'];
  quoteAsset: PriceAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceTrackingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPendingBoostLiquidityWithdrawalArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPendingBoostLiquidityWithdrawalByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolOrderByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolOrderByOrderCreatedEventIdArgs = {
  orderCreatedEventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRangeOrderFillArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRangeOrderFillByBlockAndLiquidityProviderIdAndOrderIdAndBaseAssetArgs = {
  baseAsset: ChainflipAsset;
  block: Scalars['Int']['input'];
  liquidityProviderId: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRangeOrderFillByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyBalanceChangeEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyBalanceChangeEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyBalanceChangeEventByTradingStrategyIdAndEventIdAndAssetArgs = {
  asset: ChainflipAsset;
  eventId: Scalars['BigInt']['input'];
  tradingStrategyId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyByStrategyAccountIdArgs = {
  strategyAccountId: Scalars['Int']['input'];
};

export type RangeOrderFill = Node & {
  __typename?: 'RangeOrderFill';
  /** Reads a single `Account` that is related to this `RangeOrderFill`. */
  accountByLiquidityProviderId: Account;
  baseAsset: ChainflipAsset;
  baseFeesEarned: Scalars['BigFloat']['output'];
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  baseFilledAmount: Scalars['BigFloat']['output'];
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  baseReceivedAmount: Scalars['BigFloat']['output'];
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  block: Scalars['Int']['output'];
  blockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  liquidity: Scalars['BigFloat']['output'];
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  quoteFeesEarned: Scalars['BigFloat']['output'];
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  quoteFilledAmount: Scalars['BigFloat']['output'];
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  quoteReceivedAmount: Scalars['BigFloat']['output'];
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  rangeEndTick: Scalars['Int']['output'];
  rangeStartTick: Scalars['Int']['output'];
};

export type RangeOrderFillAggregates = {
  __typename?: 'RangeOrderFillAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RangeOrderFillAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RangeOrderFillDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RangeOrderFillMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RangeOrderFillMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RangeOrderFillStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RangeOrderFillStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RangeOrderFillSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RangeOrderFillVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RangeOrderFillVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `RangeOrderFill` object types. */
export type RangeOrderFillAggregatesFilter = {
  /** Mean average aggregate over matching `RangeOrderFill` objects. */
  average?: InputMaybe<RangeOrderFillAverageAggregateFilter>;
  /** Distinct count aggregate over matching `RangeOrderFill` objects. */
  distinctCount?: InputMaybe<RangeOrderFillDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `RangeOrderFill` object to be included within the aggregate. */
  filter?: InputMaybe<RangeOrderFillFilter>;
  /** Maximum aggregate over matching `RangeOrderFill` objects. */
  max?: InputMaybe<RangeOrderFillMaxAggregateFilter>;
  /** Minimum aggregate over matching `RangeOrderFill` objects. */
  min?: InputMaybe<RangeOrderFillMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `RangeOrderFill` objects. */
  stddevPopulation?: InputMaybe<RangeOrderFillStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `RangeOrderFill` objects. */
  stddevSample?: InputMaybe<RangeOrderFillStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `RangeOrderFill` objects. */
  sum?: InputMaybe<RangeOrderFillSumAggregateFilter>;
  /** Population variance aggregate over matching `RangeOrderFill` objects. */
  variancePopulation?: InputMaybe<RangeOrderFillVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `RangeOrderFill` objects. */
  varianceSample?: InputMaybe<RangeOrderFillVarianceSampleAggregateFilter>;
};

export type RangeOrderFillAverageAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<BigFloatFilter>;
  rangeStartTick?: InputMaybe<BigFloatFilter>;
};

export type RangeOrderFillAverageAggregates = {
  __typename?: 'RangeOrderFillAverageAggregates';
  /** Mean average of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `RangeOrderFill` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RangeOrderFillCondition = {
  accountByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseFeesEarned` field. */
  baseFeesEarned?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseFeesEarnedValueUsd` field. */
  baseFeesEarnedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseFilledAmount` field. */
  baseFilledAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseFilledAmountValueUsd` field. */
  baseFilledAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseReceivedAmount` field. */
  baseReceivedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseReceivedAmountValueUsd` field. */
  baseReceivedAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `blockTimestamp` field. */
  blockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidity` field. */
  liquidity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quoteFeesEarned` field. */
  quoteFeesEarned?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteFeesEarnedValueUsd` field. */
  quoteFeesEarnedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteFilledAmount` field. */
  quoteFilledAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteFilledAmountValueUsd` field. */
  quoteFilledAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteReceivedAmount` field. */
  quoteReceivedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteReceivedAmountValueUsd` field. */
  quoteReceivedAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rangeEndTick` field. */
  rangeEndTick?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rangeStartTick` field. */
  rangeStartTick?: InputMaybe<Scalars['Int']['input']>;
};

export type RangeOrderFillDistinctCountAggregateFilter = {
  baseAsset?: InputMaybe<BigIntFilter>;
  baseFeesEarned?: InputMaybe<BigIntFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigIntFilter>;
  baseFilledAmount?: InputMaybe<BigIntFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigIntFilter>;
  baseReceivedAmount?: InputMaybe<BigIntFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  blockTimestamp?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidity?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  orderId?: InputMaybe<BigIntFilter>;
  quoteFeesEarned?: InputMaybe<BigIntFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigIntFilter>;
  quoteFilledAmount?: InputMaybe<BigIntFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigIntFilter>;
  quoteReceivedAmount?: InputMaybe<BigIntFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigIntFilter>;
  rangeEndTick?: InputMaybe<BigIntFilter>;
  rangeStartTick?: InputMaybe<BigIntFilter>;
};

export type RangeOrderFillDistinctCountAggregates = {
  __typename?: 'RangeOrderFillDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockTimestamp across the matching connection */
  blockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderId across the matching connection */
  orderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `RangeOrderFill` object types. All fields are combined with a logical ‘and.’ */
export type RangeOrderFillFilter = {
  /** Filter by the object’s `accountByLiquidityProviderId` relation. */
  accountByLiquidityProviderId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RangeOrderFillFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseFeesEarned` field. */
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseFeesEarnedValueUsd` field. */
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseFilledAmount` field. */
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseFilledAmountValueUsd` field. */
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseReceivedAmount` field. */
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseReceivedAmountValueUsd` field. */
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blockTimestamp` field. */
  blockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidity` field. */
  liquidity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RangeOrderFillFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RangeOrderFillFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quoteFeesEarned` field. */
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteFeesEarnedValueUsd` field. */
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteFilledAmount` field. */
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteFilledAmountValueUsd` field. */
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteReceivedAmount` field. */
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteReceivedAmountValueUsd` field. */
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rangeEndTick` field. */
  rangeEndTick?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rangeStartTick` field. */
  rangeStartTick?: InputMaybe<IntFilter>;
};

/** Grouping methods for `RangeOrderFill` for usage during aggregation. */
export type RangeOrderFillGroupBy =
  | 'BASE_ASSET'
  | 'BASE_FEES_EARNED'
  | 'BASE_FEES_EARNED_VALUE_USD'
  | 'BASE_FILLED_AMOUNT'
  | 'BASE_FILLED_AMOUNT_VALUE_USD'
  | 'BASE_RECEIVED_AMOUNT'
  | 'BASE_RECEIVED_AMOUNT_VALUE_USD'
  | 'BLOCK'
  | 'BLOCK_TIMESTAMP'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'LIQUIDITY'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'ORDER_ID'
  | 'QUOTE_FEES_EARNED'
  | 'QUOTE_FEES_EARNED_VALUE_USD'
  | 'QUOTE_FILLED_AMOUNT'
  | 'QUOTE_FILLED_AMOUNT_VALUE_USD'
  | 'QUOTE_RECEIVED_AMOUNT'
  | 'QUOTE_RECEIVED_AMOUNT_VALUE_USD'
  | 'RANGE_END_TICK'
  | 'RANGE_START_TICK';

export type RangeOrderFillHavingAverageInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingDistinctCountInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `RangeOrderFill` aggregates. */
export type RangeOrderFillHavingInput = {
  AND?: InputMaybe<Array<RangeOrderFillHavingInput>>;
  OR?: InputMaybe<Array<RangeOrderFillHavingInput>>;
  average?: InputMaybe<RangeOrderFillHavingAverageInput>;
  distinctCount?: InputMaybe<RangeOrderFillHavingDistinctCountInput>;
  max?: InputMaybe<RangeOrderFillHavingMaxInput>;
  min?: InputMaybe<RangeOrderFillHavingMinInput>;
  stddevPopulation?: InputMaybe<RangeOrderFillHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RangeOrderFillHavingStddevSampleInput>;
  sum?: InputMaybe<RangeOrderFillHavingSumInput>;
  variancePopulation?: InputMaybe<RangeOrderFillHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RangeOrderFillHavingVarianceSampleInput>;
};

export type RangeOrderFillHavingMaxInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingMinInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingStddevPopulationInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingStddevSampleInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingSumInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingVariancePopulationInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillHavingVarianceSampleInput = {
  baseFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  block?: InputMaybe<HavingIntFilter>;
  blockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidity?: InputMaybe<HavingBigfloatFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  quoteFeesEarned?: InputMaybe<HavingBigfloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  rangeEndTick?: InputMaybe<HavingIntFilter>;
  rangeStartTick?: InputMaybe<HavingIntFilter>;
};

export type RangeOrderFillMaxAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  blockTimestamp?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<IntFilter>;
  rangeStartTick?: InputMaybe<IntFilter>;
};

export type RangeOrderFillMaxAggregates = {
  __typename?: 'RangeOrderFillMaxAggregates';
  /** Maximum of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of blockTimestamp across the matching connection */
  blockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['Int']['output']>;
};

export type RangeOrderFillMinAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<IntFilter>;
  blockTimestamp?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<IntFilter>;
  rangeStartTick?: InputMaybe<IntFilter>;
};

export type RangeOrderFillMinAggregates = {
  __typename?: 'RangeOrderFillMinAggregates';
  /** Minimum of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of blockTimestamp across the matching connection */
  blockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['Int']['output']>;
};

export type RangeOrderFillStddevPopulationAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<BigFloatFilter>;
  rangeStartTick?: InputMaybe<BigFloatFilter>;
};

export type RangeOrderFillStddevPopulationAggregates = {
  __typename?: 'RangeOrderFillStddevPopulationAggregates';
  /** Population standard deviation of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type RangeOrderFillStddevSampleAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<BigFloatFilter>;
  rangeStartTick?: InputMaybe<BigFloatFilter>;
};

export type RangeOrderFillStddevSampleAggregates = {
  __typename?: 'RangeOrderFillStddevSampleAggregates';
  /** Sample standard deviation of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type RangeOrderFillSumAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<BigIntFilter>;
  rangeStartTick?: InputMaybe<BigIntFilter>;
};

export type RangeOrderFillSumAggregates = {
  __typename?: 'RangeOrderFillSumAggregates';
  /** Sum of baseFeesEarned across the matching connection */
  baseFeesEarned: Scalars['BigFloat']['output'];
  /** Sum of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd: Scalars['BigFloat']['output'];
  /** Sum of baseFilledAmount across the matching connection */
  baseFilledAmount: Scalars['BigFloat']['output'];
  /** Sum of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of baseReceivedAmount across the matching connection */
  baseReceivedAmount: Scalars['BigFloat']['output'];
  /** Sum of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidity across the matching connection */
  liquidity: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of quoteFeesEarned across the matching connection */
  quoteFeesEarned: Scalars['BigFloat']['output'];
  /** Sum of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd: Scalars['BigFloat']['output'];
  /** Sum of quoteFilledAmount across the matching connection */
  quoteFilledAmount: Scalars['BigFloat']['output'];
  /** Sum of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount: Scalars['BigFloat']['output'];
  /** Sum of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of rangeEndTick across the matching connection */
  rangeEndTick: Scalars['BigInt']['output'];
  /** Sum of rangeStartTick across the matching connection */
  rangeStartTick: Scalars['BigInt']['output'];
};

export type RangeOrderFillVariancePopulationAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<BigFloatFilter>;
  rangeStartTick?: InputMaybe<BigFloatFilter>;
};

export type RangeOrderFillVariancePopulationAggregates = {
  __typename?: 'RangeOrderFillVariancePopulationAggregates';
  /** Population variance of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type RangeOrderFillVarianceSampleAggregateFilter = {
  baseFeesEarned?: InputMaybe<BigFloatFilter>;
  baseFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  baseFilledAmount?: InputMaybe<BigFloatFilter>;
  baseFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  baseReceivedAmount?: InputMaybe<BigFloatFilter>;
  baseReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidity?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  quoteFeesEarned?: InputMaybe<BigFloatFilter>;
  quoteFeesEarnedValueUsd?: InputMaybe<BigFloatFilter>;
  quoteFilledAmount?: InputMaybe<BigFloatFilter>;
  quoteFilledAmountValueUsd?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmount?: InputMaybe<BigFloatFilter>;
  quoteReceivedAmountValueUsd?: InputMaybe<BigFloatFilter>;
  rangeEndTick?: InputMaybe<BigFloatFilter>;
  rangeStartTick?: InputMaybe<BigFloatFilter>;
};

export type RangeOrderFillVarianceSampleAggregates = {
  __typename?: 'RangeOrderFillVarianceSampleAggregates';
  /** Sample variance of baseFeesEarned across the matching connection */
  baseFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseFeesEarnedValueUsd across the matching connection */
  baseFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseFilledAmount across the matching connection */
  baseFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseFilledAmountValueUsd across the matching connection */
  baseFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseReceivedAmount across the matching connection */
  baseReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseReceivedAmountValueUsd across the matching connection */
  baseReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidity across the matching connection */
  liquidity?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteFeesEarned across the matching connection */
  quoteFeesEarned?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteFeesEarnedValueUsd across the matching connection */
  quoteFeesEarnedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteFilledAmount across the matching connection */
  quoteFilledAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteFilledAmountValueUsd across the matching connection */
  quoteFilledAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteReceivedAmount across the matching connection */
  quoteReceivedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteReceivedAmountValueUsd across the matching connection */
  quoteReceivedAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rangeEndTick across the matching connection */
  rangeEndTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rangeStartTick across the matching connection */
  rangeStartTick?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `RangeOrderFill` values. */
export type RangeOrderFillsConnection = {
  __typename?: 'RangeOrderFillsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RangeOrderFillAggregates>;
  /** A list of edges which contains the `RangeOrderFill` and cursor to aid in pagination. */
  edges: Array<RangeOrderFillsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RangeOrderFillAggregates>>;
  /** A list of `RangeOrderFill` objects. */
  nodes: Array<RangeOrderFill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RangeOrderFill` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `RangeOrderFill` values. */
export type RangeOrderFillsConnectionGroupedAggregatesArgs = {
  groupBy: Array<RangeOrderFillGroupBy>;
  having?: InputMaybe<RangeOrderFillHavingInput>;
};

/** A `RangeOrderFill` edge in the connection. */
export type RangeOrderFillsEdge = {
  __typename?: 'RangeOrderFillsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RangeOrderFill` at the end of the edge. */
  node: RangeOrderFill;
};

/** Methods to use when ordering `RangeOrderFill`. */
export type RangeOrderFillsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BASE_FEES_EARNED_ASC'
  | 'BASE_FEES_EARNED_DESC'
  | 'BASE_FEES_EARNED_VALUE_USD_ASC'
  | 'BASE_FEES_EARNED_VALUE_USD_DESC'
  | 'BASE_FILLED_AMOUNT_ASC'
  | 'BASE_FILLED_AMOUNT_DESC'
  | 'BASE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'BASE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'BASE_RECEIVED_AMOUNT_ASC'
  | 'BASE_RECEIVED_AMOUNT_DESC'
  | 'BASE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'BASE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'BLOCK_TIMESTAMP_ASC'
  | 'BLOCK_TIMESTAMP_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_ASC'
  | 'LIQUIDITY_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'ORDER_ID_ASC'
  | 'ORDER_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_FEES_EARNED_ASC'
  | 'QUOTE_FEES_EARNED_DESC'
  | 'QUOTE_FEES_EARNED_VALUE_USD_ASC'
  | 'QUOTE_FEES_EARNED_VALUE_USD_DESC'
  | 'QUOTE_FILLED_AMOUNT_ASC'
  | 'QUOTE_FILLED_AMOUNT_DESC'
  | 'QUOTE_FILLED_AMOUNT_VALUE_USD_ASC'
  | 'QUOTE_FILLED_AMOUNT_VALUE_USD_DESC'
  | 'QUOTE_RECEIVED_AMOUNT_ASC'
  | 'QUOTE_RECEIVED_AMOUNT_DESC'
  | 'QUOTE_RECEIVED_AMOUNT_VALUE_USD_ASC'
  | 'QUOTE_RECEIVED_AMOUNT_VALUE_USD_DESC'
  | 'RANGE_END_TICK_ASC'
  | 'RANGE_END_TICK_DESC'
  | 'RANGE_START_TICK_ASC'
  | 'RANGE_START_TICK_DESC';

export type StrategyType =
  | 'INVENTORY_BASED'
  | 'ORACLE_TRACKING'
  | 'SIMPLE_BUY_SELL'
  | 'TICK_ZERO_CENTERED';

/** A filter to be used against StrategyType fields. All fields are combined with a logical ‘and.’ */
export type StrategyTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<StrategyType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<StrategyType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<StrategyType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<StrategyType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<StrategyType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<StrategyType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<StrategyType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<StrategyType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<StrategyType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<StrategyType>>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `TradingStrategy` values. */
export type TradingStrategiesConnection = {
  __typename?: 'TradingStrategiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingStrategyAggregates>;
  /** A list of edges which contains the `TradingStrategy` and cursor to aid in pagination. */
  edges: Array<TradingStrategiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingStrategyAggregates>>;
  /** A list of `TradingStrategy` objects. */
  nodes: Array<TradingStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingStrategy` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingStrategy` values. */
export type TradingStrategiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingStrategyGroupBy>;
  having?: InputMaybe<TradingStrategyHavingInput>;
};

/** A `TradingStrategy` edge in the connection. */
export type TradingStrategiesEdge = {
  __typename?: 'TradingStrategiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingStrategy` at the end of the edge. */
  node: TradingStrategy;
};

/** Methods to use when ordering `TradingStrategy`. */
export type TradingStrategiesOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'CLOSED_AT_EVENT_ID_ASC'
  | 'CLOSED_AT_EVENT_ID_DESC'
  | 'CREATED_AT_EVENT_ID_ASC'
  | 'CREATED_AT_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KEY_ASC'
  | 'KEY_DESC'
  | 'NATURAL'
  | 'OWNER_ACCOUNT_ID_ASC'
  | 'OWNER_ACCOUNT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'STRATEGY_ACCOUNT_ID_ASC'
  | 'STRATEGY_ACCOUNT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_AVERAGE_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_COUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_COUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MAX_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_MIN_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_POPULATION_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_STDDEV_SAMPLE_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_SUM_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_POPULATION_TRADING_STRATEGY_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_AMOUNT_USD_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_AMOUNT_USD_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_BALANCE_CHANGE_EVENTS_BY_TRADING_STRATEGY_ID_VARIANCE_SAMPLE_TRADING_STRATEGY_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type TradingStrategy = Node & {
  __typename?: 'TradingStrategy';
  /** Reads a single `Account` that is related to this `TradingStrategy`. */
  accountByOwnerAccountId: Account;
  /** Reads a single `Account` that is related to this `TradingStrategy`. */
  accountByStrategyAccountId: Account;
  baseAsset: ChainflipAsset;
  closedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  createdAtEventId: Scalars['BigInt']['output'];
  /** Reads a single `Event` that is related to this `TradingStrategy`. */
  eventByClosedAtEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `TradingStrategy`. */
  eventByCreatedAtEventId: Event;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  ownerAccountId: Scalars['Int']['output'];
  quoteAsset: ChainflipAsset;
  strategyAccountId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TradingStrategyBalanceChangeEvent`. */
  tradingStrategyBalanceChangeEventsByTradingStrategyId: TradingStrategyBalanceChangeEventsConnection;
  type: StrategyType;
};


export type TradingStrategyTradingStrategyBalanceChangeEventsByTradingStrategyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyBalanceChangeEventCondition>;
  filter?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategyBalanceChangeEventsOrderBy>>;
};

export type TradingStrategyAggregates = {
  __typename?: 'TradingStrategyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingStrategyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingStrategyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingStrategyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingStrategyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingStrategyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingStrategyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingStrategySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingStrategyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingStrategyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TradingStrategy` object types. */
export type TradingStrategyAggregatesFilter = {
  /** Mean average aggregate over matching `TradingStrategy` objects. */
  average?: InputMaybe<TradingStrategyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TradingStrategy` objects. */
  distinctCount?: InputMaybe<TradingStrategyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TradingStrategy` object to be included within the aggregate. */
  filter?: InputMaybe<TradingStrategyFilter>;
  /** Maximum aggregate over matching `TradingStrategy` objects. */
  max?: InputMaybe<TradingStrategyMaxAggregateFilter>;
  /** Minimum aggregate over matching `TradingStrategy` objects. */
  min?: InputMaybe<TradingStrategyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TradingStrategy` objects. */
  stddevPopulation?: InputMaybe<TradingStrategyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TradingStrategy` objects. */
  stddevSample?: InputMaybe<TradingStrategyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TradingStrategy` objects. */
  sum?: InputMaybe<TradingStrategySumAggregateFilter>;
  /** Population variance aggregate over matching `TradingStrategy` objects. */
  variancePopulation?: InputMaybe<TradingStrategyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TradingStrategy` objects. */
  varianceSample?: InputMaybe<TradingStrategyVarianceSampleAggregateFilter>;
};

export type TradingStrategyAverageAggregateFilter = {
  closedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ownerAccountId?: InputMaybe<BigFloatFilter>;
  strategyAccountId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyAverageAggregates = {
  __typename?: 'TradingStrategyAverageAggregates';
  /** Mean average of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyBalanceChangeEvent = Node & {
  __typename?: 'TradingStrategyBalanceChangeEvent';
  amount: Scalars['BigFloat']['output'];
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  asset: ChainflipAsset;
  /** Reads a single `Event` that is related to this `TradingStrategyBalanceChangeEvent`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `TradingStrategy` that is related to this `TradingStrategyBalanceChangeEvent`. */
  tradingStrategyByTradingStrategyId: TradingStrategy;
  tradingStrategyId: Scalars['Int']['output'];
  type: TradingStrategyBalanceChangeEventType;
};

export type TradingStrategyBalanceChangeEventAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingStrategyBalanceChangeEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingStrategyBalanceChangeEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingStrategyBalanceChangeEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingStrategyBalanceChangeEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingStrategyBalanceChangeEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingStrategyBalanceChangeEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingStrategyBalanceChangeEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingStrategyBalanceChangeEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingStrategyBalanceChangeEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TradingStrategyBalanceChangeEvent` object types. */
export type TradingStrategyBalanceChangeEventAggregatesFilter = {
  /** Mean average aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  average?: InputMaybe<TradingStrategyBalanceChangeEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  distinctCount?: InputMaybe<TradingStrategyBalanceChangeEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TradingStrategyBalanceChangeEvent` object to be included within the aggregate. */
  filter?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  /** Maximum aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  max?: InputMaybe<TradingStrategyBalanceChangeEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  min?: InputMaybe<TradingStrategyBalanceChangeEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  stddevPopulation?: InputMaybe<TradingStrategyBalanceChangeEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  stddevSample?: InputMaybe<TradingStrategyBalanceChangeEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  sum?: InputMaybe<TradingStrategyBalanceChangeEventSumAggregateFilter>;
  /** Population variance aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  variancePopulation?: InputMaybe<TradingStrategyBalanceChangeEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TradingStrategyBalanceChangeEvent` objects. */
  varianceSample?: InputMaybe<TradingStrategyBalanceChangeEventVarianceSampleAggregateFilter>;
};

export type TradingStrategyBalanceChangeEventAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyBalanceChangeEventAverageAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TradingStrategyBalanceChangeEvent` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type TradingStrategyBalanceChangeEventCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  tradingStrategyByTradingStrategyId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `tradingStrategyId` field. */
  tradingStrategyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<TradingStrategyBalanceChangeEventType>;
};

export type TradingStrategyBalanceChangeEventDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  amountUsd?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  tradingStrategyId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type TradingStrategyBalanceChangeEventDistinctCountAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TradingStrategyBalanceChangeEvent` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyBalanceChangeEventFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUsd` field. */
  amountUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingStrategyBalanceChangeEventFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingStrategyBalanceChangeEventFilter>>;
  /** Filter by the object’s `tradingStrategyByTradingStrategyId` relation. */
  tradingStrategyByTradingStrategyId?: InputMaybe<TradingStrategyFilter>;
  /** Filter by the object’s `tradingStrategyId` field. */
  tradingStrategyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<TradingStrategyBalanceChangeEventTypeFilter>;
};

/** Grouping methods for `TradingStrategyBalanceChangeEvent` for usage during aggregation. */
export type TradingStrategyBalanceChangeEventGroupBy =
  | 'AMOUNT'
  | 'AMOUNT_USD'
  | 'ASSET'
  | 'EVENT_ID'
  | 'TRADING_STRATEGY_ID'
  | 'TYPE';

export type TradingStrategyBalanceChangeEventHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `TradingStrategyBalanceChangeEvent` aggregates. */
export type TradingStrategyBalanceChangeEventHavingInput = {
  AND?: InputMaybe<Array<TradingStrategyBalanceChangeEventHavingInput>>;
  OR?: InputMaybe<Array<TradingStrategyBalanceChangeEventHavingInput>>;
  average?: InputMaybe<TradingStrategyBalanceChangeEventHavingAverageInput>;
  distinctCount?: InputMaybe<TradingStrategyBalanceChangeEventHavingDistinctCountInput>;
  max?: InputMaybe<TradingStrategyBalanceChangeEventHavingMaxInput>;
  min?: InputMaybe<TradingStrategyBalanceChangeEventHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingStrategyBalanceChangeEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingStrategyBalanceChangeEventHavingStddevSampleInput>;
  sum?: InputMaybe<TradingStrategyBalanceChangeEventHavingSumInput>;
  variancePopulation?: InputMaybe<TradingStrategyBalanceChangeEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingStrategyBalanceChangeEventHavingVarianceSampleInput>;
};

export type TradingStrategyBalanceChangeEventHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  amountUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyBalanceChangeEventMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  tradingStrategyId?: InputMaybe<IntFilter>;
};

export type TradingStrategyBalanceChangeEventMaxAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['Int']['output']>;
};

export type TradingStrategyBalanceChangeEventMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  tradingStrategyId?: InputMaybe<IntFilter>;
};

export type TradingStrategyBalanceChangeEventMinAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['Int']['output']>;
};

export type TradingStrategyBalanceChangeEventStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyBalanceChangeEventStddevPopulationAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyBalanceChangeEventStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyBalanceChangeEventStddevSampleAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyBalanceChangeEventSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  tradingStrategyId?: InputMaybe<BigIntFilter>;
};

export type TradingStrategyBalanceChangeEventSumAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of amountUsd across the matching connection */
  amountUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of tradingStrategyId across the matching connection */
  tradingStrategyId: Scalars['BigInt']['output'];
};

export type TradingStrategyBalanceChangeEventType =
  | 'FUNDS_ADDED'
  | 'STRATEGY_CLOSED';

/** A filter to be used against TradingStrategyBalanceChangeEventType fields. All fields are combined with a logical ‘and.’ */
export type TradingStrategyBalanceChangeEventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TradingStrategyBalanceChangeEventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TradingStrategyBalanceChangeEventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TradingStrategyBalanceChangeEventType>>;
};

export type TradingStrategyBalanceChangeEventVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyBalanceChangeEventVariancePopulationAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyBalanceChangeEventVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  amountUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyBalanceChangeEventVarianceSampleAggregates = {
  __typename?: 'TradingStrategyBalanceChangeEventVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amountUsd across the matching connection */
  amountUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tradingStrategyId across the matching connection */
  tradingStrategyId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `TradingStrategyBalanceChangeEvent` values. */
export type TradingStrategyBalanceChangeEventsConnection = {
  __typename?: 'TradingStrategyBalanceChangeEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingStrategyBalanceChangeEventAggregates>;
  /** A list of edges which contains the `TradingStrategyBalanceChangeEvent` and cursor to aid in pagination. */
  edges: Array<TradingStrategyBalanceChangeEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingStrategyBalanceChangeEventAggregates>>;
  /** A list of `TradingStrategyBalanceChangeEvent` objects. */
  nodes: Array<TradingStrategyBalanceChangeEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingStrategyBalanceChangeEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingStrategyBalanceChangeEvent` values. */
export type TradingStrategyBalanceChangeEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingStrategyBalanceChangeEventGroupBy>;
  having?: InputMaybe<TradingStrategyBalanceChangeEventHavingInput>;
};

/** A `TradingStrategyBalanceChangeEvent` edge in the connection. */
export type TradingStrategyBalanceChangeEventsEdge = {
  __typename?: 'TradingStrategyBalanceChangeEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingStrategyBalanceChangeEvent` at the end of the edge. */
  node: TradingStrategyBalanceChangeEvent;
};

/** Methods to use when ordering `TradingStrategyBalanceChangeEvent`. */
export type TradingStrategyBalanceChangeEventsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'AMOUNT_USD_ASC'
  | 'AMOUNT_USD_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TRADING_STRATEGY_ID_ASC'
  | 'TRADING_STRATEGY_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

/**
 * A condition to be used against `TradingStrategy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TradingStrategyCondition = {
  accountByOwnerAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountByStrategyAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `closedAtEventId` field. */
  closedAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByClosedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByCreatedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownerAccountId` field. */
  ownerAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `strategyAccountId` field. */
  strategyAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<StrategyType>;
};

export type TradingStrategyDistinctCountAggregateFilter = {
  baseAsset?: InputMaybe<BigIntFilter>;
  closedAtEventId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  key?: InputMaybe<BigIntFilter>;
  ownerAccountId?: InputMaybe<BigIntFilter>;
  quoteAsset?: InputMaybe<BigIntFilter>;
  strategyAccountId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type TradingStrategyDistinctCountAggregates = {
  __typename?: 'TradingStrategyDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of key across the matching connection */
  key?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TradingStrategy` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyFilter = {
  /** Filter by the object’s `accountByOwnerAccountId` relation. */
  accountByOwnerAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountByStrategyAccountId` relation. */
  accountByStrategyAccountId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingStrategyFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `closedAtEventId` field. */
  closedAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByClosedAtEventId` relation. */
  eventByClosedAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventByClosedAtEventId` exists. */
  eventByClosedAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByCreatedAtEventId` relation. */
  eventByCreatedAtEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingStrategyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingStrategyFilter>>;
  /** Filter by the object’s `ownerAccountId` field. */
  ownerAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `strategyAccountId` field. */
  strategyAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tradingStrategyBalanceChangeEventsByTradingStrategyId` relation. */
  tradingStrategyBalanceChangeEventsByTradingStrategyId?: InputMaybe<TradingStrategyToManyTradingStrategyBalanceChangeEventFilter>;
  /** Some related `tradingStrategyBalanceChangeEventsByTradingStrategyId` exist. */
  tradingStrategyBalanceChangeEventsByTradingStrategyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StrategyTypeFilter>;
};

/** Grouping methods for `TradingStrategy` for usage during aggregation. */
export type TradingStrategyGroupBy =
  | 'BASE_ASSET'
  | 'CLOSED_AT_EVENT_ID'
  | 'CREATED_AT_EVENT_ID'
  | 'KEY'
  | 'OWNER_ACCOUNT_ID'
  | 'QUOTE_ASSET'
  | 'TYPE';

export type TradingStrategyHavingAverageInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingDistinctCountInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `TradingStrategy` aggregates. */
export type TradingStrategyHavingInput = {
  AND?: InputMaybe<Array<TradingStrategyHavingInput>>;
  OR?: InputMaybe<Array<TradingStrategyHavingInput>>;
  average?: InputMaybe<TradingStrategyHavingAverageInput>;
  distinctCount?: InputMaybe<TradingStrategyHavingDistinctCountInput>;
  max?: InputMaybe<TradingStrategyHavingMaxInput>;
  min?: InputMaybe<TradingStrategyHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingStrategyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingStrategyHavingStddevSampleInput>;
  sum?: InputMaybe<TradingStrategyHavingSumInput>;
  variancePopulation?: InputMaybe<TradingStrategyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingStrategyHavingVarianceSampleInput>;
};

export type TradingStrategyHavingMaxInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingMinInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingStddevPopulationInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingStddevSampleInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingSumInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingVariancePopulationInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingVarianceSampleInput = {
  closedAtEventId?: InputMaybe<HavingBigintFilter>;
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ownerAccountId?: InputMaybe<HavingIntFilter>;
  strategyAccountId?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyMaxAggregateFilter = {
  closedAtEventId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  ownerAccountId?: InputMaybe<IntFilter>;
  strategyAccountId?: InputMaybe<IntFilter>;
};

export type TradingStrategyMaxAggregates = {
  __typename?: 'TradingStrategyMaxAggregates';
  /** Maximum of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['Int']['output']>;
};

export type TradingStrategyMinAggregateFilter = {
  closedAtEventId?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  ownerAccountId?: InputMaybe<IntFilter>;
  strategyAccountId?: InputMaybe<IntFilter>;
};

export type TradingStrategyMinAggregates = {
  __typename?: 'TradingStrategyMinAggregates';
  /** Minimum of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['Int']['output']>;
};

export type TradingStrategyStddevPopulationAggregateFilter = {
  closedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ownerAccountId?: InputMaybe<BigFloatFilter>;
  strategyAccountId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyStddevPopulationAggregates = {
  __typename?: 'TradingStrategyStddevPopulationAggregates';
  /** Population standard deviation of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyStddevSampleAggregateFilter = {
  closedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ownerAccountId?: InputMaybe<BigFloatFilter>;
  strategyAccountId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyStddevSampleAggregates = {
  __typename?: 'TradingStrategyStddevSampleAggregates';
  /** Sample standard deviation of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategySumAggregateFilter = {
  closedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  ownerAccountId?: InputMaybe<BigIntFilter>;
  strategyAccountId?: InputMaybe<BigIntFilter>;
};

export type TradingStrategySumAggregates = {
  __typename?: 'TradingStrategySumAggregates';
  /** Sum of closedAtEventId across the matching connection */
  closedAtEventId: Scalars['BigFloat']['output'];
  /** Sum of createdAtEventId across the matching connection */
  createdAtEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of ownerAccountId across the matching connection */
  ownerAccountId: Scalars['BigInt']['output'];
  /** Sum of strategyAccountId across the matching connection */
  strategyAccountId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `TradingStrategyBalanceChangeEvent` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyToManyTradingStrategyBalanceChangeEventFilter = {
  /** Aggregates across related `TradingStrategyBalanceChangeEvent` match the filter criteria. */
  aggregates?: InputMaybe<TradingStrategyBalanceChangeEventAggregatesFilter>;
  /** Every related `TradingStrategyBalanceChangeEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  /** No related `TradingStrategyBalanceChangeEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
  /** Some related `TradingStrategyBalanceChangeEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TradingStrategyBalanceChangeEventFilter>;
};

export type TradingStrategyVariancePopulationAggregateFilter = {
  closedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ownerAccountId?: InputMaybe<BigFloatFilter>;
  strategyAccountId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyVariancePopulationAggregates = {
  __typename?: 'TradingStrategyVariancePopulationAggregates';
  /** Population variance of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyVarianceSampleAggregateFilter = {
  closedAtEventId?: InputMaybe<BigFloatFilter>;
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ownerAccountId?: InputMaybe<BigFloatFilter>;
  strategyAccountId?: InputMaybe<BigFloatFilter>;
};

export type TradingStrategyVarianceSampleAggregates = {
  __typename?: 'TradingStrategyVarianceSampleAggregates';
  /** Sample variance of closedAtEventId across the matching connection */
  closedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ownerAccountId across the matching connection */
  ownerAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of strategyAccountId across the matching connection */
  strategyAccountId?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigration = Node & {
  __typename?: '_PrismaMigration';
  appliedStepsCount: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  logs?: Maybe<Scalars['String']['output']>;
  migrationName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  startedAt: Scalars['Datetime']['output'];
};

export type _PrismaMigrationAggregates = {
  __typename?: '_PrismaMigrationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<_PrismaMigrationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<_PrismaMigrationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<_PrismaMigrationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<_PrismaMigrationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<_PrismaMigrationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<_PrismaMigrationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<_PrismaMigrationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<_PrismaMigrationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<_PrismaMigrationVarianceSampleAggregates>;
};

export type _PrismaMigrationAverageAggregates = {
  __typename?: '_PrismaMigrationAverageAggregates';
  /** Mean average of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `_PrismaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type _PrismaMigrationCondition = {
  /** Checks for equality with the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logs` field. */
  logs?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `migrationName` field. */
  migrationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type _PrismaMigrationDistinctCountAggregates = {
  __typename?: '_PrismaMigrationDistinctCountAggregates';
  /** Distinct count of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of checksum across the matching connection */
  checksum?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of logs across the matching connection */
  logs?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of migrationName across the matching connection */
  migrationName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `_PrismaMigration` object types. All fields are combined with a logical ‘and.’ */
export type _PrismaMigrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logs` field. */
  logs?: InputMaybe<StringFilter>;
  /** Filter by the object’s `migrationName` field. */
  migrationName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<_PrismaMigrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `_PrismaMigration` for usage during aggregation. */
export type _PrismaMigrationGroupBy =
  | 'APPLIED_STEPS_COUNT'
  | 'CHECKSUM'
  | 'FINISHED_AT'
  | 'FINISHED_AT_TRUNCATED_TO_DAY'
  | 'FINISHED_AT_TRUNCATED_TO_HOUR'
  | 'FINISHED_AT_TRUNCATED_TO_MONTH'
  | 'FINISHED_AT_TRUNCATED_TO_WEEK'
  | 'LOGS'
  | 'MIGRATION_NAME'
  | 'ROLLED_BACK_AT'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_DAY'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_HOUR'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_MONTH'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_WEEK'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT_TRUNCATED_TO_MONTH'
  | 'STARTED_AT_TRUNCATED_TO_WEEK';

export type _PrismaMigrationHavingAverageInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingDistinctCountInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `_PrismaMigration` aggregates. */
export type _PrismaMigrationHavingInput = {
  AND?: InputMaybe<Array<_PrismaMigrationHavingInput>>;
  OR?: InputMaybe<Array<_PrismaMigrationHavingInput>>;
  average?: InputMaybe<_PrismaMigrationHavingAverageInput>;
  distinctCount?: InputMaybe<_PrismaMigrationHavingDistinctCountInput>;
  max?: InputMaybe<_PrismaMigrationHavingMaxInput>;
  min?: InputMaybe<_PrismaMigrationHavingMinInput>;
  stddevPopulation?: InputMaybe<_PrismaMigrationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<_PrismaMigrationHavingStddevSampleInput>;
  sum?: InputMaybe<_PrismaMigrationHavingSumInput>;
  variancePopulation?: InputMaybe<_PrismaMigrationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<_PrismaMigrationHavingVarianceSampleInput>;
};

export type _PrismaMigrationHavingMaxInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingMinInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingStddevPopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingStddevSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingSumInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingVariancePopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingVarianceSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationMaxAggregates = {
  __typename?: '_PrismaMigrationMaxAggregates';
  /** Maximum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type _PrismaMigrationMinAggregates = {
  __typename?: '_PrismaMigrationMinAggregates';
  /** Minimum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type _PrismaMigrationStddevPopulationAggregates = {
  __typename?: '_PrismaMigrationStddevPopulationAggregates';
  /** Population standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationStddevSampleAggregates = {
  __typename?: '_PrismaMigrationStddevSampleAggregates';
  /** Sample standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationSumAggregates = {
  __typename?: '_PrismaMigrationSumAggregates';
  /** Sum of appliedStepsCount across the matching connection */
  appliedStepsCount: Scalars['BigInt']['output'];
};

export type _PrismaMigrationVariancePopulationAggregates = {
  __typename?: '_PrismaMigrationVariancePopulationAggregates';
  /** Population variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationVarianceSampleAggregates = {
  __typename?: '_PrismaMigrationVarianceSampleAggregates';
  /** Sample variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnection = {
  __typename?: '_PrismaMigrationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<_PrismaMigrationAggregates>;
  /** A list of edges which contains the `_PrismaMigration` and cursor to aid in pagination. */
  edges: Array<_PrismaMigrationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<_PrismaMigrationAggregates>>;
  /** A list of `_PrismaMigration` objects. */
  nodes: Array<_PrismaMigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `_PrismaMigration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<_PrismaMigrationGroupBy>;
  having?: InputMaybe<_PrismaMigrationHavingInput>;
};

/** A `_PrismaMigration` edge in the connection. */
export type _PrismaMigrationsEdge = {
  __typename?: '_PrismaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `_PrismaMigration` at the end of the edge. */
  node: _PrismaMigration;
};

/** Methods to use when ordering `_PrismaMigration`. */
export type _PrismaMigrationsOrderBy =
  | 'APPLIED_STEPS_COUNT_ASC'
  | 'APPLIED_STEPS_COUNT_DESC'
  | 'CHECKSUM_ASC'
  | 'CHECKSUM_DESC'
  | 'FINISHED_AT_ASC'
  | 'FINISHED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOGS_ASC'
  | 'LOGS_DESC'
  | 'MIGRATION_NAME_ASC'
  | 'MIGRATION_NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLLED_BACK_AT_ASC'
  | 'ROLLED_BACK_AT_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC';

export type BoostBalanceChangeFragment = { __typename?: 'BoostLiquidityBalanceChange', amount: string, amountUsd?: string | null, type: BoostPoolBalanceChangeType, event: { __typename?: 'Event', block: number, indexInBlock: number, timestamp: string }, pool: { __typename?: 'BoostPool', asset: ChainflipAsset, feeTierPips: number }, boost?: { __typename?: 'Boost', depositChannel: { __typename?: 'DepositChannel', chain: ChainflipChain, channelId: string, issuedBlockId: number } } | null };

export type GetTotalBoostFeesForPoolQueryVariables = Exact<{
  startingTimestamp: Scalars['Datetime']['input'];
}>;


export type GetTotalBoostFeesForPoolQuery = { __typename?: 'Query', allBoosts?: { __typename?: 'BoostsConnection', aggregates?: { __typename?: 'BoostAggregates', sum?: { __typename?: 'BoostSumAggregates', feeUsd: string } | null } | null } | null };

export type GetLpNumericSearchResultsQueryVariables = Exact<{
  loanId: Scalars['BigInt']['input'];
}>;


export type GetLpNumericSearchResultsQuery = { __typename?: 'Query', loan?: { __typename?: 'Loan', id: string } | null };

export type GetBoostContributionCountForAccountQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetBoostContributionCountForAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', count: { __typename?: 'BoostSharesConnection', totalCount: number } } | null };

export type GetLpSupplyHistoryQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  filter?: InputMaybe<LendingLiquidityBalanceChangeFilter>;
  orderBy?: InputMaybe<Array<LendingLiquidityBalanceChangesOrderBy> | LendingLiquidityBalanceChangesOrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLpSupplyHistoryQuery = { __typename?: 'Query', account?: { __typename?: 'Account', balanceChanges: { __typename?: 'LendingLiquidityBalanceChangesConnection', totalCount: number, edges: Array<{ __typename?: 'LendingLiquidityBalanceChangesEdge', node: { __typename?: 'LendingLiquidityBalanceChange', amount: string, amountUsd?: string | null, asset: ChainflipAsset, type: LendingPoolBalanceChangeType, event: { __typename?: 'Event', block: number, indexInBlock: number, timestamp: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type GetOrderFillsByBlocksQueryVariables = Exact<{
  blocks?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  baseAssets?: InputMaybe<Array<ChainflipAsset> | ChainflipAsset>;
}>;


export type GetOrderFillsByBlocksQuery = { __typename?: 'Query', limitOrderFills?: { __typename?: 'LimitOrderFillsConnection', nodes: Array<{ __typename?: 'LimitOrderFill', id: number, block: number, tick: number, type: LimitOrderType, baseAsset: ChainflipAsset, filledAmount: string, filledAmountValueUsd?: string | null, blockTimestamp?: string | null, lp: { __typename?: 'Account', idSs58: string } }> } | null, rangeOrderFills?: { __typename?: 'RangeOrderFillsConnection', nodes: Array<{ __typename?: 'RangeOrderFill', id: number, block: number, baseAsset: ChainflipAsset, rangeStartTick: number, rangeEndTick: number, baseFilledAmount: string, quoteFilledAmount: string, baseFilledAmountValueUsd?: string | null, quoteFilledAmountValueUsd?: string | null, baseReceivedAmount: string, quoteReceivedAmount: string, baseReceivedAmountValueUsd?: string | null, quoteReceivedAmountValueUsd?: string | null, baseFeesEarned: string, quoteFeesEarned: string, blockTimestamp?: string | null, lp: { __typename?: 'Account', idSs58: string } }> } | null };

export type GetFillVolumeByBlocksQueryVariables = Exact<{
  blocks?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  baseAssets?: InputMaybe<Array<ChainflipAsset> | ChainflipAsset>;
}>;


export type GetFillVolumeByBlocksQuery = { __typename?: 'Query', limitOrderFills?: { __typename?: 'LimitOrderFillsConnection', nodes: Array<{ __typename?: 'LimitOrderFill', block: number, baseAsset: ChainflipAsset, type: LimitOrderType, filledAmountValueUsd?: string | null, lp: { __typename?: 'Account', idSs58: string } }> } | null, rangeOrderFills?: { __typename?: 'RangeOrderFillsConnection', nodes: Array<{ __typename?: 'RangeOrderFill', block: number, baseAsset: ChainflipAsset, baseFilledAmountValueUsd?: string | null, quoteFilledAmountValueUsd?: string | null, lp: { __typename?: 'Account', idSs58: string } }> } | null };

export type GetLimitOrderFillPricesByBlocksQueryVariables = Exact<{
  blocks?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  baseAssets?: InputMaybe<Array<ChainflipAsset> | ChainflipAsset>;
}>;


export type GetLimitOrderFillPricesByBlocksQuery = { __typename?: 'Query', allLimitOrderFills?: { __typename?: 'LimitOrderFillsConnection', nodes: Array<{ __typename?: 'LimitOrderFill', block: number, baseAsset: ChainflipAsset, type: LimitOrderType, tick: number, filledAmountValueUsd?: string | null, lp: { __typename?: 'Account', idSs58: string } }> } | null };

export type GetBoostPoolLiquidityBalanceChangeQueryVariables = Exact<{
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBoostPoolLiquidityBalanceChangeQuery = { __typename?: 'Query', balanceChanges?: { __typename?: 'BoostLiquidityBalanceChangesConnection', edges: Array<{ __typename?: 'BoostLiquidityBalanceChangesEdge', node: { __typename?: 'BoostLiquidityBalanceChange', amount: string, amountUsd?: string | null, type: BoostPoolBalanceChangeType, event: { __typename?: 'Event', block: number, indexInBlock: number, timestamp: string }, lp: { __typename?: 'Account', idSs58: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } | null };

export type GetBoostSharesByPoolQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBoostSharesByPoolQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', boostSummaries: { __typename?: 'LiquidityProviderBoostPoolSummariesConnection', nodes: Array<{ __typename?: 'LiquidityProviderBoostPoolSummary', feeUsd: string, fee: string, amountUsd: string, amount: string, account: { __typename?: 'Account', id: number, idSs58: string }, boostPool: { __typename?: 'BoostPool', asset: ChainflipAsset } }> } }> } | null };

export type GetPoolBoostsQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolBoostSharesOrderBy> | BoostPoolBoostSharesOrderBy>;
}>;


export type GetPoolBoostsQuery = { __typename?: 'Query', boostShares?: { __typename?: 'BoostPoolBoostSharesConnection', totalCount: number, edges: Array<{ __typename?: 'BoostPoolBoostSharesEdge', node: { __typename?: 'BoostPoolBoostShare', id: string, amount: string, amountUsd?: string | null, fee: string, feeUsd?: string | null, lost: boolean, liquidityProviderFeePortion: string, liquidityProviderFeePortionUsd?: string | null, networkFeePortion: string, networkFeePortionUsd?: string | null, boost: { __typename?: 'Boost', depositAmount: string, swapRequestId?: string | null, liquidityProviderFeePortion?: string | null, liquidityProviderFeePortionUsd?: string | null, networkFeePortion?: string | null, networkFeePortionUsd?: string | null, settledAtTimestamp?: string | null, networkFeeSwapRequestId?: string | null, executedAtTimestamp: string, channel: { __typename?: 'DepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string, type: DepositChannelType } }, pool: { __typename?: 'BoostPool', asset: ChainflipAsset, feeTierPips: number } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } | null };

export type LpBoostPoolIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type LpBoostPoolIdsQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, asset: ChainflipAsset, feeTierPips: number, isActive: boolean }> } | null };

export type GetBoostSharesByAccountAndPoolQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSharesOrderBy> | BoostSharesOrderBy>;
}>;


export type GetBoostSharesByAccountAndPoolQuery = { __typename?: 'Query', account?: { __typename?: 'Account', shares: { __typename?: 'BoostSharesConnection', totalCount: number, edges: Array<{ __typename?: 'BoostSharesEdge', node: { __typename?: 'BoostShare', id: number, amount: string, amountUsd?: string | null, fee: string, feeUsd?: string | null, lost: boolean, boost: { __typename?: 'Boost', depositAmount: string, swapRequestId?: string | null, liquidityProviderFeePortion?: string | null, liquidityProviderFeePortionUsd?: string | null, networkFeePortion?: string | null, networkFeePortionUsd?: string | null, settledAtTimestamp?: string | null, networkFeeSwapRequestId?: string | null, executedAtTimestamp: string, channel: { __typename?: 'DepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string, type: DepositChannelType } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } } | null };

export type AccountBoostLiquidityBalanceChangesQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AccountBoostLiquidityBalanceChangesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', balanceChanges: { __typename?: 'BoostLiquidityBalanceChangesConnection', edges: Array<{ __typename?: 'BoostLiquidityBalanceChangesEdge', node: { __typename?: 'BoostLiquidityBalanceChange', amount: string, amountUsd?: string | null, type: BoostPoolBalanceChangeType, event: { __typename?: 'Event', block: number, indexInBlock: number, timestamp: string }, lp: { __typename?: 'Account', idSs58: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } } | null };

export type EarnedFeesByPoolForAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  since?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type EarnedFeesByPoolForAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', boostShares: { __typename?: 'BoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostShareSumAggregates', amount: string, amountUsd: string, fee: string, feeUsd: string } | null }> | null } } | null, boostPools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, feeTierPips: number, asset: ChainflipAsset }> } | null };

export type EarnedFeesInPoolForAccountQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  boostPoolId?: InputMaybe<Scalars['Int']['input']>;
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
  groupBy: Array<BoostShareGroupBy> | BoostShareGroupBy;
}>;


export type EarnedFeesInPoolForAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', boostShares: { __typename?: 'BoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostShareSumAggregates', fee: string, feeUsd: string } | null }> | null }, firstShare: { __typename?: 'BoostSharesConnection', nodes: Array<{ __typename?: 'BoostShare', executedAtTimestamp: string }> } } | null };

export type EarnedFeesByPool24hsForAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  timestamp: Scalars['Datetime']['input'];
}>;


export type EarnedFeesByPool24hsForAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', boostShares: { __typename?: 'BoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostShareSumAggregates', fee: string, feeUsd: string } | null }> | null } } | null };

export type EarnedFeesAndVolumeForPoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type EarnedFeesAndVolumeForPoolsQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, feeTierPips: number, asset: ChainflipAsset, shares: { __typename?: 'BoostPoolBoostSharesConnection', aggregates?: { __typename?: 'BoostPoolBoostShareAggregates', sum?: { __typename?: 'BoostPoolBoostShareSumAggregates', amount: string, amountUsd: string, fee: string, feeUsd: string } | null } | null } }> } | null };

export type GetBoostPoolVolumeAndFeesAggregatesQueryVariables = Exact<{
  boostPoolId: Scalars['Int']['input'];
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
  groupBy: BoostPoolBoostShareGroupBy;
}>;


export type GetBoostPoolVolumeAndFeesAggregatesQuery = { __typename?: 'Query', boostPools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', boostShares: { __typename?: 'BoostPoolBoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostPoolBoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostPoolBoostShareSumAggregates', amountUsd: string, amount: string, fee: string, feeUsd: string } | null }> | null }, firstShare: { __typename?: 'BoostPoolBoostSharesConnection', nodes: Array<{ __typename?: 'BoostPoolBoostShare', executedAtTimestamp: string }> } }> } | null };

export type GetBoostPoolApyQueryVariables = Exact<{
  asset: ChainflipAsset;
  feeTierPips: Scalars['Int']['input'];
  minTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  maxTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBoostPoolApyQuery = { __typename?: 'Query', boostPool?: { __typename?: 'BoostPool', apys: { __typename?: 'BoostPoolApiesConnection', nodes: Array<{ __typename?: 'BoostPoolApy', timestamp: string, projectedApy72H?: string | null }> } } | null };

export type GetAllBoostPoolApyQueryVariables = Exact<{
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
  asset?: InputMaybe<ChainflipAsset>;
}>;


export type GetAllBoostPoolApyQuery = { __typename?: 'Query', allBoostPools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', asset: ChainflipAsset, feeTierPips: number, apys: { __typename?: 'BoostPoolApiesConnection', nodes: Array<{ __typename?: 'BoostPoolApy', projectedApy72H?: string | null }> } }> } | null };

export type GetBoostFeesAggregatedByLpQueryVariables = Exact<{
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBoostFeesAggregatedByLpQuery = { __typename?: 'Query', lps?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, boostShares: { __typename?: 'BoostSharesConnection', aggregates?: { __typename?: 'BoostShareAggregates', sum?: { __typename?: 'BoostShareSumAggregates', feeUsd: string } | null } | null } }> } | null };

export type GetLastBoostPoolWithdrawalQueryVariables = Exact<{
  boostPoolId: Scalars['Int']['input'];
  accountId: Scalars['String']['input'];
}>;


export type GetLastBoostPoolWithdrawalQuery = { __typename?: 'Query', account?: { __typename?: 'Account', balanceChanges: { __typename?: 'BoostLiquidityBalanceChangesConnection', nodes: Array<{ __typename?: 'BoostLiquidityBalanceChange', event: { __typename?: 'Event', timestamp: string } }> } } | null };

export type GetAllBoostPoolsVolumeAndFeesQueryVariables = Exact<{
  date24HoursAgo: Scalars['Datetime']['input'];
  date48HoursAgo: Scalars['Datetime']['input'];
}>;


export type GetAllBoostPoolsVolumeAndFeesQuery = { __typename?: 'Query', currentDay?: { __typename?: 'BoostPoolBoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostPoolBoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostPoolBoostShareSumAggregates', amountUsd: string, feeUsd: string, fee: string } | null }> | null } | null, previousDay?: { __typename?: 'BoostPoolBoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostPoolBoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostPoolBoostShareSumAggregates', amountUsd: string, feeUsd: string } | null }> | null } | null, pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, asset: ChainflipAsset, feeTierPips: number }> } | null };

export type GetLastBlocksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastBlocksQuery = { __typename?: 'Query', latestBlocks?: { __typename?: 'LastBlocksConnection', nodes: Array<{ __typename?: 'LastBlock', timestamp: string }> } | null };

export type GetAllLpLoanFeesQueryVariables = Exact<{
  loanIds: Array<Scalars['BigInt']['input']> | Scalars['BigInt']['input'];
}>;


export type GetAllLpLoanFeesQuery = { __typename?: 'Query', allLoanFees?: { __typename?: 'LoanFeesConnection', edges: Array<{ __typename?: 'LoanFeesEdge', node: { __typename?: 'LoanFee', loanId: string, totalAmountValueUsd: string, totalAmount: string } }> } | null };

export type GetLoanCreationTimestampsQueryVariables = Exact<{
  loanIds: Array<Scalars['BigInt']['input']> | Scalars['BigInt']['input'];
}>;


export type GetLoanCreationTimestampsQuery = { __typename?: 'Query', allLoans?: { __typename?: 'LoansConnection', nodes: Array<{ __typename?: 'Loan', id: string, createdAtTimestamp: string }> } | null };

export type GetLendingPoolsApyQueryVariables = Exact<{
  asset?: InputMaybe<ChainflipAsset>;
}>;


export type GetLendingPoolsApyQuery = { __typename?: 'Query', lendingPools?: { __typename?: 'LendingPoolsConnection', nodes: Array<{ __typename?: 'LendingPool', stats: { __typename?: 'LendingPoolStatsConnection', nodes: Array<{ __typename?: 'LendingPoolStat', asset: ChainflipAsset, projectedApy6H?: string | null, projectedApy24H?: string | null, projectedApy72H?: string | null, projectedApy168H?: string | null, projectedApy720H?: string | null, projectedBorrowApy6H?: string | null, projectedBorrowApy24H?: string | null, projectedBorrowApy72H?: string | null, projectedBorrowApy168H?: string | null, projectedBorrowApy720H?: string | null }> } }> } | null };

export type GetLendingLiquiditySnapshotsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
  groupBy: Array<LiquiditySnapshotGroupBy> | LiquiditySnapshotGroupBy;
}>;


export type GetLendingLiquiditySnapshotsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', snapshots: { __typename?: 'LiquiditySnapshotsConnection', agg?: Array<{ __typename?: 'LiquiditySnapshotAggregates', keys?: Array<string> | null, max?: { __typename?: 'LiquiditySnapshotMaxAggregates', lendingLiquidityUsd?: string | null } | null }> | null } } | null };

export type GetAllTimeLendingStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTimeLendingStatsQuery = { __typename?: 'Query', loans?: { __typename?: 'LoanUpdatesConnection', agg?: { __typename?: 'LoanUpdateAggregates', sum?: { __typename?: 'LoanUpdateSumAggregates', amountValueUsd: string } | null } | null } | null, loanFees?: { __typename?: 'LoanFeesConnection', agg?: { __typename?: 'LoanFeeAggregates', sum?: { __typename?: 'LoanFeeSumAggregates', poolFeePortionAmountValueUsd: string, totalAmountValueUsd: string, networkFeePortionAmountValueUsd: string } | null } | null } | null };

export type GetLendingAnalyticsChartQueryVariables = Exact<{
  assets?: InputMaybe<Array<ChainflipAsset> | ChainflipAsset>;
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  feeGroupBy: Array<LoanFeeGroupBy> | LoanFeeGroupBy;
  statsGroupBy: Array<LendingPoolStatGroupBy> | LendingPoolStatGroupBy;
}>;


export type GetLendingAnalyticsChartQuery = { __typename?: 'Query', fees?: { __typename?: 'LoanFeesConnection', agg?: Array<{ __typename?: 'LoanFeeAggregates', keys?: Array<string> | null, sum?: { __typename?: 'LoanFeeSumAggregates', totalAmountValueUsd: string } | null }> | null } | null, stats?: { __typename?: 'LendingPoolStatsConnection', agg?: Array<{ __typename?: 'LendingPoolStatAggregates', keys?: Array<string> | null, average?: { __typename?: 'LendingPoolStatAverageAggregates', avgUnavailableAmountUsd?: string | null, avgTvlValueUsd?: string | null } | null }> | null } | null };

export type GetAllLoansQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  idSs58?: InputMaybe<Scalars['String']['input']>;
  filter: LoanFilter;
}>;


export type GetAllLoansQueryQuery = { __typename?: 'Query', loans?: { __typename?: 'LoansConnection', totalCount: number, nodes: Array<{ __typename?: 'Loan', asset: ChainflipAsset, id: string, isLiquidated: boolean, createdAtTimestamp: string, lastUpdatedAtTimestamp?: string | null, borrowerType: LoanBorrowerType, borrower?: { __typename?: 'Account', idSs58: string } | null, loanUpdates: { __typename?: 'LoanUpdatesConnection', nodes: Array<{ __typename?: 'LoanUpdate', type: LoanUpdateType, amount: string, amountValueUsd: string, timestamp: string, event: { __typename?: 'Event', block: number, indexInBlock: number } }> }, totalFees: { __typename?: 'LoanFeesConnection', agg?: { __typename?: 'LoanFeeAggregates', sum?: { __typename?: 'LoanFeeSumAggregates', totalAmount: string, totalAmountValueUsd: string } | null } | null }, fees: { __typename?: 'LoanFeesConnection', daily?: Array<{ __typename?: 'LoanFeeAggregates', keys?: Array<string> | null, sum?: { __typename?: 'LoanFeeSumAggregates', totalAmount: string, totalAmountValueUsd: string } | null, max?: { __typename?: 'LoanFeeMaxAggregates', timestamp?: string | null } | null }> | null }, liquidationFees: { __typename?: 'LoanFeesConnection', nodes: Array<{ __typename?: 'LoanFee', totalAmount: string, totalAmountValueUsd: string, timestamp: string }> }, inLiquidationSwaps: { __typename?: 'LiquidationSwapRequestsConnection', nodes: Array<{ __typename?: 'LiquidationSwapRequest', createdAtEventId: string, completedAtEventId?: string | null, abortedAtEventId?: string | null }> }, allLiquidationSwaps: { __typename?: 'LiquidationSwapRequestsConnection', nodes: Array<{ __typename?: 'LiquidationSwapRequest', isHard?: boolean | null, swapRequestId: string, createdAtEventId: string, completedAtEventId?: string | null, abortedAtEventId?: string | null }> }, createdAtEvent: { __typename?: 'Event', block: number, indexInBlock: number }, settledAtEvent?: { __typename?: 'Event', block: number, indexInBlock: number } | null, boost?: { __typename?: 'Boost', swapRequestId?: string | null } | null }> } | null };

export type GetAllLoanUpdatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllLoanUpdatesQuery = { __typename?: 'Query', allLoanUpdates?: { __typename?: 'LoanUpdatesConnection', totalCount: number, nodes: Array<{ __typename?: 'LoanUpdate', id: number, type: LoanUpdateType, loanId: string, timestamp: string, amount: string, amountValueUsd: string, event: { __typename?: 'Event', block: number, indexInBlock: number }, loan: { __typename?: 'Loan', asset: ChainflipAsset, borrowerType: LoanBorrowerType, borrower?: { __typename?: 'Account', idSs58: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetAllLiquidationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllLiquidationsQuery = { __typename?: 'Query', allLiquidationSwapRequests?: { __typename?: 'LiquidationSwapRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'LiquidationSwapRequest', swapRequestId: string, isHard?: boolean | null, createdAtEvent: { __typename?: 'Event', timestamp: string }, loan: { __typename?: 'Loan', id: string, borrower?: { __typename?: 'Account', idSs58: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetLoanByIdQueryVariables = Exact<{
  loanId: Scalars['BigInt']['input'];
}>;


export type GetLoanByIdQuery = { __typename?: 'Query', loan?: { __typename?: 'Loan', asset: ChainflipAsset, id: string, isLiquidated: boolean, createdAtTimestamp: string, lastUpdatedAtTimestamp?: string | null, borrowerType: LoanBorrowerType, borrower?: { __typename?: 'Account', idSs58: string } | null, loanUpdates: { __typename?: 'LoanUpdatesConnection', nodes: Array<{ __typename?: 'LoanUpdate', type: LoanUpdateType, amount: string, amountValueUsd: string, timestamp: string, event: { __typename?: 'Event', block: number, indexInBlock: number } }> }, totalFees: { __typename?: 'LoanFeesConnection', agg?: { __typename?: 'LoanFeeAggregates', sum?: { __typename?: 'LoanFeeSumAggregates', totalAmount: string, totalAmountValueUsd: string } | null } | null }, fees: { __typename?: 'LoanFeesConnection', daily?: Array<{ __typename?: 'LoanFeeAggregates', keys?: Array<string> | null, sum?: { __typename?: 'LoanFeeSumAggregates', totalAmount: string, totalAmountValueUsd: string } | null, max?: { __typename?: 'LoanFeeMaxAggregates', timestamp?: string | null } | null }> | null }, liquidationFees: { __typename?: 'LoanFeesConnection', nodes: Array<{ __typename?: 'LoanFee', totalAmount: string, totalAmountValueUsd: string, timestamp: string }> }, inLiquidationSwaps: { __typename?: 'LiquidationSwapRequestsConnection', nodes: Array<{ __typename?: 'LiquidationSwapRequest', createdAtEventId: string, completedAtEventId?: string | null, abortedAtEventId?: string | null }> }, allLiquidationSwaps: { __typename?: 'LiquidationSwapRequestsConnection', nodes: Array<{ __typename?: 'LiquidationSwapRequest', isHard?: boolean | null, swapRequestId: string, createdAtEventId: string, completedAtEventId?: string | null, abortedAtEventId?: string | null }> }, createdAtEvent: { __typename?: 'Event', block: number, indexInBlock: number }, settledAtEvent?: { __typename?: 'Event', block: number, indexInBlock: number } | null, boost?: { __typename?: 'Boost', swapRequestId?: string | null } | null } | null };

export type LoanInfoFragment = { __typename?: 'Loan', asset: ChainflipAsset, id: string, isLiquidated: boolean, createdAtTimestamp: string, lastUpdatedAtTimestamp?: string | null, borrowerType: LoanBorrowerType, borrower?: { __typename?: 'Account', idSs58: string } | null, loanUpdates: { __typename?: 'LoanUpdatesConnection', nodes: Array<{ __typename?: 'LoanUpdate', type: LoanUpdateType, amount: string, amountValueUsd: string, timestamp: string, event: { __typename?: 'Event', block: number, indexInBlock: number } }> }, totalFees: { __typename?: 'LoanFeesConnection', agg?: { __typename?: 'LoanFeeAggregates', sum?: { __typename?: 'LoanFeeSumAggregates', totalAmount: string, totalAmountValueUsd: string } | null } | null }, fees: { __typename?: 'LoanFeesConnection', daily?: Array<{ __typename?: 'LoanFeeAggregates', keys?: Array<string> | null, sum?: { __typename?: 'LoanFeeSumAggregates', totalAmount: string, totalAmountValueUsd: string } | null, max?: { __typename?: 'LoanFeeMaxAggregates', timestamp?: string | null } | null }> | null }, liquidationFees: { __typename?: 'LoanFeesConnection', nodes: Array<{ __typename?: 'LoanFee', totalAmount: string, totalAmountValueUsd: string, timestamp: string }> }, inLiquidationSwaps: { __typename?: 'LiquidationSwapRequestsConnection', nodes: Array<{ __typename?: 'LiquidationSwapRequest', createdAtEventId: string, completedAtEventId?: string | null, abortedAtEventId?: string | null }> }, allLiquidationSwaps: { __typename?: 'LiquidationSwapRequestsConnection', nodes: Array<{ __typename?: 'LiquidationSwapRequest', isHard?: boolean | null, swapRequestId: string, createdAtEventId: string, completedAtEventId?: string | null, abortedAtEventId?: string | null }> }, createdAtEvent: { __typename?: 'Event', block: number, indexInBlock: number }, settledAtEvent?: { __typename?: 'Event', block: number, indexInBlock: number } | null, boost?: { __typename?: 'Boost', swapRequestId?: string | null } | null };

export type GetLendingBorrowApyStatsQueryVariables = Exact<{
  asset: ChainflipAsset;
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
}>;


export type GetLendingBorrowApyStatsQuery = { __typename?: 'Query', lendingPoolStats?: { __typename?: 'LendingPoolStatsConnection', groupedAggregates?: Array<{ __typename?: 'LendingPoolStatAggregates', keys?: Array<string> | null, average?: { __typename?: 'LendingPoolStatAverageAggregates', avgInterestRateBps?: string | null, projectedBorrowApy6H?: string | null, projectedBorrowApy24H?: string | null, projectedBorrowApy72H?: string | null, projectedBorrowApy168H?: string | null, projectedBorrowApy720H?: string | null } | null }> | null } | null };

export type GetLendingSupplyApyStatsQueryVariables = Exact<{
  asset: ChainflipAsset;
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
}>;


export type GetLendingSupplyApyStatsQuery = { __typename?: 'Query', lendingPoolStats?: { __typename?: 'LendingPoolStatsConnection', groupedAggregates?: Array<{ __typename?: 'LendingPoolStatAggregates', keys?: Array<string> | null, average?: { __typename?: 'LendingPoolStatAverageAggregates', projectedApy6H?: string | null, projectedApy24H?: string | null, projectedApy72H?: string | null, projectedApy168H?: string | null, projectedApy720H?: string | null } | null }> | null } | null };

export type GetAllIncentiveSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllIncentiveSeasonsQuery = { __typename?: 'Query', allIncentiveSeasons?: { __typename?: 'IncentiveSeasonsConnection', nodes: Array<{ __typename?: 'IncentiveSeason', isActive: boolean, seasonIndex: number, startBlockHeight: number, startBlockDate: string, endBlockHeight: number, endBlockDate: string, program: { __typename?: 'LendingPoolIncentiveProgramsConnection', nodes: Array<{ __typename?: 'LendingPoolIncentiveProgram', id: number, type: LendingPoolIncentiveProgramType, intervalBlocks: number, pointsPerInterval: string, totalPoints: string, totalFlip: string, lendingPool: { __typename?: 'LendingPool', asset: ChainflipAsset } }> } }> } | null };

export type GetLpFlipDistributionInfoQueryVariables = Exact<{
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  seasonIndex: Scalars['Int']['input'];
}>;


export type GetLpFlipDistributionInfoQuery = { __typename?: 'Query', flipDistributions?: { __typename?: 'LpFlipAirdropDistributionEventsConnection', nodes: Array<{ __typename?: 'LpFlipAirdropDistributionEvent', lpSs58Id: string, txRef?: string | null, flipAmount: string, pointAmount: string, flipAmountUsd?: string | null, lendingPoolIncentiveProgramId: number }> } | null };

export type GetLpSupplyPnlQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  groupBy: Array<LpLendingPoolSnapshotGroupBy> | LpLendingPoolSnapshotGroupBy;
  filters?: InputMaybe<LpLendingPoolSnapshotFilter>;
}>;


export type GetLpSupplyPnlQuery = { __typename?: 'Query', account?: { __typename?: 'Account', snapshots: { __typename?: 'LpLendingPoolSnapshotsConnection', agg?: Array<{ __typename?: 'LpLendingPoolSnapshotAggregates', keys?: Array<string> | null, sum?: { __typename?: 'LpLendingPoolSnapshotSumAggregates', supplyPnl1H: string, supplyPnl1HUsd: string } | null }> | null } } | null };

export type GetLpLendingPositionOpeningsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  assets?: InputMaybe<Array<ChainflipAsset> | ChainflipAsset>;
}>;


export type GetLpLendingPositionOpeningsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', balanceChanges: { __typename?: 'LendingLiquidityBalanceChangesConnection', groupedAggregates?: Array<{ __typename?: 'LendingLiquidityBalanceChangeAggregates', keys?: Array<string> | null, max?: { __typename?: 'LendingLiquidityBalanceChangeMaxAggregates', timestamp?: string | null } | null }> | null } } | null };

export type GetLpTotalSupplyPnlQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  minTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  maxTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type GetLpTotalSupplyPnlQuery = { __typename?: 'Query', account?: { __typename?: 'Account', snapshots: { __typename?: 'LpLendingPoolSnapshotsConnection', agg?: { __typename?: 'LpLendingPoolSnapshotAggregates', sum?: { __typename?: 'LpLendingPoolSnapshotSumAggregates', supplyPnl1HUsd: string } | null } | null } } | null };

export type LimitOrderFillFragment = { __typename?: 'LimitOrderFill', id: number, tick: number, type: LimitOrderType, orderId: string, baseAsset: ChainflipAsset, sellAmount: string, filledAmount: string, blockTimestamp?: string | null, sellAmountValueUsd?: string | null, filledAmountValueUsd?: string | null, originalSellAmount: string, originalSellAmountValueUsd?: string | null, lp: { __typename?: 'Account', idSs58: string } };

export type RangeOrderFillFragment = { __typename?: 'RangeOrderFill', id: number, orderId: string, liquidity: string, baseAsset: ChainflipAsset, blockTimestamp?: string | null, rangeEndTick: number, rangeStartTick: number, baseFilledAmount: string, quoteFilledAmount: string, baseFilledAmountValueUsd?: string | null, quoteFilledAmountValueUsd?: string | null, baseReceivedAmount: string, quoteReceivedAmount: string, baseFeesEarned: string, quoteFeesEarned: string, lp: { __typename?: 'Account', idSs58: string } };

export type GetLpEarnedFeeAggregatesQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
  limitOrderGroupBy: Array<LimitOrderFillGroupBy> | LimitOrderFillGroupBy;
  rangeOrderGroupBy: Array<RangeOrderFillGroupBy> | RangeOrderFillGroupBy;
  boostShareGroupBy: Array<BoostShareGroupBy> | BoostShareGroupBy;
}>;


export type GetLpEarnedFeeAggregatesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', limitOrderFees: { __typename?: 'LimitOrderFillsConnection', groupedAggregates?: Array<{ __typename?: 'LimitOrderFillAggregates', keys?: Array<string> | null, sum?: { __typename?: 'LimitOrderFillSumAggregates', feeUsd: string } | null }> | null }, rangeOrderFees: { __typename?: 'RangeOrderFillsConnection', groupedAggregates?: Array<{ __typename?: 'RangeOrderFillAggregates', keys?: Array<string> | null, sum?: { __typename?: 'RangeOrderFillSumAggregates', baseFeeUsd: string, quoteFeeUsd: string } | null }> | null }, boostFees: { __typename?: 'BoostSharesConnection', groupedAggregates?: Array<{ __typename?: 'BoostShareAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BoostShareSumAggregates', feeUsd: string } | null }> | null } } | null };

export type GetAllLpsTotalVolumeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLpsTotalVolumeQueryQuery = { __typename?: 'Query', limitOrders?: { __typename?: 'LimitOrderFillsConnection', aggregates?: { __typename?: 'LimitOrderFillAggregates', sum?: { __typename?: 'LimitOrderFillSumAggregates', filledAmountValueUsd: string } | null } | null } | null, rangeOrders?: { __typename?: 'RangeOrderFillsConnection', aggregates?: { __typename?: 'RangeOrderFillAggregates', sum?: { __typename?: 'RangeOrderFillSumAggregates', baseFilledAmountValueUsd: string, quoteFilledAmountValueUsd: string } | null } | null } | null };

export type GetLpsVolumeQueryQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type GetLpsVolumeQueryQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, strategies: { __typename?: 'TradingStrategiesConnection', nodes: Array<{ __typename?: 'TradingStrategy', strategy: { __typename?: 'Account', limitOrders: { __typename?: 'LimitOrderFillsConnection', aggregates?: { __typename?: 'LimitOrderFillAggregates', sum?: { __typename?: 'LimitOrderFillSumAggregates', filledAmountValueUsd: string } | null } | null } } }> }, limitOrders: { __typename?: 'LimitOrderFillsConnection', aggregates?: { __typename?: 'LimitOrderFillAggregates', sum?: { __typename?: 'LimitOrderFillSumAggregates', filledAmountValueUsd: string } | null } | null }, rangeOrders: { __typename?: 'RangeOrderFillsConnection', aggregates?: { __typename?: 'RangeOrderFillAggregates', sum?: { __typename?: 'RangeOrderFillSumAggregates', quoteFilledAmountValueUsd: string, baseFilledAmountValueUsd: string } | null } | null } }> } | null };

export type GetLpIdQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetLpIdQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: number } | null };

export type GetOrderFillsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  asset?: InputMaybe<ChainflipAsset>;
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  minFilledValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrderFillsQuery = { __typename?: 'Query', limitOrderFills?: { __typename?: 'LimitOrderFillsConnection', nodes: Array<{ __typename?: 'LimitOrderFill', id: number, tick: number, type: LimitOrderType, orderId: string, baseAsset: ChainflipAsset, sellAmount: string, filledAmount: string, blockTimestamp?: string | null, sellAmountValueUsd?: string | null, filledAmountValueUsd?: string | null, originalSellAmount: string, originalSellAmountValueUsd?: string | null, lp: { __typename?: 'Account', idSs58: string } }> } | null, rangeOrderFills?: { __typename?: 'RangeOrderFillsConnection', nodes: Array<{ __typename?: 'RangeOrderFill', id: number, orderId: string, liquidity: string, baseAsset: ChainflipAsset, blockTimestamp?: string | null, rangeEndTick: number, rangeStartTick: number, baseFilledAmount: string, quoteFilledAmount: string, baseFilledAmountValueUsd?: string | null, quoteFilledAmountValueUsd?: string | null, baseReceivedAmount: string, quoteReceivedAmount: string, baseFeesEarned: string, quoteFeesEarned: string, lp: { __typename?: 'Account', idSs58: string } }> } | null };

export type GetOpenOrdersByAccountQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetOpenOrdersByAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', openOrders: { __typename?: 'PoolOrdersConnection', nodes: Array<{ __typename?: 'PoolOrder', id: string, orderId: string, liquidityProviderId: number, orderType: PoolOrderType, status: PoolOrderStatus, lowerTick: string, upperTick: string, filledQuoteAmount: string, quoteAsset: ChainflipAsset, quoteAmount: string, quoteCollectedFees: string, baseAsset: ChainflipAsset, filledBaseAmount: string, baseAmount: string, baseCollectedFees: string, orderCreatedEventId: string, orderLastUpdatedEventId?: string | null, orderCreatedTimestamp: string }> } } | null };

export type GetOrdersByAccountQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  idSs58: Scalars['String']['input'];
  baseAsset?: InputMaybe<ChainflipAsset>;
  orderBy?: InputMaybe<Array<PoolOrdersOrderBy> | PoolOrdersOrderBy>;
}>;


export type GetOrdersByAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', allOrders: { __typename?: 'PoolOrdersConnection', nodes: Array<{ __typename?: 'PoolOrder', id: string, orderId: string, liquidityProviderId: number, orderType: PoolOrderType, status: PoolOrderStatus, lowerTick: string, upperTick: string, filledQuoteAmount: string, quoteAsset: ChainflipAsset, quoteAmount: string, quoteCollectedFees: string, baseAsset: ChainflipAsset, filledBaseAmount: string, baseAmount: string, baseCollectedFees: string, orderCreatedEventId: string, orderLastUpdatedEventId?: string | null, orderCreatedTimestamp: string }> } } | null };

export type PoolOrderFragment = { __typename?: 'PoolOrder', id: string, orderId: string, liquidityProviderId: number, orderType: PoolOrderType, status: PoolOrderStatus, lowerTick: string, upperTick: string, filledQuoteAmount: string, quoteAsset: ChainflipAsset, quoteAmount: string, quoteCollectedFees: string, baseAsset: ChainflipAsset, filledBaseAmount: string, baseAmount: string, baseCollectedFees: string, orderCreatedEventId: string, orderLastUpdatedEventId?: string | null, orderCreatedTimestamp: string };

export type GetAccountLiquiditySnapshotsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
  groupBy: Array<LiquiditySnapshotGroupBy> | LiquiditySnapshotGroupBy;
}>;


export type GetAccountLiquiditySnapshotsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', snapshots: { __typename?: 'LiquiditySnapshotsConnection', agg?: Array<{ __typename?: 'LiquiditySnapshotAggregates', keys?: Array<string> | null, max?: { __typename?: 'LiquiditySnapshotMaxAggregates', totalLiquidityUsd?: string | null } | null }> | null } } | null };

export type GetAccountTotalBalanceSnapshotsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  minTimestamp: Scalars['Datetime']['input'];
  maxTimestamp: Scalars['Datetime']['input'];
  groupBy: Array<LiquiditySnapshotGroupBy> | LiquiditySnapshotGroupBy;
}>;


export type GetAccountTotalBalanceSnapshotsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', snapshots: { __typename?: 'LiquiditySnapshotsConnection', agg?: Array<{ __typename?: 'LiquiditySnapshotAggregates', keys?: Array<string> | null, max?: { __typename?: 'LiquiditySnapshotMaxAggregates', totalBalanceUsd?: string | null } | null }> | null } } | null };

export type GetStrategiesBalanceChangesQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetStrategiesBalanceChangesQuery = { __typename?: 'Query', account?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, strategy: { __typename?: 'TradingStrategiesConnection', nodes: Array<{ __typename?: 'TradingStrategy', baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, owner: { __typename?: 'Account', idSs58: string }, balanceChangeEvents: { __typename?: 'TradingStrategyBalanceChangeEventsConnection', nodes: Array<{ __typename?: 'TradingStrategyBalanceChangeEvent', asset: ChainflipAsset, amountUsd?: string | null, amount: string, type: TradingStrategyBalanceChangeEventType, event: { __typename?: 'Event', block: number, indexInBlock: number, timestamp: string } }> } }> } }> } | null };

export const BoostBalanceChangeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoostBalanceChange"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoostLiquidityBalanceChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pool"},"name":{"kind":"Name","value":"boostPoolByBoostPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"boostByBoostId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"depositChannel"},"name":{"kind":"Name","value":"depositChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}}]}}]}}]}}]} as unknown as DocumentNode<BoostBalanceChangeFragment, unknown>;
export const LoanInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Loan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiquidated"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAtTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","name":{"kind":"Name","value":"borrowerType"}},{"kind":"Field","alias":{"kind":"Name","value":"loanUpdates"},"name":{"kind":"Name","value":"loanUpdatesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"totalFees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"EnumValue","value":"LIQUIDATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"daily"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_TRUNCATED_TO_DAY"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationFees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"EnumValue","value":"LIQUIDATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inLiquidationSwaps"},"name":{"kind":"Name","value":"liquidationSwapRequestsByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"abortedAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allLiquidationSwaps"},"name":{"kind":"Name","value":"liquidationSwapRequestsByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHard"}},{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdAtEvent"},"name":{"kind":"Name","value":"eventByCreatedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"settledAtEvent"},"name":{"kind":"Name","value":"eventBySettledAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"boostByBoostId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}}]}}]}}]} as unknown as DocumentNode<LoanInfoFragment, unknown>;
export const LimitOrderFillFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitOrderFill"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LimitOrderFill"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sellAmount"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"blockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"sellAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"originalSellAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalSellAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]} as unknown as DocumentNode<LimitOrderFillFragment, unknown>;
export const RangeOrderFillFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RangeOrderFill"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RangeOrderFill"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"blockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"rangeEndTick"}},{"kind":"Field","name":{"kind":"Name","value":"rangeStartTick"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseReceivedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReceivedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseFeesEarned"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFeesEarned"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]} as unknown as DocumentNode<RangeOrderFillFragment, unknown>;
export const PoolOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PoolOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PoolOrder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lowerTick"}},{"kind":"Field","name":{"kind":"Name","value":"upperTick"}},{"kind":"Field","name":{"kind":"Name","value":"filledQuoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteCollectedFees"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"filledBaseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseCollectedFees"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreatedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"orderLastUpdatedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreatedTimestamp"}}]}}]} as unknown as DocumentNode<PoolOrderFragment, unknown>;
export const GetTotalBoostFeesForPoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTotalBoostFeesForPool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startingTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBoosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"settledAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startingTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTotalBoostFeesForPoolQuery, GetTotalBoostFeesForPoolQueryVariables>;
export const GetLpNumericSearchResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpNumericSearchResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loan"},"name":{"kind":"Name","value":"loanById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLpNumericSearchResultsQuery, GetLpNumericSearchResultsQueryVariables>;
export const GetBoostContributionCountForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostContributionCountForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostContributionCountForAccountQuery, GetBoostContributionCountForAccountQueryVariables>;
export const GetLpSupplyHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpSupplyHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LendingLiquidityBalanceChangeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LendingLiquidityBalanceChangesOrderBy"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"EVENT_ID_DESC"}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balanceChanges"},"name":{"kind":"Name","value":"lendingLiquidityBalanceChangesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLpSupplyHistoryQuery, GetLpSupplyHistoryQueryVariables>;
export const GetOrderFillsByBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderFillsByBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limitOrderFills"},"name":{"kind":"Name","value":"allLimitOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"blockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rangeOrderFills"},"name":{"kind":"Name","value":"allRangeOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rangeStartTick"}},{"kind":"Field","name":{"kind":"Name","value":"rangeEndTick"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseReceivedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReceivedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseReceivedAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReceivedAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseFeesEarned"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFeesEarned"}},{"kind":"Field","name":{"kind":"Name","value":"blockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderFillsByBlocksQuery, GetOrderFillsByBlocksQueryVariables>;
export const GetFillVolumeByBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFillVolumeByBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limitOrderFills"},"name":{"kind":"Name","value":"allLimitOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rangeOrderFills"},"name":{"kind":"Name","value":"allRangeOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFillVolumeByBlocksQuery, GetFillVolumeByBlocksQueryVariables>;
export const GetLimitOrderFillPricesByBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLimitOrderFillPricesByBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLimitOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLimitOrderFillPricesByBlocksQuery, GetLimitOrderFillPricesByBlocksQueryVariables>;
export const GetBoostPoolLiquidityBalanceChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostPoolLiquidityBalanceChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balanceChanges"},"name":{"kind":"Name","value":"allBoostLiquidityBalanceChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FUNDS_ADDED"},{"kind":"EnumValue","value":"WITHDRAWAL"},{"kind":"EnumValue","value":"DELAYED_WITHDRAWAL"},{"kind":"EnumValue","value":"FUNDS_LOST"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostPoolLiquidityBalanceChangeQuery, GetBoostPoolLiquidityBalanceChangeQueryVariables>;
export const GetBoostSharesByPoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostSharesByPool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierPips"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostSummaries"},"name":{"kind":"Name","value":"liquidityProviderBoostPoolSummariesByBoostPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boostPool"},"name":{"kind":"Name","value":"boostPoolByBoostPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostSharesByPoolQuery, GetBoostSharesByPoolQueryVariables>;
export const GetPoolBoostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPoolBoosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoostPoolBoostSharesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostShares"},"name":{"kind":"Name","value":"allBoostPoolBoostShares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolByBoostPoolId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierPips"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lost"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderFeePortion"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderFeePortionUsd"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortion"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortionUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"boostByBoostId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderFeePortion"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderFeePortionUsd"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortion"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortionUsd"}},{"kind":"Field","name":{"kind":"Name","value":"settledAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeeSwapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"executedAtTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"depositChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pool"},"name":{"kind":"Name","value":"boostPoolByBoostPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetPoolBoostsQuery, GetPoolBoostsQueryVariables>;
export const LpBoostPoolIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LpBoostPoolIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<LpBoostPoolIdsQuery, LpBoostPoolIdsQueryVariables>;
export const GetBoostSharesByAccountAndPoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostSharesByAccountAndPool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoostSharesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shares"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lost"}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"boostByBoostId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderFeePortion"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderFeePortionUsd"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortion"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortionUsd"}},{"kind":"Field","name":{"kind":"Name","value":"settledAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeeSwapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"executedAtTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"depositChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostSharesByAccountAndPoolQuery, GetBoostSharesByAccountAndPoolQueryVariables>;
export const AccountBoostLiquidityBalanceChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountBoostLiquidityBalanceChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balanceChanges"},"name":{"kind":"Name","value":"boostLiquidityBalanceChangesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FUNDS_ADDED"},{"kind":"EnumValue","value":"WITHDRAWAL"},{"kind":"EnumValue","value":"DELAYED_WITHDRAWAL"},{"kind":"EnumValue","value":"FUNDS_LOST"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountBoostLiquidityBalanceChangesQuery, AccountBoostLiquidityBalanceChangesQueryVariables>;
export const EarnedFeesByPoolForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EarnedFeesByPoolForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostShares"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"BOOST_POOL_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boostPools"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}}]}}]}}]} as unknown as DocumentNode<EarnedFeesByPoolForAccountQuery, EarnedFeesByPoolForAccountQueryVariables>;
export const EarnedFeesInPoolForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EarnedFeesInPoolForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoostShareGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostShares"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EXECUTED_AT_TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstShare"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EXECUTED_AT_TIMESTAMP_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executedAtTimestamp"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EarnedFeesInPoolForAccountQuery, EarnedFeesInPoolForAccountQueryVariables>;
export const EarnedFeesByPool24hsForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EarnedFeesByPool24hsForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostShares"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"BOOST_POOL_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EarnedFeesByPool24hsForAccountQuery, EarnedFeesByPool24hsForAccountQueryVariables>;
export const EarnedFeesAndVolumeForPoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EarnedFeesAndVolumeForPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","alias":{"kind":"Name","value":"shares"},"name":{"kind":"Name","value":"boostPoolBoostSharesByBoostPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EarnedFeesAndVolumeForPoolsQuery, EarnedFeesAndVolumeForPoolsQueryVariables>;
export const GetBoostPoolVolumeAndFeesAggregatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostPoolVolumeAndFeesAggregates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoostPoolBoostShareGroupBy"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostPools"},"name":{"kind":"Name","value":"allBoostPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostShares"},"name":{"kind":"Name","value":"boostPoolBoostSharesByBoostPoolId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstShare"},"name":{"kind":"Name","value":"boostPoolBoostSharesByBoostPoolId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EXECUTED_AT_TIMESTAMP_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executedAtTimestamp"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostPoolVolumeAndFeesAggregatesQuery, GetBoostPoolVolumeAndFeesAggregatesQueryVariables>;
export const GetBoostPoolApyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostPoolApy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boostPool"},"name":{"kind":"Name","value":"boostPoolByAssetAndFeeTierPips"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"asset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}},{"kind":"Argument","name":{"kind":"Name","value":"feeTierPips"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"apys"},"name":{"kind":"Name","value":"boostPoolApiesByBoostPoolId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostPoolApyQuery, GetBoostPoolApyQueryVariables>;
export const GetAllBoostPoolApyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllBoostPoolApy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBoostPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierPips"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","alias":{"kind":"Name","value":"apys"},"name":{"kind":"Name","value":"boostPoolApiesByBoostPoolId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllBoostPoolApyQuery, GetAllBoostPoolApyQueryVariables>;
export const GetBoostFeesAggregatedByLpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostFeesAggregatedByLp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lps"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"boostShares"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostFeesAggregatedByLpQuery, GetBoostFeesAggregatedByLpQueryVariables>;
export const GetLastBoostPoolWithdrawalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastBoostPoolWithdrawal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balanceChanges"},"name":{"kind":"Name","value":"boostLiquidityBalanceChangesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"WITHDRAWAL"}},{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostPoolId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLastBoostPoolWithdrawalQuery, GetLastBoostPoolWithdrawalQueryVariables>;
export const GetAllBoostPoolsVolumeAndFeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllBoostPoolsVolumeAndFees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentDay"},"name":{"kind":"Name","value":"allBoostPoolBoostShares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolByBoostPoolId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"BOOST_POOL_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previousDay"},"name":{"kind":"Name","value":"allBoostPoolBoostShares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lost"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"boostPoolByBoostPoolId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"BOOST_POOL_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ASSET_ASC"},{"kind":"EnumValue","value":"FEE_TIER_PIPS_DESC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllBoostPoolsVolumeAndFeesQuery, GetAllBoostPoolsVolumeAndFeesQueryVariables>;
export const GetLastBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastBlocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestBlocks"},"name":{"kind":"Name","value":"allLastBlocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetLastBlocksQuery, GetLastBlocksQueryVariables>;
export const GetAllLpLoanFeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLpLoanFees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLoanFees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loanId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLpLoanFeesQuery, GetAllLpLoanFeesQueryVariables>;
export const GetLoanCreationTimestampsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoanCreationTimestamps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLoans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtTimestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetLoanCreationTimestampsQuery, GetLoanCreationTimestampsQueryVariables>;
export const GetLendingPoolsApyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLendingPoolsApy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lendingPools"},"name":{"kind":"Name","value":"allLendingPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stats"},"name":{"kind":"Name","value":"lendingPoolStatsByPoolId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy720H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy720H"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLendingPoolsApyQuery, GetLendingPoolsApyQueryVariables>;
export const GetLendingLiquiditySnapshotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLendingLiquiditySnapshots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiquiditySnapshotGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"snapshots"},"name":{"kind":"Name","value":"liquiditySnapshotsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lendingLiquidityUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLendingLiquiditySnapshotsQuery, GetLendingLiquiditySnapshotsQueryVariables>;
export const GetAllTimeLendingStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTimeLendingStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loans"},"name":{"kind":"Name","value":"allLoanUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"BORROWING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanFees"},"name":{"kind":"Name","value":"allLoanFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poolFeePortionAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"networkFeePortionAmountValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllTimeLendingStatsQuery, GetAllTimeLendingStatsQueryVariables>;
export const GetLendingAnalyticsChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLendingAnalyticsChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeGroupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoanFeeGroupBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statsGroupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LendingPoolStatGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"allLoanFees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assets"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeGroupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"stats"},"name":{"kind":"Name","value":"allLendingPoolStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assets"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statsGroupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avgUnavailableAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"avgTvlValueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}}]}}]} as unknown as DocumentNode<GetLendingAnalyticsChartQuery, GetLendingAnalyticsChartQueryVariables>;
export const GetAllLoansQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLoansQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoanFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loans"},"name":{"kind":"Name","value":"allLoans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LAST_UPDATED_AT_TIMESTAMP_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountByBorrowerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"filter"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Loan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiquidated"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAtTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","name":{"kind":"Name","value":"borrowerType"}},{"kind":"Field","alias":{"kind":"Name","value":"loanUpdates"},"name":{"kind":"Name","value":"loanUpdatesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"totalFees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"EnumValue","value":"LIQUIDATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"daily"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_TRUNCATED_TO_DAY"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationFees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"EnumValue","value":"LIQUIDATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inLiquidationSwaps"},"name":{"kind":"Name","value":"liquidationSwapRequestsByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"abortedAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allLiquidationSwaps"},"name":{"kind":"Name","value":"liquidationSwapRequestsByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHard"}},{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdAtEvent"},"name":{"kind":"Name","value":"eventByCreatedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"settledAtEvent"},"name":{"kind":"Name","value":"eventBySettledAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"boostByBoostId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}}]}}]}}]} as unknown as DocumentNode<GetAllLoansQueryQuery, GetAllLoansQueryQueryVariables>;
export const GetAllLoanUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLoanUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLoanUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loanByLoanId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountByBorrowerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loan"},"name":{"kind":"Name","value":"loanByLoanId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"borrowerType"}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLoanUpdatesQuery, GetAllLoanUpdatesQueryVariables>;
export const GetAllLiquidationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLiquidations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLiquidationSwapRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loanByLoanId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountByBorrowerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"isHard"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAtEvent"},"name":{"kind":"Name","value":"eventByCreatedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loan"},"name":{"kind":"Name","value":"loanByLoanId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLiquidationsQuery, GetAllLiquidationsQueryVariables>;
export const GetLoanByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoanById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loan"},"name":{"kind":"Name","value":"loanById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Loan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiquidated"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAtTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","name":{"kind":"Name","value":"borrowerType"}},{"kind":"Field","alias":{"kind":"Name","value":"loanUpdates"},"name":{"kind":"Name","value":"loanUpdatesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"totalFees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"EnumValue","value":"LIQUIDATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"daily"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_TRUNCATED_TO_DAY"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationFees"},"name":{"kind":"Name","value":"loanFeesByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"EnumValue","value":"LIQUIDATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inLiquidationSwaps"},"name":{"kind":"Name","value":"liquidationSwapRequestsByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"abortedAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allLiquidationSwaps"},"name":{"kind":"Name","value":"liquidationSwapRequestsByLoanId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAtEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHard"}},{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"createdAtEvent"},"name":{"kind":"Name","value":"eventByCreatedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"settledAtEvent"},"name":{"kind":"Name","value":"eventBySettledAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boost"},"name":{"kind":"Name","value":"boostByBoostId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapRequestId"}}]}}]}}]} as unknown as DocumentNode<GetLoanByIdQuery, GetLoanByIdQueryVariables>;
export const GetLendingBorrowApyStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLendingBorrowApyStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lendingPoolStats"},"name":{"kind":"Name","value":"allLendingPoolStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ASSET"},{"kind":"EnumValue","value":"TIMESTAMP_TRUNCATED_TO_DAY"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avgInterestRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedBorrowApy720H"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLendingBorrowApyStatsQuery, GetLendingBorrowApyStatsQueryVariables>;
export const GetLendingSupplyApyStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLendingSupplyApyStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lendingPoolStats"},"name":{"kind":"Name","value":"allLendingPoolStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ASSET"},{"kind":"EnumValue","value":"TIMESTAMP_TRUNCATED_TO_DAY"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectedApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy720H"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLendingSupplyApyStatsQuery, GetLendingSupplyApyStatsQueryVariables>;
export const GetAllIncentiveSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllIncentiveSeasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allIncentiveSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"SEASON_INDEX_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"seasonIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockDate"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","alias":{"kind":"Name","value":"program"},"name":{"kind":"Name","value":"lendingPoolIncentiveProgramsByIncentiveSeasonId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"lendingPool"},"name":{"kind":"Name","value":"lendingPoolByLendingPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"intervalBlocks"},"name":{"kind":"Name","value":"pointDistributionIntervalBlocks"}},{"kind":"Field","alias":{"kind":"Name","value":"pointsPerInterval"},"name":{"kind":"Name","value":"pointsDistributedPerInterval"}},{"kind":"Field","alias":{"kind":"Name","value":"totalPoints"},"name":{"kind":"Name","value":"maxAllocatedPoints"}},{"kind":"Field","alias":{"kind":"Name","value":"totalFlip"},"name":{"kind":"Name","value":"maxAllocatedFlipAmount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllIncentiveSeasonsQuery, GetAllIncentiveSeasonsQueryVariables>;
export const GetLpFlipDistributionInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpFlipDistributionInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flipDistributions"},"name":{"kind":"Name","value":"allLpFlipAirdropDistributionEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lendingPoolIncentiveProgramByLendingPoolIncentiveProgramId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incentiveSeasonByIncentiveSeasonId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seasonIndex"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonIndex"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lpSs58Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lpSs58Id"}},{"kind":"Field","name":{"kind":"Name","value":"txRef"}},{"kind":"Field","name":{"kind":"Name","value":"flipAmount"}},{"kind":"Field","name":{"kind":"Name","value":"pointAmount"}},{"kind":"Field","name":{"kind":"Name","value":"flipAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"lendingPoolIncentiveProgramId"}}]}}]}}]}}]} as unknown as DocumentNode<GetLpFlipDistributionInfoQuery, GetLpFlipDistributionInfoQueryVariables>;
export const GetLpSupplyPnlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpSupplyPnl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LpLendingPoolSnapshotGroupBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LpLendingPoolSnapshotFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"snapshots"},"name":{"kind":"Name","value":"lpLendingPoolSnapshotsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplyPnl1H"}},{"kind":"Field","name":{"kind":"Name","value":"supplyPnl1HUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLpSupplyPnlQuery, GetLpSupplyPnlQueryVariables>;
export const GetLpLendingPositionOpeningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpLendingPositionOpenings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balanceChanges"},"name":{"kind":"Name","value":"lendingLiquidityBalanceChangesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPositionOpening"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assets"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLpLendingPositionOpeningsQuery, GetLpLendingPositionOpeningsQueryVariables>;
export const GetLpTotalSupplyPnlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpTotalSupplyPnl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"snapshots"},"name":{"kind":"Name","value":"lpLendingPoolSnapshotsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplyPnl1HUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLpTotalSupplyPnlQuery, GetLpTotalSupplyPnlQueryVariables>;
export const GetLpEarnedFeeAggregatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLpEarnedFeeAggregates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitOrderGroupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LimitOrderFillGroupBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rangeOrderGroupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RangeOrderFillGroupBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boostShareGroupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoostShareGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limitOrderFees"},"name":{"kind":"Name","value":"limitOrderFillsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitOrderGroupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"feeUsd"},"name":{"kind":"Name","value":"feesEarnedValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rangeOrderFees"},"name":{"kind":"Name","value":"rangeOrderFillsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rangeOrderGroupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"baseFeeUsd"},"name":{"kind":"Name","value":"baseFeesEarnedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"quoteFeeUsd"},"name":{"kind":"Name","value":"quoteFeesEarnedValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boostFees"},"name":{"kind":"Name","value":"boostSharesByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executedAtTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EXECUTED_AT_TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boostShareGroupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLpEarnedFeeAggregatesQuery, GetLpEarnedFeeAggregatesQueryVariables>;
export const GetAllLpsTotalVolumeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllLpsTotalVolumeQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limitOrders"},"name":{"kind":"Name","value":"allLimitOrderFills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rangeOrders"},"name":{"kind":"Name","value":"allRangeOrderFills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllLpsTotalVolumeQueryQuery, GetAllLpsTotalVolumeQueryQueryVariables>;
export const GetLpsVolumeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLpsVolumeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"strategies"},"name":{"kind":"Name","value":"tradingStrategiesByOwnerAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"strategy"},"name":{"kind":"Name","value":"accountByStrategyAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limitOrders"},"name":{"kind":"Name","value":"limitOrderFillsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"limitOrders"},"name":{"kind":"Name","value":"limitOrderFillsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rangeOrders"},"name":{"kind":"Name","value":"rangeOrderFillsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmountValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLpsVolumeQueryQuery, GetLpsVolumeQueryQueryVariables>;
export const GetLpIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLpId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLpIdQuery, GetLpIdQueryVariables>;
export const GetOrderFillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderFills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minFilledValueUsd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limitOrderFills"},"name":{"kind":"Name","value":"allLimitOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"liquidityProviderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"filledAmountValueUsd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minFilledValueUsd"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LimitOrderFill"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rangeOrderFills"},"name":{"kind":"Name","value":"allRangeOrderFills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"liquidityProviderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minFilledValueUsd"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseFilledAmountValueUsd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minFilledValueUsd"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RangeOrderFill"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LimitOrderFill"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LimitOrderFill"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tick"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sellAmount"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"blockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"sellAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"filledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"originalSellAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalSellAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RangeOrderFill"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RangeOrderFill"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"blockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"rangeEndTick"}},{"kind":"Field","name":{"kind":"Name","value":"rangeStartTick"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFilledAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"baseReceivedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteReceivedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseFeesEarned"}},{"kind":"Field","name":{"kind":"Name","value":"quoteFeesEarned"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"accountByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]} as unknown as DocumentNode<GetOrderFillsQuery, GetOrderFillsQueryVariables>;
export const GetOpenOrdersByAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOpenOrdersByAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"openOrders"},"name":{"kind":"Name","value":"poolOrdersByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"OPEN"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_CREATED_EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PoolOrder"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PoolOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PoolOrder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lowerTick"}},{"kind":"Field","name":{"kind":"Name","value":"upperTick"}},{"kind":"Field","name":{"kind":"Name","value":"filledQuoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteCollectedFees"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"filledBaseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseCollectedFees"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreatedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"orderLastUpdatedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreatedTimestamp"}}]}}]} as unknown as DocumentNode<GetOpenOrdersByAccountQuery, GetOpenOrdersByAccountQueryVariables>;
export const GetOrdersByAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrdersByAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PoolOrdersOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allOrders"},"name":{"kind":"Name","value":"poolOrdersByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PoolOrder"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PoolOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PoolOrder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lowerTick"}},{"kind":"Field","name":{"kind":"Name","value":"upperTick"}},{"kind":"Field","name":{"kind":"Name","value":"filledQuoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteCollectedFees"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"filledBaseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseCollectedFees"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreatedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"orderLastUpdatedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"orderCreatedTimestamp"}}]}}]} as unknown as DocumentNode<GetOrdersByAccountQuery, GetOrdersByAccountQueryVariables>;
export const GetAccountLiquiditySnapshotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountLiquiditySnapshots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiquiditySnapshotGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"snapshots"},"name":{"kind":"Name","value":"liquiditySnapshotsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalLiquidityUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountLiquiditySnapshotsQuery, GetAccountLiquiditySnapshotsQueryVariables>;
export const GetAccountTotalBalanceSnapshotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountTotalBalanceSnapshots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiquiditySnapshotGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"snapshots"},"name":{"kind":"Name","value":"liquiditySnapshotsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minTimestamp"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TIMESTAMP_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalBalanceUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountTotalBalanceSnapshotsQuery, GetAccountTotalBalanceSnapshotsQueryVariables>;
export const GetStrategiesBalanceChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStrategiesBalanceChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"strategy"},"name":{"kind":"Name","value":"tradingStrategiesByStrategyAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","alias":{"kind":"Name","value":"owner"},"name":{"kind":"Name","value":"accountByOwnerAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"balanceChangeEvents"},"name":{"kind":"Name","value":"tradingStrategyBalanceChangeEventsByTradingStrategyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStrategiesBalanceChangesQuery, GetStrategiesBalanceChangesQueryVariables>;